/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AuthProtocolsCheckPasswordRequest {
  email: string;
  password: string;
}

export interface AuthProtocolsCheckPasswordResponse {
  success: string;
}

export interface AuthProtocolsCreateClientViewAuthorizationRequest {
  /** @format int32 */
  client_id: number;
}

export interface AuthProtocolsCreateClientViewAuthorizationResponse {
  access_token: string;
  refresh_token: string;
}

export interface AuthProtocolsGetClientViewClientsResponse {
  client_list: AuthProtocolsGetClientViewClientsResponseClient[];
}

export interface AuthProtocolsGetClientViewClientsResponseClient {
  brand_name_list: string[];
  /** @format int32 */
  id: number;
  is_active: boolean;
  name: string;
}

export interface AuthProtocolsGetUserInfoResponse {
  /** @format int32 */
  client_id: number;
  client_name: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00"
   */
  created_date: string;
  custom_filter: boolean;
  customer_type: AuthProtocolsGetUserInfoResponseCustomerType;
  detected_tip: boolean;
  language: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  last_release_note_date?: string | null;
  limited_access_policy?: SettingsProtocolsLimitedAccessPolicy;
  logo_url?: string | null;
  piracy_info?: AuthProtocolsGetUserInfoResponsePiracyInfo;
  reporting_cap_client: boolean;
  role: MarqCommonEnumsClientClientRoleEnum;
  status: MarqCommonEnumsClientStatusEnum;
  transliteration: boolean;
  /** @format int32 */
  unpaid_count: number;
  use_cleanliness: boolean;
  use_custom_performance: boolean;
  use_cv_assistant: boolean;
  use_domain_name: boolean;
  use_ecommerce: boolean;
  use_gen_ai: boolean;
  use_impersonation_only: boolean;
  use_landscaping: boolean;
  use_map_monitoring: boolean;
  use_price_analytics: boolean;
  use_social_media: boolean;
  use_stand_alone: boolean;
  use_translate: MarqCommonEnumsTranslateStatusEnum;
  user_email: string;
  /** @format int32 */
  user_id: number;
}

export interface AuthProtocolsGetUserInfoResponseCustomerType {
  primary?: MarqCommonEnumsClientClientTypeEnum;
  secondary?: MarqCommonEnumsClientClientTypeEnum[] | null;
}

export interface AuthProtocolsGetUserInfoResponsePiracyInfo {
  confirm_need: boolean;
  google_confirm_need: boolean;
}

export interface AuthProtocolsLoginRequest {
  email: string;
  otp?: string | null;
  password: string;
  remember_me: boolean;
}

export interface AuthProtocolsLoginResponse {
  access_token?: string | null;
  mfa_status: MarqCommonEnumsAuthMfaStatusEnum;
  refresh_token?: string | null;
}

export interface AuthProtocolsLogoutRequest {
  access_token?: string | null;
}

export interface AuthProtocolsLogoutResponse {
  success: string;
}

export interface AuthProtocolsOktaLoginRequest {
  code: string;
  code_verifier: string;
  url: string;
}

export interface AuthProtocolsOktaLoginResponse {
  access_token: string;
  refresh_token: string;
}

export interface AuthProtocolsOktaLoginInfoRequest {
  app_domain: string;
}

export interface AuthProtocolsOktaLoginInfoResponse {
  auth_server: string;
  okta_client_id: string;
  redirect_uri: string;
}

export interface AuthProtocolsOktaRiotLoginRequest {
  access_token: string;
}

export interface AuthProtocolsOktaRiotLoginResponse {
  access_token: string;
  refresh_token: string;
}

export interface AuthProtocolsOktaSamlLoginRequest {
  auth_key: string;
}

export interface AuthProtocolsOktaSamlLoginResponse {
  access_token: string;
  refresh_token: string;
}

export interface AuthProtocolsRefreshTokenRequest {
  refresh_token: string;
}

export interface AuthProtocolsRefreshTokenResponse {
  access_token: string;
}

export interface AuthProtocolsRegisterOtpRequest {
  otp: string;
  uuid: string;
}

export interface AuthProtocolsResendVerificationEmailRequest {
  email: string;
  password: string;
}

export interface AuthProtocolsVerifyEmailRequest {
  uuid: string;
}

export interface AuthProtocolsVerifyEmailResponse {
  qr_code: string;
}

export interface AuthorizedSellerKeywordFilteringProtocolsAddKeywordsRequest {
  keywords: string[];
}

export interface AuthorizedSellerKeywordFilteringProtocolsAddKeywordsResponse {
  /** @format int32 */
  added_count: number;
}

export interface AuthorizedSellerKeywordFilteringProtocolsDeleteKeywordRequest {
  keyword_ids: number[];
}

export interface AuthorizedSellerKeywordFilteringProtocolsGetKeywordsKeyword {
  added_by: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  added_on: string;
  /** @format int32 */
  id: number;
  is_general_keyword: boolean;
  keyword: string;
}

export interface AuthorizedSellerKeywordFilteringProtocolsGetKeywordsRequest {
  sorted_column?: MarqCommonEnumsAuthorizedSellerKeywordSortedColumnEnum;
  sorted_order?: MarqCommonEnumsSortedOrderEnum;
}

export interface AuthorizedSellerKeywordFilteringProtocolsGetKeywordsResponse {
  keywords: AuthorizedSellerKeywordFilteringProtocolsGetKeywordsKeyword[];
}

export interface AuthorizedSellerProtocolsAddAuthorizedSellerRequest {
  add_url_list: string[];
}

export interface AuthorizedSellerProtocolsDeleteAuthorizedSellerRequest {
  id_list: number[];
}

export interface AuthorizedSellerProtocolsExportAuthorizedSellerRequest {
  domain_id_list?: number[] | null;
  id_list?: number[] | null;
  search?: string | null;
  sorted_column: MarqCommonEnumsAuthorizedSellerSortedColumnEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
}

export interface AuthorizedSellerProtocolsGetAllAuthorizedSellerIdListRequest {
  domain_id_list?: number[] | null;
  search?: string | null;
}

export interface AuthorizedSellerProtocolsGetAllAuthorizedSellerIdListResponse {
  id_list: number[];
}

export interface AuthorizedSellerProtocolsGetAuthorizedSellerCountRequest {
  domain_id_list?: number[] | null;
  search?: string | null;
}

export interface AuthorizedSellerProtocolsGetAuthorizedSellerCountResponse {
  /** @format int32 */
  total_count: number;
}

export interface AuthorizedSellerProtocolsGetAuthorizedSellerDetailAuthorizedSellerDetailResponse {
  country: MarqFoundationEnumsCountryCodeEnum;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  created_date: string;
  domain_name: string;
  listing_url?: string | null;
  /** @format int32 */
  seller_id: number;
  seller_name: string;
  seller_url?: string | null;
  shop_name: string;
}

export interface AuthorizedSellerProtocolsGetAuthorizedSellerDetailRequest {
  /** @format int32 */
  seller_id: number;
}

export interface AuthorizedSellerProtocolsGetAuthorizedSellerDetailResponse {
  data: AuthorizedSellerProtocolsGetAuthorizedSellerDetailAuthorizedSellerDetailResponse;
}

export interface AuthorizedSellerProtocolsGetAuthorizedSellerListAuthorizedSellerResponse {
  country: MarqFoundationEnumsCountryCodeEnum;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  created_date: string;
  domain_name: string;
  listing_url?: string | null;
  new: boolean;
  /** @format int32 */
  seller_id: number;
  seller_name: string;
  seller_url?: string | null;
  shop_name: string;
}

export interface AuthorizedSellerProtocolsGetAuthorizedSellerListRequest {
  domain_id_list?: number[] | null;
  /** @format int32 */
  limit: number;
  /** @format int32 */
  offset: number;
  search?: string | null;
  sorted_column: MarqCommonEnumsAuthorizedSellerSortedColumnEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
}

export interface AuthorizedSellerProtocolsGetAuthorizedSellerListResponse {
  seller_list: AuthorizedSellerProtocolsGetAuthorizedSellerListAuthorizedSellerResponse[];
}

export interface AuthorizedSellerProtocolsGetDomainFilterRequest {
  domain_id_list?: number[] | null;
  search?: string | null;
}

export interface AuthorizedSellerProtocolsGetDomainFilterResponse {
  domain_list: MarqBrandCoreModelProtocolCountryDomains[];
  /** @format int32 */
  total_count: number;
}

export interface AuthorizedWebsiteProtocolsAddAuthWebsiteRequest {
  add_url_list: string[];
}

export interface AuthorizedWebsiteProtocolsDeleteAuthWebsiteRequest {
  id_list: number[];
}

export interface AuthorizedWebsiteProtocolsExportAuthWebsiteRequest {
  id_list?: number[] | null;
  search: string;
  sorted_column: MarqCommonEnumsAuthorizedSellerSortedColumnEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
}

export interface AuthorizedWebsiteProtocolsGetAllAuthWebsiteIdListRequest {
  search?: string | null;
}

export interface AuthorizedWebsiteProtocolsGetAllAuthWebsiteIdListResponse {
  id_list: number[];
}

export interface AuthorizedWebsiteProtocolsGetAuthWebsiteCountRequest {
  search?: string | null;
}

export interface AuthorizedWebsiteProtocolsGetAuthWebsiteCountResponse {
  /** @format int32 */
  total_count: number;
}

export interface AuthorizedWebsiteProtocolsGetAuthWebsiteListRequest {
  /** @format int32 */
  limit: number;
  /** @format int32 */
  offset: number;
  search: string;
  sorted_column: MarqCommonEnumsAuthorizedSellerSortedColumnEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
}

export interface AuthorizedWebsiteProtocolsGetAuthWebsiteListResponse {
  list: AuthorizedWebsiteProtocolsGetAuthWebsiteListResponseAuthWebsiteResponse[];
}

export interface AuthorizedWebsiteProtocolsGetAuthWebsiteListResponseAuthWebsiteResponse {
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  created_date: string;
  domain_name: string;
  domain_url: string;
  /** @format int32 */
  id: number;
}

export interface CommonProtocolsGetCreditsResponse {
  /** @format int32 */
  remaining_credits: number;
  /** @format int32 */
  remaining_returned_credits: number;
  /** @format int32 */
  total_credits: number;
}

export interface CommonProtocolsGetDownloadUrlRequest {
  snapshot_url: string;
}

export interface CommonProtocolsGetDownloadUrlResponse {
  download_url: string;
}

export interface CommonProtocolsUpdateTranslateRequest {
  translate: MarqCommonEnumsTranslateStatusEnum;
}

export interface CopyrightedImageProtocolsCreateCollectionRequest {
  /** @format int32 */
  brand_id: number;
  collection_name: string;
}

export interface CopyrightedImageProtocolsCreateCollectionResponse {
  /** @format int32 */
  collection_id: number;
}

export interface CopyrightedImageProtocolsCreateCopyrightedImagesPresignedRequest {
  /** @format int32 */
  brand_id: number;
  /** @format int32 */
  collection_id?: number | null;
  image_file_url_list: CopyrightedImageProtocolsCreateCopyrightedImagesPresignedRequestImageFileUrlRequest[];
  note?: string | null;
  product_url?: string | null;
}

export interface CopyrightedImageProtocolsCreateCopyrightedImagesPresignedRequestImageFileUrlRequest {
  file_name: string;
  presigned_url: string;
}

export interface CopyrightedImageProtocolsDeleteCollectionRequest {
  /** @format int32 */
  collection_id: number;
}

export interface CopyrightedImageProtocolsDeleteCopyrightedImagesRequest {
  copyrighted_image_id_list: number[];
}

export interface CopyrightedImageProtocolsGetAllCopyrightedImagesRequest {
  /** @format int32 */
  brand_id?: number | null;
  collection_filter?: string[] | null;
  /** @format int32 */
  display_images?: number | null;
  /** @format int32 */
  limit: number;
  /** @format int32 */
  offset: number;
  search?: string | null;
  sorted_by?: MarqCommonEnumsCopyrightedImageCollectionSortedByEnum;
  sorted_order?: MarqCommonEnumsSortedOrderEnum;
}

export interface CopyrightedImageProtocolsGetAllCopyrightedImagesResponse {
  brand_list: CopyrightedImageProtocolsGetAllCopyrightedImagesResponseBrand[];
}

export interface CopyrightedImageProtocolsGetAllCopyrightedImagesResponseBrand {
  /** @format int32 */
  collection_count: number;
  collection_list: CopyrightedImageProtocolsGetAllCopyrightedImagesResponseCollection[];
  /** @format int32 */
  id: number;
  /** @format int32 */
  image_count: number;
  name: string;
}

export interface CopyrightedImageProtocolsGetAllCopyrightedImagesResponseCollection {
  copyrighted_image_list: CopyrightedImageProtocolsGetAllCopyrightedImagesResponseCopyrightedImage[];
  /** @format int32 */
  count: number;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  created_date: string;
  /** @format int32 */
  id: number;
  name: string;
}

export interface CopyrightedImageProtocolsGetAllCopyrightedImagesResponseCopyrightedImage {
  /** @format int32 */
  id: number;
  image_url?: string | null;
  image_vault_url?: string | null;
  name: string;
  note?: string | null;
  product_url: string;
}

export interface CopyrightedImageProtocolsGetCollectionDetailsRequest {
  /** @format int32 */
  brand_id: number;
  /** @format int32 */
  collection_id: number;
  /** @format int32 */
  limit: number;
  /** @format int32 */
  offset: number;
  search?: string | null;
  sorted_by?: MarqCommonEnumsCopyrightedImageSortedByEnum;
  sorted_order?: MarqCommonEnumsSortedOrderEnum;
}

export interface CopyrightedImageProtocolsGetCollectionDetailsResponse {
  collection: CopyrightedImageProtocolsGetCollectionDetailsResponseCollection;
}

export interface CopyrightedImageProtocolsGetCollectionDetailsResponseCollection {
  /** @format int32 */
  brand_id: number;
  brand_name: string;
  copyrighted_image_data: CopyrightedImageProtocolsGetCollectionDetailsResponseCollectionCopyrightedImage[];
  /** @format int32 */
  count: number;
  /** @format int32 */
  id: number;
  name: string;
}

export interface CopyrightedImageProtocolsGetCollectionDetailsResponseCollectionCopyrightedImage {
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  added_date: string;
  /** @format int32 */
  id: number;
  image_url?: string | null;
  image_vault_url?: string | null;
  name: string;
  note?: string | null;
  product_url: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  updated_date: string;
}

export interface CopyrightedImageProtocolsGetCollectionFilterRequest {
  /** @format int32 */
  brand_id?: number | null;
}

export interface CopyrightedImageProtocolsGetCollectionsRequest {
  /** @format int32 */
  brand_id: number;
}

export interface CopyrightedImageProtocolsGetCollectionsResponse {
  collection_list: CopyrightedImageProtocolsGetCollectionsResponseCollection[];
}

export interface CopyrightedImageProtocolsGetCollectionsResponseCollection {
  /** @format int32 */
  id: number;
  name: string;
}

export interface CopyrightedImageProtocolsGetCopyrightedImageDetailRequest {
  /** @format int32 */
  id: number;
}

export interface CopyrightedImageProtocolsGetCopyrightedImageDetailResponse {
  /** @format int32 */
  brand_id: number;
  /** @format int32 */
  collection_id: number;
  /** @format int32 */
  id: number;
  image_url?: string | null;
  image_vault_url?: string | null;
  name: string;
  note?: string | null;
  product_url: string;
}

export interface CopyrightedImageProtocolsGetCopyrightedImagePresignedUrlRequest {
  file_name: string;
}

export interface CopyrightedImageProtocolsGetCopyrightedImagePresignedUrlResponse {
  url: string;
}

export interface CopyrightedImageProtocolsUpdateCollectionRequest {
  /** @format int32 */
  collection_id: number;
  collection_name: string;
}

export interface CopyrightedImageProtocolsUpdateCopyrightedImageRequest {
  /** @format int32 */
  brand_id: number;
  /** @format int32 */
  collection_id?: number | null;
  /** @format int32 */
  id: number;
  name: string;
  note?: string | null;
  product_url?: string | null;
}

export interface EmailProtocolsRequestUpdateEmailRequest {
  email: string;
  password: string;
}

export interface EmailProtocolsUpdateEmailAddressRequest {
  token: string;
}

export interface EmployeeSignupProtocolsGetEmployeeDataWithTokenRequest {
  token: string;
}

export interface EmployeeSignupProtocolsGetEmployeeDataWithTokenResponse {
  client_currency: MarqFoundationEnumsCurrencyEnum;
  company?: string | null;
  country?: MarqFoundationEnumsCountryCodeEnum;
  email?: string | null;
  /** @format int32 */
  id: number;
  language?: string | null;
  role: MarqCommonEnumsClientClientRoleEnum;
}

export interface EmployeeSignupProtocolsUpdateRegisterRequest {
  email: string;
  first_name?: string | null;
  last_name?: string | null;
  password: string;
  token: string;
}

export interface EmployeeSignupProtocolsUpdateRegisterResponse {
  access_token?: string | null;
  refresh_token?: string | null;
}

export interface HomeProtocolsBrand {
  brand_name: string;
  /** @format int32 */
  id: number;
}

export interface HomeProtocolsFileIdNameAndUrl {
  filename: string;
  /** @format int32 */
  id?: number | null;
  url: string;
}

export interface HomeProtocolsFilenameAndUrl {
  filename: string;
  url: string;
}

export interface HomeProtocolsGetBrandAssetsResponse {
  list: HomeProtocolsGetBrandAssetsResponseBrandAssets[];
}

export interface HomeProtocolsGetBrandAssetsResponseBrandAssets {
  assets: HomeProtocolsGetBrandAssetsResponseBrandAssetsAsset[];
  /** @format int32 */
  brand_id: number;
  brand_name: string;
}

export interface HomeProtocolsGetBrandAssetsResponseBrandAssetsAsset {
  /** @format int32 */
  brand_id: number;
  brand_name: string;
  /** @format int32 */
  id: number;
  name: string;
}

export interface HomeProtocolsGetHomeResponse {
  name?: string | null;
  /** @format int32 */
  new_closed: number;
  performance_report?: HomeProtocolsGetHomeResponsePerfReportSection;
  register_payment_method: boolean;
  request_types: MarqCommonEnumsCrClientRequestTypeEnum[];
  to_do_list: HomeProtocolsGetHomeResponseToDoItem[];
}

export interface HomeProtocolsGetHomeResponsePerfReportSection {
  filename: string;
  is_new: boolean;
  s3url: string;
}

export interface HomeProtocolsGetHomeResponseToDoItem {
  detail: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  due_date?: string | null;
  file_type?: MarqCommonEnumsCrClientTaskFileTypeEnum;
  is_new: boolean;
  /** @format int32 */
  task_id: number;
  title: string;
  type: MarqCommonEnumsCrClientTaskTypeEnum;
  wrong_file_list: HomeProtocolsFileIdNameAndUrl[];
}

export interface HomeProtocolsGetTaskDetailRequest {
  /** @format int32 */
  id: number;
}

export interface HomeProtocolsGetTaskDetailResponse {
  /** @format int32 */
  id: number;
  list: HomeProtocolsGetTaskDetailResponseTypeAndDetail[];
  task_status: MarqCommonEnumsCrClientTaskStatusEnum;
}

export type HomeProtocolsGetTaskDetailResponseDetail =
  | HomeProtocolsGetTaskDetailResponseOpenDetail
  | HomeProtocolsGetTaskDetailResponseReOpenDetail
  | HomeProtocolsGetTaskDetailResponseReplyDetail;

export interface HomeProtocolsGetTaskDetailResponseOpenDetail {
  attached_template_list: HomeProtocolsFileIdNameAndUrl[];
  brand?: HomeProtocolsBrand;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  created_date: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  due_date: string;
  file_type: MarqCommonEnumsCrClientTaskFileTypeEnum;
  required_task: boolean;
  requirement: string;
  task_subtitle: string;
  task_title: string;
}

export interface HomeProtocolsGetTaskDetailResponseReOpenDetail {
  attached_template_list: HomeProtocolsFileIdNameAndUrl[];
  brand?: HomeProtocolsBrand;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  created_date: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  due_date: string;
  file_type: MarqCommonEnumsCrClientTaskFileTypeEnum;
  required_task: boolean;
  requirement: string;
  task_subtitle: string;
  task_title: string;
  wrong_file_list: HomeProtocolsFileIdNameAndUrl[];
}

export interface HomeProtocolsGetTaskDetailResponseReplyDetail {
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  created_date: string;
  file_list: HomeProtocolsFileIdNameAndUrl[];
}

export interface HomeProtocolsGetTaskDetailResponseTypeAndDetail {
  detail: HomeProtocolsGetTaskDetailResponseDetail;
  type: MarqCommonEnumsCrClientTaskMessageTypeEnum;
}

export interface HomeProtocolsTaskDismissRequest {
  /** @format int32 */
  id: number;
}

export interface HomeProtocolsTaskGetDownloadUrlRequest {
  /** @format int32 */
  file_id: number;
  /** @format int32 */
  task_id: number;
}

export interface HomeProtocolsTaskGetDownloadUrlResponse {
  url: string;
}

export interface HomeProtocolsTaskGetUploadUrlRequest {
  filename: string;
}

export interface HomeProtocolsTaskGetUploadUrlResponse {
  url: string;
}

export interface HomeProtocolsTaskSubmitRequest {
  /** @format int32 */
  id: number;
  list: HomeProtocolsFilenameAndUrl[];
}

export interface InfringingImageProtocolsCreateCollectionRequest {
  /** @format int32 */
  brand_id: number;
  collection_name: string;
}

export interface InfringingImageProtocolsCreateCollectionResponse {
  /** @format int32 */
  collection_id: number;
}

export interface InfringingImageProtocolsCreateInfringingImageLibraryByPresignedRequest {
  /** @format int32 */
  brand_id: number;
  /** @format int32 */
  collection_id?: number | null;
  image_file_url_list?: string[] | null;
}

export interface InfringingImageProtocolsDeleteCollectionRequest {
  /** @format int32 */
  collection_id: number;
}

export interface InfringingImageProtocolsGetAllCollectionsRequest {
  /** @format int32 */
  brand_id?: number | null;
}

export interface InfringingImageProtocolsGetAllCollectionsResponse {
  brand_collection: InfringingImageProtocolsGetAllCollectionsResponseIpPortfolioCollection[];
}

export interface InfringingImageProtocolsGetAllCollectionsResponseCollectionData {
  /** @format int32 */
  id: number;
  name: string;
}

export interface InfringingImageProtocolsGetAllCollectionsResponseIpPortfolioCollection {
  brand: InfringingImageProtocolsGetAllCollectionsResponseIpPortfolioData;
  collection_tree: InfringingImageProtocolsGetAllCollectionsResponseCollectionData[];
}

export interface InfringingImageProtocolsGetAllCollectionsResponseIpPortfolioData {
  /** @format int32 */
  id: number;
  name: string;
}

export interface InfringingImageProtocolsGetAllInfringingImagesRequest {
  /** @format int32 */
  brand_id?: number | null;
}

export interface InfringingImageProtocolsGetAllInfringingImagesResponse {
  brands: InfringingImageProtocolsGetAllInfringingImagesResponseBrandImage[];
}

export interface InfringingImageProtocolsGetAllInfringingImagesResponseBrandImage {
  /** @format int32 */
  brand_id: number;
  brand_name: string;
  collections: InfringingImageProtocolsGetAllInfringingImagesResponseBrandImageImageByCollection[];
}

export interface InfringingImageProtocolsGetAllInfringingImagesResponseBrandImageImageByCollection {
  /** @format int32 */
  collection_id?: number | null;
  collection_name?: string | null;
  images: MarqBrandCoreModelResponseIdWithUrl[];
}

export interface InfringingImageProtocolsGetCollectionDetailRequest {
  /** @format int32 */
  brand_id: number;
  /** @format int32 */
  collection_id?: number | null;
  /** @format int32 */
  limit: number;
  /** @format int32 */
  offset: number;
}

export interface InfringingImageProtocolsGetCollectionDetailResponse {
  collection_data: InfringingImageProtocolsGetCollectionDetailResponseCollectionData;
}

export interface InfringingImageProtocolsGetCollectionDetailResponseCollectionData {
  /** @format int32 */
  count: number;
  /** @format int32 */
  id?: number | null;
  infringing_images: InfringingImageProtocolsGetCollectionDetailResponseInfringingImage[];
  name: string;
}

export interface InfringingImageProtocolsGetCollectionDetailResponseInfringingImage {
  /** @format int32 */
  id: number;
  url?: string | null;
}

export interface InfringingImageProtocolsGetImageCountByBrandResponse {
  brands: InfringingImageProtocolsGetImageCountByBrandResponseBrand[];
}

export interface InfringingImageProtocolsGetImageCountByBrandResponseBrand {
  /** @format int32 */
  brand_id: number;
  brand_name: string;
  /** @format int32 */
  count: number;
}

export interface InfringingImageProtocolsGetInfringingImagePresignedUrlRequest {
  /** @format int32 */
  brand_id: number;
  /** @format int32 */
  collection_id?: number | null;
  file_name: string;
}

export interface InfringingImageProtocolsGetInfringingImagePresignedUrlResponse {
  url: string;
}

export interface InfringingImageProtocolsUpdateCollectionRequest {
  /** @format int32 */
  collection_id: number;
  collection_name: string;
}

export interface InfringingImageProtocolsUpdateInfringingImageLibraryByPresignedRequest {
  /** @format int32 */
  brand_id: number;
  /** @format int32 */
  collection_id?: number | null;
  delete_file_id_list?: number[] | null;
  image_file_url_list: string[];
}

export interface LSettingsProtocolsDeleteEmployeeRequest {
  /** @format int32 */
  employee_id: number;
}

export interface LSettingsProtocolsRequestInvitationEmailRequest {
  email: string;
}

export interface LSettingsProtocolsSendInvitationRequest {
  invitation_data: LSettingsProtocolsSendInvitationRequestInvitation[];
}

export interface LSettingsProtocolsSendInvitationRequestInvitation {
  email: string;
  limited_access_policy?: SettingsProtocolsLimitedAccessPolicy;
  role: MarqCommonEnumsClientClientRoleEnum;
}

export interface LSettingsProtocolsUpdateEmployeeRoleRequest {
  /** @format int32 */
  id: number;
  limited_access_policy?: SettingsProtocolsLimitedAccessPolicy;
  role: MarqCommonEnumsClientClientRoleEnum;
}

export interface ListingCommentProtocolsComment {
  attachments: ListingCommentProtocolsCommentAttachment[];
  content?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  created_at: string;
  deleted: boolean;
  email: string;
  /** @format int32 */
  id: number;
  is_admin: boolean;
  /** @format int32 */
  reply_count?: number | null;
}

export interface ListingCommentProtocolsCommentAttachment {
  file_name: string;
  /** @format int32 */
  id?: number | null;
  url: string;
}

export interface ListingCommentProtocolsCreateRequest {
  comment: ListingCommentProtocolsCreateRequestCreateComment;
  listing_id_list: number[];
  /** @format int32 */
  parent_comment_id?: number | null;
}

export interface ListingCommentProtocolsCreateRequestCreateComment {
  attachments: ListingCommentProtocolsCommentAttachment[];
  content: string;
}

export interface ListingCommentProtocolsDeleteRequest {
  /** @format int32 */
  comment_id: number;
  /** @format int32 */
  listing_id: number;
}

export interface ListingCommentProtocolsGetChildListRequest {
  /** @format int32 */
  listing_id: number;
  /** @format int32 */
  parent_id: number;
}

export interface ListingCommentProtocolsGetChildListResponse {
  list: ListingCommentProtocolsComment[];
}

export interface ListingCommentProtocolsGetParentListRequest {
  /** @format int32 */
  listing_id: number;
}

export interface ListingCommentProtocolsGetParentListResponse {
  list: ListingCommentProtocolsComment[];
}

export interface ListingCommentProtocolsUploadAttachmentRequest {
  file_names: string[];
}

export interface ListingCommentProtocolsUploadAttachmentResponse {
  attachments: ListingCommentProtocolsCommentAttachment[];
}

export interface OfficialImageWebProtocolsBrand {
  copyright_footer?: string | null;
  logo_url?: string | null;
  official_images: OfficialImageWebProtocolsOfficialImage[];
}

export interface OfficialImageWebProtocolsGetBrandHomeResponse {
  brands: OfficialImageWebProtocolsBrand[];
  client_name: string;
}

export interface OfficialImageWebProtocolsGetClientHomeResponse {
  brands: OfficialImageWebProtocolsBrand[];
  client_name: string;
}

export interface OfficialImageWebProtocolsGetOfficialImageResponse {
  client_name: string;
  copyright_footer?: string | null;
  logo_url?: string | null;
  note?: string | null;
  oi_url?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00"
   */
  published_date: string;
}

export interface OfficialImageWebProtocolsOfficialImage {
  detail_url: string;
  image_url: string;
}

export interface PasswordProtocolsChangePasswordRequest {
  password: string;
}

export interface PasswordProtocolsFindPasswordRequest {
  email: string;
}

export interface PasswordProtocolsResetPasswordRequest {
  password: string;
  token: string;
}

export interface SellerIntelligenceProtocolsGetClusterDetailsCountriesRequest {
  /** @format int32 */
  cluster_id: number;
  /** @format int32 */
  master_id: number;
  sort_by: MarqCommonEnumsSellerintelSellerIntelDetailsCountriesSortBy;
}

export interface SellerIntelligenceProtocolsGetClusterDetailsCountriesResponse {
  country_list: MarqBrandDataModelSellerCountryWithCountDataListCountryWithCountData[];
}

export interface SellerIntelligenceProtocolsGetClusterDetailsMarketplacesRequest {
  /** @format int32 */
  cluster_id: number;
  /** @format int32 */
  master_id: number;
  sort_by: MarqCommonEnumsSellerintelSellerIntelDetailsDomainsSortBy;
}

export interface SellerIntelligenceProtocolsGetClusterDetailsMarketplacesResponse {
  marketplace_list: MarqBrandDataModelSellerMarketplaceWithCountDataListMarketplaceWithCountData[];
}

export interface SellerIntelligenceProtocolsGetClusterDetailsSellersRequest {
  /** @format int32 */
  cluster_id: number;
  /** @format int32 */
  master_id: number;
  sort_by: MarqCommonEnumsSellerintelSellerIntelDetailsSellersSortBy;
}

export interface SellerIntelligenceProtocolsGetClusterDetailsSellersResponse {
  seller_list: MarqBrandDataModelSellerSellerWithCountDataListSellerWithCountData[];
}

export interface SellerIntelligenceProtocolsGetClusterDetailsSellersDataRequest {
  /** @format int32 */
  cluster_id: number;
  /** @format int32 */
  limit: number;
  /** @format int32 */
  master_id: number;
  /** @format int32 */
  offset: number;
  sort_by?: MarqCommonEnumsSellerintelSellerClusterDataSortByEnum;
}

export interface SellerIntelligenceProtocolsGetClusterDetailsSellersDataResponse {
  seller_data_list: MarqBrandDataModelSellerClusterAnalysisSellerDataSellerData[];
}

export interface SellerIntelligenceProtocolsGetClusterDetailsSummaryRequest {
  /** @format int32 */
  cluster_id: number;
  /** @format int32 */
  master_id: number;
  status?: MarqCommonEnumsSellerintelSellerClusterStatusEnum;
}

export interface SellerIntelligenceProtocolsGetClusterDetailsSummaryResponse {
  action: MarqBrandDataModelSellerClusterDetailsSummaryAction;
  clustering: MarqBrandDataModelSellerClusterDetailsSummaryClustering;
  most_used_info?: MarqBrandDataModelSellerClusterDetailsSummaryMostUsedInfo;
  processing: MarqBrandDataModelSellerClusterDetailsSummaryProcessing;
}

export interface SellerIntelligenceProtocolsGetClusterMasterStatusResponse {
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  last_updated: string;
  /** @format int32 */
  master_id: number;
  status: MarqCommonEnumsSellerintelSellerClusterStatusEnum;
}

export interface SellerIntelligenceProtocolsGetClustersSideViewTypeARequest {
  mapping_level: MarqCommonEnumsSellerintelSellerIntelMappingLevel;
  /** @format int32 */
  offset?: number | null;
  sort_by: MarqCommonEnumsSellerintelSellerIntelClusterSortBy;
}

export interface SellerIntelligenceProtocolsGetClustersSideViewTypeAResponse {
  cluster_list: MarqBrandDataModelSellerClusterSideInfo[];
}

export interface SellerIntelligenceProtocolsGetClustersSideViewTypeBRequest {
  /** @format int32 */
  offset?: number | null;
  product_desc: boolean;
  product_title: boolean;
  sort_by: MarqCommonEnumsSellerintelSellerIntelClusterSortBy;
}

export interface SellerIntelligenceProtocolsGetClustersSideViewTypeBResponse {
  cluster_list: MarqBrandDataModelSellerClusterSideInfo[];
}

export interface SellerIntelligenceProtocolsGetExportDataRequest {
  /** @format int32 */
  cluster_id: number;
  /** @format int32 */
  master_id: number;
}

export interface SellerIntelligenceProtocolsGetTypeAClusterByIdRequest {
  /** @format int32 */
  cluster_id: number;
  mapping_level: MarqCommonEnumsSellerintelSellerIntelMappingLevel;
}

export interface SellerIntelligenceProtocolsGetTypeAClusterByIdResponse {
  cluster: MarqBrandDataModelSellerCluster;
}

export interface SellerIntelligenceProtocolsGetTypeBClusterByIdRequest {
  /** @format int32 */
  cluster_id: number;
  product_desc: boolean;
  product_title: boolean;
}

export interface SellerIntelligenceProtocolsGetTypeBClusterByIdResponse {
  cluster: MarqBrandDataModelSellerCluster;
}

export interface SettingsProtocolsGetClientActiveCountriesResponse {
  countries: SettingsProtocolsLimitedAccessPolicyCountry[];
}

export interface SettingsProtocolsGetEmployeeListResponse {
  employee_list: SettingsProtocolsGetEmployeeListResponseEmployee[];
}

export interface SettingsProtocolsGetEmployeeListResponseEmployee {
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  created_date?: string | null;
  email?: string | null;
  first_name?: string | null;
  has_signed_up: boolean;
  /** @format int32 */
  id: number;
  last_name?: string | null;
  limited_access_policy?: SettingsProtocolsLimitedAccessPolicy;
  /** @format int32 */
  order: number;
  role: MarqCommonEnumsClientClientRoleEnum;
}

export interface SettingsProtocolsGetProfileResponse {
  client_currency: MarqFoundationEnumsCurrencyEnum;
  company_address?: string | null;
  company_name?: string | null;
  country?: MarqFoundationEnumsCountryCodeEnum;
  email: string;
  first_name?: string | null;
  /** @format int32 */
  id: number;
  last_name?: string | null;
  limited_access_policy?: SettingsProtocolsLimitedAccessPolicy;
  logo_url?: string | null;
  use_official_image_hosting: boolean;
  website?: string | null;
}

export interface SettingsProtocolsGetUploadUrlRequest {
  file_name: string;
}

export interface SettingsProtocolsGetUploadUrlResponse {
  url: string;
}

export interface SettingsProtocolsLimitedAccessPolicy {
  brands?: SettingsProtocolsLimitedAccessPolicyBrand[] | null;
  countries?: SettingsProtocolsLimitedAccessPolicyCountry[] | null;
  has_all_brand_access?: boolean | null;
  has_all_country_access?: boolean | null;
  has_readonly_access?: boolean | null;
  pages?: MarqCommonEnumsClientEmployeeAccessPageEnum[] | null;
  piracy_assets?: SettingsProtocolsLimitedAccessPolicyPiracyAsset[] | null;
}

export interface SettingsProtocolsLimitedAccessPolicyBrand {
  /** @format int32 */
  id: number;
  name?: string | null;
}

export interface SettingsProtocolsLimitedAccessPolicyCountry {
  code: string;
  name?: string | null;
}

export interface SettingsProtocolsUpdateCompanyInfoRequest {
  company_address?: string | null;
  company_name?: string | null;
  country?: MarqFoundationEnumsCountryCodeEnum;
  logo_url?: string | null;
  website?: string | null;
}

export interface AssetPiracyAssetPiracyProtocolsCreateAssetRequest {
  keywords?: string | null;
  name: string;
  official_url?: string | null;
  product_type: PiracyCommonEnumsProductTypeEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  release_day?: string | null;
  thumbnail_url: string;
}

export interface AssetPiracyAssetPiracyProtocolsDeleteAssetRequest {
  /** @format int32 */
  asset_id: number;
}

export interface AssetPiracyAssetPiracyProtocolsGetAllAssetListResponse {
  assets: AssetPiracyAssetPiracyProtocolsGetAllAssetListResponseAsset[];
}

export interface AssetPiracyAssetPiracyProtocolsGetAllAssetListResponseAsset {
  /** @format int32 */
  id: number;
  name: string;
}

export interface AssetPiracyAssetPiracyProtocolsGetAssetRequest {
  /** @format int32 */
  id: number;
}

export interface AssetPiracyAssetPiracyProtocolsGetAssetResponse {
  /** @format int32 */
  id: number;
  images: string[];
  keywords: string[];
  name: string;
  official_url?: string | null;
  product_type: PiracyCommonEnumsProductTypeEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  release_day?: string | null;
}

export interface AssetPiracyAssetPiracyProtocolsGetAssetImagesResponse {
  images: string[];
}

export interface AssetPiracyAssetPiracyProtocolsGetAssetListRequest {
  /** @format int32 */
  limit: number;
  /** @format int32 */
  offset: number;
}

export interface AssetPiracyAssetPiracyProtocolsGetAssetListResponse {
  assets: AssetPiracyAssetPiracyProtocolsGetAssetListResponseAsset[];
}

export interface AssetPiracyAssetPiracyProtocolsGetAssetListResponseAsset {
  /** @format int32 */
  id: number;
  images: string[];
  name: string;
  official_url?: string | null;
  product_type: PiracyCommonEnumsProductTypeEnum;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00"
   */
  updated_date: string;
}

export interface AssetPiracyAssetPiracyProtocolsGetPresignedUrlResponse {
  url: string;
}

export interface AssetPiracyAssetPiracyProtocolsUpdateAssetRequest {
  /** @format int32 */
  id: number;
  keywords?: string | null;
  name: string;
  official_url: string;
  product_type: PiracyCommonEnumsProductTypeEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  release_day?: string | null;
}

export interface AuthorizedPiracyAuthorizedListPiracyProtocolsAddAuthorizedListRequest {
  add_url_list: string[];
  platform_group: PiracyCommonEnumsPerfPerfChannelGroupEnum;
}

export interface AuthorizedPiracyAuthorizedListPiracyProtocolsDeleteAuthorizedListRequest {
  id_list: number[];
  platform_group: PiracyCommonEnumsPerfPerfChannelGroupEnum;
}

export interface AuthorizedPiracyAuthorizedListPiracyProtocolsExportAuthorizedListRequest {
  id_list?: number[] | null;
  platform_group: PiracyCommonEnumsPerfPerfChannelGroupEnum;
  platform_list?: PiracyCommonEnumsChannelEnum[] | null;
  search?: string | null;
  sorted_column: PiracyCommonEnumsAuthorizedListSortedColumnEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
}

export interface AuthorizedPiracyAuthorizedListPiracyProtocolsGetAllAuthorizedListIdListRequest {
  platform_group: PiracyCommonEnumsPerfPerfChannelGroupEnum;
  platform_list?: PiracyCommonEnumsChannelEnum[] | null;
  search?: string | null;
}

export interface AuthorizedPiracyAuthorizedListPiracyProtocolsGetAllAuthorizedListIdListResponse {
  id_list: number[];
}

export interface AuthorizedPiracyAuthorizedListPiracyProtocolsGetAuthorizedListAuthorizedListResponse {
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  created_date: string;
  /** @format int32 */
  id: number;
  name: string;
  platform_name?: string | null;
  profile_url?: string | null;
}

export interface AuthorizedPiracyAuthorizedListPiracyProtocolsGetAuthorizedListRequest {
  /** @format int32 */
  limit: number;
  /** @format int32 */
  offset: number;
  platform_group: PiracyCommonEnumsPerfPerfChannelGroupEnum;
  platform_list?: PiracyCommonEnumsChannelEnum[] | null;
  search?: string | null;
  sorted_column: PiracyCommonEnumsAuthorizedListSortedColumnEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
}

export interface AuthorizedPiracyAuthorizedListPiracyProtocolsGetAuthorizedListResponse {
  profile_list: AuthorizedPiracyAuthorizedListPiracyProtocolsGetAuthorizedListAuthorizedListResponse[];
}

export interface AuthorizedPiracyAuthorizedListPiracyProtocolsGetAuthorizedListCountRequest {
  platform_group: PiracyCommonEnumsPerfPerfChannelGroupEnum;
  platform_list?: PiracyCommonEnumsChannelEnum[] | null;
  search?: string | null;
}

export interface AuthorizedPiracyAuthorizedListPiracyProtocolsGetAuthorizedListCountResponse {
  /** @format int32 */
  total_count: number;
}

export interface AuthorizedPiracyAuthorizedListPiracyProtocolsGetPlatformFilterRequest {
  platform_group: PiracyCommonEnumsPerfPerfChannelGroupEnum;
  search?: string | null;
}

export interface AuthorizedPiracyAuthorizedListPiracyProtocolsGetPlatformFilterResponse {
  platform_list: PiracyCommonEnumsChannelEnum[];
  /** @format int32 */
  total_count: number;
}

export interface CrCrProtocolsCreateCrRequest {
  /** @format int32 */
  asset_id?: number | null;
  attachment_list?: CrCrProtocolsCreateCrRequestAttachment[] | null;
  /** @format int32 */
  brand_id: number;
  detail?: string | null;
  title?: string | null;
  type: MarqCommonEnumsCrClientRequestTypeEnum;
  url_additional_info?: CrCrProtocolsCreateCrRequestUrlAdditionalInfo;
}

export interface CrCrProtocolsCreateCrRequestAttachment {
  file_name: string;
  url: string;
}

export interface CrCrProtocolsCreateCrRequestUrlAdditionalInfo {
  channel: MarqCommonEnumsCrClientRequestChannelTypeEnum;
  enforcement_type: MarqCommonEnumsCrClientRequestEnforcementTypeEnum;
  url_list: string[];
}

export interface CrCrProtocolsCreateCrResponse {
  /** @format int32 */
  id: number;
  /** @format int32 */
  url_count?: number | null;
}

export interface CrCrProtocolsGetCrDetailRequest {
  /** @format int32 */
  seq: number;
}

export interface CrCrProtocolsGetCrDetailResponse {
  brand_name: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  closed_date?: string | null;
  email?: string | null;
  reply?: CrCrProtocolsGetCrDetailResponseContent;
  request: CrCrProtocolsGetCrDetailResponseContent;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  requested_date: string;
  type: MarqCommonEnumsCrClientRequestTypeEnum;
  url_additional_info?: CrCrProtocolsGetCrDetailResponseUrlAdditionalInfo;
}

export interface CrCrProtocolsGetCrDetailResponseAttachment {
  file_name: string;
  url: string;
}

export interface CrCrProtocolsGetCrDetailResponseContent {
  attachment_list?: CrCrProtocolsGetCrDetailResponseAttachment[] | null;
  detail?: string | null;
  title: string;
}

export interface CrCrProtocolsGetCrDetailResponseUrlAdditionalInfo {
  channel: MarqCommonEnumsCrClientRequestChannelTypeEnum;
  /** @format int32 */
  completed: number;
  enforcement_type: MarqCommonEnumsCrClientRequestEnforcementTypeEnum;
  /** @format int32 */
  failed: number;
  /** @format int32 */
  in_progress: number;
  /** @format int32 */
  total: number;
  url_list: CrCrProtocolsGetCrDetailResponseUrlAdditionalInfoUrl[];
}

export interface CrCrProtocolsGetCrDetailResponseUrlAdditionalInfoUrl {
  current_status: MarqCommonEnumsCrCrUrlProgressStatusEnum;
  /** @format int32 */
  item_id?: number | null;
  progress: CrCrProtocolsGetCrDetailResponseUrlAdditionalInfoUrlProgress;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  updated_date?: string | null;
  url: string;
}

export interface CrCrProtocolsGetCrDetailResponseUrlAdditionalInfoUrlProgress {
  detail?: string | null;
  status: MarqCommonEnumsCrCrUrlStatusEnum;
}

export interface CrCrProtocolsGetCrListRequest {
  /** @format int32 */
  brand_id?: number | null;
  /** @format int32 */
  limit?: number | null;
  /** @format int32 */
  offset?: number | null;
  /** @format int32 */
  page?: number | null;
  status: MarqCommonEnumsCrClientRequestStatusEnum;
}

export interface CrCrProtocolsGetCrListResponse {
  cr_list: CrCrProtocolsGetCrListResponseCr[];
  /** @format int32 */
  total_count: number;
}

export interface CrCrProtocolsGetCrListResponseCr {
  brand_name: string;
  channel: MarqCommonEnumsCrClientRequestChannelTypeEnum;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  closed_date?: string | null;
  enforcement_type?: MarqCommonEnumsCrClientRequestEnforcementTypeEnum;
  is_new: boolean;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  requested_date: string;
  /** @format int32 */
  seq: number;
  title: string;
  type: MarqCommonEnumsCrClientRequestTypeEnum;
}

export interface CvassistantCvAssistantProtocolsAuthorizeSellersRequest {
  cv_assistant_id_list: number[];
}

export interface CvassistantCvAssistantProtocolsAuthorizeSellersResponse {
  success: boolean;
}

export interface CvassistantCvAssistantProtocolsDismissSellersRequest {
  cv_assistant_id_list: number[];
}

export interface CvassistantCvAssistantProtocolsDismissSellersResponse {
  success: boolean;
}

export interface CvassistantCvAssistantProtocolsEngageSellersRequest {
  cv_assistant_id_list: number[];
}

export interface CvassistantCvAssistantProtocolsEngageSellersResponse {
  success: boolean;
}

export interface CvassistantCvAssistantProtocolsExcelExportRequest {
  domain_id_filter?: number[] | null;
  logo_detection_filter?: boolean | null;
  result_filter?: MarqCommonEnumsCvassistantCvAssistantResultEnum[] | null;
  search?: string | null;
  sorted_column: MarqBrandEnumsCvassistantCvAssistantSortedColumnEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
  tab: MarqBrandEnumsCvassistantCvAssistantTabEnum;
}

export interface CvassistantCvAssistantProtocolsExcelExportResponse {
  /** @format int32 */
  progress_id: number;
}

export interface CvassistantCvAssistantProtocolsExcelExportBySellerIdRequest {
  cv_assistant_id_list: number[];
  tab: MarqBrandEnumsCvassistantCvAssistantTabEnum;
}

export interface CvassistantCvAssistantProtocolsFileInfoListResponse {
  list: MarqBrandCoreModelCvassistantCvAssistantFileInfo[];
}

export interface CvassistantCvAssistantProtocolsGetChatAsExcelRequest {
  cv_assistant_id_list: number[];
}

export interface CvassistantCvAssistantProtocolsGetChatAsSnapshotRequest {
  cv_assistant_id_list: number[];
}

export interface CvassistantCvAssistantProtocolsGetDetectedListingDetailsRequest {
  /** @format int32 */
  cv_assistant_id: number;
  /** @format int32 */
  listing_id: number;
}

export interface CvassistantCvAssistantProtocolsGetDetectedListingDetailsResponse {
  asset_name: string;
  description: MarqBrandCoreModelListingTextWithDetection;
  description_translate?: MarqBrandCoreModelListingTextWithDetection;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00"
   */
  detected_date: string;
  featured: boolean;
  image_list: MarqBrandDataModelListingImageWithFlagsClient[];
  keyword_list: string[];
  /** @format int32 */
  like_count?: number | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00"
   */
  listed_date?: string | null;
  /** @format int32 */
  listing_id: number;
  listing_url: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00"
   */
  scanned_date: string;
  tag_list: MarqCommonEnumsAiClientTagEnum[];
  translated_keyword_list: MarqBrandCoreModelResponseTranslateResponse[];
}

export interface CvassistantCvAssistantProtocolsGetFilterInfoResultRequest {
  domain_id_filter?: number[] | null;
  logo_detection_filter?: boolean | null;
  result_filter?: MarqCommonEnumsCvassistantCvAssistantResultEnum[] | null;
  search?: string | null;
  tab: MarqBrandEnumsCvassistantCvAssistantTabEnum;
}

export interface CvassistantCvAssistantProtocolsGetFilterInfoResultResponse {
  list: MarqBrandCoreModelCvassistantCvAssistantResultFilterItem[];
}

export interface CvassistantCvAssistantProtocolsGetSellerCountRequest {
  domain_id_filter?: number[] | null;
  logo_detection_filter?: boolean | null;
  result_filter?: MarqCommonEnumsCvassistantCvAssistantResultEnum[] | null;
  search?: string | null;
  tab: MarqBrandEnumsCvassistantCvAssistantTabEnum;
}

export interface CvassistantCvAssistantProtocolsGetSellerCountResponse {
  /** @format int32 */
  count: number;
}

export interface CvassistantCvAssistantProtocolsGetSellerDetailsRequest {
  /** @format int32 */
  cv_assistant_id: number;
}

export interface CvassistantCvAssistantProtocolsGetSellerDetailsResponse {
  cv_result?: MarqBrandCoreModelCvassistantCvResult;
  detected_listing_list: MarqBrandCoreModelCvassistantCvAssistantDetectedListing[];
  featured_product: MarqBrandCoreModelCvassistantCvAssistantListingDetails;
  seller_details: MarqBrandCoreModelCvassistantCvAssistantSellerDetails;
}

export interface CvassistantCvAssistantProtocolsGetSellerListRequest {
  domain_id_filter?: number[] | null;
  /** @format int32 */
  limit: number;
  logo_detection_filter?: boolean | null;
  /** @format int32 */
  offset: number;
  result_filter?: MarqCommonEnumsCvassistantCvAssistantResultEnum[] | null;
  search?: string | null;
  sorted_column: MarqBrandEnumsCvassistantCvAssistantSortedColumnEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
  tab: MarqBrandEnumsCvassistantCvAssistantTabEnum;
}

export interface CvassistantCvAssistantProtocolsGetSellerListResponse {
  list: MarqBrandCoreModelCvassistantCvAssistantSeller[];
}

export interface ExcelExcelProtocolsCancelExcelExportRequest {
  /** @format int32 */
  id: number;
}

export interface ExcelExcelProtocolsExportExcelByWebsiteIdsRequest {
  website_id_list?: number[] | null;
}

export interface ExcelExcelProtocolsGetExcelResultRequest {
  /** @format int32 */
  id: number;
}

export interface ExcelExcelProtocolsGetExcelResultResponse {
  completed: boolean;
  /** @format int32 */
  progress: number;
  url?: string | null;
}

export interface HomePiracyHomePiracyProtocolsAddNewRequestRequest {
  attachments: PiracyCommonModelAttachment[];
  cr_type: PiracyCommonEnumsCrCRTypeEnum;
  details: string;
  urls?: string[] | null;
}

export interface HomePiracyHomePiracyProtocolsGetCrDetailsRequest {
  /** @format int32 */
  db_id: number;
}

export interface HomePiracyHomePiracyProtocolsGetCrDetailsResponse {
  admin_attachments: PiracyCommonModelAttachment[];
  admin_response?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  admin_updated_date?: string | null;
  attachments: PiracyCommonModelAttachment[];
  /** @format int32 */
  client_cr_id: number;
  cr_status: PiracyCommonEnumsCrCRStatusEnum;
  cr_type: PiracyCommonEnumsCrCRTypeEnum;
  /** @format int32 */
  db_id: number;
  details: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  requested_date: string;
  urls: string[];
}

export interface HomePiracyHomePiracyProtocolsGetCrHasNewBadgeResponse {
  cr_has_new: boolean;
}

export interface HomePiracyHomePiracyProtocolsGetCrListRequest {
  cr_status_list: PiracyCommonEnumsCrCRStatusEnum[];
  cr_type?: PiracyCommonEnumsCrCRTypeEnum;
  /** @format int32 */
  limit: number;
  /** @format int32 */
  offset: number;
}

export interface HomePiracyHomePiracyProtocolsGetCrListResponse {
  cr_list: HomePiracyHomePiracyProtocolsGetCrListResponseCR[];
}

export interface HomePiracyHomePiracyProtocolsGetCrListResponseCR {
  attachments: PiracyCommonModelAttachment[];
  /** @format int32 */
  client_cr_id: number;
  cr_status: PiracyCommonEnumsCrCRStatusEnum;
  cr_type: PiracyCommonEnumsCrCRTypeEnum;
  /** @format int32 */
  db_id: number;
  details: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  requested_date: string;
  show_new_badge: boolean;
  urls: string[];
}

export interface HomePiracyHomePiracyProtocolsGetCrListCountRequest {
  cr_status_list: PiracyCommonEnumsCrCRStatusEnum[];
  cr_type?: PiracyCommonEnumsCrCRTypeEnum;
}

export interface HomePiracyHomePiracyProtocolsGetCrListCountResponse {
  /** @format int32 */
  cr_count: number;
}

export interface HomePiracyHomePiracyProtocolsGetUploadUrlRequest {
  file_name: string;
}

export interface HomePiracyHomePiracyProtocolsGetUploadUrlResponse {
  url: string;
}

export interface HomePiracyHomePiracyProtocolsReportGetListResponse {
  list: HomePiracyHomePiracyProtocolsReportGetListResponseReport[];
}

export interface HomePiracyHomePiracyProtocolsReportGetListResponseReport {
  filename: string;
  /** @format int32 */
  id: number;
  is_new: boolean;
  s3url: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  uploaded_date: string;
}

export interface IoKtorHttpContentType {
  content_subtype: string;
  content_type: string;
  parameters: IoKtorHttpHeaderValueParam[];
}

export interface IoKtorHttpHeaderValueParam {
  name: string;
  value: string;
}

export type KotlinAny = unknown;

export interface ListingsListingsProtocolsAddAuthorizedRequest {
  listing_id_list: number[];
}

export interface ListingsListingsProtocolsApplyCustomTagRequest {
  add_custom_tag_id_list?: number[] | null;
  delete_custom_tag_id_list?: number[] | null;
  listing_id_list: number[];
}

export interface ListingsListingsProtocolsComment {
  attachment_list?: ListingsListingsProtocolsCommentDocument[] | null;
  content: string;
}

export interface ListingsListingsProtocolsCommentDocument {
  filename: string;
  url: string;
}

export interface ListingsListingsProtocolsDeleteAllCustomTagRequest {
  listing_id_list: number[];
}

export interface ListingsListingsProtocolsDoEnforcementRequest {
  comment?: ListingsListingsProtocolsComment;
  listing_id_list: number[];
}

export interface ListingsListingsProtocolsDoEnforcementResponse {
  /** @format int32 */
  affected: number;
  listing_image_list?: string[] | null;
  listing_title?: string | null;
  /** @format int32 */
  potential_authorized_count: number;
  /** @format int32 */
  request_id?: number | null;
  success: boolean;
}

export interface ListingsListingsProtocolsDoEnforcementByListingOptionsRequest {
  comment?: ListingsListingsProtocolsComment;
  listing_option_id_list: number[];
}

export interface ListingsListingsProtocolsDoEnforcementByListingOptionsResponse {
  /** @format int32 */
  affected: number;
  listing_image_list?: string[] | null;
  listing_title?: string | null;
  /** @format int32 */
  potential_authorized_count: number;
  /** @format int32 */
  request_id?: number | null;
  success: boolean;
}

export interface ListingsListingsProtocolsDoEnforcementBySellerRequest {
  cluster_id_list?: number[] | null;
  comment?: ListingsListingsProtocolsComment;
  string_seller_id_list?: string[] | null;
}

export interface ListingsListingsProtocolsDoEnforcementBySellerResponse {
  /** @format int32 */
  affected: number;
  listing_image_list?: string[] | null;
  listing_title?: string | null;
  /** @format int32 */
  potential_authorized_count: number;
  /** @format int32 */
  request_id?: number | null;
  /** @format int32 */
  requested_count: number;
  success: boolean;
}

export interface ListingsListingsProtocolsGetAllSnapshotByListingIdListRequest {
  listing_id_list: number[];
}

export interface ListingsListingsProtocolsGetAllSnapshotByListingIdListResponse {
  snapshot_list: ListingsListingsProtocolsGetAllSnapshotByListingIdListResponseSnapshotResponse[];
}

export interface ListingsListingsProtocolsGetAllSnapshotByListingIdListResponseSnapshotResponse {
  /** @format int32 */
  listing_id: number;
  snapshot_url: string;
}

export interface ListingsListingsProtocolsGetCounterfeitReasonsRequest {
  /** @format int32 */
  listing_id: number;
}

export interface ListingsListingsProtocolsGetCounterfeitReasonsResponse {
  reasons?: MarqBrandModelResponseCounterfeitReasonResponse;
}

export interface ListingsListingsProtocolsGetDetailsRequest {
  /** @format int32 */
  brand_id?: number | null;
  /** @format int32 */
  listing_id: number;
  /** @format int32 */
  listing_option_id?: number | null;
}

export interface ListingsListingsProtocolsGetDetailsResponse {
  action_section_info: ListingsListingsProtocolsGetDetailsResponseActionSectionInfo;
  /** @format int32 */
  comment_count: number;
  enforcement_progress?: MarqBrandModelResponseEnforcementProgressResponse;
  investigation_detail?: MarqBrandModelResponseInvestigationDetailResponse;
  listing_attachments: MarqBrandDataModelListingAttachmentResponseBase[];
  listing_detail: MarqBrandModelResponseListingDetailResponse;
  seller_detail?: MarqBrandModelResponseSellerDetailResponse;
  tp_detail?: MarqBrandCoreModelResponseTpDetailResponseForBrand;
}

export interface ListingsListingsProtocolsGetDetailsResponseActionSectionInfo {
  client_status?: MarqBrandEnumsListingMonitoringStatusEnum;
  detail?: string | null;
  possible_add_authorized: boolean;
  possible_enforcement: boolean;
  title?: string | null;
}

export interface ListingsListingsProtocolsRequestTestPurchaseRequest {
  listing_id_list: number[];
  tp_type: MarqCommonEnumsTpTpTypeEnum;
}

export interface ListingsListingsProtocolsUndoEnforcementRequest {
  /** @format int32 */
  request_id: number;
}

export interface ListingsListingsProtocolsUndoEnforcementResponse {
  success: boolean;
}

export interface ListingsListingsProtocolsUpdateCounterfeitReasonThumbRequest {
  down?: boolean | null;
  /** @format int32 */
  id: number;
  /** @format int32 */
  listing_id: number;
  up?: boolean | null;
}

export interface ListingsListingsProtocolsUpdateToArchivedRequest {
  listing_ids: number[];
}

export interface ListingsListingsProtocolsUpdateToArchivedResponse {
  /** @format int32 */
  affected: number;
  listing_image_list?: string[] | null;
  listing_title?: string | null;
}

export interface ListingsListingsProtocolsUpdateToDismissRequest {
  listing_ids: number[];
}

export interface ListingsListingsProtocolsUpdateToDismissResponse {
  /** @format int32 */
  affected: number;
  listing_image_list?: string[] | null;
  listing_title?: string | null;
}

export interface ListingsListingsProtocolsUpdateToFlaggedRequest {
  listing_ids: number[];
}

export interface ListingsListingsProtocolsUpdateToFlaggedResponse {
  /** @format int32 */
  affected: number;
  listing_image_list?: string[] | null;
  listing_title?: string | null;
}

export interface MapMapModelCountryProtocolsExcludeListingOptionRequest {
  listing_option_id_list: number[];
}

export interface MapMapModelCountryProtocolsGetFilterInfoDomainRequest {
  country: MarqFoundationEnumsCountryCodeEnum;
  /** @format int32 */
  model_id: number;
}

export interface MapMapModelCountryProtocolsGetInfoRequest {
  country: MarqFoundationEnumsCountryCodeEnum;
  /** @format int32 */
  model_id: number;
  sort: MarqCommonEnumsMapSortEnum;
}

export interface MapMapModelCountryProtocolsGetInfoResponse {
  asset_name: string;
  brand_name: string;
  collection_name?: string | null;
  country_list: MarqFoundationEnumsCountryCodeEnum[];
  currency: MarqFoundationEnumsCurrencyEnum;
  domain_price_list: MapMapModelCountryProtocolsGetInfoResponseDomainPrice[];
  is_noti_enabled: boolean;
  /** @format double */
  map: number;
  model_image: string;
  model_name: string;
  my_listings: MapMapModelCountryProtocolsGetInfoResponseMyListing[];
  my_rocket_listings: MapMapModelCountryProtocolsGetInfoResponseMyRocketListing[];
}

export interface MapMapModelCountryProtocolsGetInfoResponseDomainPrice {
  /** @format int32 */
  domain_id: number;
  domain_name: string;
  /** @format double */
  value: number;
}

export interface MapMapModelCountryProtocolsGetInfoResponseMyListing {
  /** @format double */
  dynamic_price: number;
  is_hourly_supported: boolean;
  /** @format int32 */
  listing_id: number;
  /** @format int32 */
  listing_option_id: number;
  title: string;
}

export interface MapMapModelCountryProtocolsGetInfoResponseMyRocketListing {
  /** @format double */
  dynamic_price: number;
  is_hourly_supported: boolean;
  /** @format int32 */
  listing_id: number;
  /** @format int32 */
  listing_option_id: number;
  title: string;
}

export interface MapMapModelCountryProtocolsGetPriceHistoryRequest {
  /** @format int32 */
  listing_option_id: number;
  period: MapMapModelCountryProtocolsMapPriceHistoryPeriodEnum;
  time_zone?: string | null;
}

export interface MapMapModelCountryProtocolsGetPriceHistoryResponse {
  map_currency: MarqFoundationEnumsCurrencyEnum;
  /** @format double */
  map_price: number;
  period_time: MarqCommonModelOffsetDateTimeRange;
  price_chart_list: MapMapModelCountryProtocolsGetPriceHistoryResponseDatePrice[];
  recent_price: MapMapModelCountryProtocolsGetPriceHistoryResponseDatePrice[];
}

export interface MapMapModelCountryProtocolsGetPriceHistoryResponseDatePrice {
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  date_time: string;
  /** @format double */
  dynamic_price?: number | null;
  /** @format double */
  final_price?: number | null;
  /** @format double */
  price?: number | null;
  price_change_direction?: MarqBrandEnumsPriceChangeDirectionEnum;
  /** @format double */
  shipping_fee?: number | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  x_axis_time: string;
}

export interface MapMapModelCountryProtocolsGetViolationAnalysisRequest {
  country: MarqFoundationEnumsCountryCodeEnum;
  date_range: MarqCommonModelLocalDateRange;
  domain_list?: number[] | null;
  /** @format int32 */
  model_id: number;
  period: MapMapModelCountryProtocolsMapAnalysisPeriodEnum;
}

export interface MapMapModelCountryProtocolsGetViolationAnalysisResponse {
  lowest_dynamic_price: MapMapModelCountryProtocolsGetViolationAnalysisResponseLowestDynamicPrice;
  violation_listings: MapMapModelCountryProtocolsGetViolationAnalysisResponseViolationListings;
}

export interface MapMapModelCountryProtocolsGetViolationAnalysisResponseLowestDynamicPrice {
  group_list: MapMapModelCountryProtocolsGetViolationAnalysisResponseLowestDynamicPriceMapPriceChartValue[];
  group_name_list: string[];
  /** @format double */
  map: number;
}

export interface MapMapModelCountryProtocolsGetViolationAnalysisResponseLowestDynamicPriceMapPriceChartValue {
  /**
   * @format date
   * @example "2023-03-01"
   */
  date: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  from_date?: string | null;
  group_list: MapMapModelCountryProtocolsGetViolationAnalysisResponseLowestDynamicPricePriceGroupData[];
  /**
   * @format date
   * @example "2023-03-01"
   */
  to_date?: string | null;
}

export interface MapMapModelCountryProtocolsGetViolationAnalysisResponseLowestDynamicPricePriceGroupData {
  /** @format double */
  dynamic_price?: number | null;
  group_name: string;
  is_lowest: boolean;
}

export interface MapMapModelCountryProtocolsGetViolationAnalysisResponseViolationListings {
  group_list: MapMapModelCountryProtocolsGetViolationAnalysisResponseViolationListingsMapListingChartValue[];
  group_name_list: string[];
}

export interface MapMapModelCountryProtocolsGetViolationAnalysisResponseViolationListingsListingGroupData {
  /** @format int32 */
  count?: number | null;
  group_name: string;
  market_group: boolean;
}

export interface MapMapModelCountryProtocolsGetViolationAnalysisResponseViolationListingsMapListingChartValue {
  /**
   * @format date
   * @example "2023-03-01"
   */
  date: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  from_date?: string | null;
  group_list: MapMapModelCountryProtocolsGetViolationAnalysisResponseViolationListingsListingGroupData[];
  /**
   * @format date
   * @example "2023-03-01"
   */
  to_date?: string | null;
}

export interface MapMapModelCountryProtocolsGetViolationListingsRequest {
  authorized_seller?: boolean | null;
  country: MarqFoundationEnumsCountryCodeEnum;
  domain_list?: number[] | null;
  /** @format int32 */
  model_id: number;
  sort?: MarqCommonEnumsMapSortEnum;
}

export interface MapMapModelCountryProtocolsGetViolationListingsResponse {
  has_model_group: boolean;
  listing_list: MapMapModelCountryProtocolsGetViolationListingsResponseMapListing[];
  /** @format int32 */
  total_count: number;
  unit_price_per?: string | null;
}

export interface MapMapModelCountryProtocolsGetViolationListingsResponseMapListing {
  authorized_seller: boolean;
  currency: MarqFoundationEnumsCurrencyEnum;
  domain_name: string;
  /** @format double */
  dynamic_price: number;
  enforceability_action: MapMapModelCountryProtocolsEnforceabilityActionEnum;
  /** @format double */
  final_price: number;
  is_hourly_supported: boolean;
  /** @format int32 */
  listing_id: number;
  /** @format int32 */
  listing_option_id: number;
  listing_url: string;
  /** @format double */
  price: number;
  seller_name?: string | null;
  shipping_additional_info?: string | null;
  /** @format double */
  shipping_fee: number;
  shipping_type: MarqCommonEnumsShippingTypeEnum;
  should_highlight: boolean;
  title: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  updated_date: string;
}

export enum MapMapModelCountryProtocolsMapAnalysisPeriodEnum {
  Daily = 'daily',
  Weekly = 'weekly',
  Monthly = 'monthly',
}

export enum MapMapModelCountryProtocolsMapPriceHistoryPeriodEnum {
  Hourly = 'hourly',
  Daily = 'daily',
}

export interface MapMapModelProtocolsGetModelInfoRequest {
  /** @format int32 */
  model_id: number;
  sort: MarqCommonEnumsMapSortEnum;
}

export interface MapMapModelProtocolsGetModelInfoResponse {
  asset_name: string;
  brand_name: string;
  collection_name?: string | null;
  /** @format int32 */
  country_count: number;
  country_item_list: MapMapModelProtocolsGetModelInfoResponseCountryItem[];
  /** @format int32 */
  domain_count: number;
  is_noti_enabled: boolean;
  model_image: string;
  model_name: string;
}

export interface MapMapModelProtocolsGetModelInfoResponseCountryItem {
  country: MarqFoundationEnumsCountryCodeEnum;
  currency: MarqFoundationEnumsCurrencyEnum;
  domain_item_list: MapMapModelProtocolsGetModelInfoResponseDomainMapItem[];
  has_my_listing: boolean;
  has_my_rocket_listing: boolean;
  /** @format double */
  map: number;
}

export interface MapMapModelProtocolsGetModelInfoResponseDomainMapItem {
  currency: MarqFoundationEnumsCurrencyEnum;
  /** @format int32 */
  domain_id: number;
  domain_name: string;
  /** @format double */
  lowest_dynamic_price: number;
  /** @format double */
  lowest_final_price: number;
  /** @format double */
  lowest_price: number;
  /** @format int32 */
  violation_listings: number;
  /** @format int32 */
  violation_sellers: number;
}

export interface MapMapProtocolsExportRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_list?: MarqFoundationEnumsCountryCodeEnum[] | null;
  model_list?: number[] | null;
  search?: string | null;
  sort: MarqCommonEnumsMapSortEnum;
}

export interface MapMapProtocolsExportResponse {
  /** @format int32 */
  progress_id: number;
}

export interface MapMapProtocolsGetFilterInfoCountryRequest {
  /** @format int32 */
  brand_id?: number | null;
  model_list?: number[] | null;
  search?: string | null;
}

export interface MapMapProtocolsGetFilterInfoModelRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_list?: MarqFoundationEnumsCountryCodeEnum[] | null;
  search?: string | null;
}

export interface MapMapProtocolsGetMapCountRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_list?: MarqFoundationEnumsCountryCodeEnum[] | null;
  model_list?: number[] | null;
  search?: string | null;
}

export interface MapMapProtocolsGetMapCountResponse {
  /** @format int32 */
  count: number;
}

export interface MapMapProtocolsGetMapListRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_list?: MarqFoundationEnumsCountryCodeEnum[] | null;
  /** @format int32 */
  limit: number;
  model_list?: number[] | null;
  /** @format int32 */
  offset: number;
  search?: string | null;
  sort: MarqCommonEnumsMapSortEnum;
}

export interface MapMapProtocolsGetMapListResponse {
  list: MapMapProtocolsGetMapListResponseMapModel[];
}

export interface MapMapProtocolsGetMapListResponseCountryMapItem {
  country?: MarqFoundationEnumsCountryCodeEnum;
  currency: MarqFoundationEnumsCurrencyEnum;
  has_my_listing: boolean;
  has_my_rocket_listing: boolean;
  /** @format double */
  lowest_dynamic_price: number;
  /** @format double */
  lowest_final_price: number;
  /** @format double */
  lowest_price: number;
  /** @format double */
  map: number;
  /** @format int32 */
  monitored_listings: number;
  /** @format int32 */
  violation_listings: number;
  /** @format int32 */
  violation_sellers: number;
}

export interface MapMapProtocolsGetMapListResponseMapModel {
  asset_name: string;
  is_noti_enabled: boolean;
  item_list: MapMapProtocolsGetMapListResponseCountryMapItem[];
  /** @format int32 */
  model_id: number;
  model_image: string;
  model_name: string;
}

export interface MapMapProtocolsUpdateNotificationRequest {
  enabled: boolean;
  model_id_list: number[];
}

export interface MapPriceAnalyticsProtocolsExportRequest {
  /** @format int32 */
  brand_id?: number | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date: string;
  sort?: MarqCommonEnumsPriceAnalyticsModelSortEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date: string;
  time_zone: string;
  type: MarqCommonEnumsPriceAnalyticsExportType;
}

export interface MapPriceAnalyticsProtocolsExportResponse {
  /** @format int32 */
  progress_id: number;
}

export interface MapPriceAnalyticsProtocolsGetImpactSummaryRequest {
  /** @format int32 */
  brand_id?: number | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date: string;
  time_zone: string;
}

export interface MapPriceAnalyticsProtocolsGetImpactSummaryResponse {
  /** @format int32 */
  enforced_listing_cnt: number;
  /** @format int32 */
  impacted_seller_cluster_cnt: number;
  /** @format int32 */
  impacted_seller_cnt: number;
  /** @format int32 */
  removed_listing_cnt: number;
}

export interface MapPriceAnalyticsProtocolsGetListingListListing {
  currency?: MarqFoundationEnumsCurrencyEnum;
  has_report?: boolean | null;
  has_soft_notice?: boolean | null;
  marketplace_name: string;
  /** @format double */
  price?: number | null;
  reason?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  removed_date?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  requested_date?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  scanned_date: string;
  seller_name?: string | null;
  title: string;
}

export interface MapPriceAnalyticsProtocolsGetListingListRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date: string;
  /** @format int32 */
  limit: number;
  /** @format int32 */
  model_id: number;
  /** @format int32 */
  offset: number;
  price_analytics_listing_type: MarqBrandEnumsPriceAnalyticsListingType;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date: string;
  time_zone: string;
}

export interface MapPriceAnalyticsProtocolsGetListingListResponse {
  listing_list: MapPriceAnalyticsProtocolsGetListingListListing[];
}

export interface MapPriceAnalyticsProtocolsGetModelRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date: string;
  /** @format int32 */
  model_id: number;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date: string;
  time_zone: string;
}

export interface MapPriceAnalyticsProtocolsGetModelResponse {
  model: MapPriceAnalyticsProtocolsModel;
}

export interface MapPriceAnalyticsProtocolsGetModelListRequest {
  /** @format int32 */
  brand_id?: number | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date: string;
  search?: string | null;
  sort: MarqCommonEnumsPriceAnalyticsModelSortEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date: string;
  time_zone: string;
}

export interface MapPriceAnalyticsProtocolsGetModelListResponse {
  model_list: MapPriceAnalyticsProtocolsModel[];
}

export interface MapPriceAnalyticsProtocolsGetOverviewRecoveryInfo {
  /** @format double */
  price: number;
  /** @format double */
  rate: number;
}

export interface MapPriceAnalyticsProtocolsGetOverviewRequest {
  /** @format int32 */
  brand_id?: number | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date: string;
  time_zone: string;
}

export interface MapPriceAnalyticsProtocolsGetOverviewResponse {
  currency: MarqFoundationEnumsCurrencyEnum;
  /** @format int32 */
  my_rocket_listing_cnt: number;
  /** @format int32 */
  protected_model_cnt: number;
  recovery_info?: MapPriceAnalyticsProtocolsGetOverviewRecoveryInfo;
  retention_info?: MapPriceAnalyticsProtocolsGetOverviewRetentionInfo;
}

export interface MapPriceAnalyticsProtocolsGetOverviewRetentionInfo {
  distribution: Record<string, number>;
  /** @format double */
  rate: number;
}

export interface MapPriceAnalyticsProtocolsModel {
  /** @format double */
  avg_my_rocket_listing_price?: number | null;
  currency: MarqFoundationEnumsCurrencyEnum;
  /** @format int32 */
  enforced_listing_cnt: number;
  /** @format int32 */
  impacted_seller_cluster_cnt: number;
  /** @format int32 */
  impacted_seller_cnt: number;
  /** @format int32 */
  model_id: number;
  model_image?: string | null;
  model_name: string;
  /** @format int32 */
  recovery_cnt: number;
  /** @format double */
  recovery_price: number;
  /** @format double */
  recovery_rate: number;
  /** @format int32 */
  removed_listing_cnt: number;
  /** @format double */
  retention_rate: number;
  /** @format double */
  rrp: number;
}

export enum MarqBrandCoreModelClientListingSortedColumnEnum {
  DetectedDate = 'detected_date',
  Price = 'price',
  Featured = 'featured',
  SalesVolume = 'sales_volume',
  RequestedDate = 'requested_date',
  CreatedDate = 'created_date',
  UpdatedDate = 'updated_date',
  SellerName = 'seller_name',
  CommentDate = 'comment_date',
}

export interface MarqBrandCoreModelCvassistantCvAssistantDetectedListing {
  asset_name: string;
  featured: boolean;
  /** @format int32 */
  listing_id: number;
  thumbnail_url?: string | null;
}

export interface MarqBrandCoreModelCvassistantCvAssistantFileInfo {
  file_url?: string | null;
  seller_name: string;
}

export interface MarqBrandCoreModelCvassistantCvAssistantListingDetails {
  asset_name: string;
  description: MarqBrandCoreModelListingTextWithDetection;
  description_translate?: MarqBrandCoreModelListingTextWithDetection;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00"
   */
  detected_date: string;
  featured: boolean;
  image_list: MarqBrandDataModelListingImageWithFlagsClient[];
  keyword_list: string[];
  /** @format int32 */
  like_count?: number | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00"
   */
  listed_date?: string | null;
  /** @format int32 */
  listing_id: number;
  listing_url: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00"
   */
  scanned_date: string;
  tag_list: MarqCommonEnumsAiClientTagEnum[];
  translated_keyword_list: MarqBrandCoreModelDtoTranslateTextDto[];
}

export interface MarqBrandCoreModelCvassistantCvAssistantResultFilterItem {
  code: MarqCommonEnumsCvassistantCvAssistantResultEnum;
  /** @format int32 */
  count: number;
}

export interface MarqBrandCoreModelCvassistantCvAssistantSeller {
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  completed_date?: string | null;
  /** @format int32 */
  cv_assistant_id: number;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  detected_date: string;
  /** @format int32 */
  detected_listing_count: number;
  domain_name: string;
  featured_product?: MarqBrandCoreModelCvassistantCvAssistantSellerFeaturedProduct;
  /** @format int32 */
  follower_count?: number | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  last_message_sent_date?: string | null;
  /** @format int32 */
  post_count?: number | null;
  reportable?: boolean | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  reported_date?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  requested_date?: string | null;
  result?: MarqCommonEnumsCvassistantCvAssistantResultEnum;
  seller_name?: string | null;
  seller_url?: string | null;
  snapshot_url?: string | null;
  status: MarqCommonEnumsCvassistantCvAssistantStatusEnum;
  tm_logo_used: boolean;
  tm_text_used: boolean;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  updated_date?: string | null;
}

export interface MarqBrandCoreModelCvassistantCvAssistantSellerFeaturedProduct {
  /** @format int32 */
  listing_id: number;
  listing_status: MarqCommonEnumsListingStatusEnum;
  listing_url: string;
  thumbnail_url: string;
}

export interface MarqBrandCoreModelCvassistantCvAssistantSellerDetails {
  bio?: string | null;
  bio_translate?: string | null;
  bio_url?: string | null;
  /** @format int32 */
  detected_listing_count?: number | null;
  domain_name: string;
  /** @format int32 */
  follower_count?: number | null;
  /** @format int32 */
  post_count?: number | null;
  repeat_offender: boolean;
  /** @format int32 */
  seller_id: number;
  seller_name: string;
  seller_url?: string | null;
}

export interface MarqBrandCoreModelCvassistantCvResult {
  reason_list?: MarqBrandCoreModelCvassistantCvResultReasonItem[] | null;
  result: MarqCommonEnumsCvassistantCvAssistantResultEnum;
  snapshot_url?: string | null;
}

export interface MarqBrandCoreModelCvassistantCvResultReasonItem {
  description: string;
  title: string;
}

export interface MarqBrandCoreModelDtoTranslateTextDto {
  from?: MarqFoundationEnumsLanguageEnum;
  origin: string;
  to: MarqFoundationEnumsLanguageEnum;
  translated: string;
}

export interface MarqBrandCoreModelListingTextWithDetection {
  /** @format int32 */
  end_index?: number | null;
  /** @format int32 */
  start_index?: number | null;
  text: string;
}

export interface MarqBrandCoreModelPerfListingsChartValue {
  /**
   * @format date
   * @example "2023-03-01"
   */
  date: string;
  grouped_count_list?: MarqBrandCoreModelPerfListingsChartValueGroupedCount[] | null;
  /** @format int64 */
  listing_count: number;
  /** @format int64 */
  top_search_count?: number | null;
}

export interface MarqBrandCoreModelPerfListingsChartValueGroupedCount {
  /** @format int64 */
  count: number;
  /** @format int32 */
  id?: number | null;
  name: string;
}

export interface MarqBrandCoreModelPerfTopData {
  grouped_list?: MarqBrandCoreModelPerfTopDataGroupedTopData[] | null;
  /** @format int64 */
  listing_count: number;
  /** @format double */
  listing_percent: number;
  name: string;
}

export interface MarqBrandCoreModelPerfTopDataGroupedTopData {
  /** @format int64 */
  count: number;
  /** @format int32 */
  group_id?: number | null;
  group_label: string;
}

export interface MarqBrandCoreModelProtocolCountryDomains {
  /** @format int32 */
  count?: number | null;
  country_code?: MarqFoundationEnumsCountryCodeEnum;
  country_name: string;
  domain_list: MarqBrandCoreModelProtocolDomain[];
}

export interface MarqBrandCoreModelProtocolDomain {
  /** @format int32 */
  count?: number | null;
  /** @format int32 */
  domain_id: number;
  domain_name: string;
}

export interface MarqBrandCoreModelProtocolInvestigationTags {
  authentic?: boolean | null;
  copyright: boolean;
  design: boolean;
  free_riding: boolean;
  in_progress?: boolean | null;
  irrelevant?: boolean | null;
  logo_name_conceal: boolean;
  material_diff: boolean;
  model_not_exist: boolean;
  no_authorization: boolean;
  no_counterfeit?: boolean | null;
  no_ip_rights?: boolean | null;
  official_image: boolean;
  official_video: boolean;
  origin_diff: boolean;
  other: boolean;
  reported?: boolean | null;
  shape_diff: boolean;
  size_diff: boolean;
  test_purchased?: boolean | null;
  trademark: boolean;
  unavailable?: boolean | null;
  word_obvious: boolean;
}

export interface MarqBrandCoreModelProtocolTags {
  ai_drafted?: boolean | null;
  client_requested: boolean;
  infringing_image?: boolean | null;
  is_not_for_sale?: boolean | null;
  is_used_listing?: boolean | null;
  low_price?: boolean | null;
  official_image: boolean;
  repeat_offender?: boolean | null;
  text_detection: boolean;
  top_result: boolean;
  trademark: boolean;
}

export interface MarqBrandCoreModelRequestRiskScoreFilterRequestRiskScoreItem {
  /** @format int32 */
  max_risk_score?: number | null;
  /** @format int32 */
  min_risk_score?: number | null;
}

export interface MarqBrandCoreModelResponseClusterProfileResponse {
  address?: string | null;
  business_reg_num?: string | null;
  company_name?: string | null;
  /** @format int32 */
  company_name_seller_count?: number | null;
  country_code?: MarqFoundationEnumsCountryCodeEnum;
  country_name?: string | null;
  /** @format int32 */
  country_seller_count?: number | null;
  email?: string | null;
  /** @format int32 */
  email_seller_count?: number | null;
  legal_representative?: string | null;
  location?: MarqBrandCoreModelResponseClusterProfileResponseLocation;
  marketplace_name?: string | null;
  /** @format int32 */
  marketplace_seller_count?: number | null;
  online_marketing_number?: string | null;
  phone?: string | null;
  seller_name?: string | null;
  /** @format int32 */
  seller_name_seller_count?: number | null;
  seller_type: MarqCommonEnumsSellerAnalyticsSellerTypeEnum;
  seller_url?: string | null;
  shop_name?: string | null;
  /** @format int32 */
  shop_name_seller_count?: number | null;
}

export interface MarqBrandCoreModelResponseClusterProfileResponseLocation {
  /** @format double */
  lat: number;
  /** @format double */
  lng: number;
}

export interface MarqBrandCoreModelResponseCodeLabelComboBoxResponse {
  label: string;
  value: string;
}

export interface MarqBrandCoreModelResponseComboBoxIntValueLabelResponse {
  label: string;
  /** @format int32 */
  value: number;
}

export interface MarqBrandCoreModelResponseCustomTagResponse {
  /** @format int32 */
  id: number;
  name: string;
}

export interface MarqBrandCoreModelResponseDataDrivenInsightResponse {
  action_list: MarqBrandCoreModelResponsePossibleComboBox[];
  infringing_type_list: MarqBrandCoreModelResponsePossibleComboBox[];
  risk_reason_list: MarqBrandCoreModelResponsePossibleComboBox[];
  /** @format int32 */
  risk_score: number;
}

export interface MarqBrandCoreModelResponseIdAndStringValueResponse {
  /** @format int32 */
  id: number;
  value: string;
}

export interface MarqBrandCoreModelResponseIdWithUrl {
  /** @format int32 */
  id: number;
  url?: string | null;
}

export interface MarqBrandCoreModelResponsePossibleComboBox {
  code: string;
  possible: boolean;
}

export interface MarqBrandCoreModelResponseSellerAnalyticResponse {
  cluster?: MarqBrandCoreModelResponseSellerAnalyticResponseClusterSimpleResponse;
  seller?: MarqBrandCoreModelResponseSellerAnalyticResponseSellerSimpleResponse;
}

export interface MarqBrandCoreModelResponseSellerAnalyticResponseClusterSimpleResponse {
  /** @format int32 */
  active_listings: number;
  /** @format int32 */
  cluster_id: number;
  cluster_name: string;
  /** @format int32 */
  seller_count: number;
}

export interface MarqBrandCoreModelResponseSellerAnalyticResponseSellerSimpleResponse {
  /** @format int32 */
  active_listings: number;
  authorized: boolean;
  channel_type: MarqCommonEnumsChannelTypeEnum;
  exist_email: boolean;
  seller_id: string;
  seller_name: string;
}

export interface MarqBrandCoreModelResponseSellerDetailSummaryResponse {
  /** @format int32 */
  asset_count: number;
  /** @format int32 */
  available_stock_count: number;
  /**
   * @format date
   * @example "2023-03-01"
   */
  first_detected_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  last_detected_date?: string | null;
  /** @format int64 */
  sales_volume_count: number;
}

export interface MarqBrandCoreModelResponseTpDetailResponseForBrand {
  tp_case_info?: MarqBrandCoreModelResponseTpDetailResponseForBrandTpCaseInfoResponse;
  tp_report?: MarqBrandCoreModelResponseTpReportResponse;
}

export interface MarqBrandCoreModelResponseTpDetailResponseForBrandTpCaseInfoResponse {
  case_id: string;
  /** @format int32 */
  domain_id?: number | null;
  domain_name?: string | null;
  listing_url?: string | null;
  payment: MarqBrandCoreModelResponseTpHistoryGroup[];
  progress: MarqBrandCoreModelResponseTpHistoryGroup[];
  requested_by: string;
  service_type: MarqCommonEnumsTpTpTypeEnum;
  /** @format int32 */
  tp_id: number;
}

export interface MarqBrandCoreModelResponseTpHistory {
  /**
   * @format date
   * @example "2023-03-01"
   */
  date: string;
  delivery?: MarqBrandCoreModelResponseTpHistoryTpDeliverResponse;
  /** @format int32 */
  edit_id?: number | null;
  failed_reason?: MarqBrandCoreModelResponseTpHistoryTpFailedReason;
  order?: MarqBrandCoreModelResponseTpHistoryTpOrder;
  shipping?: MarqBrandCoreModelResponseTpHistoryTpShipping;
  title: string;
  tp_payment_status?: MarqCommonEnumsTpTpPaymentStatusEnum;
  tp_status?: MarqCommonEnumsTpTpStatusEnum;
  use_block_icon: boolean;
}

export interface MarqBrandCoreModelResponseTpHistoryTpFailedReason {
  reason_detail?: string | null;
  reason_type?: string | null;
}

export interface MarqBrandCoreModelResponseTpHistoryTpShipping {
  order_confirmation_name?: string | null;
  order_confirmation_url?: string | null;
  shipping_company?: string | null;
  tracking_number?: string | null;
}

export interface MarqBrandCoreModelResponseTpHistoryGroup {
  histories: MarqBrandCoreModelResponseTpHistory[];
  title: string;
}

export interface MarqBrandCoreModelResponseTpReportResponse {
  case_id: string;
  domain_name?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  item_received_date?: string | null;
  legal_representative?: string | null;
  order_confirmation_name?: string | null;
  order_confirmation_url?: string | null;
  order_note?: string | null;
  order_number?: string | null;
  product_detail_list?: MarqBrandDataModelDtoTpTpProductDetailAttr[] | null;
  product_price?: MarqBrandCoreModelResponsePriceResponse;
  product_url?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  purchase_date?: string | null;
  requested_by: string;
  result?: MarqCommonEnumsTpTpResultType;
  result_note?: string | null;
  return_address?: string | null;
  return_contact?: string | null;
  return_name?: string | null;
  seller_address?: string | null;
  seller_contact?: string | null;
  seller_name?: string | null;
  sender_address?: string | null;
  sender_contact?: string | null;
  sender_country?: MarqFoundationEnumsCountryCodeEnum;
  sender_name?: string | null;
  service_type: MarqCommonEnumsTpTpTypeEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  shipping_date?: string | null;
  shipping_fee?: MarqBrandCoreModelResponsePriceResponse;
  tax?: MarqBrandCoreModelResponsePriceResponse;
  total_price?: MarqBrandCoreModelResponsePriceResponse;
  /** @format int32 */
  tp_id: number;
  tp_image_list: MarqBrandCoreModelResponseTpReportResponseImageWithUrlResponse[];
  /** @format int32 */
  tp_result_id: number;
}

export interface MarqBrandCoreModelResponseTpReportResponseImageWithUrlResponse {
  /** @format int32 */
  id?: number | null;
  image_name?: string | null;
  image_url: string;
  tp_image_type: MarqCommonEnumsTpTpImageTypeEnum;
}

export interface MarqBrandCoreModelResponseTranslateResponse {
  org: string;
  translated?: string | null;
}

export interface MarqBrandCoreModelRuleSmartRuleForClient {
  action: MarqCommonEnumsRuleSmartRuleActionEnum;
  /** @format int32 */
  brand_id: number;
  brand_name: string;
  /** @format int32 */
  client_id: number;
  condition: MarqCommonModelRuleSmartRuleConditionForClient;
  created_by: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  created_date: string;
  custom_tag_ids?: number[] | null;
  /** @format int32 */
  id: number;
  is_pinned: boolean;
  status: MarqCommonEnumsRuleSmartRuleStatusEnum;
  title: string;
  updated_by: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  updated_date: string;
}

export interface MarqBrandDataModelAssetDataFullIpDoc {
  /** @format int32 */
  ip_doc_id: number;
  unique_name: string;
}

export interface MarqBrandDataModelIpDocByClass {
  class_id?: string | null;
  class_label: string;
  ip_docs: MarqBrandDataModelIpDocByClassIpDoc[];
}

export interface MarqBrandDataModelIpDocByClassIpDoc {
  /** @format int32 */
  ip_doc_id: number;
  unique_name: string;
}

export interface MarqBrandDataModelListingAttachmentResponseBase {
  file_name: string;
  /** @format int32 */
  id: number;
  url: string;
}

export interface MarqBrandDataModelListingImageWithFlagsClient {
  /** @format int32 */
  id: number;
  img_url: string;
  infringing_image_flag: boolean;
  logo_detection_data?: MarqBrandDataTableLogodetectionLogoDetectionData[] | null;
  official_image_flag: boolean;
}

export interface MarqBrandDataModelSellerCluster {
  c_sum: MarqBrandDataModelSellerClusterCSum;
  /** @format int32 */
  id: number;
  name?: string | null;
  name_trans?: string | null;
  s_detected_list?: MarqBrandDataModelSellerClusterSSimpleInfo[] | null;
  s_remove_list?: MarqBrandDataModelSellerClusterSSimpleInfo[] | null;
  s_sales_volume_list?: MarqBrandDataModelSellerClusterSSimpleInfo[] | null;
  s_stock_count_list?: MarqBrandDataModelSellerClusterSSimpleInfo[] | null;
}

export interface MarqBrandDataModelSellerClusterCSum {
  /** @format int32 */
  active: number;
  /** @format int32 */
  detected: number;
  /** @format int32 */
  m_count: number;
  /** @format int32 */
  removed: number;
  /** @format int32 */
  s_count: number;
  /** @format int32 */
  s_vol: number;
  /** @format int32 */
  st_count: number;
}

export interface MarqBrandDataModelSellerClusterSSimpleInfo {
  s_id: string;
  s_name: string;
  s_name_trans: string;
  /** @format int32 */
  s_value: number;
}

export interface MarqBrandDataModelSellerClusterAnalysisSellerDataSellerData {
  /** @format int32 */
  active: number;
  address?: string | null;
  address_trans?: string | null;
  bus_reg_num?: string | null;
  comp_name?: string | null;
  comp_name_trans?: string | null;
  /** @format int32 */
  detected: number;
  email?: string | null;
  leg_rep?: string | null;
  leg_rep_trans?: string | null;
  listing_desc?: string | null;
  listing_images?: string[] | null;
  listing_title?: string | null;
  market: string;
  market_country_code: MarqFoundationEnumsCountryCodeEnum;
  online_mark_num?: string | null;
  online_mark_num_trans?: string | null;
  phone_num?: string | null;
  /** @format int32 */
  removed: number;
  /** @format int32 */
  sales_volume: number;
  seller_name?: string | null;
  seller_name_trans?: string | null;
  shop_name?: string | null;
  shop_name_trans?: string | null;
}

export interface MarqBrandDataModelSellerClusterDetailsSummaryAction {
  /** @format int32 */
  seller_notice_count: number;
  /** @format int32 */
  tp_count: number;
}

export interface MarqBrandDataModelSellerClusterDetailsSummaryClustering {
  /** @format int32 */
  country_count: number;
  /** @format int32 */
  marketplace_count: number;
  /** @format int32 */
  seller_count: number;
}

export interface MarqBrandDataModelSellerClusterDetailsSummaryMostUsedInfo {
  address?: string | null;
  /** @format int32 */
  address_matched?: number | null;
  address_trans?: string | null;
  bus_reg_num?: string | null;
  /** @format int32 */
  bus_reg_num_matched?: number | null;
  comp_name?: string | null;
  /** @format int32 */
  comp_name_matched?: number | null;
  comp_name_trans?: string | null;
  email?: string | null;
  /** @format int32 */
  email_matched?: number | null;
  leg_rep?: string | null;
  /** @format int32 */
  leg_rep_matched?: number | null;
  leg_rep_trans?: string | null;
  listing_desc?: string | null;
  /** @format int32 */
  listing_desc_matched?: number | null;
  listing_images?: string[] | null;
  /** @format int32 */
  listing_images_matched?: number | null;
  listing_title?: string | null;
  /** @format int32 */
  listing_title_matched?: number | null;
  online_mark_num?: string | null;
  /** @format int32 */
  online_mark_num_matched?: number | null;
  online_mark_num_trans?: string | null;
  phone_num?: string | null;
  /** @format int32 */
  phone_num_matched?: number | null;
  seller_name?: string | null;
  /** @format int32 */
  seller_name_matched?: number | null;
  seller_name_trans?: string | null;
  shop_name?: string | null;
  /** @format int32 */
  shop_name_matched?: number | null;
  shop_name_trans?: string | null;
}

export interface MarqBrandDataModelSellerClusterDetailsSummaryProcessing {
  /** @format int32 */
  active: number;
  /** @format int32 */
  detected: number;
  /** @format int32 */
  enforcement_req: number;
  /** @format int32 */
  removed: number;
}

export interface MarqBrandDataModelSellerClusterSideInfo {
  c_sum: MarqBrandDataModelSellerClusterSideInfoCSum;
  /** @format int32 */
  id: number;
  name?: string | null;
  name_trans?: string | null;
}

export interface MarqBrandDataModelSellerClusterSideInfoCSum {
  /** @format int32 */
  active: number;
  /** @format int32 */
  detected: number;
  /** @format int32 */
  m_count: number;
  /** @format int32 */
  removed: number;
  /** @format int32 */
  s_count: number;
  /** @format int32 */
  s_vol: number;
  /** @format int32 */
  st_count: number;
}

export interface MarqBrandDataModelSellerCountryWithCountDataListCountryWithCountData {
  /** @format int32 */
  count_data: number;
  country_code: MarqFoundationEnumsCountryCodeEnum;
}

export interface MarqBrandDataModelSellerMarketplaceWithCountDataListMarketplaceWithCountData {
  /** @format int32 */
  count_data: number;
  marketplace_name: string;
}

export interface MarqBrandDataModelSellerSellerWithCountDataListSellerWithCountData {
  /** @format int32 */
  count_data: number;
  seller_id: string;
  seller_name: string;
}

export interface MarqBrandDataTableLogodetectionLogoDetectionData {
  /** @format double */
  bb_x1?: number | null;
  /** @format double */
  bb_x2?: number | null;
  /** @format double */
  bb_y1?: number | null;
  /** @format double */
  bb_y2?: number | null;
  /** @format int32 */
  image_height?: number | null;
  /** @format int32 */
  image_width?: number | null;
}

export enum MarqBrandEnumsListingMonitoringStatusEnum {
  Scanned = 'scanned',
  Detection = 'detection',
  Processing = 'processing',
  Reporting = 'reporting',
  SoftNotice = 'soft_notice',
  OnHold = 'on_hold',
  Removed = 'removed',
  Denied = 'denied',
  NonEnforceable = 'non_enforceable',
  Dismissed = 'dismissed',
  TpAll = 'tp_all',
  ReviewNeeded = 'review_needed',
  Archived = 'archived',
}

export enum MarqBrandEnumsPriceAnalyticsListingType {
  EnforcementRequested = 'enforcement_requested',
  Removed = 'removed',
}

export enum MarqBrandEnumsPriceChangeDirectionEnum {
  Flat = 'flat',
  Up = 'up',
  Down = 'down',
}

export enum MarqBrandEnumsWebsiteBrandSortedColumnEnum {
  ScannedDate = 'scanned_date',
  RequestDate = 'request_date',
  UpdatedDate = 'updated_date',
  DomainName = 'domain_name',
  Featured = 'featured',
  ProgressDate = 'progress_date',
  RemovedDate = 'removed_date',
  WatchlistAddedDate = 'watchlist_added_date',
  CommentDate = 'comment_date',
  DetectedDate = 'detected_date',
}

export enum MarqBrandEnumsWebsiteContentsTpTabEnum {
  Reviewing = 'reviewing',
  Purchase = 'purchase',
  Completed = 'completed',
  CaseClosed = 'case_closed',
}

export enum MarqBrandEnumsCvassistantCvAssistantSortedColumnEnum {
  Featured = 'featured',
  DetectedDate = 'detected_date',
  RequestedDate = 'requested_date',
  CompletedDate = 'completed_date',
  ListingCount = 'listing_count',
  SellerName = 'seller_name',
}

export enum MarqBrandEnumsCvassistantCvAssistantTabEnum {
  Detected = 'detected',
  Requested = 'requested',
  Completed = 'completed',
}

export interface MarqBrandModelRequestSeListingsChartValue {
  /** @format int64 */
  content_removed_count: number;
  /**
   * @format date
   * @example "2023-03-01"
   */
  date: string;
  /** @format int64 */
  search_engine_delisted_count: number;
  /** @format int64 */
  top_search_delisted_count: number;
}

export interface MarqBrandModelRequestTopRow {
  /** @format int64 */
  count: number;
  /** @format int32 */
  id: number;
  name: string;
}

export interface MarqBrandModelResponseCounterfeitReasonResponse {
  list: MarqBrandModelResponseCounterfeitReasonResponseReason[];
}

export interface MarqBrandModelResponseCounterfeitReasonResponseReason {
  body: string;
  down: boolean;
  /** @format int32 */
  id: number;
  title: string;
  up: boolean;
}

export interface MarqBrandModelResponseEnforcementProgressResponse {
  enforcement_progress_list: MarqBrandModelResponseEnforcementProgressResponseItem[];
}

export interface MarqBrandModelResponseEnforcementProgressResponseItem {
  /**
   * @format date
   * @example "2023-03-01"
   */
  date: string;
  descriptions?: string[] | null;
  email?: string | null;
  type: string;
}

export interface MarqBrandModelResponseEnforcementTPListingResponse {
  asset_name: string;
  /** @format double */
  confidence_score?: number | null;
  converted_currency?: MarqFoundationEnumsCurrencyEnum;
  /** @format double */
  converted_price?: number | null;
  country?: MarqFoundationEnumsCountryCodeEnum;
  description?: string | null;
  description_translate?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  detected_date?: string | null;
  domain_name?: string | null;
  exist_tp_report: boolean;
  /** @format int32 */
  id: number;
  list_currency?: MarqFoundationEnumsCurrencyEnum;
  listing_url: string;
  name?: string | null;
  name_translate?: string | null;
  /** @format int32 */
  official_image_id?: number | null;
  /** @format double */
  price?: number | null;
  /** @format int32 */
  seller_id?: number | null;
  seller_name: string;
  seller_url?: string | null;
  ship_from?: string | null;
  snapshot_pdf_url?: string | null;
  thumbnail_image_url?: string | null;
  tp_group_status?: MarqCommonEnumsTpTpProgressStatusEnum;
  tp_group_status_name?: string | null;
  /** @format int32 */
  tp_id?: number | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  tp_requested_date?: string | null;
  tp_status_label: string;
  tp_type?: MarqCommonEnumsTpTpTypeEnum;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  updated_date?: string | null;
}

export interface MarqBrandModelResponseEnforcementTPListingResponseImageResponse {
  default: string;
  oi_highest_score?: string | null;
}

export interface MarqBrandModelResponseInvestigationDetailResponse {
  counterfeit_proof_list: MarqBrandModelResponseInvestigationDetailResponseImageWithUrlResponse[];
  /** @format int32 */
  enforceability_info_id: number;
  genuine_proof_list: MarqBrandModelResponseInvestigationDetailResponseImageWithUrlResponse[];
  ip_document_response_list: MarqBrandModelResponseInvestigationDetailResponseImageWithUrlResponse[];
  ipr_used_proof_list: MarqBrandModelResponseInvestigationDetailResponseImageWithUrlResponse[];
  /** @format int32 */
  listing_id: number;
  listing_status: MarqCommonEnumsListingStatusEnum;
  listing_url: string;
  non_enforceable_list: MarqCommonEnumsNonEnforcementReasonEnum[];
  /** @format int32 */
  seller_id?: number | null;
  use_counterfeit?: boolean | null;
  use_counterfeit_type?: MarqCommonEnumsIpCounterfeitType;
  use_ip_rights?: boolean | null;
  use_ip_rights_type?: MarqCommonEnumsIpRightType;
  use_report_reason?: string | null;
}

export interface MarqBrandModelResponseInvestigationDetailResponseImageWithUrlResponse {
  /** @format int32 */
  id: number;
  img_url: string;
  name?: string | null;
}

export interface MarqBrandModelResponseListingDetailResponse {
  ai_result?: MarqCommonEnumsAiClientAIResultEnum;
  asset_name: string;
  brand_name: string;
  converted_currency?: MarqFoundationEnumsCurrencyEnum;
  /** @format double */
  converted_price?: number | null;
  custom_tag_list: MarqBrandCoreModelResponseCustomTagResponse[];
  description: MarqBrandCoreModelListingTextWithDetection;
  description_translate?: MarqBrandCoreModelListingTextWithDetection;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00"
   */
  detected_date: string;
  domain_name: string;
  domain_type: MarqCommonEnumsDomainTypeEnum;
  images: MarqBrandDataModelListingImageWithFlagsClient[];
  keywords: string[];
  /** @format int32 */
  like_count?: number | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00"
   */
  listed_date?: string | null;
  listing_currency?: MarqFoundationEnumsCurrencyEnum;
  /** @format double */
  listing_price?: number | null;
  listing_status: MarqCommonEnumsListingStatusEnum;
  official_image_name?: string | null;
  option_info?: MarqBrandModelResponseListingDetailResponseOptionInfo;
  product_code?: string | null;
  /** @format int32 */
  product_id: number;
  /** @format int32 */
  sales_volume?: number | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00"
   */
  scanned_date: string;
  scanned_status?: MarqCommonEnumsScannedStatusEnum;
  /** @format int32 */
  seller_id?: number | null;
  seller_name: string;
  ship_from?: string | null;
  snapshot_pdf_url?: string | null;
  snapshot_pdf_url_list?: string[] | null;
  /** @format int32 */
  stock_count?: number | null;
  tag_list: MarqCommonEnumsAiClientTagEnum[];
  tags: MarqBrandCoreModelProtocolTags;
  title: MarqBrandCoreModelListingTextWithDetection;
  title_translate?: MarqBrandCoreModelListingTextWithDetection;
  translate_keyword_list: MarqBrandCoreModelResponseTranslateResponse[];
  url: string;
}

export interface MarqBrandModelResponseListingDetailResponseOptionInfo {
  currency: MarqFoundationEnumsCurrencyEnum;
  name: string;
  /** @format double */
  price: number;
}

export interface MarqBrandModelResponseMonitoringListingResponse {
  ai_result?: MarqCommonEnumsAiClientAIResultEnum;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  archived_date?: string | null;
  asset_name: string;
  /** @format int32 */
  comment_count: number;
  /** @format double */
  confidence_score?: number | null;
  converted_currency?: MarqFoundationEnumsCurrencyEnum;
  /** @format double */
  converted_price?: number | null;
  description?: string | null;
  description_translate?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  dismissed_date?: string | null;
  domain_name?: string | null;
  /** @format int32 */
  id: number;
  images: MarqBrandModelResponseMonitoringListingResponseImageResponse[];
  list_currency?: MarqFoundationEnumsCurrencyEnum;
  listing_status: MarqCommonEnumsListingStatusEnum;
  listing_url: string;
  name?: string | null;
  name_translate?: string | null;
  /** @format int32 */
  official_image_id?: number | null;
  /** @format double */
  price?: number | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  scanned_date?: string | null;
  scanned_status?: MarqCommonEnumsScannedStatusEnum;
  /** @format int32 */
  seller_id?: number | null;
  seller_name: string;
  snapshot_pdf_url?: string | null;
  snapshot_pdf_url_list?: string[] | null;
  social_profile?: boolean | null;
  tag: MarqBrandCoreModelProtocolInvestigationTags;
  tag_list: MarqCommonEnumsAiClientTagEnum[];
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  updated_date?: string | null;
}

export interface MarqBrandModelResponseMonitoringListingResponseImageResponse {
  default: string;
}

export interface MarqBrandModelResponsePotentialAuthorizedListingResponse {
  ai_result?: MarqCommonEnumsAiClientAIResultEnum;
  /** @format double */
  confidence_score?: number | null;
  converted_currency?: MarqFoundationEnumsCurrencyEnum;
  /** @format double */
  converted_price?: number | null;
  description?: string | null;
  description_translate?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  detected_date?: string | null;
  domain_name?: string | null;
  /** @format int32 */
  id: number;
  images: MarqBrandModelResponsePotentialAuthorizedListingResponseImageResponse[];
  list_currency?: MarqFoundationEnumsCurrencyEnum;
  listing_url: string;
  name?: string | null;
  name_translate?: string | null;
  /** @format int32 */
  official_image_id?: number | null;
  /** @format double */
  price?: number | null;
  /** @format int32 */
  seller_id?: number | null;
  seller_name: string;
  tag_list: MarqCommonEnumsAiClientTagEnum[];
  tags: MarqBrandCoreModelProtocolTags;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  updated_date?: string | null;
}

export interface MarqBrandModelResponsePotentialAuthorizedListingResponseImageResponse {
  default: string;
}

export interface MarqBrandModelResponseSellerCountResponse {
  /** @format int64 */
  count: number;
  /** @format int32 */
  domain_id?: number | null;
  domain_name?: string | null;
  /** @format int64 */
  id: number;
  name: string;
  repeat_offender: boolean;
  /** @format int32 */
  seller_score?: number | null;
}

export interface MarqBrandModelResponseSellerDetailResponse {
  basic_info: MarqBrandModelResponseSellerDetailResponseBasicInfo;
  count_by_listing_status: MarqBrandModelResponseSellerDetailResponseCountByListingStatus;
  detection_path_history?: MarqBrandModelResponseSellerDetailResponseDetectionPathHistory[] | null;
  first_enforcement_history: MarqBrandModelResponseSellerDetailResponseFirstEnforcementHistory[];
  recent_enforcement_activity: MarqBrandModelResponseSellerDetailResponseRecentEnforcementActivity[];
}

export interface MarqBrandModelResponseSellerDetailResponseBasicInfo {
  /** @format int32 */
  domain_id: number;
  domain_name: string;
  is_brand_specified: boolean;
  is_clustered: boolean;
  is_repeat_offender: boolean;
  seller_id: string;
  seller_name: string;
  seller_url?: string | null;
}

export interface MarqBrandModelResponseSellerDetailResponseCountByListingStatus {
  /** @format int32 */
  active_count: number;
  /** @format int32 */
  detected_count: number;
  /** @format int32 */
  removed_count: number;
}

export interface MarqBrandModelResponseSellerDetailResponseDetectionPathHistory {
  check: boolean;
  /**
   * @format date
   * @example "2023-03-01"
   */
  date: string;
  description: MarqBrandModelResponseSellerDetailResponseDetectionPathHistoryDescription;
}

export interface MarqBrandModelResponseSellerDetailResponseDetectionPathHistoryDescription {
  platform_name: string;
  profile_name: string;
  profile_url: string;
  seller_id?: string | null;
}

export interface MarqBrandModelResponseSellerDetailResponseFirstEnforcementHistory {
  /**
   * @format date
   * @example "2023-03-01"
   */
  date: string;
  event: string;
}

export interface MarqBrandModelResponseSellerDetailResponseRecentEnforcementActivity {
  listing_title: string;
  listing_title_translate?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  removed_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  reported_date: string;
  status: string;
}

export interface MarqBrandModelResponseMonitoringSocialmediaPiracyDetailInfoResponse {
  asset_name: string;
  description?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  detected_date: string;
  features: MarqBrandModelProtocolFeatures;
  image_list: string[];
  /** @format int32 */
  listing_id: number;
  listing_url: string;
  platform_name: string;
  profile_name?: string | null;
  running_time?: string | null;
  search_keyword_list: string[];
  search_method: PiracyCommonEnumsSearchMethodEnum;
  snapshot_url?: string | null;
  /** @format int32 */
  subscription?: number | null;
  title: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  uploaded_date?: string | null;
  /** @format int32 */
  views?: number | null;
}

export interface MarqBrandModelResponseMonitoringSocialmediaPiracySocialMediaDetailPiracyResponse {
  detail_info: MarqBrandModelResponseMonitoringSocialmediaPiracyDetailInfoResponse;
  enforcement_progress: MarqBrandModelResponseMonitoringWebsitePiracyEnforcementResponse;
}

export interface MarqBrandModelResponseMonitoringWebsitePiracyDetailInfoResponse {
  asset_name: string;
  description?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  detected_date: string;
  domain_name: string;
  features: MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsFeatures;
  image_list: string[];
  /** @format int32 */
  listing_id: number;
  listing_url: string;
  profile_name?: string | null;
  running_time?: string | null;
  search_keyword_list: string[];
  search_method: PiracyCommonEnumsSearchMethodEnum;
  snapshot_url?: string | null;
  /** @format int32 */
  subscription?: number | null;
  title: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  uploaded_date?: string | null;
  /** @format int32 */
  views?: number | null;
}

export interface MarqBrandModelResponseMonitoringWebsitePiracyEnforcementResponse {
  google_progress?: MarqBrandModelResponseMonitoringWebsitePiracyEnforcementResponseGoogleProgressResponse;
}

export interface MarqBrandModelResponseMonitoringWebsitePiracyEnforcementResponseGoogleProgressResponse {
  progress_list: MarqBrandModelResponseMonitoringWebsitePiracyEnforcementResponseGoogleProgressResponseItem[];
  status?: PiracyCommonEnumsWebsiteListingHistoryStatusEnum;
}

export interface MarqBrandModelResponseMonitoringWebsitePiracyEnforcementResponseGoogleProgressResponseItem {
  /** @format int32 */
  history_id: number;
  /**
   * @format date
   * @example "2023-03-01"
   */
  progress_date: string;
  status: PiracyCommonEnumsWebsiteListingHistoryStatusEnum;
}

export interface MarqBrandModelResponseMonitoringWebsitePiracyWebsiteContentsDetailPiracyResponse {
  detail_info: MarqBrandModelResponseMonitoringWebsitePiracyDetailInfoResponse;
  enforcement_progress: PiracyCommonModelEnforcementProgress;
}

export interface MarqBrandModelResponseSellerBrandSellerClusterResponse {
  channel_list: MarqCommonEnumsDomainTypeEnum[];
  /** @format int32 */
  cluster_id: number;
  demand_letter?: MarqBrandModelResponseSellerDemandLetterResponse;
  domain_list: string[];
  /** @format int32 */
  enforcement_possible_count: number;
  /**
   * @format date
   * @example "2023-03-01"
   */
  last_detected_date?: string | null;
  name: string;
  /** @format int32 */
  other_seller_count?: number | null;
  /** @format int32 */
  risk_score: number;
  /** @format int32 */
  sales_volume: number;
  /** @format int32 */
  sn_listing_count: number;
  /** @format int32 */
  total_active: number;
  /** @format int32 */
  total_detected: number;
  /** @format int32 */
  total_removed: number;
}

export interface MarqBrandModelResponseSellerDemandLetterResponse {
  /** @format int32 */
  demand_letter_count: number;
  /** @format int32 */
  removed_listing_count: number;
  /** @format int32 */
  requested_count: number;
  /** @format int32 */
  sent_count: number;
  status_list: MarqCommonEnumsDemandLetterStatusEnum[];
}

export interface MarqBrandModelResponseSellerSellerAnalyticsResponse {
  authorized: boolean;
  channel_list: MarqCommonEnumsDomainTypeEnum[];
  /** @format int32 */
  cluster_id?: number | null;
  clustered: boolean;
  demand_letter?: MarqBrandModelResponseSellerDemandLetterResponse;
  domain_list: string[];
  /** @format int32 */
  enforcement_possible_count: number;
  exist_email: boolean;
  /**
   * @format date
   * @example "2023-03-01"
   */
  last_detected_date?: string | null;
  name: string;
  /** @format int32 */
  risk_score: number;
  /** @format int32 */
  sales_volume: number;
  seller_contact_status?: MarqCommonEnumsSellerContactThreadStatusEnum;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  seller_contact_updated_at?: string | null;
  seller_id: string;
  seller_url?: string | null;
  /** @format int32 */
  sn_listing_count: number;
  /** @format int32 */
  total_active: number;
  /** @format int32 */
  total_detected: number;
  /** @format int32 */
  total_removed: number;
}

export interface MarqBrandModelResponseSellerSellerAnalyticsSellerInClusterResponse {
  channel_list: MarqCommonEnumsDomainTypeEnum[];
  /** @format int32 */
  cluster_id?: number | null;
  demand_letter?: MarqBrandModelResponseSellerDemandLetterResponse;
  domain_list: string[];
  /** @format int32 */
  enforcement_possible_count: number;
  is_clustered: boolean;
  /**
   * @format date
   * @example "2023-03-01"
   */
  last_detected_date?: string | null;
  name: string;
  /** @format int32 */
  other_seller_count?: number | null;
  /** @format int32 */
  risk_score: number;
  /** @format int32 */
  sales_volume: number;
  seller_id?: string | null;
  seller_url?: string | null;
  /** @format int32 */
  sn_listing_count: number;
  /** @format int32 */
  total_active: number;
  /** @format int32 */
  total_detected: number;
  /** @format int32 */
  total_removed: number;
}

export interface MarqBrandModelResponseWebsiteIpResponse {
  asn?: string | null;
  country?: MarqFoundationEnumsCountryCodeEnum;
  /** @format int32 */
  id: number;
  ip_address: string;
  isp?: string | null;
}

export interface MarqBrandModelResponseWebsiteLogoDetectionResponse {
  /** @format double */
  bb_x1?: number | null;
  /** @format double */
  bb_x2?: number | null;
  /** @format double */
  bb_y1?: number | null;
  /** @format double */
  bb_y2?: number | null;
  /** @format int32 */
  image_height?: number | null;
  /** @format int32 */
  image_width?: number | null;
}

export interface MarqBrandModelResponseWebsiteWebsiteCommonHostingProviderResponse {
  address?: string | null;
  city?: string | null;
  country_code?: MarqFoundationEnumsCountryCodeEnum;
  email?: string | null;
  name?: string | null;
  organization_id?: string | null;
  phone_number?: string | null;
  postal_code?: string | null;
  state?: string | null;
}

export interface MarqBrandModelResponseWebsiteWebsiteCommonRegistrantResponse {
  address?: string | null;
  city?: string | null;
  country_code?: MarqFoundationEnumsCountryCodeEnum;
  email_list?: MarqBrandCoreModelResponseIdAndStringValueResponse[] | null;
  name?: string | null;
  organization?: string | null;
  phone_number?: string | null;
  postal_code?: string | null;
  state?: string | null;
}

export interface MarqBrandModelResponseWebsiteWebsiteCommonRegistrarResponse {
  email?: string | null;
  homepage?: string | null;
  icann_id?: string | null;
  name?: string | null;
  phone_number?: string | null;
  whois_server?: string | null;
}

export interface MarqBrandModelResponseWebsiteWebsiteContentsDetailInfoResponse {
  asset_name?: string | null;
  custom_tag_list?: MarqBrandCoreModelResponseCustomTagResponse[] | null;
  hosting_provider?: MarqBrandModelResponseWebsiteWebsiteCommonHostingProviderResponse;
  image_url?: string | null;
  ip?: MarqBrandModelResponseWebsiteIpResponse;
  logo_detection?: MarqBrandModelResponseWebsiteLogoDetectionResponse;
  proof_url?: string | null;
  registrant?: MarqBrandModelResponseWebsiteWebsiteCommonRegistrantResponse;
  registrar?: MarqBrandModelResponseWebsiteWebsiteCommonRegistrarResponse;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  scanned_date?: string | null;
  scanned_status?: MarqCommonEnumsScannedStatusEnum;
  search_keyword?: string | null;
  thumbnail_url?: string | null;
  title: string;
  title_translate?: string | null;
  /** @format int32 */
  website_id: number;
  website_url: string;
}

export interface MarqBrandModelResponseWebsiteWebsiteContentsDetailResponse {
  enforcement_progress?: MarqBrandModelResponseWebsiteWebsiteContentsEnforcementResponse;
  tp_info?: MarqBrandCoreModelResponseTpDetailResponseForBrand;
  website_info: MarqBrandModelResponseWebsiteWebsiteContentsDetailInfoResponse;
}

export interface MarqBrandModelResponseWebsiteWebsiteContentsEnforcementResponse {
  google_progress?: MarqBrandModelResponseWebsiteWebsiteContentsEnforcementResponseGoogleProgressResponse;
  infringing_progress?: MarqBrandModelResponseWebsiteWebsiteContentsEnforcementResponseInfringingProgressResponse;
}

export interface MarqBrandModelResponseWebsiteWebsiteContentsEnforcementResponseGoogleProgressResponse {
  progress_list: MarqBrandModelResponseWebsiteWebsiteContentsEnforcementResponseGoogleProgressResponseItem[];
  status: MarqCommonEnumsSwWebsiteDelistingProgressEnum;
}

export interface MarqBrandModelResponseWebsiteWebsiteContentsEnforcementResponseGoogleProgressResponseItem {
  action: MarqCommonEnumsSwSWActionTypeEnum;
  isp?: MarqCommonEnumsReportAbuseIspEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  progress_date: string;
  status: MarqCommonEnumsSwWebsiteDelistingProgressEnum;
}

export interface MarqBrandModelResponseWebsiteWebsiteContentsEnforcementResponseInfringingProgressResponse {
  progress_list: MarqBrandModelResponseWebsiteWebsiteContentsEnforcementResponseInfringingProgressResponseItem[];
  status: MarqCommonEnumsSwWebsiteReportProgressEnum;
}

export interface MarqBrandModelResponseWebsiteWebsiteContentsEnforcementResponseInfringingProgressResponseItem {
  action: MarqCommonEnumsSwSWActionTypeEnum;
  isp?: MarqCommonEnumsReportAbuseIspEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  progress_date: string;
  status: MarqCommonEnumsSwWebsiteReportProgressEnum;
}

export interface MarqBrandModelResponseWebsiteWebsiteDomainNamesDetailAiVerdictInfoResponse {
  ai_verdict: MarqCommonEnumsSwAiLabelEnum;
  reason_list: MarqBrandModelResponseWebsiteWebsiteDomainNamesDetailAiVerdictInfoResponseAiReason[];
}

export interface MarqBrandModelResponseWebsiteWebsiteDomainNamesDetailAiVerdictInfoResponseAiReason {
  reason: string;
  subheading: string;
}

export interface MarqBrandModelResponseWebsiteWebsiteDomainNamesDetailHeaderInfoResponse {
  brand_name: string;
  current_status?: MarqCommonEnumsSwDomainTakedownStatusEnum;
  domain_status?: MarqCommonEnumsSwAiLabelEnum;
  favicon_url?: string | null;
  /** @format int32 */
  takedown_history_count: number;
  website_url: string;
}

export interface MarqBrandModelResponseWebsiteWebsiteDomainNamesDetailInfoResponse {
  country: MarqFoundationEnumsCountryCodeEnum;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  created_date?: string | null;
  custom_tag_list?: MarqBrandCoreModelResponseCustomTagResponse[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  expiration_date?: string | null;
  hosting_provider?: MarqBrandModelResponseWebsiteWebsiteCommonHostingProviderResponse;
  image_url?: string | null;
  ip?: MarqBrandModelResponseWebsiteIpResponse;
  logo_detection: boolean;
  logo_detection_data?: MarqBrandModelResponseWebsiteLogoDetectionResponse;
  mx_record: boolean;
  proof_url?: string | null;
  registrant?: MarqBrandModelResponseWebsiteWebsiteCommonRegistrantResponse;
  registrar?: MarqBrandModelResponseWebsiteWebsiteCommonRegistrarResponse;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  scanned_date?: string | null;
  scanned_status?: MarqCommonEnumsScannedStatusEnum;
  ssl_certificate?: string | null;
  thumbnail_url?: string | null;
  title: string;
  title_translate?: string | null;
  /** @format int32 */
  website_id: number;
  website_url: string;
}

export interface MarqBrandModelResponseWebsiteWebsiteDomainNamesDetailOverviewResponse {
  address?: string | null;
  address_location?: MarqBrandModelResponseWebsiteWebsiteDomainNamesDetailOverviewResponseLocation;
  asn?: string | null;
  brand_name: string;
  country: MarqFoundationEnumsCountryCodeEnum;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  created_date?: string | null;
  custom_tag_list?: MarqBrandCoreModelResponseCustomTagResponse[] | null;
  description: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  expiration_date?: string | null;
  hosting_provider_name?: string | null;
  ip_address: string;
  logo_detection: boolean;
  mx_record: boolean;
  mx_record_list?: string[] | null;
  registrant_name?: string | null;
  registrar_name?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  registration_date?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  scanned_date?: string | null;
  ssl_certificate?: string | null;
  title: string;
  title_translate?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  updated_date?: string | null;
  /** @format int32 */
  website_id: number;
}

export interface MarqBrandModelResponseWebsiteWebsiteDomainNamesDetailOverviewResponseLocation {
  /** @format double */
  lat: number;
  /** @format double */
  lng: number;
}

export interface MarqBrandModelResponseWebsiteWebsiteDomainNamesDetailResponse {
  enforcement_progress?: MarqBrandModelResponseWebsiteWebsiteDomainNamesEnforcementResponse;
  website_info: MarqBrandModelResponseWebsiteWebsiteDomainNamesDetailInfoResponse;
}

export interface MarqBrandModelResponseWebsiteWebsiteDomainNamesDomainHistoryResponse {
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  date: string;
  favicon_url?: string | null;
  pdf_url?: string | null;
  status: MarqCommonEnumsSwAiLabelEnum;
}

export interface MarqBrandModelResponseWebsiteWebsiteDomainNamesEnforcementResponse {
  google_progress?: MarqBrandModelResponseWebsiteWebsiteDomainNamesEnforcementResponseGoogleProgressResponse;
  infringing_progress?: MarqBrandModelResponseWebsiteWebsiteDomainNamesEnforcementResponseInfringingProgressResponse;
}

export interface MarqBrandModelResponseWebsiteWebsiteDomainNamesEnforcementResponseGoogleProgressResponse {
  progress_list: MarqBrandModelResponseWebsiteWebsiteDomainNamesEnforcementResponseGoogleProgressResponseItem[];
  status: MarqCommonEnumsSwWebsiteDelistingProgressEnum;
}

export interface MarqBrandModelResponseWebsiteWebsiteDomainNamesEnforcementResponseGoogleProgressResponseItem {
  action: MarqCommonEnumsSwSWActionTypeEnum;
  isp?: MarqCommonEnumsReportAbuseIspEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  progress_date: string;
  status: MarqCommonEnumsSwWebsiteDelistingProgressEnum;
}

export interface MarqBrandModelResponseWebsiteWebsiteDomainNamesEnforcementResponseInfringingProgressResponse {
  progress_list: MarqBrandModelResponseWebsiteWebsiteDomainNamesEnforcementResponseInfringingProgressResponseItem[];
  status: MarqCommonEnumsSwWebsiteReportProgressEnum;
}

export interface MarqBrandModelResponseWebsiteWebsiteDomainNamesEnforcementResponseInfringingProgressResponseItem {
  action: MarqCommonEnumsSwSWActionTypeEnum;
  isp?: MarqCommonEnumsReportAbuseIspEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  progress_date: string;
  status: MarqCommonEnumsSwWebsiteReportProgressEnum;
}

export interface MarqBrandModelResponseWebsiteWebsiteDomainNamesListing {
  ai_label?: MarqCommonEnumsSwAiLabelEnum;
  cdn?: string | null;
  /** @format int32 */
  comment_count: number;
  country?: MarqFoundationEnumsCountryCodeEnum;
  custom_tags?: MarqBrandCoreModelResponseCustomTagResponse[] | null;
  description?: string | null;
  description_translate?: string | null;
  domain_status?: MarqCommonEnumsSwAiLabelEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  expiration_date?: string | null;
  favicon_url?: string | null;
  google_delisting_status?: MarqCommonEnumsSwWebsiteDelistingProgressEnum;
  hosting_provider?: string | null;
  ip_address?: string | null;
  logo_detection: boolean;
  logo_detection_data?: MarqBrandCoreModelSwLogoDetectionResponse;
  mx_record: boolean;
  /**
   * @format date
   * @example "2023-03-01"
   */
  progress_date?: string | null;
  registrant?: string | null;
  registrar?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  registration_date?: string | null;
  report_status?: MarqCommonEnumsSwWebsiteReportProgressEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  requested_date?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  scanned_date?: string | null;
  scanned_status?: MarqCommonEnumsScannedStatusEnum;
  ssl_certificate?: string | null;
  thumbnail_url?: string | null;
  title: string;
  title_translate?: string | null;
  /** @format int32 */
  website_id: number;
  website_url: string;
}

export interface MarqBrandModelResponseWebsiteWebsiteDomainNamesReportedDetailResponse {
  ai_verdict_info?: MarqBrandModelResponseWebsiteWebsiteDomainNamesDetailAiVerdictInfoResponse;
  domain_history_list?: MarqBrandModelResponseWebsiteWebsiteDomainNamesDomainHistoryResponse[] | null;
  header_info: MarqBrandModelResponseWebsiteWebsiteDomainNamesDetailHeaderInfoResponse;
  overview: MarqBrandModelResponseWebsiteWebsiteDomainNamesDetailOverviewResponse;
  screenshot_url?: string | null;
  takedown_history_list: MarqBrandModelResponseWebsiteWebsiteDomainNamesTakedownHistoryResponse[];
}

export interface MarqBrandModelResponseWebsiteWebsiteDomainNamesTakedownHistoryResponse {
  google_progress?: MarqBrandModelResponseWebsiteWebsiteDomainNamesTakedownHistoryResponseGoogleProgressResponse;
  infringing_progress?: MarqBrandModelResponseWebsiteWebsiteDomainNamesTakedownHistoryResponseInfringingProgressResponse;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  start_date: string;
  status: MarqCommonEnumsSwDomainTakedownStatusEnum;
}

export interface MarqBrandModelResponseWebsiteWebsiteDomainNamesTakedownHistoryResponseGoogleProgressResponse {
  progress_list: MarqBrandModelResponseWebsiteWebsiteDomainNamesTakedownHistoryResponseGoogleProgressResponseItem[];
  status: MarqCommonEnumsSwWebsiteDelistingProgressEnum;
}

export interface MarqBrandModelResponseWebsiteWebsiteDomainNamesTakedownHistoryResponseGoogleProgressResponseItem {
  /**
   * @format date
   * @example "2023-03-01"
   */
  progress_date: string;
  status: MarqCommonEnumsSwWebsiteDelistingProgressEnum;
}

export interface MarqBrandModelResponseWebsiteWebsiteDomainNamesTakedownHistoryResponseInfringingProgressResponse {
  progress_list: MarqBrandModelResponseWebsiteWebsiteDomainNamesTakedownHistoryResponseInfringingProgressResponseItem[];
  status: MarqCommonEnumsSwWebsiteReportProgressEnum;
}

export interface MarqBrandModelResponseWebsiteWebsiteDomainNamesTakedownHistoryResponseInfringingProgressResponseItem {
  action: MarqCommonEnumsSwSWActionTypeEnum;
  isp?: MarqCommonEnumsReportAbuseIspEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  progress_date: string;
  status: MarqCommonEnumsSwWebsiteReportProgressEnum;
}

export enum MarqCommonEnumsAuthorizedSellerKeywordSortedColumnEnum {
  AddedOn = 'added_on',
  Keyword = 'keyword',
}

export enum MarqCommonEnumsAuthorizedSellerSortedColumnEnum {
  SellerName = 'seller_name',
  AddedDate = 'added_date',
}

export enum MarqCommonEnumsChannelTypeEnum {
  Ecommerce = 'ecommerce',
  SocialMedia = 'social_media',
  WebsiteContents = 'website_contents',
  DomainNames = 'domain_names',
}

export enum MarqCommonEnumsClientStatusEnum {
  Demo = 'demo',
  Deactivated = 'deactivated',
  Test = 'test',
  ActiveClient = 'active_client',
}

export enum MarqCommonEnumsCopyrightedImageCollectionSortedByEnum {
  NumberOfImages = 'number_of_images',
  CollectionTitle = 'collection_title',
  CreatedDate = 'created_date',
}

export enum MarqCommonEnumsCopyrightedImageSortedByEnum {
  ImageTitle = 'image_title',
  CreatedDate = 'created_date',
}

export enum MarqCommonEnumsDemandLetterStatusEnum {
  Requested = 'requested',
  Reviewing = 'reviewing',
  Delivering = 'delivering',
  SellerResponse = 'seller_response',
  ContactFailed = 'contact_failed',
  CaseClosed = 'case_closed',
}

export enum MarqCommonEnumsDomainTypeEnum {
  Ecommerce = 'ecommerce',
  SocialMedia = 'social_media',
  StandAlone = 'stand_alone',
}

export enum MarqCommonEnumsEnforcementStatusEnum {
  Processing = 'processing',
  Reporting = 'reporting',
  SoftNotice = 'soft_notice',
  Removed = 'removed',
  Denied = 'denied',
  NonEnforceable = 'non_enforceable',
  Tp = 'tp',
}

export enum MarqCommonEnumsIpRightType {
  Trademark = 'trademark',
  Copyright = 'copyright',
  Design = 'design',
  NotFound = 'not_found',
}

export enum MarqCommonEnumsListingPostTypeEnum {
  Post = 'post',
  Profile = 'profile',
}

export enum MarqCommonEnumsListingStatusEnum {
  Tbtba = 'tbtba',
  ToBeApproved = 'to_be_approved',
  TbaIr = 'tba_ir',
  Irrelevant = 'irrelevant',
  Unprotected = 'unprotected',
  Authorized = 'authorized',
  Authentic = 'authentic',
  Overpriced = 'overpriced',
  Expired = 'expired',
  PreApproved = 'pre_approved',
  PrePublic = 'pre_public',
  PotentialAuthorized = 'potential_authorized',
  IrrelevantPublic = 'irrelevant_public',
  Unavailable = 'unavailable',
  AuthenticPublic = 'authentic_public',
  Checking = 'checking',
  DocPending = 'doc_pending',
  PreSn = 'pre_sn',
  DocDraft = 'doc_draft',
  DocFirst = 'doc_first',
  DocFinal = 'doc_final',
  PostSn = 'post_sn',
  Approved = 'approved',
  Public = 'public',
  DocApproved = 'doc_approved',
  Investigated = 'investigated',
  OldInvestigated = 'old_investigated',
  Pending = 'pending',
  Archived = 'archived',
  Dismissed = 'dismissed',
  Later = 'later',
  Gray = 'gray',
  InvDismissed = 'inv_dismissed',
  InvLater = 'inv_later',
  InvGray = 'inv_gray',
  Tbr = 'tbr',
  Unreportable = 'unreportable',
  InReview = 'in_review',
  OnHold = 'on_hold',
  Tp = 'tp',
  Enforced = 'enforced',
  Denied = 'denied',
  NonEc = 'non_ec',
  SelfRemoved = 'self_removed',
  Trash = 'trash',
  Landscaping = 'landscaping',
}

export enum MarqCommonEnumsMapSortEnum {
  ViolationListings = 'violation_listings',
  ViolationSellers = 'violation_sellers',
  LowestPrice = 'lowest_price',
  LowestDynamicPrice = 'lowest_dynamic_price',
  LowestFinalPrice = 'lowest_final_price',
  LowestConvertedDynamicPrice = 'lowest_converted_dynamic_price',
  LowestConvertedAdvertisedPrice = 'lowest_converted_advertised_price',
}

export enum MarqCommonEnumsMimeTypeEnum {
  TextPlain = 'text/plain',
  TextHtml = 'text/html',
}

export enum MarqCommonEnumsNonEnforcementReasonEnum {
  NoCounterfeit = 'no_counterfeit',
  NoIpRights = 'no_ip_rights',
  Authentic = 'authentic',
  Irrelevant = 'irrelevant',
  Unavailable = 'unavailable',
}

export enum MarqCommonEnumsPerfTimeFrequencyEnum {
  Daily = 'daily',
  Weekly = 'weekly',
  Monthly = 'monthly',
  Yearly = 'yearly',
}

export enum MarqCommonEnumsPotentialAuthorizedReasonEnum {
  Keyword = 'keyword',
  MatchingName = 'matching_name',
  SimilarName = 'similar_name',
  Clustered = 'clustered',
  MarqvisionReview = 'marqvision_review',
}

export enum MarqCommonEnumsPotentialAuthorizedSortedColumnEnum {
  DetectedDate = 'detected_date',
  SellerName = 'seller_name',
}

export enum MarqCommonEnumsPriceAnalyticsExportType {
  Overview = 'overview',
  Models = 'models',
}

export enum MarqCommonEnumsPriceAnalyticsModelSortEnum {
  RetentionRate = 'retention_rate',
  RecoveryRate = 'recovery_rate',
}

export enum MarqCommonEnumsReportAbuseIspEnum {
  Kisa = 'kisa',
  Registrar = 'registrar',
  HostingProvider = 'hosting_provider',
  Registry = 'registry',
  Icann = 'icann',
  Payment = 'payment',
  WebsiteBuilder = 'website_builder',
  GoogleSafeBrowsing = 'google_safe_browsing',
  Cdn = 'cdn',
}

export enum MarqCommonEnumsReportableReasonEnum {
  TrademarkWordObvious = 'trademark_word_obvious',
  TrademarkOriginDiff = 'trademark_origin_diff',
  TrademarkSizeDiff = 'trademark_size_diff',
  TrademarkMaterialDiff = 'trademark_material_diff',
  TrademarkShapeDiff = 'trademark_shape_diff',
  TrademarkLogoNameConceal = 'trademark_logo_name_conceal',
  TrademarkModelNotExist = 'trademark_model_not_exist',
  TrademarkFreeRiding = 'trademark_free_riding',
  TrademarkOther = 'trademark_other',
  TrademarkMiscellaneous = 'trademark_miscellaneous',
  TrademarkNotFound = 'trademark_not_found',
  CopyrightWordObvious = 'copyright_word_obvious',
  CopyrightOriginDiff = 'copyright_origin_diff',
  CopyrightSizeDiff = 'copyright_size_diff',
  CopyrightMaterialDiff = 'copyright_material_diff',
  CopyrightShapeDiff = 'copyright_shape_diff',
  CopyrightModelNotExist = 'copyright_model_not_exist',
  CopyrightArtworkUse = 'copyright_artwork_use',
  CopyrightOther = 'copyright_other',
  CopyrightMiscellaneous = 'copyright_miscellaneous',
  CopyrightNotFound = 'copyright_not_found',
  DesignNoAuthorization = 'design_no_authorization',
  DesignMiscellaneous = 'design_miscellaneous',
  DesignNotFound = 'design_not_found',
  OfficialImage = 'official_image',
  OfficialVideo = 'official_video',
  NotFoundMiscellaneous = 'not_found_miscellaneous',
  NotFoundWordObvious = 'not_found_word_obvious',
  NotFoundOriginDiff = 'not_found_origin_diff',
  NotFoundSizeDiff = 'not_found_size_diff',
  NotFoundMaterialDiff = 'not_found_material_diff',
  NotFoundShapeDiff = 'not_found_shape_diff',
  NotFoundLogoNameConceal = 'not_found_logo_name_conceal',
  NotFoundModelNotExist = 'not_found_model_not_exist',
  NotFoundFreeRiding = 'not_found_free_riding',
  NotFoundArtworkUse = 'not_found_artwork_use',
  NotFoundOther = 'not_found_other',
  NotFoundNoAuthorization = 'not_found_no_authorization',
  CvKcCertificationNumberMissing = 'cv_kc_certification_number_missing',
  CvExpirationInfoMissing = 'cv_expiration_info_missing',
  CvRequiredProductInfoMissing = 'cv_required_product_info_missing',
  CvPersonalDataActViolation = 'cv_personal_data_act_violation',
  CvKeywordAbuseInProductName = 'cv_keyword_abuse_in_product_name',
  CvUnregisteredHealthSupplement = 'cv_unregistered_health_supplement',
  CvFalseASInfo = 'cv_false_AS_info',
  CvOriginNotProvided = 'cv_origin_not_provided',
  CvCosmeticRepackaged = 'cv_cosmetic_repackaged',
  CvCosmeticSamples = 'cv_cosmetic_samples',
  CvCosmeticExpired = 'cv_cosmetic_expired',
  CvRfidTagRemoved = 'cv_rfid_tag_removed',
  CvOthers = 'cv_others',
}

export enum MarqCommonEnumsScannedStatusEnum {
  All = 'all',
  RecentlyScanned = 'recently_scanned',
  Irrelevant = 'irrelevant',
  OutOfScope = 'out_of_scope',
}

export enum MarqCommonEnumsSellerAnalyticsSellerTypeEnum {
  Cluster = 'cluster',
  Ecommerce = 'ecommerce',
  StandAlone = 'stand_alone',
}

export enum MarqCommonEnumsSellerContactSenderTypeEnum {
  Client = 'client',
  Seller = 'seller',
}

export enum MarqCommonEnumsSellerContactTemplateTypeEnum {
  IpNotice = 'ip_notice',
  SellerVerify = 'seller_verify',
  ClientCustom = 'client_custom',
  NewMessage = 'new_message',
}

export enum MarqCommonEnumsSellerContactThreadStatusEnum {
  Sent = 'sent',
  Received = 'received',
  Resolved = 'resolved',
  Escalated = 'escalated',
}

export enum MarqCommonEnumsSellerLinkRequestStatusEnum {
  Wait = 'wait',
  InProgress = 'in_progress',
  Completed = 'completed',
  Failed = 'failed',
}

export enum MarqCommonEnumsSellerListingStatusGraphTabType {
  AllDays = 'all_days',
  SevenDays = 'seven_days',
  ThirtyDays = 'thirty_days',
  NinetyDays = 'ninety_days',
  OneYears = 'one_years',
}

export enum MarqCommonEnumsSellerSearchSortEnum {
  RiskScore = 'risk_score',
  TotalDetected = 'total_detected',
  TotalRemoved = 'total_removed',
  ActiveListings = 'active_listings',
  SellerName = 'seller_name',
  SalesVolume = 'sales_volume',
  SellerContactAt = 'seller_contact_at',
}

export enum MarqCommonEnumsShippingTypeEnum {
  Free = 'free',
  Paid = 'paid',
  ConditionalFree = 'conditional_free',
  UnitQuantityPaid = 'unit_quantity_paid',
  RangeQuantityPaid = 'range_quantity_paid',
  Undefined = 'undefined',
}

export enum MarqCommonEnumsSmartRuleSortedByEnum {
  Title = 'title',
  CreatedDate = 'created_date',
  UpdatedDate = 'updated_date',
}

export enum MarqCommonEnumsSortedColumnArchivedPageEnum {
  ArchivedDate = 'archived_date',
}

export enum MarqCommonEnumsSortedColumnEnforcementPageEnum {
  UpdatedDate = 'updated_date',
  RequestedDate = 'requested_date',
}

export enum MarqCommonEnumsSortedOrderEnum {
  Asc = 'asc',
  Desc = 'desc',
}

export enum MarqCommonEnumsSortedSellerGroupEnum {
  ListingCount = 'listing_count',
  SellerName = 'seller_name',
  Featured = 'featured',
}

export enum MarqCommonEnumsStorageFileTypeEnum {
  ListingAttachment = 'listing_attachment',
  Cr = 'cr',
  CrOther = 'cr_other',
  CrTask = 'cr_task',
  CrTemplate = 'cr_template',
  IpOwner = 'ip_owner',
  IpLicensee = 'ip_licensee',
  CommentAttachment = 'comment_attachment',
  ScrapeExtension = 'scrape_extension',
  ClientContract = 'client_contract',
  SellerContactAttachment = 'seller_contact_attachment',
  Tp = 'tp',
  Ip = 'ip',
  Standalone = 'standalone',
  PerformanceReport = 'performance_report',
  Asset = 'asset',
  Atom = 'atom',
  AddRaw = 'add_raw',
  OfficialImage = 'official_image',
  InfringingImage = 'infringing_image',
  Enforceability = 'enforceability',
  LogoAux = 'logo_aux',
  NeutralImage = 'neutral_image',
  ReleaseNote = 'release_note',
  ClientLogo = 'client_logo',
}

export enum MarqCommonEnumsSwAiLabelEnum {
  Impersonation = 'impersonation',
  ParkedDomain = 'parked_domain',
  InactiveDomain = 'inactive_domain',
  Clean = 'clean',
  NotSure = 'not_sure',
  Failed = 'failed',
  Abnormal = 'abnormal',
}

export enum MarqCommonEnumsSwDomainTakedownStatusEnum {
  Requested = 'requested',
  ReportInProgress = 'report_in_progress',
  Removed = 'removed',
  Denied = 'denied',
}

export enum MarqCommonEnumsTranslateStatusEnum {
  On = 'on',
  Off = 'off',
  DeActive = 'de_active',
}

export enum MarqCommonEnumsAiClientAIResultEnum {
  LikelyCounterfeit = 'likely_counterfeit',
  AnalysisResult = 'analysis_result',
}

export enum MarqCommonEnumsAiClientTagEnum {
  Trademark = 'trademark',
  TextDetection = 'text_detection',
  ClientRequested = 'client_requested',
  InfringingImage = 'infringing_image',
  OfficialImage = 'official_image',
  RepeatOffender = 'repeat_offender',
  LowPrice = 'low_price',
  TopResult = 'top_result',
}

export enum MarqCommonEnumsAuthMfaStatusEnum {
  NotRequired = 'not_required',
  NotRegistered = 'not_registered',
  Registered = 'registered',
}

export enum MarqCommonEnumsCleanlinessCleanlinessLabelEnum {
  Authorized = 'authorized',
  Counterfeit = 'counterfeit',
  SuspectedCounterfeit = 'suspected_counterfeit',
  TrademarkAbuse = 'trademark_abuse',
  CopyrightAbuse = 'copyright_abuse',
  Unauthorized = 'unauthorized',
  Undetermined = 'undetermined',
  OutOfScope = 'out_of_scope',
  Irrelevant = 'irrelevant',
}

export enum MarqCommonEnumsClientClientRoleEnum {
  Owner = 'owner',
  Member = 'member',
  LimitedAccess = 'limited_access',
  Admin = 'admin',
}

export enum MarqCommonEnumsClientClientTypeEnum {
  Counterfeit = 'counterfeit',
  UnauthorizedSales = 'unauthorized_sales',
  Impersonation = 'impersonation',
  Piracy = 'piracy',
}

export enum MarqCommonEnumsCommentCommentUserTypeEnum {
  All = 'all',
  Admin = 'admin',
  Client = 'client',
}

export enum MarqCommonEnumsCrClientRequestChannelTypeEnum {
  Ecommerce = 'ecommerce',
  Website = 'website',
  SocialProfile = 'social_profile',
  None = 'none',
}

export enum MarqCommonEnumsCrClientRequestEnforcementTypeEnum {
  PrePublic = 'pre_public',
  Enforced = 'enforced',
}

export enum MarqCommonEnumsCrClientRequestStatusEnum {
  Opened = 'opened',
  Closed = 'closed',
}

export enum MarqCommonEnumsCrClientRequestTypeEnum {
  Url = 'url',
  Other = 'other',
}

export enum MarqCommonEnumsCrClientTaskFileTypeEnum {
  All = 'all',
  Document = 'document',
  Image = 'image',
  Sheet = 'sheet',
}

export enum MarqCommonEnumsCrClientTaskMessageTypeEnum {
  Open = 'open',
  Reply = 'reply',
  Reopen = 'reopen',
}

export enum MarqCommonEnumsCrClientTaskStatusEnum {
  Opened = 'opened',
  Reopened = 'reopened',
  Replied = 'replied',
  Completed = 'completed',
}

export enum MarqCommonEnumsCrClientTaskTypeEnum {
  ReviewCommercePotentialWhiteSeller = 'review_commerce_potential_white_seller',
  ReviewSocialMediaPotentialWhiteSeller = 'review_social_media_potential_white_seller',
  Confirm = 'confirm',
  Upload = 'upload',
  ReUpload = 're_upload',
  ReviewMarketplaceSeller = 'review_marketplace_seller',
  ReviewSocialMediaSeller = 'review_social_media_seller',
}

export enum MarqCommonEnumsCrCrUrlProgressStatusEnum {
  MarqVisionUnderReview = 'MarqVision under review',
  Flagged = 'Flagged',
  TestPurchaseOffered = 'Test Purchase Offered',
  ReviewNeeded = 'Review needed',
  UnderReview = 'Under review',
  Archived = 'Archived',
  EnforcementInProgress = 'Enforcement in Progress',
  Removed = 'Removed',
  CaseClosed = 'Case closed',
  RemovalDenied = 'Removal Denied',
  AuthorizedSeller = 'Authorized seller',
  AuthorizedWebsites = 'Authorized websites',
  LikelyToBeAuthentic = 'Likely to be authentic',
  URLExpired = 'URL expired',
  NotEnforceable = 'Not enforceable',
  InvalidURL = 'Invalid URL',
  Value = '-',
}

export enum MarqCommonEnumsCrCrUrlStatusEnum {
  InProgress = 'in_progress',
  Completed = 'completed',
  Failed = 'failed',
}

export enum MarqCommonEnumsCvassistantCvAssistantResultEnum {
  Infringing = 'infringing',
  NotInfringing = 'not_infringing',
  Undecidable = 'undecidable',
  NoResponse = 'no_response',
}

export enum MarqCommonEnumsCvassistantCvAssistantStatusEnum {
  Detected = 'detected',
  Requested = 'requested',
  Approved = 'approved',
  Pending = 'pending',
  InProgress = 'in_progress',
  Completed = 'completed',
  UrlRemoved = 'url_removed',
  Reported = 'reported',
  Dismissed = 'dismissed',
  Authorized = 'authorized',
}

export enum MarqCommonEnumsIpCopyrightType {
  Artwork = 'artwork',
  Image = 'image',
  Software = 'software',
  Video = 'video',
  Publication = 'publication',
}

export enum MarqCommonEnumsIpCounterfeitType {
  WordObvious = 'word_obvious',
  OriginDiff = 'origin_diff',
  MaterialDiff = 'material_diff',
  SizeDiff = 'size_diff',
  ShapeDiff = 'shape_diff',
  LogoNameConceal = 'logo_name_conceal',
  ModelNotExist = 'model_not_exist',
  FreeRiding = 'free_riding',
  ArtworkUse = 'artwork_use',
  ImageTheft = 'image_theft',
  Misc = 'misc',
  VideoUse = 'video_use',
  NoAuthorization = 'no_authorization',
  Other = 'other',
  NotFound = 'not_found',
  UnauthorizedSales = 'unauthorized_sales',
}

export enum MarqCommonEnumsPerfPerformaceImpersonationComponentEnum {
  FunnelChart = 'funnel_chart',
  Insight = 'insight',
  Reporting = 'reporting',
  Compliance = 'compliance',
  ProcessingTime = 'processing_time',
}

export enum MarqCommonEnumsPerfPerformanceEnforcementGroupByEnum {
  None = 'none',
  Country = 'country',
  Platform = 'platform',
  Asset = 'asset',
  Collection = 'collection',
}

export enum MarqCommonEnumsPerfPerformanceEnforcementIntervalEnum {
  Daily = 'daily',
  Weekly = 'weekly',
  Monthly = 'monthly',
  Yearly = 'yearly',
}

export enum MarqCommonEnumsPerfPerformanceEnforcementReportableEnum {
  Reportable = 'reportable',
  NotReportable = 'not_reportable',
}

export enum MarqCommonEnumsPerfPerformanceEnforcementTabEnum {
  Scanned = 'scanned',
  Flagged = 'flagged',
  Requested = 'requested',
  Reviewed = 'reviewed',
  Reported = 'reported',
  Removed = 'removed',
}

export enum MarqCommonEnumsRuleDescriptionContainsTypeEnum {
  All = 'all',
  Any = 'any',
  None = 'none',
}

export enum MarqCommonEnumsRulePriceRelativeReferenceTypeEnum {
  Asset = 'asset',
  Model = 'model',
}

export enum MarqCommonEnumsRuleProductCodeMatchTypeEnum {
  Any = 'any',
  None = 'none',
}

export enum MarqCommonEnumsRuleShipFromContainsTypeEnum {
  Any = 'any',
  None = 'none',
}

export enum MarqCommonEnumsRuleSmartRuleActionEnum {
  Tag = 'tag',
  ArchiveDismissed = 'archive_dismissed',
  Archived = 'archived',
  Enforcement = 'enforcement',
}

export enum MarqCommonEnumsRuleSmartRuleConditionTypeEnum {
  And = 'and',
  Or = 'or',
  Assets = 'assets',
  Models = 'models',
  Domain = 'domain',
  ProductCode = 'product_code',
  TrademarkedLogo = 'trademarked_logo',
  TrademarkedTextUsed = 'trademarked_text_used',
  RepeatOffenders = 'repeat_offenders',
  TopSearchResults = 'top_search_results',
  LowPrice = 'low_price',
  SaturationRate = 'saturation_rate',
  PriceFixed = 'price_fixed',
  PriceRelative = 'price_relative',
  CopyrightedImage = 'copyrighted_image',
  InfringingImage = 'infringing_image',
  ShipFrom = 'ship_from',
  TitleContains = 'title_contains',
  DescriptionContains = 'description_contains',
  Seller = 'seller',
  SellerContains = 'seller_contains',
  AvailableStock = 'available_stock',
}

export enum MarqCommonEnumsRuleSmartRuleDomainGroupEnum {
  Amazon = 'amazon',
  Coupang = 'coupang',
  Walmart = 'walmart',
}

export enum MarqCommonEnumsRuleSmartRuleStatusEnum {
  Activated = 'activated',
  Deactivated = 'deactivated',
  Processing = 'processing',
}

export enum MarqCommonEnumsRuleTitleContainsTypeEnum {
  All = 'all',
  Any = 'any',
  None = 'none',
}

export enum MarqCommonEnumsSellerintelSellerClusterDataSortByEnum {
  SellerName = 'seller_name',
  BusRegNum = 'bus_reg_num',
  OnlineMarkNum = 'online_mark_num',
  PhoneNum = 'phone_num',
  Email = 'email',
  Address = 'address',
  CompName = 'comp_name',
  LegRep = 'leg_rep',
  ShopName = 'shop_name',
  Market = 'market',
  MarketCountryCode = 'market_country_code',
  ListingImages = 'listing_images',
  ListingTitle = 'listing_title',
  ListingDesc = 'listing_desc',
  Detected = 'detected',
  Removed = 'removed',
  Active = 'active',
  SalesVolume = 'sales_volume',
}

export enum MarqCommonEnumsSellerintelSellerClusterStatusEnum {
  ActCalculating = 'act_calculating',
  ActActual = 'act_actual',
  Deactivated = 'deactivated',
}

export enum MarqCommonEnumsSellerintelSellerIntelClusterSortBy {
  SCount = 's_count',
  MCount = 'm_count',
  Detected = 'detected',
  Removed = 'removed',
  SVol = 's_vol',
  StCount = 'st_count',
}

export enum MarqCommonEnumsSellerintelSellerIntelDetailsCountriesSortBy {
  SellerCount = 'seller_count',
  MarketplaceCount = 'marketplace_count',
  DetectedCount = 'detected_count',
  EnforcedCount = 'enforced_count',
  SalesVolume = 'sales_volume',
  AvailableStock = 'available_stock',
}

export enum MarqCommonEnumsSellerintelSellerIntelDetailsDomainsSortBy {
  SellerCount = 'seller_count',
  DetectedCount = 'detected_count',
  EnforcedCount = 'enforced_count',
  SalesVolume = 'sales_volume',
  AvailableStock = 'available_stock',
}

export enum MarqCommonEnumsSellerintelSellerIntelDetailsSellersSortBy {
  DetectedCount = 'detected_count',
  EnforcedCount = 'enforced_count',
  SalesVolume = 'sales_volume',
  AvailableStock = 'available_stock',
}

export enum MarqCommonEnumsSellerintelSellerIntelMappingLevel {
  Level1 = 'level_1',
  Level2 = 'level_2',
  Level3 = 'level_3',
  Level4 = 'level_4',
}

export enum MarqCommonEnumsSwSWActionTypeEnum {
  GoogleDelisting = 'google_delisting',
  SoftNotice = 'soft_notice',
  ReportAbuse = 'report_abuse',
  Udrp = 'udrp',
}

export enum MarqCommonEnumsSwSWStatusEnum {
  ThirdFetched = 'third_fetched',
  ToBeApproved = 'to_be_approved',
  Approved = 'approved',
  Public = 'public',
  InvestigatePending = 'investigate_pending',
  InvInProgress = 'inv_in_progress',
  Investigated = 'investigated',
  ActionTaken = 'action_taken',
  NonEnforceable = 'non_enforceable',
  Irrelevant = 'irrelevant',
  Authorized = 'authorized',
  Tp = 'tp',
  Trash = 'trash',
  Ignore = 'ignore',
  Removed = 'removed',
  Denied = 'denied',
  Dissmissed = 'dissmissed',
  Watchlist = 'watchlist',
  InvCompleted = 'inv_completed',
  NotUse = 'not_use',
}

export enum MarqCommonEnumsSwWebsiteBrandDomainNamesTabEnum {
  Scanned = 'scanned',
  Detected = 'detected',
  Requested = 'requested',
  CaseClosed = 'case_closed',
  Dismissed = 'dismissed',
  Denied = 'denied',
  Removed = 'removed',
  Watchlist = 'watchlist',
  Monitoring = 'monitoring',
  NonEnforceable = 'non_enforceable',
  Reported = 'reported',
}

export enum MarqCommonEnumsSwWebsiteContentsTabEnum {
  Scanned = 'scanned',
  Detected = 'detected',
  Requested = 'requested',
  CaseClosed = 'case_closed',
  Reported = 'reported',
  Removed = 'removed',
  Denied = 'denied',
  Dismissed = 'dismissed',
  Tp = 'tp',
}

export enum MarqCommonEnumsSwWebsiteDelistingProgressEnum {
  Reviewing = 'reviewing',
  Reported = 'reported',
  Delisted = 'delisted',
  Denied = 'denied',
}

export enum MarqCommonEnumsSwWebsiteReportProgressEnum {
  Reviewing = 'reviewing',
  Reported = 'reported',
  Removed = 'removed',
  Denied = 'denied',
}

export enum MarqCommonEnumsTpTPImageTypeEnum {
  Waybill = 'waybill',
  Package = 'package',
  Product = 'product',
  Labels = 'labels',
  Others = 'others',
  Report = 'report',
  Image = 'image',
}

export enum MarqCommonEnumsTpTPTypeEnum {
  Standard = 'standard',
  Basic = 'basic',
}

export interface MarqCommonModelCoordinate {
  /** @format double */
  x1: number;
  /** @format double */
  x2: number;
  /** @format double */
  y1: number;
  /** @format double */
  y2: number;
}

export interface MarqCommonModelLocalDateRange {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start?: string | null;
}

export interface MarqCommonModelOffsetDateTimeRange {
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  end: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  start: string;
}

export type MarqCommonModelRuleSmartRuleConditionForClient =
  | MarqCommonModelRuleSmartRuleConditionForClientAnd
  | MarqCommonModelRuleSmartRuleConditionForClientAssets
  | MarqCommonModelRuleSmartRuleConditionForClientAvailableStock
  | MarqCommonModelRuleSmartRuleConditionForClientCopyrightedImage
  | MarqCommonModelRuleSmartRuleConditionForClientDescriptionContains
  | MarqCommonModelRuleSmartRuleConditionForClientDomain
  | MarqCommonModelRuleSmartRuleConditionForClientInfringingImage
  | MarqCommonModelRuleSmartRuleConditionForClientLowPrice
  | MarqCommonModelRuleSmartRuleConditionForClientModels
  | MarqCommonModelRuleSmartRuleConditionForClientOr
  | MarqCommonModelRuleSmartRuleConditionForClientPriceFixed
  | MarqCommonModelRuleSmartRuleConditionForClientPriceRelative
  | MarqCommonModelRuleSmartRuleConditionForClientProductCode
  | MarqCommonModelRuleSmartRuleConditionForClientRepeatOffenders
  | MarqCommonModelRuleSmartRuleConditionForClientSaturationRate
  | MarqCommonModelRuleSmartRuleConditionForClientSeller
  | MarqCommonModelRuleSmartRuleConditionForClientSellerContains
  | MarqCommonModelRuleSmartRuleConditionForClientShipFrom
  | MarqCommonModelRuleSmartRuleConditionForClientTitleContains
  | MarqCommonModelRuleSmartRuleConditionForClientTopSearchResults
  | MarqCommonModelRuleSmartRuleConditionForClientTrademarkedLogo
  | MarqCommonModelRuleSmartRuleConditionForClientTrademarkedTextUsed;

export interface MarqCommonModelRuleSmartRuleConditionForClientAnd {
  conditions: MarqCommonModelRuleSmartRuleConditionForClient[];
  type: MarqCommonEnumsRuleSmartRuleConditionTypeEnum;
}

export interface MarqCommonModelRuleSmartRuleConditionForClientAssets {
  asset_ids: number[];
  type: MarqCommonEnumsRuleSmartRuleConditionTypeEnum;
}

export interface MarqCommonModelRuleSmartRuleConditionForClientAvailableStock {
  /** @format int32 */
  gt?: number | null;
  /** @format int32 */
  gte?: number | null;
  /** @format int32 */
  lt?: number | null;
  /** @format int32 */
  lte?: number | null;
  type: MarqCommonEnumsRuleSmartRuleConditionTypeEnum;
}

export interface MarqCommonModelRuleSmartRuleConditionForClientCopyrightedImage {
  all: boolean;
  entire_official_image_collection_ids?: (number | null)[];
  partial_official_image_collections?:
    | MarqCommonModelRuleSmartRuleConditionForClientCopyrightedImageOfficialImageCollection[]
    | null;
  type: MarqCommonEnumsRuleSmartRuleConditionTypeEnum;
}

export interface MarqCommonModelRuleSmartRuleConditionForClientCopyrightedImageOfficialImageCollection {
  /** @format int32 */
  official_image_collection_id?: number | null;
  official_image_ids: number[];
}

export interface MarqCommonModelRuleSmartRuleConditionForClientDescriptionContains {
  contains_type: MarqCommonEnumsRuleDescriptionContainsTypeEnum;
  keywords: string[];
  type: MarqCommonEnumsRuleSmartRuleConditionTypeEnum;
}

export interface MarqCommonModelRuleSmartRuleConditionForClientDomain {
  domain_ids: number[];
  type: MarqCommonEnumsRuleSmartRuleConditionTypeEnum;
}

export interface MarqCommonModelRuleSmartRuleConditionForClientInfringingImage {
  all: boolean;
  infringing_image_collection_ids?: (number | null)[];
  infringing_image_ids?: number[] | null;
  type: MarqCommonEnumsRuleSmartRuleConditionTypeEnum;
}

export interface MarqCommonModelRuleSmartRuleConditionForClientLowPrice {
  type: MarqCommonEnumsRuleSmartRuleConditionTypeEnum;
}

export interface MarqCommonModelRuleSmartRuleConditionForClientModels {
  assets: MarqCommonModelRuleSmartRuleConditionForClientModelsAsset[];
  type: MarqCommonEnumsRuleSmartRuleConditionTypeEnum;
}

export interface MarqCommonModelRuleSmartRuleConditionForClientModelsAsset {
  /** @format int32 */
  id: number;
  model_ids: number[];
}

export interface MarqCommonModelRuleSmartRuleConditionForClientOr {
  conditions: MarqCommonModelRuleSmartRuleConditionForClient[];
  type: MarqCommonEnumsRuleSmartRuleConditionTypeEnum;
}

export interface MarqCommonModelRuleSmartRuleConditionForClientPriceFixed {
  currency: MarqFoundationEnumsCurrencyEnum;
  /** @format double */
  max?: number | null;
  /** @format double */
  min?: number | null;
  type: MarqCommonEnumsRuleSmartRuleConditionTypeEnum;
}

export interface MarqCommonModelRuleSmartRuleConditionForClientPriceRelative {
  /** @format double */
  max?: number | null;
  /** @format double */
  min?: number | null;
  reference: MarqCommonEnumsRulePriceRelativeReferenceTypeEnum;
  type: MarqCommonEnumsRuleSmartRuleConditionTypeEnum;
}

export interface MarqCommonModelRuleSmartRuleConditionForClientProductCode {
  domain_group: MarqCommonEnumsRuleSmartRuleDomainGroupEnum;
  match_type: MarqCommonEnumsRuleProductCodeMatchTypeEnum;
  product_codes: string[];
  type: MarqCommonEnumsRuleSmartRuleConditionTypeEnum;
}

export interface MarqCommonModelRuleSmartRuleConditionForClientRepeatOffenders {
  type: MarqCommonEnumsRuleSmartRuleConditionTypeEnum;
}

export interface MarqCommonModelRuleSmartRuleConditionForClientSaturationRate {
  type: MarqCommonEnumsRuleSmartRuleConditionTypeEnum;
}

export interface MarqCommonModelRuleSmartRuleConditionForClientSeller {
  seller_names: string[];
  type: MarqCommonEnumsRuleSmartRuleConditionTypeEnum;
}

export interface MarqCommonModelRuleSmartRuleConditionForClientSellerContains {
  keywords: string[];
  type: MarqCommonEnumsRuleSmartRuleConditionTypeEnum;
}

export interface MarqCommonModelRuleSmartRuleConditionForClientShipFrom {
  contains_type: MarqCommonEnumsRuleShipFromContainsTypeEnum;
  countries: string[];
  type: MarqCommonEnumsRuleSmartRuleConditionTypeEnum;
}

export interface MarqCommonModelRuleSmartRuleConditionForClientTitleContains {
  contains_type: MarqCommonEnumsRuleTitleContainsTypeEnum;
  keywords: string[];
  type: MarqCommonEnumsRuleSmartRuleConditionTypeEnum;
}

export interface MarqCommonModelRuleSmartRuleConditionForClientTopSearchResults {
  type: MarqCommonEnumsRuleSmartRuleConditionTypeEnum;
}

export interface MarqCommonModelRuleSmartRuleConditionForClientTrademarkedLogo {
  all: boolean;
  trademarked_logo_ids?: number[] | null;
  type: MarqCommonEnumsRuleSmartRuleConditionTypeEnum;
}

export interface MarqCommonModelRuleSmartRuleConditionForClientTrademarkedTextUsed {
  type: MarqCommonEnumsRuleSmartRuleConditionTypeEnum;
}

export type MarqCommonProtocolEmptyRequest = object;

export type MarqCommonProtocolEmptyResponse = object;

export interface MarqCommonProtocolFileResponse {
  /** @format byte */
  bytes: string;
  content_type: IoKtorHttpContentType;
  filename: string;
}

export enum MarqFoundationEnumsCountryCodeEnum {
  AF = 'AF',
  AX = 'AX',
  AL = 'AL',
  DZ = 'DZ',
  AS = 'AS',
  AD = 'AD',
  AO = 'AO',
  AI = 'AI',
  AQ = 'AQ',
  AG = 'AG',
  AR = 'AR',
  AM = 'AM',
  AW = 'AW',
  AU = 'AU',
  AT = 'AT',
  AZ = 'AZ',
  BS = 'BS',
  BH = 'BH',
  BD = 'BD',
  BB = 'BB',
  BY = 'BY',
  BE = 'BE',
  BZ = 'BZ',
  BJ = 'BJ',
  BM = 'BM',
  BT = 'BT',
  BO = 'BO',
  BQ = 'BQ',
  BA = 'BA',
  BW = 'BW',
  BV = 'BV',
  BR = 'BR',
  IO = 'IO',
  BN = 'BN',
  BG = 'BG',
  BF = 'BF',
  BI = 'BI',
  KH = 'KH',
  CM = 'CM',
  CA = 'CA',
  CV = 'CV',
  KY = 'KY',
  CF = 'CF',
  TD = 'TD',
  CL = 'CL',
  CN = 'CN',
  CX = 'CX',
  CC = 'CC',
  CO = 'CO',
  KM = 'KM',
  CG = 'CG',
  CD = 'CD',
  CK = 'CK',
  CR = 'CR',
  CI = 'CI',
  HR = 'HR',
  CU = 'CU',
  CW = 'CW',
  CY = 'CY',
  CZ = 'CZ',
  DK = 'DK',
  DJ = 'DJ',
  DM = 'DM',
  DO = 'DO',
  EC = 'EC',
  EG = 'EG',
  SV = 'SV',
  GB = 'GB',
  GQ = 'GQ',
  ER = 'ER',
  EE = 'EE',
  ET = 'ET',
  FK = 'FK',
  FO = 'FO',
  FJ = 'FJ',
  FI = 'FI',
  FR = 'FR',
  GF = 'GF',
  PF = 'PF',
  TF = 'TF',
  GA = 'GA',
  GM = 'GM',
  GE = 'GE',
  DE = 'DE',
  GH = 'GH',
  GI = 'GI',
  GR = 'GR',
  GL = 'GL',
  GD = 'GD',
  GP = 'GP',
  GU = 'GU',
  GT = 'GT',
  GG = 'GG',
  GN = 'GN',
  GW = 'GW',
  GY = 'GY',
  HT = 'HT',
  HM = 'HM',
  VA = 'VA',
  HN = 'HN',
  HK = 'HK',
  HU = 'HU',
  IS = 'IS',
  IN = 'IN',
  ID = 'ID',
  IR = 'IR',
  IQ = 'IQ',
  IE = 'IE',
  IM = 'IM',
  IL = 'IL',
  IT = 'IT',
  JM = 'JM',
  JP = 'JP',
  JE = 'JE',
  JO = 'JO',
  KZ = 'KZ',
  KE = 'KE',
  KI = 'KI',
  KP = 'KP',
  KR = 'KR',
  KW = 'KW',
  KG = 'KG',
  LA = 'LA',
  LV = 'LV',
  LB = 'LB',
  LS = 'LS',
  LR = 'LR',
  LY = 'LY',
  LI = 'LI',
  LT = 'LT',
  LU = 'LU',
  MO = 'MO',
  MK = 'MK',
  MG = 'MG',
  MW = 'MW',
  MV = 'MV',
  MY = 'MY',
  ML = 'ML',
  MT = 'MT',
  MH = 'MH',
  MQ = 'MQ',
  MR = 'MR',
  MU = 'MU',
  YT = 'YT',
  MX = 'MX',
  FM = 'FM',
  MD = 'MD',
  MC = 'MC',
  MN = 'MN',
  ME = 'ME',
  MS = 'MS',
  MA = 'MA',
  MZ = 'MZ',
  MM = 'MM',
  NA = 'NA',
  NR = 'NR',
  NP = 'NP',
  NL = 'NL',
  NC = 'NC',
  NZ = 'NZ',
  NI = 'NI',
  NE = 'NE',
  NG = 'NG',
  NU = 'NU',
  NF = 'NF',
  MP = 'MP',
  NO = 'NO',
  OM = 'OM',
  PK = 'PK',
  PW = 'PW',
  PS = 'PS',
  PA = 'PA',
  PG = 'PG',
  PY = 'PY',
  PE = 'PE',
  PH = 'PH',
  PN = 'PN',
  PL = 'PL',
  PT = 'PT',
  PR = 'PR',
  QA = 'QA',
  RE = 'RE',
  RO = 'RO',
  RU = 'RU',
  RW = 'RW',
  BL = 'BL',
  SH = 'SH',
  KN = 'KN',
  LC = 'LC',
  MF = 'MF',
  PM = 'PM',
  VC = 'VC',
  WS = 'WS',
  SM = 'SM',
  ST = 'ST',
  SA = 'SA',
  SN = 'SN',
  RS = 'RS',
  SC = 'SC',
  SL = 'SL',
  SX = 'SX',
  SG = 'SG',
  SK = 'SK',
  SI = 'SI',
  SB = 'SB',
  SO = 'SO',
  ZA = 'ZA',
  GS = 'GS',
  SS = 'SS',
  ES = 'ES',
  LK = 'LK',
  SD = 'SD',
  SR = 'SR',
  SJ = 'SJ',
  SZ = 'SZ',
  SE = 'SE',
  CH = 'CH',
  SY = 'SY',
  TW = 'TW',
  TJ = 'TJ',
  TZ = 'TZ',
  TL = 'TL',
  TH = 'TH',
  TG = 'TG',
  TK = 'TK',
  TO = 'TO',
  TT = 'TT',
  TN = 'TN',
  TR = 'TR',
  TM = 'TM',
  TC = 'TC',
  TV = 'TV',
  UG = 'UG',
  UA = 'UA',
  AE = 'AE',
  US = 'US',
  UM = 'UM',
  UY = 'UY',
  UZ = 'UZ',
  VU = 'VU',
  VE = 'VE',
  VN = 'VN',
  VG = 'VG',
  VI = 'VI',
  WF = 'WF',
  EH = 'EH',
  YE = 'YE',
  ZM = 'ZM',
  ZW = 'ZW',
  EU = 'EU',
  Value00 = '00',
  Value10 = '10',
}

export enum MarqFoundationEnumsCurrencyEnum {
  LTL = 'LTL',
  THB = 'THB',
  CDF = 'CDF',
  HKD = 'HKD',
  IDR = 'IDR',
  CLF = 'CLF',
  TRY = 'TRY',
  ETB = 'ETB',
  ILS = 'ILS',
  MOP = 'MOP',
  SYP = 'SYP',
  AOA = 'AOA',
  SCR = 'SCR',
  HRK = 'HRK',
  GTQ = 'GTQ',
  SLL = 'SLL',
  HUF = 'HUF',
  MXN = 'MXN',
  CVE = 'CVE',
  RUB = 'RUB',
  JMD = 'JMD',
  AWG = 'AWG',
  ZAR = 'ZAR',
  SAR = 'SAR',
  BWP = 'BWP',
  TOP = 'TOP',
  MNT = 'MNT',
  IRR = 'IRR',
  UYU = 'UYU',
  TTD = 'TTD',
  MYR = 'MYR',
  BND = 'BND',
  ANG = 'ANG',
  IMP = 'IMP',
  BTN = 'BTN',
  QAR = 'QAR',
  SHP = 'SHP',
  CUP = 'CUP',
  BMD = 'BMD',
  SDG = 'SDG',
  LAK = 'LAK',
  AED = 'AED',
  CLP = 'CLP',
  ZMK = 'ZMK',
  RSD = 'RSD',
  KGS = 'KGS',
  KES = 'KES',
  XPF = 'XPF',
  AZN = 'AZN',
  XCD = 'XCD',
  AFN = 'AFN',
  KPW = 'KPW',
  ERN = 'ERN',
  AUD = 'AUD',
  NGN = 'NGN',
  BGN = 'BGN',
  TWD = 'TWD',
  LYD = 'LYD',
  NPR = 'NPR',
  PLN = 'PLN',
  COP = 'COP',
  CRC = 'CRC',
  BHD = 'BHD',
  PKR = 'PKR',
  XOF = 'XOF',
  GBP = 'GBP',
  TND = 'TND',
  OMR = 'OMR',
  MZN = 'MZN',
  GYD = 'GYD',
  CZK = 'CZK',
  MGA = 'MGA',
  DKK = 'DKK',
  KYD = 'KYD',
  GGP = 'GGP',
  GIP = 'GIP',
  MVR = 'MVR',
  RON = 'RON',
  RWF = 'RWF',
  NAD = 'NAD',
  JOD = 'JOD',
  XAU = 'XAU',
  VUV = 'VUV',
  BBD = 'BBD',
  UAH = 'UAH',
  CHF = 'CHF',
  BTC = 'BTC',
  SOS = 'SOS',
  CAD = 'CAD',
  GEL = 'GEL',
  LKR = 'LKR',
  BOB = 'BOB',
  MDL = 'MDL',
  NZD = 'NZD',
  MMK = 'MMK',
  LRD = 'LRD',
  VND = 'VND',
  MRO = 'MRO',
  MRU = 'MRU',
  BYR = 'BYR',
  PGK = 'PGK',
  PYG = 'PYG',
  BZD = 'BZD',
  SRD = 'SRD',
  SEK = 'SEK',
  DZD = 'DZD',
  SVC = 'SVC',
  ARS = 'ARS',
  KHR = 'KHR',
  FJD = 'FJD',
  PEN = 'PEN',
  UZS = 'UZS',
  DJF = 'DJF',
  BRL = 'BRL',
  HNL = 'HNL',
  LBP = 'LBP',
  XAG = 'XAG',
  EGP = 'EGP',
  USD = 'USD',
  TJS = 'TJS',
  JEP = 'JEP',
  FKP = 'FKP',
  TMT = 'TMT',
  PHP = 'PHP',
  LSL = 'LSL',
  ISK = 'ISK',
  YER = 'YER',
  VEF = 'VEF',
  SBD = 'SBD',
  MUR = 'MUR',
  CNY = 'CNY',
  PAB = 'PAB',
  BAM = 'BAM',
  NOK = 'NOK',
  KMF = 'KMF',
  BDT = 'BDT',
  INR = 'INR',
  HTG = 'HTG',
  ALL = 'ALL',
  MWK = 'MWK',
  MAD = 'MAD',
  GMD = 'GMD',
  AMD = 'AMD',
  UGX = 'UGX',
  KRW = 'KRW',
  DOP = 'DOP',
  MKD = 'MKD',
  KWD = 'KWD',
  EUR = 'EUR',
  ZWL = 'ZWL',
  TZS = 'TZS',
  BYN = 'BYN',
  ZMW = 'ZMW',
  XAF = 'XAF',
  STD = 'STD',
  STN = 'STN',
  NIO = 'NIO',
  KZT = 'KZT',
  SGD = 'SGD',
  JPY = 'JPY',
  IQD = 'IQD',
  WST = 'WST',
  BIF = 'BIF',
  GHS = 'GHS',
  XDR = 'XDR',
  LVL = 'LVL',
  CUC = 'CUC',
  SZL = 'SZL',
  BSD = 'BSD',
  GNF = 'GNF',
  VES = 'VES',
  SSP = 'SSP',
}

export enum MarqFoundationEnumsLanguageEnum {
  Ae = 'ae',
  In = 'in',
  Tw = 'tw',
  Af = 'af',
  Als = 'als',
  Am = 'am',
  An = 'an',
  Ar = 'ar',
  Arz = 'arz',
  As = 'as',
  Ast = 'ast',
  Av = 'av',
  Az = 'az',
  Azb = 'azb',
  Ba = 'ba',
  Bar = 'bar',
  Bcl = 'bcl',
  Be = 'be',
  Bg = 'bg',
  Bh = 'bh',
  Bn = 'bn',
  Bo = 'bo',
  Bpy = 'bpy',
  Br = 'br',
  Bs = 'bs',
  Bxr = 'bxr',
  Ca = 'ca',
  Cbk = 'cbk',
  Ce = 'ce',
  Ceb = 'ceb',
  Ckb = 'ckb',
  Co = 'co',
  Cs = 'cs',
  Cv = 'cv',
  Cy = 'cy',
  Da = 'da',
  De = 'de',
  Diq = 'diq',
  Dsb = 'dsb',
  Dty = 'dty',
  Dv = 'dv',
  El = 'el',
  Eml = 'eml',
  En = 'en',
  Eo = 'eo',
  Es = 'es',
  Et = 'et',
  Eu = 'eu',
  Fa = 'fa',
  Fi = 'fi',
  Fr = 'fr',
  Frr = 'frr',
  Fy = 'fy',
  Ga = 'ga',
  Gd = 'gd',
  Gl = 'gl',
  Gn = 'gn',
  Gom = 'gom',
  Gu = 'gu',
  Gv = 'gv',
  He = 'he',
  Hi = 'hi',
  Hif = 'hif',
  Hr = 'hr',
  Hsb = 'hsb',
  Ht = 'ht',
  Hu = 'hu',
  Hy = 'hy',
  Ia = 'ia',
  Id = 'id',
  Ie = 'ie',
  Ilo = 'ilo',
  Io = 'io',
  Is = 'is',
  It = 'it',
  Ja = 'ja',
  Jbo = 'jbo',
  Jv = 'jv',
  Ka = 'ka',
  Kk = 'kk',
  Km = 'km',
  Kn = 'kn',
  Ko = 'ko',
  Krc = 'krc',
  Ku = 'ku',
  Kv = 'kv',
  Kw = 'kw',
  Ky = 'ky',
  La = 'la',
  Lb = 'lb',
  Lez = 'lez',
  Li = 'li',
  Lmo = 'lmo',
  Lo = 'lo',
  Lrc = 'lrc',
  Lt = 'lt',
  Lv = 'lv',
  Mai = 'mai',
  Mg = 'mg',
  Mhr = 'mhr',
  Min = 'min',
  Mk = 'mk',
  Ml = 'ml',
  Mn = 'mn',
  Mr = 'mr',
  Mrj = 'mrj',
  Ms = 'ms',
  Mt = 'mt',
  Mwl = 'mwl',
  My = 'my',
  Myv = 'myv',
  Mzn = 'mzn',
  Nah = 'nah',
  Nap = 'nap',
  Nds = 'nds',
  Ne = 'ne',
  New = 'new',
  Nl = 'nl',
  Nn = 'nn',
  No = 'no',
  Oc = 'oc',
  Or = 'or',
  Os = 'os',
  Pa = 'pa',
  Pam = 'pam',
  Pfl = 'pfl',
  Pl = 'pl',
  Pms = 'pms',
  Pnb = 'pnb',
  Ps = 'ps',
  Pt = 'pt',
  Qu = 'qu',
  Rm = 'rm',
  Ro = 'ro',
  Ru = 'ru',
  Rue = 'rue',
  Sa = 'sa',
  Sah = 'sah',
  Sc = 'sc',
  Scn = 'scn',
  Sco = 'sco',
  Sd = 'sd',
  Sh = 'sh',
  Si = 'si',
  Sk = 'sk',
  Sl = 'sl',
  So = 'so',
  Sq = 'sq',
  Sr = 'sr',
  Su = 'su',
  Sv = 'sv',
  Sw = 'sw',
  Ta = 'ta',
  Te = 'te',
  Tg = 'tg',
  Th = 'th',
  Tk = 'tk',
  Tl = 'tl',
  Tr = 'tr',
  Tt = 'tt',
  Tyv = 'tyv',
  Ug = 'ug',
  Uk = 'uk',
  Ur = 'ur',
  Uz = 'uz',
  Vec = 'vec',
  Vep = 'vep',
  Vi = 'vi',
  Vls = 'vls',
  Vo = 'vo',
  Wa = 'wa',
  War = 'war',
  Wuu = 'wuu',
  Xal = 'xal',
  Xmf = 'xmf',
  Yi = 'yi',
  Yo = 'yo',
  Yue = 'yue',
  Zh = 'zh',
}

export interface MonitoringCommonViewProtocolsExcelExportRequest {
  asset_id_filter?: number[] | null;
  /** @format int32 */
  brand_id?: number | null;
  channel_type: MarqCommonEnumsChannelTypeEnum[];
  client_requested_filter?: boolean | null;
  client_status_filter: MarqBrandEnumsListingMonitoringStatusEnum;
  comment_user_type_filter?: MarqCommonEnumsCommentCommentUserTypeEnum[] | null;
  currency?: MarqFoundationEnumsCurrencyEnum;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  enforcement_rule_id_filter?: number[] | null;
  gen_ai_counterfeit_filter?: boolean | null;
  include_expired?: boolean | null;
  infringing_images_filter?: boolean | null;
  low_price_filter?: boolean | null;
  /** @format double */
  max_price?: number | null;
  /** @format double */
  max_sales_volume?: number | null;
  /** @format double */
  min_price?: number | null;
  /** @format double */
  min_sales_volume?: number | null;
  model_id_filter?: number[] | null;
  official_image_id_filter?: number[] | null;
  post_type_filter?: MarqCommonEnumsListingPostTypeEnum;
  potential_authorized_reason_filter?: MarqCommonEnumsPotentialAuthorizedReasonEnum[] | null;
  repeat_offender_filter?: boolean | null;
  reportable_filter?: MarqCommonEnumsReportableReasonEnum[] | null;
  scanned_status_filter?: MarqCommonEnumsScannedStatusEnum;
  search?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  search_date_filter?: string | null;
  seller_name_filter?: string[] | null;
  ship_from_filter?: string[] | null;
  sorted_column: MarqBrandCoreModelClientListingSortedColumnEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
  tm_infringement_filter?: boolean | null;
  tm_infringement_logo_filter?: number[] | null;
  tm_infringement_text_filter?: boolean | null;
  top_result_filter?: boolean | null;
  updated_date_range_filter?: MarqCommonModelLocalDateRange;
}

export interface MonitoringCommonViewProtocolsExcelExportResponse {
  /** @format int32 */
  progress_id: number;
}

export interface MonitoringCommonViewProtocolsExcelExportByListingIdRequest {
  listing_id_list: number[];
}

export interface MonitoringCommonViewProtocolsGetAllListingIdRequest {
  asset_id_filter?: number[] | null;
  /** @format int32 */
  brand_id?: number | null;
  channel_type: MarqCommonEnumsChannelTypeEnum[];
  client_requested_filter?: boolean | null;
  client_status_filter: MarqBrandEnumsListingMonitoringStatusEnum;
  comment_user_type_filter?: MarqCommonEnumsCommentCommentUserTypeEnum[] | null;
  currency?: MarqFoundationEnumsCurrencyEnum;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  enforcement_rule_id_filter?: number[] | null;
  gen_ai_counterfeit_filter?: boolean | null;
  include_expired?: boolean | null;
  infringing_images_filter?: boolean | null;
  low_price_filter?: boolean | null;
  /** @format double */
  max_price?: number | null;
  /** @format double */
  max_sales_volume?: number | null;
  /** @format double */
  min_price?: number | null;
  /** @format double */
  min_sales_volume?: number | null;
  model_id_filter?: number[] | null;
  official_image_id_filter?: number[] | null;
  post_type_filter?: MarqCommonEnumsListingPostTypeEnum;
  potential_authorized_reason_filter?: MarqCommonEnumsPotentialAuthorizedReasonEnum[] | null;
  repeat_offender_filter?: boolean | null;
  reportable_filter?: MarqCommonEnumsReportableReasonEnum[] | null;
  scanned_status_filter?: MarqCommonEnumsScannedStatusEnum;
  search?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  search_date_filter?: string | null;
  seller_name_filter?: string[] | null;
  ship_from_filter?: string[] | null;
  tm_infringement_filter?: boolean | null;
  tm_infringement_logo_filter?: number[] | null;
  tm_infringement_text_filter?: boolean | null;
  top_result_filter?: boolean | null;
  updated_date_range_filter?: MarqCommonModelLocalDateRange;
}

export interface MonitoringCommonViewProtocolsGetAllListingIdResponse {
  listing_id_list: number[];
}

export interface MonitoringCommonViewProtocolsGetCountRequest {
  asset_id_filter?: number[] | null;
  /** @format int32 */
  brand_id?: number | null;
  channel_type: MarqCommonEnumsChannelTypeEnum[];
  client_requested_filter?: boolean | null;
  client_status_filter: MarqBrandEnumsListingMonitoringStatusEnum;
  comment_user_type_filter?: MarqCommonEnumsCommentCommentUserTypeEnum[] | null;
  currency?: MarqFoundationEnumsCurrencyEnum;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  enforcement_rule_id_filter?: number[] | null;
  gen_ai_counterfeit_filter?: boolean | null;
  include_expired?: boolean | null;
  infringing_images_filter?: boolean | null;
  low_price_filter?: boolean | null;
  /** @format double */
  max_price?: number | null;
  /** @format double */
  max_sales_volume?: number | null;
  /** @format double */
  min_price?: number | null;
  /** @format double */
  min_sales_volume?: number | null;
  model_id_filter?: number[] | null;
  official_image_id_filter?: number[] | null;
  post_type_filter?: MarqCommonEnumsListingPostTypeEnum;
  potential_authorized_reason_filter?: MarqCommonEnumsPotentialAuthorizedReasonEnum[] | null;
  repeat_offender_filter?: boolean | null;
  reportable_filter?: MarqCommonEnumsReportableReasonEnum[] | null;
  scanned_status_filter?: MarqCommonEnumsScannedStatusEnum;
  search?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  search_date_filter?: string | null;
  seller_name_filter?: string[] | null;
  ship_from_filter?: string[] | null;
  tm_infringement_filter?: boolean | null;
  tm_infringement_logo_filter?: number[] | null;
  tm_infringement_text_filter?: boolean | null;
  top_result_filter?: boolean | null;
  updated_date_range_filter?: MarqCommonModelLocalDateRange;
}

export interface MonitoringCommonViewProtocolsGetCountResponse {
  /** @format int32 */
  total_count: number;
}

export interface MonitoringCommonViewProtocolsGetCountProgressRequest {
  /** @format int32 */
  brand_id?: number | null;
  channel_type: MarqCommonEnumsChannelTypeEnum;
}

export interface MonitoringCommonViewProtocolsGetCountProgressResponse {
  /** @format int32 */
  reporting: number;
  /** @format int32 */
  soft_notice: number;
}

export interface MonitoringEnforcementTPProtocolsExcelExportRequest {
  asset_id_filter?: number[] | null;
  /** @format int32 */
  brand_id?: number | null;
  channel_type: MarqCommonEnumsChannelTypeEnum[];
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  model_id_filter?: number[] | null;
  search?: string | null;
  seller_name_filter?: string[] | null;
  ship_from_filter?: string[] | null;
  sorted_column: MarqBrandCoreModelClientListingSortedColumnEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
  tp_progress_status_filter?: MarqCommonEnumsTpTpProgressStatusEnum[] | null;
  tp_reported_filter?: boolean | null;
}

export interface MonitoringEnforcementTPProtocolsExcelExportResponse {
  /** @format int32 */
  progress_id: number;
}

export interface MonitoringEnforcementTPProtocolsExcelExportByListingIdRequest {
  listing_id_list?: number[] | null;
}

export interface MonitoringEnforcementTPProtocolsGetEnforcementTPListingsRequest {
  asset_id_filter?: number[] | null;
  /** @format int32 */
  brand_id?: number | null;
  channel_type: MarqCommonEnumsChannelTypeEnum[];
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  /** @format int32 */
  limit: number;
  model_id_filter?: number[] | null;
  /** @format int32 */
  offset: number;
  search?: string | null;
  seller_name_filter?: string[] | null;
  ship_from_filter?: string[] | null;
  sorted_column: MarqBrandCoreModelClientListingSortedColumnEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
  tp_progress_status_filter?: MarqCommonEnumsTpTpProgressStatusEnum[] | null;
  tp_reported_filter?: boolean | null;
}

export interface MonitoringEnforcementTPProtocolsGetEnforcementTPListingsResponse {
  asset_exists: boolean;
  listings: MarqBrandModelResponseEnforcementTPListingResponse[];
  /** @format int32 */
  total_count: number;
}

export interface MonitoringEnforcementTPProtocolsGetExportListingsRequest {
  asset_id_filter?: number[] | null;
  /** @format int32 */
  brand_id?: number | null;
  channel_type: MarqCommonEnumsChannelTypeEnum[];
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  listing_id_list?: number[] | null;
  model_id_filter?: number[] | null;
  search?: string | null;
  seller_name_filter?: string[] | null;
  ship_from_filter?: string[] | null;
  sorted_column: MarqBrandCoreModelClientListingSortedColumnEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
  tp_progress_status_filter?: MarqCommonEnumsTpTpProgressStatusEnum[] | null;
  tp_reported_filter?: boolean | null;
}

export interface MonitoringFilterProtocolPagingRequest {
  asset_id_filter?: number[] | null;
  /** @format int32 */
  brand_id?: number | null;
  channel_type: MarqCommonEnumsChannelTypeEnum[];
  client_requested_filter?: boolean | null;
  client_status_filter: MarqBrandEnumsListingMonitoringStatusEnum;
  comment_user_type_filter?: MarqCommonEnumsCommentCommentUserTypeEnum[] | null;
  currency?: MarqFoundationEnumsCurrencyEnum;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  enforcement_rule_id_filter?: number[] | null;
  gen_ai_counterfeit_filter?: boolean | null;
  in_search_keyword_filter?: string | null;
  include_expired?: boolean | null;
  infringing_images_filter?: boolean | null;
  low_price_filter?: boolean | null;
  /** @format double */
  max_price?: number | null;
  /** @format double */
  max_sales_volume?: number | null;
  /** @format double */
  min_price?: number | null;
  /** @format double */
  min_sales_volume?: number | null;
  model_id_filter?: number[] | null;
  official_image_id_filter?: number[] | null;
  post_type_filter?: MarqCommonEnumsListingPostTypeEnum;
  potential_authorized_reason_filter?: MarqCommonEnumsPotentialAuthorizedReasonEnum[] | null;
  repeat_offender_filter?: boolean | null;
  reportable_filter?: MarqCommonEnumsReportableReasonEnum[] | null;
  scanned_status_filter?: MarqCommonEnumsScannedStatusEnum;
  search?: string | null;
  search_after: KotlinAny[];
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  search_date_filter?: string | null;
  seller_name_filter?: string[] | null;
  ship_from_filter?: string[] | null;
  /** @format int32 */
  size: number;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
  tm_infringement_filter?: boolean | null;
  tm_infringement_logo_filter?: number[] | null;
  tm_infringement_text_filter?: boolean | null;
  top_result_filter?: boolean | null;
  tp_progress_status_filter?: MarqCommonEnumsTpTpProgressStatusEnum[] | null;
  tp_reported_filter?: boolean | null;
  updated_date_range_filter?: MarqCommonModelLocalDateRange;
}

export interface MonitoringFilterProtocolRequest {
  asset_id_filter?: number[] | null;
  /** @format int32 */
  brand_id?: number | null;
  channel_type: MarqCommonEnumsChannelTypeEnum[];
  client_requested_filter?: boolean | null;
  client_status_filter: MarqBrandEnumsListingMonitoringStatusEnum;
  comment_user_type_filter?: MarqCommonEnumsCommentCommentUserTypeEnum[] | null;
  currency?: MarqFoundationEnumsCurrencyEnum;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  enforcement_rule_id_filter?: number[] | null;
  gen_ai_counterfeit_filter?: boolean | null;
  include_expired?: boolean | null;
  infringing_images_filter?: boolean | null;
  low_price_filter?: boolean | null;
  /** @format double */
  max_price?: number | null;
  /** @format double */
  max_sales_volume?: number | null;
  /** @format double */
  min_price?: number | null;
  /** @format double */
  min_sales_volume?: number | null;
  model_id_filter?: number[] | null;
  official_image_id_filter?: number[] | null;
  post_type_filter?: MarqCommonEnumsListingPostTypeEnum;
  potential_authorized_reason_filter?: MarqCommonEnumsPotentialAuthorizedReasonEnum[] | null;
  repeat_offender_filter?: boolean | null;
  reportable_filter?: MarqCommonEnumsReportableReasonEnum[] | null;
  scanned_status_filter?: MarqCommonEnumsScannedStatusEnum;
  search?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  search_date_filter?: string | null;
  seller_name_filter?: string[] | null;
  ship_from_filter?: string[] | null;
  tm_infringement_filter?: boolean | null;
  tm_infringement_logo_filter?: number[] | null;
  tm_infringement_text_filter?: boolean | null;
  top_result_filter?: boolean | null;
  updated_date_range_filter?: MarqCommonModelLocalDateRange;
  tp_progress_status_filter?: MarqCommonEnumsTpTpProgressStatusEnum[] | null;
  tp_reported_filter?: boolean | null;
}

export interface MonitoringFilterProtocolResponse {
  /** @format int32 */
  count?: number | null;
  filter_display: boolean;
  list: MonitoringFilterProtocolResponseFilterItem[];
  search_after?: KotlinAny[] | null;
}

export interface MonitoringFilterProtocolResponseFilterItem {
  bbox_list?: MarqCommonModelCoordinate[] | null;
  /** @format int32 */
  count?: number | null;
  id: KotlinAny;
  image_url?: string | null;
  list?: MonitoringFilterProtocolResponseFilterItem[] | null;
  text: string;
}

export interface MonitoringImageViewProtocolsGetGroupAllListingIdsRequest {
  asset_id_filter?: number[] | null;
  /** @format int32 */
  brand_id?: number | null;
  channel_type: MarqCommonEnumsChannelTypeEnum[];
  client_requested_filter?: boolean | null;
  client_status_filter: MarqBrandEnumsListingMonitoringStatusEnum;
  comment_user_type_filter?: MarqCommonEnumsCommentCommentUserTypeEnum[] | null;
  currency?: MarqFoundationEnumsCurrencyEnum;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  enforcement_rule_id_filter?: number[] | null;
  gen_ai_counterfeit_filter?: boolean | null;
  /** @format int32 */
  group_image_id: number;
  include_expired?: boolean | null;
  infringing_images_filter?: boolean | null;
  low_price_filter?: boolean | null;
  /** @format double */
  max_price?: number | null;
  /** @format double */
  max_sales_volume?: number | null;
  /** @format double */
  min_price?: number | null;
  /** @format double */
  min_sales_volume?: number | null;
  model_id_filter?: number[] | null;
  official_image_id_filter?: number[] | null;
  post_type_filter?: MarqCommonEnumsListingPostTypeEnum;
  potential_authorized_reason_filter?: MarqCommonEnumsPotentialAuthorizedReasonEnum[] | null;
  repeat_offender_filter?: boolean | null;
  reportable_filter?: MarqCommonEnumsReportableReasonEnum[] | null;
  scanned_status_filter?: MarqCommonEnumsScannedStatusEnum;
  search?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  search_date_filter?: string | null;
  seller_name_filter?: string[] | null;
  ship_from_filter?: string[] | null;
  tm_infringement_filter?: boolean | null;
  tm_infringement_logo_filter?: number[] | null;
  tm_infringement_text_filter?: boolean | null;
  top_result_filter?: boolean | null;
  updated_date_range_filter?: MarqCommonModelLocalDateRange;
}

export interface MonitoringImageViewProtocolsGetGroupAllListingIdsResponse {
  listing_ids: number[];
}

export interface MonitoringImageViewProtocolsGetGroupListingsRequest {
  asset_id_filter?: number[] | null;
  /** @format int32 */
  brand_id?: number | null;
  channel_type: MarqCommonEnumsChannelTypeEnum[];
  client_requested_filter?: boolean | null;
  client_status_filter: MarqBrandEnumsListingMonitoringStatusEnum;
  comment_user_type_filter?: MarqCommonEnumsCommentCommentUserTypeEnum[] | null;
  currency?: MarqFoundationEnumsCurrencyEnum;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  enforcement_rule_id_filter?: number[] | null;
  gen_ai_counterfeit_filter?: boolean | null;
  /** @format int32 */
  group_image_id: number;
  include_expired?: boolean | null;
  infringing_images_filter?: boolean | null;
  /** @format int32 */
  limit: number;
  low_price_filter?: boolean | null;
  /** @format double */
  max_price?: number | null;
  /** @format double */
  max_sales_volume?: number | null;
  /** @format double */
  min_price?: number | null;
  /** @format double */
  min_sales_volume?: number | null;
  model_id_filter?: number[] | null;
  official_image_id_filter?: number[] | null;
  /** @format int32 */
  offset: number;
  post_type_filter?: MarqCommonEnumsListingPostTypeEnum;
  potential_authorized_reason_filter?: MarqCommonEnumsPotentialAuthorizedReasonEnum[] | null;
  repeat_offender_filter?: boolean | null;
  reportable_filter?: MarqCommonEnumsReportableReasonEnum[] | null;
  scanned_status_filter?: MarqCommonEnumsScannedStatusEnum;
  search?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  search_date_filter?: string | null;
  seller_name_filter?: string[] | null;
  ship_from_filter?: string[] | null;
  tm_infringement_filter?: boolean | null;
  tm_infringement_logo_filter?: number[] | null;
  tm_infringement_text_filter?: boolean | null;
  top_result_filter?: boolean | null;
  updated_date_range_filter?: MarqCommonModelLocalDateRange;
}

export interface MonitoringImageViewProtocolsGetGroupListingsResponse {
  listings: MarqBrandModelResponseMonitoringListingResponse[];
}

export interface MonitoringImageViewProtocolsGetImageGroupsRequest {
  asset_id_filter?: number[] | null;
  /** @format int32 */
  brand_id?: number | null;
  channel_type: MarqCommonEnumsChannelTypeEnum[];
  client_requested_filter?: boolean | null;
  client_status_filter: MarqBrandEnumsListingMonitoringStatusEnum;
  comment_user_type_filter?: MarqCommonEnumsCommentCommentUserTypeEnum[] | null;
  currency?: MarqFoundationEnumsCurrencyEnum;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  enforcement_rule_id_filter?: number[] | null;
  gen_ai_counterfeit_filter?: boolean | null;
  include_expired?: boolean | null;
  infringing_images_filter?: boolean | null;
  /** @format int32 */
  limit: number;
  low_price_filter?: boolean | null;
  /** @format double */
  max_price?: number | null;
  /** @format double */
  max_sales_volume?: number | null;
  /** @format double */
  min_price?: number | null;
  /** @format double */
  min_sales_volume?: number | null;
  model_id_filter?: number[] | null;
  official_image_id_filter?: number[] | null;
  /** @format int32 */
  offset: number;
  post_type_filter?: MarqCommonEnumsListingPostTypeEnum;
  potential_authorized_reason_filter?: MarqCommonEnumsPotentialAuthorizedReasonEnum[] | null;
  repeat_offender_filter?: boolean | null;
  reportable_filter?: MarqCommonEnumsReportableReasonEnum[] | null;
  scanned_status_filter?: MarqCommonEnumsScannedStatusEnum;
  search?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  search_date_filter?: string | null;
  seller_name_filter?: string[] | null;
  ship_from_filter?: string[] | null;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
  tm_infringement_filter?: boolean | null;
  tm_infringement_logo_filter?: number[] | null;
  tm_infringement_text_filter?: boolean | null;
  top_result_filter?: boolean | null;
  updated_date_range_filter?: MarqCommonModelLocalDateRange;
}

export interface MonitoringImageViewProtocolsGetImageGroupsResponse {
  listing_groups: MonitoringImageViewProtocolsGetImageGroupsResponseImageGroup[];
}

export interface MonitoringImageViewProtocolsGetImageGroupsResponseImageGroup {
  /** @format int32 */
  group_image_id?: number | null;
  listing_list: MarqBrandModelResponseMonitoringListingResponse[];
  /** @format int32 */
  total_count: number;
}

export interface MonitoringListViewProtocolsGetListingsRequest {
  asset_id_filter?: number[] | null;
  /** @format int32 */
  brand_id?: number | null;
  channel_type: MarqCommonEnumsChannelTypeEnum[];
  client_requested_filter?: boolean | null;
  client_status_filter: MarqBrandEnumsListingMonitoringStatusEnum;
  comment_user_type_filter?: MarqCommonEnumsCommentCommentUserTypeEnum[] | null;
  currency?: MarqFoundationEnumsCurrencyEnum;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  enforcement_rule_id_filter?: number[] | null;
  gen_ai_counterfeit_filter?: boolean | null;
  include_expired?: boolean | null;
  infringing_images_filter?: boolean | null;
  /** @format int32 */
  limit: number;
  low_price_filter?: boolean | null;
  /** @format double */
  max_price?: number | null;
  /** @format double */
  max_sales_volume?: number | null;
  /** @format double */
  min_price?: number | null;
  /** @format double */
  min_sales_volume?: number | null;
  model_id_filter?: number[] | null;
  official_image_id_filter?: number[] | null;
  /** @format int32 */
  offset: number;
  post_type_filter?: MarqCommonEnumsListingPostTypeEnum;
  potential_authorized_reason_filter?: MarqCommonEnumsPotentialAuthorizedReasonEnum[] | null;
  repeat_offender_filter?: boolean | null;
  reportable_filter?: MarqCommonEnumsReportableReasonEnum[] | null;
  scanned_status_filter?: MarqCommonEnumsScannedStatusEnum;
  search?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  search_date_filter?: string | null;
  seller_name_filter?: string[] | null;
  ship_from_filter?: string[] | null;
  sorted_column: MarqBrandCoreModelClientListingSortedColumnEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
  tm_infringement_filter?: boolean | null;
  tm_infringement_logo_filter?: number[] | null;
  tm_infringement_text_filter?: boolean | null;
  top_result_filter?: boolean | null;
  updated_date_range_filter?: MarqCommonModelLocalDateRange;
}

export interface MonitoringListViewProtocolsGetListingsResponse {
  asset_exists: boolean;
  listings: MarqBrandModelResponseMonitoringListingResponse[];
}

export interface MonitoringPotentialAuthorizedProtocolsExcelExportRequest {
  asset_id_filter?: number[] | null;
  /** @format int32 */
  brand_id?: number | null;
  channel_type: MarqCommonEnumsChannelTypeEnum[];
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  model_id_filter?: number[] | null;
  potential_authorized_reason_filter?: MarqCommonEnumsPotentialAuthorizedReasonEnum[] | null;
  search?: string | null;
  seller_name_filter?: string[] | null;
  sorted_column: MarqCommonEnumsPotentialAuthorizedSortedColumnEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
}

export interface MonitoringPotentialAuthorizedProtocolsExcelExportResponse {
  /** @format int32 */
  progress_id: number;
}

export interface MonitoringPotentialAuthorizedProtocolsExcelExportBySellerIdsRequest {
  seller_ids: number[];
}

export interface MonitoringPotentialAuthorizedProtocolsGetAllSellerIdsRequest {
  asset_id_filter?: number[] | null;
  /** @format int32 */
  brand_id?: number | null;
  channel_type: MarqCommonEnumsChannelTypeEnum[];
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  model_id_filter?: number[] | null;
  potential_authorized_reason_filter?: MarqCommonEnumsPotentialAuthorizedReasonEnum[] | null;
  search?: string | null;
  seller_name_filter?: string[] | null;
}

export interface MonitoringPotentialAuthorizedProtocolsGetAllSellerIdsResponse {
  sellers: number[];
}

export interface MonitoringPotentialAuthorizedProtocolsGetCountRequest {
  asset_id_filter?: number[] | null;
  /** @format int32 */
  brand_id?: number | null;
  channel_type: MarqCommonEnumsChannelTypeEnum[];
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  model_id_filter?: number[] | null;
  potential_authorized_reason_filter?: MarqCommonEnumsPotentialAuthorizedReasonEnum[] | null;
  search?: string | null;
  seller_name_filter?: string[] | null;
}

export interface MonitoringPotentialAuthorizedProtocolsGetCountResponse {
  /** @format int32 */
  count: number;
  is_new: boolean;
}

export interface MonitoringPotentialAuthorizedProtocolsGetListingsRequest {
  asset_id_filter?: number[] | null;
  /** @format int32 */
  brand_id?: number | null;
  channel_type: MarqCommonEnumsChannelTypeEnum[];
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  model_id_filter?: number[] | null;
  potential_authorized_reason_filter?: MarqCommonEnumsPotentialAuthorizedReasonEnum[] | null;
  search?: string | null;
  /** @format int32 */
  seller_id: number;
  seller_name_filter?: string[] | null;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
}

export interface MonitoringPotentialAuthorizedProtocolsGetListingsResponse {
  domain_name?: string | null;
  listing_list: MarqBrandModelResponsePotentialAuthorizedListingResponse[];
  /** @format int32 */
  total_count: number;
}

export interface MonitoringPotentialAuthorizedProtocolsGetSellersRequest {
  asset_id_filter?: number[] | null;
  /** @format int32 */
  brand_id?: number | null;
  channel_type: MarqCommonEnumsChannelTypeEnum[];
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  /** @format int32 */
  limit: number;
  model_id_filter?: number[] | null;
  /** @format int32 */
  offset: number;
  potential_authorized_reason_filter?: MarqCommonEnumsPotentialAuthorizedReasonEnum[] | null;
  search?: string | null;
  seller_name_filter?: string[] | null;
  sorted_column: MarqBrandCoreModelClientListingSortedColumnEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
}

export interface MonitoringPotentialAuthorizedProtocolsGetSellersResponse {
  sellers: MonitoringPotentialAuthorizedProtocolsPotentialAuthorizedSeller[];
}

export interface MonitoringPotentialAuthorizedProtocolsMarkAsAuthorizedRequest {
  seller_ids: number[];
}

export interface MonitoringPotentialAuthorizedProtocolsMarkAsAuthorizedResponse {
  /** @format int32 */
  count: number;
}

export interface MonitoringPotentialAuthorizedProtocolsMarkAsDismissedRequest {
  seller_ids: number[];
}

export interface MonitoringPotentialAuthorizedProtocolsMarkAsDismissedResponse {
  /** @format int32 */
  count: number;
}

export interface MonitoringPotentialAuthorizedProtocolsMarkAsUnauthorizedRequest {
  seller_ids: number[];
}

export interface MonitoringPotentialAuthorizedProtocolsMarkAsUnauthorizedResponse {
  /** @format int32 */
  count: number;
}

export interface MonitoringPotentialAuthorizedProtocolsPotentialAuthorizedSeller {
  /** @format int32 */
  count: number;
  /** @format int32 */
  domain_id: number;
  domain_name: string;
  matched_keyword?: string | null;
  reason_code: MarqCommonEnumsPotentialAuthorizedReasonEnum;
  reason_text: string;
  /** @format int32 */
  seller_id: number;
  seller_name: string;
  seller_url?: string | null;
}

export interface MonitoringSellerViewProtocolsGetListingIdForSellerRequest {
  asset_id_filter?: number[] | null;
  /** @format int32 */
  brand_id?: number | null;
  channel_type: MarqCommonEnumsChannelTypeEnum[];
  client_requested_filter?: boolean | null;
  client_status_filter: MarqBrandEnumsListingMonitoringStatusEnum;
  comment_user_type_filter?: MarqCommonEnumsCommentCommentUserTypeEnum[] | null;
  currency?: MarqFoundationEnumsCurrencyEnum;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  enforcement_rule_id_filter?: number[] | null;
  gen_ai_counterfeit_filter?: boolean | null;
  include_expired?: boolean | null;
  infringing_images_filter?: boolean | null;
  low_price_filter?: boolean | null;
  /** @format double */
  max_price?: number | null;
  /** @format double */
  max_sales_volume?: number | null;
  /** @format double */
  min_price?: number | null;
  /** @format double */
  min_sales_volume?: number | null;
  model_id_filter?: number[] | null;
  official_image_id_filter?: number[] | null;
  post_type_filter?: MarqCommonEnumsListingPostTypeEnum;
  potential_authorized_reason_filter?: MarqCommonEnumsPotentialAuthorizedReasonEnum[] | null;
  repeat_offender_filter?: boolean | null;
  reportable_filter?: MarqCommonEnumsReportableReasonEnum[] | null;
  scanned_status_filter?: MarqCommonEnumsScannedStatusEnum;
  search?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  search_date_filter?: string | null;
  /** @format int32 */
  seller_id?: number | null;
  seller_name_filter?: string[] | null;
  seller_sorted_column: MarqCommonEnumsSortedSellerGroupEnum;
  seller_sorted_order: MarqCommonEnumsSortedOrderEnum;
  ship_from_filter?: string[] | null;
  tm_infringement_filter?: boolean | null;
  tm_infringement_logo_filter?: number[] | null;
  tm_infringement_text_filter?: boolean | null;
  top_result_filter?: boolean | null;
  updated_date_range_filter?: MarqCommonModelLocalDateRange;
}

export interface MonitoringSellerViewProtocolsGetListingIdForSellerResponse {
  /** @format int32 */
  count: number;
  listing_ids: number[];
}

export interface MonitoringSellerViewProtocolsGetSellerDetailsRequest {
  /** @format int32 */
  brand_id?: number | null;
  /** @format int32 */
  seller_id: number;
}

export interface MonitoringSellerViewProtocolsGetSellerDetailsResponse {
  seller_detail: MarqBrandModelResponseSellerDetailResponse;
}

export interface MonitoringSellerViewProtocolsGetSellerListingsRequest {
  asset_id_filter?: number[] | null;
  /** @format int32 */
  brand_id?: number | null;
  channel_type: MarqCommonEnumsChannelTypeEnum[];
  client_requested_filter?: boolean | null;
  client_status_filter: MarqBrandEnumsListingMonitoringStatusEnum;
  comment_user_type_filter?: MarqCommonEnumsCommentCommentUserTypeEnum[] | null;
  currency?: MarqFoundationEnumsCurrencyEnum;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  enforcement_rule_id_filter?: number[] | null;
  gen_ai_counterfeit_filter?: boolean | null;
  include_expired?: boolean | null;
  infringing_images_filter?: boolean | null;
  low_price_filter?: boolean | null;
  /** @format double */
  max_price?: number | null;
  /** @format double */
  max_sales_volume?: number | null;
  /** @format double */
  min_price?: number | null;
  /** @format double */
  min_sales_volume?: number | null;
  model_id_filter?: number[] | null;
  official_image_id_filter?: number[] | null;
  post_type_filter?: MarqCommonEnumsListingPostTypeEnum;
  potential_authorized_reason_filter?: MarqCommonEnumsPotentialAuthorizedReasonEnum[] | null;
  repeat_offender_filter?: boolean | null;
  reportable_filter?: MarqCommonEnumsReportableReasonEnum[] | null;
  scanned_status_filter?: MarqCommonEnumsScannedStatusEnum;
  search?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  search_date_filter?: string | null;
  /** @format int32 */
  seller_id?: number | null;
  seller_name_filter?: string[] | null;
  ship_from_filter?: string[] | null;
  tm_infringement_filter?: boolean | null;
  tm_infringement_logo_filter?: number[] | null;
  tm_infringement_text_filter?: boolean | null;
  top_result_filter?: boolean | null;
  updated_date_range_filter?: MarqCommonModelLocalDateRange;
}

export interface MonitoringSellerViewProtocolsGetSellerListingsResponse {
  /** @format int32 */
  domain_id?: number | null;
  domain_name?: string | null;
  listing_list: MarqBrandModelResponseMonitoringListingResponse[];
  seller_page_url?: string | null;
  snapshot_path?: string | null;
  /** @format int32 */
  total_count: number;
}

export interface MonitoringSellerViewProtocolsGetSellersRequest {
  asset_id_filter?: number[] | null;
  /** @format int32 */
  brand_id?: number | null;
  channel_type: MarqCommonEnumsChannelTypeEnum[];
  client_requested_filter?: boolean | null;
  client_status_filter: MarqBrandEnumsListingMonitoringStatusEnum;
  comment_user_type_filter?: MarqCommonEnumsCommentCommentUserTypeEnum[] | null;
  currency?: MarqFoundationEnumsCurrencyEnum;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  enforcement_rule_id_filter?: number[] | null;
  gen_ai_counterfeit_filter?: boolean | null;
  include_expired?: boolean | null;
  infringing_images_filter?: boolean | null;
  /** @format int32 */
  limit: number;
  low_price_filter?: boolean | null;
  /** @format double */
  max_price?: number | null;
  /** @format double */
  max_sales_volume?: number | null;
  /** @format double */
  min_price?: number | null;
  /** @format double */
  min_sales_volume?: number | null;
  model_id_filter?: number[] | null;
  official_image_id_filter?: number[] | null;
  /** @format int32 */
  offset: number;
  post_type_filter?: MarqCommonEnumsListingPostTypeEnum;
  potential_authorized_reason_filter?: MarqCommonEnumsPotentialAuthorizedReasonEnum[] | null;
  repeat_offender_filter?: boolean | null;
  reportable_filter?: MarqCommonEnumsReportableReasonEnum[] | null;
  scanned_status_filter?: MarqCommonEnumsScannedStatusEnum;
  search?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  search_date_filter?: string | null;
  seller_name_filter?: string[] | null;
  seller_sorted_column: MarqCommonEnumsSortedSellerGroupEnum;
  seller_sorted_order: MarqCommonEnumsSortedOrderEnum;
  ship_from_filter?: string[] | null;
  tm_infringement_filter?: boolean | null;
  tm_infringement_logo_filter?: number[] | null;
  tm_infringement_text_filter?: boolean | null;
  top_result_filter?: boolean | null;
  updated_date_range_filter?: MarqCommonModelLocalDateRange;
}

export interface MonitoringSellerViewProtocolsGetSellersResponse {
  sellers: MarqBrandModelResponseSellerCountResponse[];
}

export interface MonitoringSocialmediaPiracySocialMediaPiracyProtocolsCancelConfirmRequest {
  listing_id_list: number[];
}

export interface MonitoringSocialmediaPiracySocialMediaPiracyProtocolsExportCsvRequest {
  asset_list?: number[] | null;
  client_status: PiracyCommonEnumsClientStatus;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  listing_id_list?: number[] | null;
  live_filter?: boolean | null;
  search_method_list?: PiracyCommonEnumsSearchMethodEnum[] | null;
  search_string?: string | null;
  sort_column: PiracyCommonEnumsSortColumnEnum;
  sort_order: PiracyCommonEnumsSortOrderEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
  top_search_filter?: boolean | null;
  website_id_list?: number[] | null;
}

export interface MonitoringSocialmediaPiracySocialMediaPiracyProtocolsFeatures {
  live: boolean;
}

export interface MonitoringSocialmediaPiracySocialMediaPiracyProtocolsGetChannelGroupCountResponse {
  /** @format int32 */
  channel_group_count: number;
}

export interface MonitoringSocialmediaPiracySocialMediaPiracyProtocolsGetDetailRequest {
  channel: PiracyCommonEnumsChannelEnum;
  /** @format int32 */
  id: number;
}

export interface MonitoringSocialmediaPiracySocialMediaPiracyProtocolsGetListRequest {
  asset_list?: number[] | null;
  client_status: PiracyCommonEnumsClientStatus;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /** @format int32 */
  limit: number;
  live_filter?: boolean | null;
  /** @format int32 */
  offset: number;
  search_method_list?: PiracyCommonEnumsSearchMethodEnum[] | null;
  search_string?: string | null;
  sort_column: PiracyCommonEnumsSortColumnEnum;
  sort_order: PiracyCommonEnumsSortOrderEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
  top_search_filter?: boolean | null;
  website_id_list?: number[] | null;
}

export interface MonitoringSocialmediaPiracySocialMediaPiracyProtocolsGetListResponse {
  list: MonitoringSocialmediaPiracySocialMediaPiracyProtocolsGetListResponseListing[];
}

export interface MonitoringSocialmediaPiracySocialMediaPiracyProtocolsGetListResponseListing {
  asset_name: string;
  channel: PiracyCommonEnumsChannelEnum;
  features: MonitoringSocialmediaPiracySocialMediaPiracyProtocolsFeatures;
  /** @format int32 */
  id: number;
  platform_name: string;
  profile_name: string;
  search_method: PiracyCommonEnumsSearchMethodEnum;
  thumbnail_url: string;
  title: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  update_date: string;
  url: string;
}

export interface MonitoringSocialmediaPiracySocialMediaPiracyProtocolsGetListingCountRequest {
  asset_list?: number[] | null;
  client_status: PiracyCommonEnumsClientStatus;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  live_filter?: boolean | null;
  search_method_list?: PiracyCommonEnumsSearchMethodEnum[] | null;
  search_string?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
  top_search_filter?: boolean | null;
  website_id_list?: number[] | null;
}

export interface MonitoringSocialmediaPiracySocialMediaPiracyProtocolsGetListingCountResponse {
  /** @format int32 */
  count: number;
}

export interface MonitoringSocialmediaPiracySocialMediaPiracyProtocolsGetListingIdListRequest {
  asset_list?: number[] | null;
  client_status: PiracyCommonEnumsClientStatus;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /** @format int32 */
  limit: number;
  live_filter?: boolean | null;
  /** @format int32 */
  offset: number;
  search_method_list?: PiracyCommonEnumsSearchMethodEnum[] | null;
  search_string?: string | null;
  sort_column: PiracyCommonEnumsSortColumnEnum;
  sort_order: PiracyCommonEnumsSortOrderEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
  top_search_filter?: boolean | null;
  website_id_list?: number[] | null;
}

export interface MonitoringSocialmediaPiracySocialMediaPiracyProtocolsGetListingIdListResponse {
  listing_id_list: number[];
  /** @format int32 */
  size: number;
}

export interface MonitoringSocialmediaPiracySocialMediaPiracyProtocolsGetStatusCountResponse {
  /** @format int32 */
  confirmed: number;
  /** @format int32 */
  detected: number;
  /** @format int32 */
  reported: number;
}

export interface MonitoringSocialmediaPiracySocialMediaPiracyProtocolsGetWebsiteFilterRequest {
  asset_list?: number[] | null;
  client_status: PiracyCommonEnumsClientStatus;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  filter_search?: string | null;
  /** @format int32 */
  limit: number;
  live_filter?: boolean | null;
  /** @format int32 */
  offset: number;
  search_method_list?: PiracyCommonEnumsSearchMethodEnum[] | null;
  search_string?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
  top_search_filter?: boolean | null;
}

export interface MonitoringSocialmediaPiracySocialMediaPiracyProtocolsPostConfirmRequest {
  doc_list?: MonitoringSocialmediaPiracySocialMediaPiracyProtocolsPostConfirmRequestFileRequest[] | null;
  listing_id_list: number[];
  note?: string | null;
}

export interface MonitoringSocialmediaPiracySocialMediaPiracyProtocolsPostConfirmRequestFileRequest {
  file_name: string;
  url: string;
}

export interface MonitoringSocialmediaPiracySocialMediaPiracyProtocolsPostDismissRequest {
  listing_id_list: number[];
}

export interface MonitoringWebsiteContentWebsiteContentCommonProtocolsApplyCustomTagRequest {
  add_custom_tag_id_list?: number[] | null;
  delete_custom_tag_id_list?: number[] | null;
  website_id_list: number[];
}

export interface MonitoringWebsiteContentWebsiteContentCommonProtocolsDeleteAllCustomTagRequest {
  website_id_list: number[];
}

export interface MonitoringWebsiteContentWebsiteContentCommonProtocolsGetCountRequest {
  /** @format int32 */
  brand_id?: number | null;
  comment_user_type_filter?: MarqCommonEnumsCommentCommentUserTypeEnum[] | null;
  country_filter?: MarqFoundationEnumsCountryCodeEnum[] | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  favicon_detected_filter?: boolean | null;
  logo_detection_filter?: boolean | null;
  mx_records_filter?: boolean | null;
  requested_date_filter?: MarqCommonModelLocalDateRange;
  scanned_date_filter?: MarqCommonModelLocalDateRange;
  scanned_status_filter?: MarqCommonEnumsScannedStatusEnum;
  search?: string | null;
  ssl_cert_filter?: boolean | null;
  tab: MarqCommonEnumsSwWebsiteContentsTabEnum;
  tp_progress_status_filter?: MarqCommonEnumsTpTpProgressStatusEnum[] | null;
  tp_reported_filter?: boolean | null;
}

export interface MonitoringWebsiteContentWebsiteContentCommonProtocolsGetCountResponse {
  /** @format int32 */
  count: number;
}

export interface MonitoringWebsiteContentWebsiteContentCommonProtocolsGetCountryFilterRequest {
  /** @format int32 */
  brand_id?: number | null;
  comment_user_type_filter?: MarqCommonEnumsCommentCommentUserTypeEnum[] | null;
  country_filter?: MarqFoundationEnumsCountryCodeEnum[] | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  favicon_detected_filter?: boolean | null;
  logo_detection_filter?: boolean | null;
  mx_records_filter?: boolean | null;
  requested_date_filter?: MarqCommonModelLocalDateRange;
  scanned_date_filter?: MarqCommonModelLocalDateRange;
  scanned_status_filter?: MarqCommonEnumsScannedStatusEnum;
  search?: string | null;
  ssl_cert_filter?: boolean | null;
  tab: MarqCommonEnumsSwWebsiteContentsTabEnum;
  tp_progress_status_filter?: MarqCommonEnumsTpTpProgressStatusEnum[] | null;
  tp_reported_filter?: boolean | null;
}

export interface MonitoringWebsiteContentWebsiteContentCommonProtocolsGetCustomTagsFilterRequest {
  /** @format int32 */
  brand_id?: number | null;
  comment_user_type_filter?: MarqCommonEnumsCommentCommentUserTypeEnum[] | null;
  country_filter?: MarqFoundationEnumsCountryCodeEnum[] | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  favicon_detected_filter?: boolean | null;
  logo_detection_filter?: boolean | null;
  mx_records_filter?: boolean | null;
  requested_date_filter?: MarqCommonModelLocalDateRange;
  scanned_date_filter?: MarqCommonModelLocalDateRange;
  scanned_status_filter?: MarqCommonEnumsScannedStatusEnum;
  search?: string | null;
  ssl_cert_filter?: boolean | null;
  tab: MarqCommonEnumsSwWebsiteContentsTabEnum;
  tp_progress_status_filter?: MarqCommonEnumsTpTpProgressStatusEnum[] | null;
  tp_reported_filter?: boolean | null;
}

export interface MonitoringWebsiteContentWebsiteContentCommonProtocolsGetDomainFilterRequest {
  /** @format int32 */
  brand_id?: number | null;
  comment_user_type_filter?: MarqCommonEnumsCommentCommentUserTypeEnum[] | null;
  country_filter?: MarqFoundationEnumsCountryCodeEnum[] | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  favicon_detected_filter?: boolean | null;
  /** @format int32 */
  limit?: number | null;
  logo_detection_filter?: boolean | null;
  mx_records_filter?: boolean | null;
  requested_date_filter?: MarqCommonModelLocalDateRange;
  scanned_date_filter?: MarqCommonModelLocalDateRange;
  scanned_status_filter?: MarqCommonEnumsScannedStatusEnum;
  search?: string | null;
  search_after?: KotlinAny[] | null;
  ssl_cert_filter?: boolean | null;
  tab: MarqCommonEnumsSwWebsiteContentsTabEnum;
  tp_progress_status_filter?: MarqCommonEnumsTpTpProgressStatusEnum[] | null;
  tp_reported_filter?: boolean | null;
}

export interface MonitoringWebsiteContentWebsiteContentCommonProtocolsGetExportListingsRequest {
  /** @format int32 */
  brand_id?: number | null;
  comment_user_type_filter?: MarqCommonEnumsCommentCommentUserTypeEnum[] | null;
  country_filter?: MarqFoundationEnumsCountryCodeEnum[] | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  favicon_detected_filter?: boolean | null;
  logo_detection_filter?: boolean | null;
  mx_records_filter?: boolean | null;
  requested_date_filter?: MarqCommonModelLocalDateRange;
  scanned_date_filter?: MarqCommonModelLocalDateRange;
  scanned_status_filter?: MarqCommonEnumsScannedStatusEnum;
  search?: string | null;
  sorted_column: MarqBrandEnumsWebsiteBrandSortedColumnEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
  ssl_cert_filter?: boolean | null;
  tab: MarqCommonEnumsSwWebsiteContentsTabEnum;
  tp_progress_status_filter?: MarqCommonEnumsTpTpProgressStatusEnum[] | null;
  tp_reported_filter?: boolean | null;
  website_id_list?: number[] | null;
}

export interface MonitoringWebsiteContentWebsiteContentCommonProtocolsGetExportListingsResponse {
  /** @format int32 */
  id: number;
}

export interface MonitoringWebsiteContentWebsiteContentCommonProtocolsGetWebsiteDetailRequest {
  /** @format int32 */
  website_id: number;
}

export interface MonitoringWebsiteContentWebsiteContentCommonProtocolsGetWebsiteDetailResponse {
  website_detail: MarqBrandCoreModelSwWebsiteContentsDetailResponse;
}

export interface MonitoringWebsiteContentWebsiteContentCommonProtocolsGetWebsiteListRequest {
  /** @format int32 */
  brand_id?: number | null;
  comment_user_type_filter?: MarqCommonEnumsCommentCommentUserTypeEnum[] | null;
  country_filter?: MarqFoundationEnumsCountryCodeEnum[] | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  favicon_detected_filter?: boolean | null;
  /** @format int32 */
  limit?: number | null;
  logo_detection_filter?: boolean | null;
  mx_records_filter?: boolean | null;
  /** @format int32 */
  offset: number;
  requested_date_filter?: MarqCommonModelLocalDateRange;
  scanned_date_filter?: MarqCommonModelLocalDateRange;
  scanned_status_filter?: MarqCommonEnumsScannedStatusEnum;
  search?: string | null;
  sorted_column: MarqBrandEnumsWebsiteBrandSortedColumnEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
  ssl_cert_filter?: boolean | null;
  tab: MarqCommonEnumsSwWebsiteContentsTabEnum;
  tp_progress_status_filter?: MarqCommonEnumsTpTpProgressStatusEnum[] | null;
  tp_reported_filter?: boolean | null;
}

export interface MonitoringWebsiteContentWebsiteContentCommonProtocolsGetWebsiteListResponse {
  website_list: MonitoringWebsiteContentWebsiteContentCommonProtocolsWebsiteContentsListing[];
}

export interface MonitoringWebsiteContentWebsiteContentCommonProtocolsRequestAuthorizedRequest {
  website_id_list: number[];
}

export interface MonitoringWebsiteContentWebsiteContentCommonProtocolsRequestAuthorizedResponse {
  /** @format int32 */
  affected: number;
  domain_name: string;
}

export interface MonitoringWebsiteContentWebsiteContentCommonProtocolsRequestTestPurchaseRequest {
  tp_type: MarqCommonEnumsTpTpTypeEnum;
  website_id_list: number[];
}

export interface MonitoringWebsiteContentWebsiteContentCommonProtocolsRequestTestPurchaseResponse {
  success: boolean;
}

export interface MonitoringWebsiteContentWebsiteContentCommonProtocolsUpdateWebsiteStatusRequest {
  from_status: MarqCommonEnumsSwSWStatusEnum;
  to_status: MarqCommonEnumsSwSWStatusEnum;
  website_id_list: number[];
}

export interface MonitoringWebsiteContentWebsiteContentCommonProtocolsUpdateWebsiteStatusResponse {
  /** @format int32 */
  failed_count: number;
  /** @format int32 */
  success_count: number;
}

export interface MonitoringWebsiteContentWebsiteContentCommonProtocolsUpdateWebsiteStatusByTabRequest {
  from_tab: MarqCommonEnumsSwWebsiteContentsTabEnum;
  to_tab: MarqCommonEnumsSwWebsiteContentsTabEnum;
  website_id_list: number[];
}

export interface MonitoringWebsiteContentWebsiteContentCommonProtocolsUpdateWebsiteStatusByTabResponse {
  /** @format int32 */
  failed_count: number;
  /** @format int32 */
  success_count: number;
}

export interface MonitoringWebsiteContentWebsiteContentCommonProtocolsWebsiteContentsListing {
  cdn?: string | null;
  /** @format int32 */
  comment_count: number;
  country?: MarqFoundationEnumsCountryCodeEnum;
  custom_tags?: MarqBrandCoreModelResponseCustomTagResponse[] | null;
  description?: string | null;
  description_translate?: string | null;
  domain_url: string;
  exist_tp_report: boolean;
  /**
   * @format date
   * @example "2023-03-01"
   */
  expiration_date?: string | null;
  full_url: string;
  google_delisting_status?: MarqCommonEnumsSwWebsiteDelistingProgressEnum;
  hosting_provider?: string | null;
  infringing_contents_status?: MarqCommonEnumsSwWebsiteReportProgressEnum;
  ip_address?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  last_reported_date?: string | null;
  logo_detection: boolean;
  mx_record: boolean;
  registrant?: string | null;
  registrar?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  registration_date?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  scanned_date: string;
  scanned_status?: MarqCommonEnumsScannedStatusEnum;
  ssl_certificate?: string | null;
  thumbnail_url?: string | null;
  title: string;
  title_translate?: string | null;
  tp_group_status?: MarqCommonEnumsTpTpProgressStatusEnum;
  tp_group_status_label?: string | null;
  /** @format int32 */
  tp_id?: number | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  tp_requested_date?: string | null;
  tp_status_label?: string | null;
  tp_type?: MarqCommonEnumsTpTpTypeEnum;
  /** @format int32 */
  website_id: number;
}

export interface MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsCancelConfirmRequest {
  listing_id_list: number[];
}

export interface MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsExportCsvRequest {
  asset_list?: number[] | null;
  client_status: PiracyCommonEnumsClientStatus;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  listing_id_list?: number[] | null;
  live_filter?: boolean | null;
  search_method_list?: PiracyCommonEnumsSearchMethodEnum[] | null;
  search_string?: string | null;
  sort_column: PiracyCommonEnumsSortColumnEnum;
  sort_order: PiracyCommonEnumsSortOrderEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
  top_search_filter?: boolean | null;
  website_id_list?: number[] | null;
}

export interface MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsFeatures {
  live: boolean;
  top_search: boolean;
}

export interface MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetChannelGroupCountResponse {
  /** @format int32 */
  channel_group_count: number;
}

export interface MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetDetailRequest {
  channel: PiracyCommonEnumsChannelEnum;
  /** @format int32 */
  id: number;
}

export interface MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetListRequest {
  asset_list?: number[] | null;
  client_status: PiracyCommonEnumsClientStatus;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /** @format int32 */
  limit: number;
  live_filter?: boolean | null;
  /** @format int32 */
  offset: number;
  search_method_list?: PiracyCommonEnumsSearchMethodEnum[] | null;
  search_string?: string | null;
  sort_column: PiracyCommonEnumsSortColumnEnum;
  sort_order: PiracyCommonEnumsSortOrderEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
  top_search_filter?: boolean | null;
  website_id_list?: number[] | null;
}

export interface MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetListResponse {
  list: MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetListResponseListing[];
}

export interface MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetListResponseListing {
  asset_name: string;
  channel: PiracyCommonEnumsChannelEnum;
  content_removal_status?: PiracyCommonEnumsContentRemovalStatusEnum;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  detected_date: string;
  domain_name: string;
  features: MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsFeatures;
  google_delisting_status?: PiracyCommonEnumsClientDelistingStatusEnum;
  /** @format int32 */
  id: number;
  search_keyword_list: string[];
  search_type: PiracyCommonEnumsSearchMethodEnum;
  title: string;
  url: string;
}

export interface MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetListingCountRequest {
  asset_list?: number[] | null;
  client_status: PiracyCommonEnumsClientStatus;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  live_filter?: boolean | null;
  search_method_list?: PiracyCommonEnumsSearchMethodEnum[] | null;
  search_string?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
  top_search_filter?: boolean | null;
  website_id_list?: number[] | null;
}

export interface MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetListingCountResponse {
  /** @format int32 */
  count: number;
}

export interface MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetListingIdListRequest {
  asset_list?: number[] | null;
  client_status: PiracyCommonEnumsClientStatus;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /** @format int32 */
  limit: number;
  live_filter?: boolean | null;
  /** @format int32 */
  offset: number;
  search_method_list?: PiracyCommonEnumsSearchMethodEnum[] | null;
  search_string?: string | null;
  sort_column: PiracyCommonEnumsSortColumnEnum;
  sort_order: PiracyCommonEnumsSortOrderEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
  top_search_filter?: boolean | null;
  website_id_list?: number[] | null;
}

export interface MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetListingIdListResponse {
  listing_id_list: number[];
  /** @format int32 */
  size: number;
}

export interface MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetStatusCountResponse {
  /** @format int32 */
  confirmed: number;
  /** @format int32 */
  detected: number;
  /** @format int32 */
  reported: number;
}

export interface MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetWebsiteFilterRequest {
  asset_list?: number[] | null;
  client_status: PiracyCommonEnumsClientStatus;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  filter_search?: string | null;
  /** @format int32 */
  limit: number;
  live_filter?: boolean | null;
  /** @format int32 */
  offset: number;
  search_method_list?: PiracyCommonEnumsSearchMethodEnum[] | null;
  search_string?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
  top_search_filter?: boolean | null;
}

export interface MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsPostConfirmRequest {
  listing_id_list: number[];
}

export interface MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsPostDismissRequest {
  listing_id_list: number[];
}

export interface MonitoringWebsiteDomainWebsiteDomainNamesProtocolsApplyCustomTagRequest {
  add_custom_tag_id_list?: number[] | null;
  delete_custom_tag_id_list?: number[] | null;
  website_id_list: number[];
}

export interface MonitoringWebsiteDomainWebsiteDomainNamesProtocolsDeleteAllCustomTagRequest {
  website_id_list: number[];
}

export interface MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetCountRequest {
  /** @format int32 */
  brand_id?: number | null;
  comment_user_type_filter?: MarqCommonEnumsCommentCommentUserTypeEnum[] | null;
  country_filter?: MarqFoundationEnumsCountryCodeEnum[] | null;
  custom_tag_id_filter?: number[] | null;
  domain_status_filter?: MarqCommonEnumsSwAiLabelEnum[] | null;
  favicon_detected_filter?: boolean | null;
  logo_detection_filter?: boolean | null;
  mx_records_filter?: boolean | null;
  requested_date_filter?: MarqCommonModelLocalDateRange;
  scanned_date_filter?: MarqCommonModelLocalDateRange;
  scanned_status_filter?: MarqCommonEnumsScannedStatusEnum;
  search?: string | null;
  ssl_cert_filter?: boolean | null;
  tab: MarqCommonEnumsSwWebsiteBrandDomainNamesTabEnum;
  watch_list_added_date_filter?: MarqCommonModelLocalDateRange;
}

export interface MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetCountResponse {
  /** @format int32 */
  count: number;
}

export interface MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetCountryFilterRequest {
  /** @format int32 */
  brand_id?: number | null;
  comment_user_type_filter?: MarqCommonEnumsCommentCommentUserTypeEnum[] | null;
  country_filter?: MarqFoundationEnumsCountryCodeEnum[] | null;
  custom_tag_id_filter?: number[] | null;
  domain_status_filter?: MarqCommonEnumsSwAiLabelEnum[] | null;
  favicon_detected_filter?: boolean | null;
  logo_detection_filter?: boolean | null;
  mx_records_filter?: boolean | null;
  requested_date_filter?: MarqCommonModelLocalDateRange;
  scanned_date_filter?: MarqCommonModelLocalDateRange;
  scanned_status_filter?: MarqCommonEnumsScannedStatusEnum;
  search?: string | null;
  ssl_cert_filter?: boolean | null;
  tab: MarqCommonEnumsSwWebsiteBrandDomainNamesTabEnum;
  watch_list_added_date_filter?: MarqCommonModelLocalDateRange;
}

export interface MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetCustomTagsFilterRequest {
  /** @format int32 */
  brand_id?: number | null;
  comment_user_type_filter?: MarqCommonEnumsCommentCommentUserTypeEnum[] | null;
  country_filter?: MarqFoundationEnumsCountryCodeEnum[] | null;
  custom_tag_id_filter?: number[] | null;
  domain_status_filter?: MarqCommonEnumsSwAiLabelEnum[] | null;
  favicon_detected_filter?: boolean | null;
  logo_detection_filter?: boolean | null;
  mx_records_filter?: boolean | null;
  requested_date_filter?: MarqCommonModelLocalDateRange;
  scanned_date_filter?: MarqCommonModelLocalDateRange;
  scanned_status_filter?: MarqCommonEnumsScannedStatusEnum;
  search?: string | null;
  ssl_cert_filter?: boolean | null;
  tab: MarqCommonEnumsSwWebsiteBrandDomainNamesTabEnum;
  watch_list_added_date_filter?: MarqCommonModelLocalDateRange;
}

export interface MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetDomainStatusFilterRequest {
  /** @format int32 */
  brand_id?: number | null;
  comment_user_type_filter?: MarqCommonEnumsCommentCommentUserTypeEnum[] | null;
  country_filter?: MarqFoundationEnumsCountryCodeEnum[] | null;
  custom_tag_id_filter?: number[] | null;
  domain_status_filter?: MarqCommonEnumsSwAiLabelEnum[] | null;
  favicon_detected_filter?: boolean | null;
  logo_detection_filter?: boolean | null;
  mx_records_filter?: boolean | null;
  requested_date_filter?: MarqCommonModelLocalDateRange;
  scanned_date_filter?: MarqCommonModelLocalDateRange;
  scanned_status_filter?: MarqCommonEnumsScannedStatusEnum;
  search?: string | null;
  ssl_cert_filter?: boolean | null;
  tab: MarqCommonEnumsSwWebsiteBrandDomainNamesTabEnum;
  watch_list_added_date_filter?: MarqCommonModelLocalDateRange;
}

export interface MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetExportListingsRequest {
  /** @format int32 */
  brand_id?: number | null;
  comment_user_type_filter?: MarqCommonEnumsCommentCommentUserTypeEnum[] | null;
  country_filter?: MarqFoundationEnumsCountryCodeEnum[] | null;
  custom_tag_id_filter?: number[] | null;
  domain_status_filter?: MarqCommonEnumsSwAiLabelEnum[] | null;
  favicon_detected_filter?: boolean | null;
  logo_detection_filter?: boolean | null;
  mx_records_filter?: boolean | null;
  requested_date_filter?: MarqCommonModelLocalDateRange;
  scanned_date_filter?: MarqCommonModelLocalDateRange;
  scanned_status_filter?: MarqCommonEnumsScannedStatusEnum;
  search?: string | null;
  sorted_column: MarqBrandEnumsWebsiteBrandSortedColumnEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
  ssl_cert_filter?: boolean | null;
  tab: MarqCommonEnumsSwWebsiteBrandDomainNamesTabEnum;
  watch_list_added_date_filter?: MarqCommonModelLocalDateRange;
  website_id_list?: number[] | null;
}

export interface MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetExportListingsResponse {
  /** @format int32 */
  id: number;
}

export interface MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetHeaderCountDataResponse {
  header_count_list: MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetHeaderCountDataResponseHeaderCountBlock[];
}

export interface MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetHeaderCountDataResponseBrandData {
  /** @format int32 */
  brand_id: number;
  brand_image_url?: string | null;
  brand_name: string;
}

export interface MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetHeaderCountDataResponseHeaderCountBlock {
  brand_data?: MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetHeaderCountDataResponseBrandData;
  /** @format int32 */
  clean_count: number;
  /** @format int32 */
  impersonation_count: number;
  /** @format int32 */
  inactive_count: number;
  /** @format int32 */
  parking_count: number;
}

export interface MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetWebsiteDetailRequest {
  /** @format int32 */
  website_id: number;
}

export interface MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetWebsiteDetailResponse {
  website_detail: MarqBrandCoreModelSwWebsiteDomainNamesDetailResponse;
}

export interface MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetWebsiteListRequest {
  /** @format int32 */
  brand_id?: number | null;
  comment_user_type_filter?: MarqCommonEnumsCommentCommentUserTypeEnum[] | null;
  country_filter?: MarqFoundationEnumsCountryCodeEnum[] | null;
  custom_tag_id_filter?: number[] | null;
  domain_status_filter?: MarqCommonEnumsSwAiLabelEnum[] | null;
  favicon_detected_filter?: boolean | null;
  /** @format int32 */
  limit?: number | null;
  logo_detection_filter?: boolean | null;
  mx_records_filter?: boolean | null;
  /** @format int32 */
  offset: number;
  requested_date_filter?: MarqCommonModelLocalDateRange;
  scanned_date_filter?: MarqCommonModelLocalDateRange;
  scanned_status_filter?: MarqCommonEnumsScannedStatusEnum;
  search?: string | null;
  sorted_column: MarqBrandEnumsWebsiteBrandSortedColumnEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
  ssl_cert_filter?: boolean | null;
  tab: MarqCommonEnumsSwWebsiteBrandDomainNamesTabEnum;
  watch_list_added_date_filter?: MarqCommonModelLocalDateRange;
}

export interface MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetWebsiteListResponse {
  website_list: MarqBrandModelResponseWebsiteWebsiteDomainNamesListing[];
}

export interface MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetWebsiteReportedDetailRequest {
  /** @format int32 */
  website_id: number;
}

export interface MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetWebsiteReportedDetailResponse {
  website_detail: MarqBrandCoreModelSwWebsiteDomainNamesReportedDetailResponse;
}

export interface MonitoringWebsiteDomainWebsiteDomainNamesProtocolsRequestAuthorizedRequest {
  website_id_list: number[];
}

export interface MonitoringWebsiteDomainWebsiteDomainNamesProtocolsRequestAuthorizedResponse {
  /** @format int32 */
  affected: number;
  domain_name: string;
}

export interface MonitoringWebsiteDomainWebsiteDomainNamesProtocolsUpdateWebsiteStatusRequest {
  from_status: MarqCommonEnumsSwSWStatusEnum;
  to_status: MarqCommonEnumsSwSWStatusEnum;
  website_id_list: number[];
}

export interface MonitoringWebsiteDomainWebsiteDomainNamesProtocolsUpdateWebsiteStatusResponse {
  /** @format int32 */
  failed_count: number;
  /** @format int32 */
  success_count: number;
}

export interface MonitoringWebsiteDomainWebsiteDomainNamesProtocolsUpdateWebsiteStatusByTabRequest {
  from_tab: MarqCommonEnumsSwWebsiteBrandDomainNamesTabEnum;
  to_tab: MarqCommonEnumsSwWebsiteBrandDomainNamesTabEnum;
  website_id_list: number[];
}

export interface MonitoringWebsiteDomainWebsiteDomainNamesProtocolsUpdateWebsiteStatusByTabResponse {
  /** @format int32 */
  failed_count: number;
  /** @format int32 */
  success_count: number;
}

export interface PerfCommercePerformanceCleanlinessProtocolsGetAiInsightsRequest {
  /** @format int32 */
  brand_id?: number | null;
  countries?: MarqFoundationEnumsCountryCodeEnum[] | null;
  domain_ids?: number[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfCommercePerformanceCleanlinessProtocolsGetAiInsightsResponse {
  paragraphs?: PerfCommercePerformanceCleanlinessProtocolsGetAiInsightsResponseParagraph[] | null;
}

export interface PerfCommercePerformanceCleanlinessProtocolsGetAiInsightsResponseParagraph {
  body: string;
  header: string;
}

export interface PerfCommercePerformanceCleanlinessProtocolsGetSaturationRateTrendRequest {
  /** @format int32 */
  brand_id?: number | null;
  countries?: MarqFoundationEnumsCountryCodeEnum[] | null;
  domain_ids?: number[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfCommercePerformanceCleanlinessProtocolsGetSaturationRateTrendResponse {
  items?: PerfCommercePerformanceCleanlinessProtocolsGetSaturationRateTrendResponseItem[] | null;
}

export interface PerfCommercePerformanceCleanlinessProtocolsGetSaturationRateTrendResponseItem {
  /**
   * @format date
   * @example "2023-03-01"
   */
  date: string;
  /** @format double */
  saturation_rate?: number | null;
}

export interface PerfCommercePerformanceCleanlinessProtocolsGetSaturationRateTrendDetailRequest {
  /** @format int32 */
  brand_id?: number | null;
  countries?: MarqFoundationEnumsCountryCodeEnum[] | null;
  domain_ids?: number[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfCommercePerformanceCleanlinessProtocolsGetSaturationRateTrendDetailResponse {
  dates: string[];
  domains?: PerfCommercePerformanceCleanlinessProtocolsGetSaturationRateTrendDetailResponseDomain[] | null;
  saturation_rate_by_date: Record<string, number>;
}

export interface PerfCommercePerformanceCleanlinessProtocolsGetSaturationRateTrendDetailResponseDomain {
  keywords: PerfCommercePerformanceCleanlinessProtocolsGetSaturationRateTrendDetailResponseKeyword[];
  name: string;
}

export interface PerfCommercePerformanceCleanlinessProtocolsGetSaturationRateTrendDetailResponseKeyword {
  keyword: string;
  saturation_rate_by_date: Record<
    string,
    PerfCommercePerformanceCleanlinessProtocolsGetSaturationRateTrendDetailResponseSaturationRate
  >;
}

export interface PerfCommercePerformanceCleanlinessProtocolsGetSaturationRateTrendDomainFilterRequest {
  /** @format int32 */
  brand_id?: number | null;
}

export interface PerfCommercePerformanceCleanlinessProtocolsGetSaturationRateTrendDomainFilterResponse {
  domains?: PerfCommercePerformanceCleanlinessProtocolsGetSaturationRateTrendDomainFilterResponseDomain[] | null;
}

export interface PerfCommercePerformanceCleanlinessProtocolsGetSaturationRateTrendDomainFilterResponseDomain {
  /** @format int32 */
  id: number;
  name: string;
}

export interface PerfCommercePerformanceCleanlinessProtocolsGetSnapshotRequest {
  /** @format int32 */
  brand_id?: number | null;
  countries?: MarqFoundationEnumsCountryCodeEnum[] | null;
  domain_ids?: number[] | null;
}

export interface PerfCommercePerformanceCleanlinessProtocolsGetSnapshotResponse {
  /**
   * @format date
   * @example "2023-03-01"
   */
  date?: string | null;
  segments?: PerfCommercePerformanceCleanlinessProtocolsSegment[] | null;
}

export interface PerfCommercePerformanceCleanlinessProtocolsGetSnapshotGroupByDomainRequest {
  /** @format int32 */
  brand_id?: number | null;
  countries?: MarqFoundationEnumsCountryCodeEnum[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  date: string;
  domain_ids?: number[] | null;
}

export interface PerfCommercePerformanceCleanlinessProtocolsGetSnapshotGroupByDomainResponse {
  domains?: PerfCommercePerformanceCleanlinessProtocolsGetSnapshotGroupByDomainResponseDomain[] | null;
}

export interface PerfCommercePerformanceCleanlinessProtocolsGetSnapshotGroupByDomainResponseDomain {
  keywords: PerfCommercePerformanceCleanlinessProtocolsGetSnapshotGroupByDomainResponseKeyword[];
  name: string;
  /** @format double */
  saturation_rate: number;
  segments: PerfCommercePerformanceCleanlinessProtocolsSegment[];
}

export interface PerfCommercePerformanceCleanlinessProtocolsGetSnapshotGroupByDomainResponseKeyword {
  keyword: string;
  /** @format double */
  saturation_rate: number;
  segments: PerfCommercePerformanceCleanlinessProtocolsSegment[];
}

export interface PerfCommercePerformanceCleanlinessProtocolsGetSnapshotGroupByKeywordRequest {
  /** @format int32 */
  brand_id?: number | null;
  countries?: MarqFoundationEnumsCountryCodeEnum[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  date: string;
  domain_ids?: number[] | null;
}

export interface PerfCommercePerformanceCleanlinessProtocolsGetSnapshotGroupByKeywordResponse {
  keywords?: PerfCommercePerformanceCleanlinessProtocolsGetSnapshotGroupByKeywordResponseKeyword[] | null;
}

export interface PerfCommercePerformanceCleanlinessProtocolsGetSnapshotGroupByKeywordResponseDomain {
  name: string;
  /** @format double */
  saturation_rate: number;
  segments: PerfCommercePerformanceCleanlinessProtocolsSegment[];
}

export interface PerfCommercePerformanceCleanlinessProtocolsGetSnapshotGroupByKeywordResponseKeyword {
  domains: PerfCommercePerformanceCleanlinessProtocolsGetSnapshotGroupByKeywordResponseDomain[];
  keyword: string;
  /** @format double */
  saturation_rate: number;
  segments: PerfCommercePerformanceCleanlinessProtocolsSegment[];
}

export interface PerfCommercePerformanceCleanlinessProtocolsGetStartDateRequest {
  /** @format int32 */
  brand_id?: number | null;
}

export interface PerfCommercePerformanceCleanlinessProtocolsGetStartDateResponse {
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfCommercePerformanceCleanlinessProtocolsGetStatusRequest {
  /** @format int32 */
  brand_id?: number | null;
}

export interface PerfCommercePerformanceCleanlinessProtocolsGetStatusResponse {
  /** @format int32 */
  num_of_keywords: number;
  /** @format int32 */
  num_of_platforms: number;
}

export interface PerfCommercePerformanceCleanlinessProtocolsSegment {
  label: MarqCommonEnumsCleanlinessCleanlinessLabelEnum;
  /** @format double */
  proportion: number;
}

export interface PerfCommercePerformanceEnforcementProtocolsExportListingsRawRequest {
  /** @format int32 */
  brand_id?: number | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date: string;
  tabs: MarqCommonEnumsPerfPerformanceEnforcementTabEnum[];
}

export interface PerfCommercePerformanceEnforcementProtocolsExportListingsRawResponse {
  files: PerfCommercePerformanceEnforcementProtocolsExportListingsRawResponseFile[];
}

export interface PerfCommercePerformanceEnforcementProtocolsExportListingsRawResponseFile {
  file_name: string;
  /** @format int32 */
  id: number;
  is_large: boolean;
}

export interface PerfCommercePerformanceEnforcementProtocolsGetAvailableTabsResponse {
  tabs: PerfCommercePerformanceEnforcementProtocolsGetAvailableTabsResponseTab[];
}

export interface PerfCommercePerformanceEnforcementProtocolsGetAvailableTabsResponseTab {
  code: MarqCommonEnumsPerfPerformanceEnforcementTabEnum;
  display_name: string;
}

export interface PerfCommercePerformanceEnforcementProtocolsGetListingCountByTabRequest {
  /** @format int32 */
  brand_id?: number | null;
  countries?: MarqFoundationEnumsCountryCodeEnum[] | null;
  domain_ids?: number[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date: string;
}

export interface PerfCommercePerformanceEnforcementProtocolsGetListingCountByTabResponse {
  count_by_tab: Record<string, number>;
}

export interface PerfCommercePerformanceEnforcementProtocolsGetListingCountsOverTimeRequest {
  /** @format int32 */
  brand_id?: number | null;
  countries?: MarqFoundationEnumsCountryCodeEnum[] | null;
  domain_ids?: number[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date: string;
  group_by: MarqCommonEnumsPerfPerformanceEnforcementGroupByEnum;
  interval?: MarqCommonEnumsPerfPerformanceEnforcementIntervalEnum;
  reportable_filter?: MarqCommonEnumsPerfPerformanceEnforcementReportableEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date: string;
  tab: MarqCommonEnumsPerfPerformanceEnforcementTabEnum;
}

export interface PerfCommercePerformanceEnforcementProtocolsGetListingCountsOverTimeResponse {
  available_intervals: MarqBrandCoreModelResponseCodeLabelComboBoxResponse[];
  chart_value_list: MarqBrandCoreModelPerfListingsChartValue[];
  /** @format int64 */
  total_count: number;
}

export interface PerfCommercePerformanceEnforcementProtocolsGetRemovedDataRequest {
  /** @format int32 */
  brand_id?: number | null;
  countries?: MarqFoundationEnumsCountryCodeEnum[] | null;
  domain_ids?: number[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date: string;
}

export interface PerfCommercePerformanceEnforcementProtocolsGetRemovedDataResponse {
  /** @format int64 */
  economic_value_of_removed_listings: number;
  /** @format int64 */
  removed_units: number;
}

export interface PerfCommercePerformanceEnforcementProtocolsTopDataRequest {
  /** @format int32 */
  brand_id?: number | null;
  countries?: MarqFoundationEnumsCountryCodeEnum[] | null;
  domain_ids?: number[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date: string;
  group_by: MarqCommonEnumsPerfPerformanceEnforcementGroupByEnum;
  reportable_filter?: MarqCommonEnumsPerfPerformanceEnforcementReportableEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date: string;
  tab: MarqCommonEnumsPerfPerformanceEnforcementTabEnum;
}

export interface PerfCommercePerformanceEnforcementProtocolsTopDataResponse {
  top_data_list: MarqBrandCoreModelPerfTopData[];
}

export interface PerfCommercePerformanceProtocolsGetClientCountryListResponse {
  country_list: MarqBrandCoreModelResponseCodeLabelComboBoxResponse[];
}

export interface PerfCommercePerformanceProtocolsGetCohortAnalysisRequest {
  asset_id_list: number[];
  /** @format int32 */
  brand_id?: number | null;
  country_list?: MarqFoundationEnumsCountryCodeEnum[] | null;
  domain_ids?: number[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date: string;
}

export interface PerfCommercePerformanceProtocolsGetCohortAnalysisResponse {
  data: PerfCommercePerformanceProtocolsGetCohortAnalysisResponseCohortMonthData[];
  /** @format double */
  removal_rate: number;
}

export interface PerfCommercePerformanceProtocolsGetCohortAnalysisResponseCohortMonthData {
  /**
   * @format date
   * @example "2023-03-01"
   */
  date: string;
  /** @format int64 */
  detected_count: number;
  /** @format int64 */
  enforcement_req_count: number;
  /** @format int64 */
  removed_count: number;
}

export interface PerfCommercePerformanceProtocolsGetCohortAnalysisCsvRequest {
  asset_id_list: number[];
  /** @format int32 */
  brand_id?: number | null;
  country_list?: MarqFoundationEnumsCountryCodeEnum[] | null;
  domain_ids?: number[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date: string;
}

export interface PerfCommercePerformanceProtocolsGetCohortAnalysisFilterRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_list?: MarqFoundationEnumsCountryCodeEnum[] | null;
  domain_ids?: number[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date: string;
}

export interface PerfCommercePerformanceProtocolsGetCohortAnalysisFilterResponse {
  asset_list: MarqBrandCoreModelResponseComboBoxIntValueLabelResponse[];
}

export interface PerfCommercePerformanceProtocolsGetComplianceRateRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_list?: MarqFoundationEnumsCountryCodeEnum[] | null;
  domain_ids?: number[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date: string;
}

export interface PerfCommercePerformanceProtocolsGetComplianceRateResponse {
  /** @format double */
  denied_percent: number;
  /** @format double */
  enforced_percent: number;
  /** @format double */
  in_review_percent: number;
}

export interface PerfCommercePerformanceProtocolsGetComplianceRateTopMarketsRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_list?: MarqFoundationEnumsCountryCodeEnum[] | null;
  domain_ids?: number[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date: string;
}

export interface PerfCommercePerformanceProtocolsGetComplianceRateTopMarketsResponse {
  rate_list: PerfCommercePerformanceProtocolsGetComplianceRateTopMarketsResponseRate[];
}

export interface PerfCommercePerformanceProtocolsGetComplianceRateTopMarketsResponseRate {
  domain_name: string;
  /** @format double */
  percent: number;
}

export interface PerfCommercePerformanceProtocolsGetEnforcedValueRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_list?: MarqFoundationEnumsCountryCodeEnum[] | null;
  domain_ids?: number[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date: string;
}

export interface PerfCommercePerformanceProtocolsGetEnforcedValueResponse {
  chart_value_list: PerfCommercePerformanceProtocolsGetEnforcedValueResponseChartValue[];
  /** @format int64 */
  enforced_value: number;
}

export interface PerfCommercePerformanceProtocolsGetEnforcedValueResponseChartValue {
  /**
   * @format date
   * @example "2023-03-01"
   */
  date: string;
  /** @format int64 */
  value: number;
}

export interface PerfCommercePerformanceProtocolsGetExpertServicesRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_list?: MarqFoundationEnumsCountryCodeEnum[] | null;
  domain_ids?: number[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date: string;
}

export interface PerfCommercePerformanceProtocolsGetExpertServicesResponse {
  /** @format int64 */
  demand_letter_count: number;
  /** @format int64 */
  tp_count: number;
}

export interface PerfCommercePerformanceProtocolsGetImpactedSellerRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_list?: MarqFoundationEnumsCountryCodeEnum[] | null;
  domain_ids?: number[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date: string;
}

export interface PerfCommercePerformanceProtocolsGetImpactedSellerResponse {
  /** @format int64 */
  impacted_seller_count: number;
  /** @format int64 */
  repeat_offender_count: number;
  /** @format int32 */
  repeat_offender_percent: number;
}

export interface PerfCommercePerformanceProtocolsGetRemovedListingsOverTimeRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_list?: MarqFoundationEnumsCountryCodeEnum[] | null;
  domain_ids?: number[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date: string;
}

export interface PerfCommercePerformanceProtocolsGetRemovedListingsOverTimeResponse {
  chart_value_list: MarqBrandCoreModelPerfListingsChartValue[];
  /** @format int64 */
  total_count: number;
}

export interface PerfCommercePerformanceProtocolsGetTopInfringingSellersRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_list?: MarqFoundationEnumsCountryCodeEnum[] | null;
  domain_ids?: number[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date: string;
}

export interface PerfCommercePerformanceProtocolsGetTopInfringingSellersResponse {
  top_sellers: PerfCommercePerformanceProtocolsGetTopInfringingSellersResponseTopSeller[];
}

export interface PerfCommercePerformanceProtocolsGetTopInfringingSellersResponseTopSeller {
  /** @format int32 */
  id: number;
  marketplace_name: string;
  name: string;
  /** @format int64 */
  removed_count: number;
  seller_string_id: string;
}

export interface PerfCommercePerformanceProtocolsGetWebsiteCountsRequest {
  /** @format int32 */
  brand_id?: number | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfCommercePerformanceProtocolsGetWebsiteCountsResponse {
  /** @format int64 */
  detected_count: number;
  /** @format int64 */
  enforced_count: number;
  /** @format int64 */
  enforcement_req_count: number;
  /** @format int64 */
  scanned_count: number;
  /** @format int64 */
  udrp_count: number;
}

export interface PerfCommercePerformanceReportProtocolsGetListRequest {
  sorted_order: MarqCommonEnumsSortedOrderEnum;
}

export interface PerfCommercePerformanceReportProtocolsGetListResponse {
  list: PerfCommercePerformanceReportProtocolsGetListResponseReport[];
}

export interface PerfCommercePerformanceReportProtocolsGetListResponseReport {
  filename: string;
  /** @format int32 */
  id: number;
  s3url: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  uploaded_date: string;
}

export interface PerfCommerceDetailsPerfDetailsCompRateProtocolsGetComplianceRateRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_list?: MarqFoundationEnumsCountryCodeEnum[] | null;
  domain_ids?: number[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date: string;
}

export interface PerfCommerceDetailsPerfDetailsCompRateProtocolsGetComplianceRateResponse {
  /** @format double */
  denied_percent: number;
  /** @format double */
  enforced_percent: number;
  /** @format double */
  four_week_percent: number;
  /** @format double */
  in_review_percent: number;
  /** @format double */
  two_week_percent: number;
}

export interface PerfCommerceDetailsPerfDetailsCompRateProtocolsGetComplianceRateOverTimeRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_list?: MarqFoundationEnumsCountryCodeEnum[] | null;
  domain_ids?: number[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date: string;
  frequency_filter?: MarqCommonEnumsPerfTimeFrequencyEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date: string;
}

export interface PerfCommerceDetailsPerfDetailsCompRateProtocolsGetComplianceRateOverTimeResponse {
  chart_value_list: PerfCommerceDetailsPerfDetailsCompRateProtocolsGetComplianceRateOverTimeResponseCompRateChartValue[];
  frequency_filter_list: MarqBrandCoreModelResponseCodeLabelComboBoxResponse[];
  /** @format int64 */
  removed_count: number;
  /** @format int64 */
  reported_count: number;
}

export interface PerfCommerceDetailsPerfDetailsCompRateProtocolsGetComplianceRateOverTimeResponseCompRateChartValue {
  /**
   * @format date
   * @example "2023-03-01"
   */
  date: string;
  /** @format int64 */
  removed_count: number;
  /** @format int64 */
  reported_count: number;
}

export interface PerfCommerceDetailsPerfDetailsCompRateProtocolsGetComplianceRateOverTimeCsvRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_list?: MarqFoundationEnumsCountryCodeEnum[] | null;
  domain_ids?: number[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date: string;
  frequency_filter?: MarqCommonEnumsPerfTimeFrequencyEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date: string;
}

export interface PerfCommerceDetailsPerfDetailsCompRateProtocolsGetComplianceRateTopCsvRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_list?: MarqFoundationEnumsCountryCodeEnum[] | null;
  domain_ids?: number[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date: string;
}

export interface PerfCommerceDetailsPerfDetailsCompRateProtocolsGetComplianceRateTopDataRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_list?: MarqFoundationEnumsCountryCodeEnum[] | null;
  domain_ids?: number[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date: string;
}

export interface PerfCommerceDetailsPerfDetailsCompRateProtocolsGetComplianceRateTopDataResponse {
  top_data_list: PerfCommerceDetailsPerfDetailsCompRateProtocolsGetComplianceRateTopDataResponseTopData[];
}

export interface PerfCommerceDetailsPerfDetailsCompRateProtocolsGetComplianceRateTopDataResponseTopData {
  domain_name: string;
  /** @format double */
  rate_percent: number;
}

export interface PerfCommerceDetailsPerfDetailsImpactedSellersProtocolsGetImpactedSellersRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_list?: MarqFoundationEnumsCountryCodeEnum[] | null;
  domain_ids?: number[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date: string;
}

export interface PerfCommerceDetailsPerfDetailsImpactedSellersProtocolsGetImpactedSellersResponse {
  impacted_sellers: PerfCommerceDetailsPerfDetailsImpactedSellersProtocolsGetImpactedSellersResponseSellerData;
  /** @format double */
  repeat_offender_percent: number;
  repeat_offenders: PerfCommerceDetailsPerfDetailsImpactedSellersProtocolsGetImpactedSellersResponseSellerData;
}

export interface PerfCommerceDetailsPerfDetailsImpactedSellersProtocolsGetImpactedSellersResponseSellerData {
  /** @format int64 */
  total_detected_listings: number;
  /** @format int64 */
  total_removed_listings: number;
  /** @format int64 */
  total_sellers: number;
}

export interface PerfCommerceDetailsPerfDetailsImpactedSellersProtocolsGetMarketplaceFilterListRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_list?: MarqFoundationEnumsCountryCodeEnum[] | null;
  domain_ids?: number[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date: string;
}

export interface PerfCommerceDetailsPerfDetailsImpactedSellersProtocolsGetMarketplaceFilterListResponse {
  marketplace_filter: PerfCommerceDetailsPerfDetailsImpactedSellersProtocolsGetMarketplaceFilterListResponseCountryMarkets[];
}

export interface PerfCommerceDetailsPerfDetailsImpactedSellersProtocolsGetMarketplaceFilterListResponseCountryMarkets {
  country: string;
  marketplace_list: MarqBrandCoreModelResponseComboBoxIntValueLabelResponse[];
}

export interface PerfCommerceDetailsPerfDetailsImpactedSellersProtocolsGetTopInfringingSellerRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_list?: MarqFoundationEnumsCountryCodeEnum[] | null;
  domain_ids?: number[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date: string;
}

export interface PerfCommerceDetailsPerfDetailsImpactedSellersProtocolsGetTopInfringingSellerResponse {
  seller_list: PerfCommerceDetailsPerfDetailsImpactedSellersProtocolsGetTopInfringingSellerResponseTopInfringingSeller[];
}

export interface PerfCommerceDetailsPerfDetailsImpactedSellersProtocolsGetTopInfringingSellerResponseTopInfringingSeller {
  /** @format int64 */
  active_count: number;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  first_detected?: string | null;
  /** @format int32 */
  id: number;
  marketplace_name: string;
  /** @format int64 */
  removed_count: number;
  seller_name: string;
  seller_string_id: string;
}

export interface PerfCommerceDetailsPerfDetailsImpactedSellersProtocolsGetTopInfringingSellerCsvRequest {
  /** @format int32 */
  brand_id?: number | null;
  country_list?: MarqFoundationEnumsCountryCodeEnum[] | null;
  domain_ids?: number[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date: string;
}

export interface PerfImpersonationPerformanceImpersonationProtocolsGetComplianceChartsRequest {
  /** @format int32 */
  brand_id?: number | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfImpersonationPerformanceImpersonationProtocolsGetComplianceChartsResponse {
  /** @format double */
  rate: number;
  rate_by_channel: PerfImpersonationPerformanceImpersonationProtocolsGetComplianceChartsResponseRateByChannelResponse[];
}

export interface PerfImpersonationPerformanceImpersonationProtocolsGetComplianceChartsResponseRateByChannelResponse {
  channel_name: string;
  grouped_count_list?:
    | PerfImpersonationPerformanceImpersonationProtocolsGetComplianceChartsResponseRateByChannelResponseGroupedCount[]
    | null;
  /** @format double */
  total_rate: number;
}

export interface PerfImpersonationPerformanceImpersonationProtocolsGetComplianceChartsResponseRateByChannelResponseGroupedCount {
  name: string;
  /** @format double */
  rate: number;
}

export interface PerfImpersonationPerformanceImpersonationProtocolsGetExportFileRequest {
  /** @format int32 */
  brand_id?: number | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfImpersonationPerformanceImpersonationProtocolsGetExportFileResponse {
  /** @format int32 */
  id: number;
}

export interface PerfImpersonationPerformanceImpersonationProtocolsGetFunnelChartsRequest {
  /** @format int32 */
  brand_id?: number | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfImpersonationPerformanceImpersonationProtocolsGetFunnelChartsResponse {
  in_period: PerfImpersonationPerformanceImpersonationProtocolsGetFunnelChartsResponseFunnelChartResponse;
  total_activity: PerfImpersonationPerformanceImpersonationProtocolsGetFunnelChartsResponseFunnelChartResponse;
}

export interface PerfImpersonationPerformanceImpersonationProtocolsGetFunnelChartsResponseFunnelChartResponse {
  /** @format int32 */
  detected: number;
  /** @format double */
  detected_rate: number;
  /** @format int32 */
  removed: number;
  /** @format double */
  removed_rate: number;
  /** @format int32 */
  reported: number;
  /** @format double */
  reported_rate: number;
  /** @format int32 */
  scanned: number;
  /** @format double */
  scanned_rate: number;
}

export interface PerfImpersonationPerformanceImpersonationProtocolsGetInsightChartsRequest {
  /** @format int32 */
  brand_id?: number | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfImpersonationPerformanceImpersonationProtocolsGetInsightChartsResponse {
  channel: PerfImpersonationPerformanceImpersonationProtocolsGetInsightChartsResponseChannelResponse[];
  monitored: PerfImpersonationPerformanceImpersonationProtocolsGetInsightChartsResponseMonitoredResponse;
}

export interface PerfImpersonationPerformanceImpersonationProtocolsGetInsightChartsResponseChannelResponse {
  /** @format int32 */
  count: number;
  name: string;
  type: MarqCommonEnumsChannelTypeEnum;
}

export interface PerfImpersonationPerformanceImpersonationProtocolsGetInsightChartsResponseMonitoredResponse {
  /** @format int32 */
  malicious: number;
  /** @format int32 */
  post_malicious: number;
  /** @format int32 */
  pre_malicious: number;
}

export interface PerfImpersonationPerformanceImpersonationProtocolsGetProcessingTimeRequest {
  /** @format int32 */
  brand_id?: number | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfImpersonationPerformanceImpersonationProtocolsGetProcessingTimeResponse {
  time_to_detected: PerfImpersonationPerformanceImpersonationProtocolsGetProcessingTimeResponseProcessingTimeResponse;
  time_to_removed: PerfImpersonationPerformanceImpersonationProtocolsGetProcessingTimeResponseProcessingTimeResponse;
  time_to_reported: PerfImpersonationPerformanceImpersonationProtocolsGetProcessingTimeResponseProcessingTimeResponse;
}

export interface PerfImpersonationPerformanceImpersonationProtocolsGetProcessingTimeResponseProcessingTimeResponse {
  domain_names?: string | null;
  social_media?: string | null;
  website_contents?: string | null;
}

export interface PerfImpersonationPerformanceImpersonationProtocolsGetReportingChartsRequest {
  /** @format int32 */
  brand_id?: number | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfImpersonationPerformanceImpersonationProtocolsGetReportingChartsResponse {
  activity_by_channel: PerfImpersonationPerformanceImpersonationProtocolsGetReportingChartsResponseActivityByChannelResponse[];
  activity_count: PerfImpersonationPerformanceImpersonationProtocolsGetReportingChartsResponseActivityCountResponse;
}

export interface PerfImpersonationPerformanceImpersonationProtocolsGetReportingChartsResponseActivityByChannelResponse {
  channel_name: string;
  grouped_count_list?:
    | PerfImpersonationPerformanceImpersonationProtocolsGetReportingChartsResponseActivityByChannelResponseGroupedCount[]
    | null;
  /** @format int32 */
  reported_count: number;
}

export interface PerfImpersonationPerformanceImpersonationProtocolsGetReportingChartsResponseActivityByChannelResponseGroupedCount {
  /** @format int32 */
  count: number;
  name: string;
}

export interface PerfImpersonationPerformanceImpersonationProtocolsGetReportingChartsResponseActivityCountResponse {
  /** @format int32 */
  activity: number;
  /** @format double */
  avg_activity: number;
  /** @format int32 */
  reported: number;
}

export interface PerfImpersonationPerformanceImpersonationProtocolsGetVisibleComponentResponse {
  component_list: MarqCommonEnumsPerfPerformaceImpersonationComponentEnum[];
}

export interface PerfPiracyPerfReportPiracyProtocolsReportGetListRequest {
  sort_order: PiracyCommonEnumsSortOrderEnum;
}

export interface PerfPiracyPerfReportPiracyProtocolsReportGetListResponse {
  list: PerfPiracyPerfReportPiracyProtocolsReportGetListResponseReport[];
}

export interface PerfPiracyPerfReportPiracyProtocolsReportGetListResponseReport {
  filename: string;
  /** @format int32 */
  id: number;
  is_new: boolean;
  s3url: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  uploaded_date: string;
}

export interface PerfPiracyPerfSocialMediaPiracyProtocolsGetComplianceRateRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyPerfSocialMediaPiracyProtocolsGetComplianceRateResponse {
  /** @format double */
  enforced_percent: number;
}

export interface PerfPiracyPerfSocialMediaPiracyProtocolsGetComplianceRateTopChannelsRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyPerfSocialMediaPiracyProtocolsGetComplianceRateTopChannelsResponse {
  rate_list: PerfPiracyPerfSocialMediaPiracyProtocolsGetComplianceRateTopChannelsResponseRate[];
}

export interface PerfPiracyPerfSocialMediaPiracyProtocolsGetComplianceRateTopChannelsResponseRate {
  channel_name: string;
  /** @format double */
  percent: number;
}

export interface PerfPiracyPerfSocialMediaPiracyProtocolsGetRemovedListingsOverTimeRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyPerfSocialMediaPiracyProtocolsGetRemovedListingsOverTimeResponse {
  chart_value_list: PiracyCommonModelListingsChartValue[];
  /** @format int64 */
  total_count: number;
}

export interface PerfPiracyPerfSocialMediaPiracyProtocolsGetTopInfringingLanguagesRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyPerfSocialMediaPiracyProtocolsGetTopInfringingLanguagesResponse {
  top_languages: PiracyCommonModelTopOffender[];
}

export interface PerfPiracyPerfSocialMediaPiracyProtocolsGetTopInfringingProfilesRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyPerfSocialMediaPiracyProtocolsGetTopInfringingProfilesResponse {
  top_profiles: PiracyCommonModelTopOffender[];
}

export interface PerfPiracyPerfWebsiteContentPiracyProtocolsGetCleanlinessRateListRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  frequency_filter: PiracyCommonEnumsPerfPerfTimeFrequencyEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyPerfWebsiteContentPiracyProtocolsGetCleanlinessRateListResponse {
  asset_keyword_list: PerfPiracyPerfWebsiteContentPiracyProtocolsGetCleanlinessRateListResponseSimpleAssetKeyword[];
  avg_rate_list: PerfPiracyPerfWebsiteContentPiracyProtocolsGetCleanlinessRateListResponseAvgRate[];
  /** @format double */
  final_cleanliness_rate: number;
}

export interface PerfPiracyPerfWebsiteContentPiracyProtocolsGetCleanlinessRateListResponseAvgRate {
  /** @format int32 */
  avg_cleanliness_rate: number;
  /**
   * @format date
   * @example "2023-03-01"
   */
  date: string;
}

export interface PerfPiracyPerfWebsiteContentPiracyProtocolsGetCleanlinessRateListResponseCleanlinessRate {
  /** @format int32 */
  cleanliness_rate: number;
  /**
   * @format date
   * @example "2023-03-01"
   */
  date: string;
}

export interface PerfPiracyPerfWebsiteContentPiracyProtocolsGetCleanlinessRateListResponseSimpleAssetKeyword {
  cleanliness_rate_list: PerfPiracyPerfWebsiteContentPiracyProtocolsGetCleanlinessRateListResponseCleanlinessRate[];
  /** @format int32 */
  id: number;
  name: string;
}

export interface PerfPiracyPerfWebsiteContentPiracyProtocolsGetComplianceRateRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyPerfWebsiteContentPiracyProtocolsGetComplianceRateResponse {
  /** @format double */
  content_removed_percent: number;
  /** @format double */
  search_engine_percent: number;
}

export interface PerfPiracyPerfWebsiteContentPiracyProtocolsGetComplianceRateEnforcementMethodsRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyPerfWebsiteContentPiracyProtocolsGetComplianceRateEnforcementMethodsResponse {
  rate_list: PerfPiracyPerfWebsiteContentPiracyProtocolsGetComplianceRateEnforcementMethodsResponseRate[];
}

export interface PerfPiracyPerfWebsiteContentPiracyProtocolsGetComplianceRateEnforcementMethodsResponseRate {
  enforcement_method: PiracyCommonEnumsEnforcementMethodEnum;
  /** @format double */
  percent: number;
}

export interface PerfPiracyPerfWebsiteContentPiracyProtocolsGetRemovedListingsOverTimeRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyPerfWebsiteContentPiracyProtocolsGetRemovedListingsOverTimeResponse {
  chart_value_list: MarqBrandModelRequestSeListingsChartValue[];
  /** @format int64 */
  content_removed_count: number;
  /** @format int64 */
  search_engine_delisted_count: number;
  /** @format int64 */
  top_search_delisted_count: number;
}

export interface PerfPiracyPerfWebsiteContentPiracyProtocolsGetTopInfringingDomainsRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  report_type: PiracyCommonEnumsPerfPerfWebsiteContentReportTypeEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyPerfWebsiteContentPiracyProtocolsGetTopInfringingDomainsResponse {
  top_domains: MarqBrandModelRequestTopRow[];
}

export interface PerfPiracyPerfWebsiteContentPiracyProtocolsGetTopInfringingHostingProvidersRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  report_type: PiracyCommonEnumsPerfPerfWebsiteContentReportTypeEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyPerfWebsiteContentPiracyProtocolsGetTopInfringingHostingProvidersResponse {
  top_hosting_providers: MarqBrandModelRequestTopRow[];
}

export interface PerfPiracyPerfWebsiteContentPiracyProtocolsGetTopInfringingLanguagesRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  report_type: PiracyCommonEnumsPerfPerfWebsiteContentReportTypeEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyPerfWebsiteContentPiracyProtocolsGetTopInfringingLanguagesResponse {
  top_languages: MarqBrandModelRequestTopRow[];
}

export interface PerfPiracyPerfWebsiteContentPiracyProtocolsGetTopInfringingRegistrarsRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  report_type: PiracyCommonEnumsPerfPerfWebsiteContentReportTypeEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyPerfWebsiteContentPiracyProtocolsGetTopInfringingRegistrarsResponse {
  top_registrars: MarqBrandModelRequestTopRow[];
}

export interface PerfPiracyDetailPerfDetailsOffenderPiracyProtocolsGetChannelFilterListRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyDetailPerfDetailsOffenderPiracyProtocolsGetChannelFilterListResponse {
  channel_filter: PiracyCommonModelCodeLabelComboBoxResponse[];
}

export interface PerfPiracyDetailPerfDetailsOffenderPiracyProtocolsGetOffendersRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyDetailPerfDetailsOffenderPiracyProtocolsGetOffendersResponse {
  /** @format int64 */
  repeat_offender_count: number;
  /** @format int64 */
  total_offender_count: number;
}

export interface PerfPiracyDetailPerfDetailsOffenderPiracyProtocolsGetTopInfringingDomainsRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyDetailPerfDetailsOffenderPiracyProtocolsGetTopInfringingDomainsResponse {
  domain_list: PerfPiracyDetailPerfDetailsOffenderPiracyProtocolsGetTopInfringingDomainsResponseTopInfringingDomain[];
}

export interface PerfPiracyDetailPerfDetailsOffenderPiracyProtocolsGetTopInfringingDomainsResponseTopInfringingDomain {
  domain_name: string;
  /** @format int32 */
  id: number;
  /** @format int64 */
  removed_count: number;
}

export interface PerfPiracyDetailPerfDetailsOffenderPiracyProtocolsGetTopInfringingDomainsCsvRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyDetailPerfDetailsOffenderPiracyProtocolsGetTopInfringingProfilesRequest {
  channel_filter: PiracyCommonEnumsChannelEnum[];
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyDetailPerfDetailsOffenderPiracyProtocolsGetTopInfringingProfilesResponse {
  profile_list: PerfPiracyDetailPerfDetailsOffenderPiracyProtocolsGetTopInfringingProfilesResponseTopInfringingProfile[];
}

export interface PerfPiracyDetailPerfDetailsOffenderPiracyProtocolsGetTopInfringingProfilesResponseTopInfringingProfile {
  channel_name: string;
  /** @format int32 */
  id: number;
  profile_name: string;
  /** @format int64 */
  removed_count: number;
}

export interface PerfPiracyDetailPerfDetailsOffenderPiracyProtocolsGetTopInfringingProfilesCsvRequest {
  channel_filter: PiracyCommonEnumsChannelEnum[];
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyDetailPerfSocialMediaCompRatePiracyProtocolsGetComplianceRateRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyDetailPerfSocialMediaCompRatePiracyProtocolsGetComplianceRateResponse {
  /** @format double */
  enforced_percent: number;
  /** @format double */
  one_month_percent: number;
  /** @format double */
  one_week_percent: number;
}

export interface PerfPiracyDetailPerfSocialMediaCompRatePiracyProtocolsGetComplianceRateOverTimeRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  frequency_filter?: PiracyCommonEnumsPerfPerfTimeFrequencyEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyDetailPerfSocialMediaCompRatePiracyProtocolsGetComplianceRateOverTimeResponse {
  chart_value_list: PerfPiracyDetailPerfSocialMediaCompRatePiracyProtocolsGetComplianceRateOverTimeResponseCompRateChartValue[];
  frequency_filter_list: PiracyCommonModelCodeLabelComboBoxResponse[];
  /** @format int64 */
  removed_count: number;
  /** @format int64 */
  reported_count: number;
}

export interface PerfPiracyDetailPerfSocialMediaCompRatePiracyProtocolsGetComplianceRateOverTimeResponseCompRateChartValue {
  /**
   * @format date
   * @example "2023-03-01"
   */
  date: string;
  /** @format int64 */
  removed_count: number;
  /** @format int64 */
  reported_count: number;
}

export interface PerfPiracyDetailPerfSocialMediaCompRatePiracyProtocolsGetComplianceRateOverTimeCsvRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  frequency_filter?: PiracyCommonEnumsPerfPerfTimeFrequencyEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyDetailPerfSocialMediaCompRatePiracyProtocolsGetComplianceRateTopCsvRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyDetailPerfSocialMediaCompRatePiracyProtocolsGetComplianceRateTopDataRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyDetailPerfSocialMediaCompRatePiracyProtocolsGetComplianceRateTopDataResponse {
  top_data_list: PerfPiracyDetailPerfSocialMediaCompRatePiracyProtocolsGetComplianceRateTopDataResponseTopData[];
}

export interface PerfPiracyDetailPerfSocialMediaCompRatePiracyProtocolsGetComplianceRateTopDataResponseTopData {
  channel_name: string;
  /** @format double */
  rate_percent: number;
}

export interface PerfPiracyDetailPerfSocialMediaEnfAnalysisPiracyProtocolsGetListingCountByAnalysisTypeRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyDetailPerfSocialMediaEnfAnalysisPiracyProtocolsGetListingCountByAnalysisTypeResponse {
  /** @format int64 */
  confirmed_count?: number | null;
  /** @format int64 */
  denied_count: number;
  /** @format int64 */
  detected_count: number;
  /** @format int64 */
  dismissed_count?: number | null;
  /** @format int64 */
  removed_count: number;
  /** @format int64 */
  reported_count: number;
}

export interface PerfPiracyDetailPerfSocialMediaEnfAnalysisPiracyProtocolsGetListingsOverTimeRequest {
  analysis_type: PiracyCommonEnumsPerfPerfListingStatusEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  frequency_filter?: PiracyCommonEnumsPerfPerfTimeFrequencyEnum;
  group_by_filter: PiracyCommonEnumsPerfPerfGroupByEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyDetailPerfSocialMediaEnfAnalysisPiracyProtocolsGetListingsOverTimeResponse {
  chart_value_list: PiracyCommonModelListingsChartValue[];
  frequency_filter_list: PiracyCommonModelCodeLabelComboBoxResponse[];
  /** @format int64 */
  total_count: number;
}

export interface PerfPiracyDetailPerfSocialMediaEnfAnalysisPiracyProtocolsGetListingsOverTimeCsvRequest {
  analysis_type: PiracyCommonEnumsPerfPerfListingStatusEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  frequency_filter?: PiracyCommonEnumsPerfPerfTimeFrequencyEnum;
  group_by_filter: PiracyCommonEnumsPerfPerfGroupByEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyDetailPerfSocialMediaEnfAnalysisPiracyProtocolsGetTopDataRequest {
  analysis_type: PiracyCommonEnumsPerfPerfListingStatusEnum;
  category: PiracyCommonEnumsPerfPerfGroupByEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  group_by_filter: PiracyCommonEnumsPerfPerfGroupByEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyDetailPerfSocialMediaEnfAnalysisPiracyProtocolsGetTopDataResponse {
  top_data_list: PiracyCommonModelTopData[];
}

export interface PerfPiracyDetailPerfSocialMediaEnfAnalysisPiracyProtocolsGetTopDataCsvRequest {
  analysis_type: PiracyCommonEnumsPerfPerfListingStatusEnum;
  category: PiracyCommonEnumsPerfPerfGroupByEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  group_by_filter: PiracyCommonEnumsPerfPerfGroupByEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyDetailPerfWebsiteContentCleanlinessPiracyProtocolsGetAssetListRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  frequency_filter: PiracyCommonEnumsPerfPerfTimeFrequencyEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyDetailPerfWebsiteContentCleanlinessPiracyProtocolsGetAssetListResponse {
  asset: PerfPiracyDetailPerfWebsiteContentCleanlinessPiracyProtocolsGetAssetListResponseAsset[];
}

export interface PerfPiracyDetailPerfWebsiteContentCleanlinessPiracyProtocolsGetAssetListResponseAsset {
  /** @format int32 */
  id: number;
  images: string[];
  name: string;
  official_url?: string | null;
  product_type: PiracyCommonEnumsProductTypeEnum;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00"
   */
  updated_date: string;
}

export interface PerfPiracyDetailPerfWebsiteContentCleanlinessPiracyProtocolsGetCleanlinessRateCsvRequest {
  asset_id_list: number[];
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  frequency_filter: PiracyCommonEnumsPerfPerfTimeFrequencyEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyDetailPerfWebsiteContentCleanlinessPiracyProtocolsGetCleanlinessRateListRequest {
  asset_id_list: number[];
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  frequency_filter: PiracyCommonEnumsPerfPerfTimeFrequencyEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyDetailPerfWebsiteContentCleanlinessPiracyProtocolsGetCleanlinessRateListResponse {
  asset_list: PerfPiracyDetailPerfWebsiteContentCleanlinessPiracyProtocolsGetCleanlinessRateListResponseSimpleAsset[];
  avg_rate_list: PerfPiracyDetailPerfWebsiteContentCleanlinessPiracyProtocolsGetCleanlinessRateListResponseAvgRate[];
  /** @format double */
  final_cleanliness_rate: number;
}

export interface PerfPiracyDetailPerfWebsiteContentCleanlinessPiracyProtocolsGetCleanlinessRateListResponseAvgRate {
  /** @format int32 */
  avg_cleanliness_rate: number;
  /**
   * @format date
   * @example "2023-03-01"
   */
  date: string;
}

export interface PerfPiracyDetailPerfWebsiteContentCleanlinessPiracyProtocolsGetCleanlinessRateListResponseCleanlinessRate {
  /** @format int32 */
  cleanliness_rate: number;
  /**
   * @format date
   * @example "2023-03-01"
   */
  date: string;
}

export interface PerfPiracyDetailPerfWebsiteContentCleanlinessPiracyProtocolsGetCleanlinessRateListResponseSimpleAsset {
  asset_keyword_list: PerfPiracyDetailPerfWebsiteContentCleanlinessPiracyProtocolsGetCleanlinessRateListResponseSimpleAssetKeyword[];
  /** @format int32 */
  id: number;
  name: string;
}

export interface PerfPiracyDetailPerfWebsiteContentCleanlinessPiracyProtocolsGetCleanlinessRateListResponseSimpleAssetKeyword {
  cleanliness_rate_list: PerfPiracyDetailPerfWebsiteContentCleanlinessPiracyProtocolsGetCleanlinessRateListResponseCleanlinessRate[];
  /** @format int32 */
  id: number;
  name: string;
}

export interface PerfPiracyDetailPerfWebsiteContentCompRatePiracyProtocolsGetComplianceEnforcementMethodsRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyDetailPerfWebsiteContentCompRatePiracyProtocolsGetComplianceEnforcementMethodsResponse {
  rate_list: PerfPiracyDetailPerfWebsiteContentCompRatePiracyProtocolsGetComplianceEnforcementMethodsResponseRate[];
}

export interface PerfPiracyDetailPerfWebsiteContentCompRatePiracyProtocolsGetComplianceEnforcementMethodsResponseRate {
  enforcement_method: PiracyCommonEnumsEnforcementMethodEnum;
  /** @format double */
  percent: number;
}

export interface PerfPiracyDetailPerfWebsiteContentCompRatePiracyProtocolsGetComplianceEnforcementMethodsCsvRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyDetailPerfWebsiteContentCompRatePiracyProtocolsGetComplianceRateRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  report_type: PiracyCommonEnumsPerfPerfWebsiteContentReportTypeEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyDetailPerfWebsiteContentCompRatePiracyProtocolsGetComplianceRateResponse {
  /** @format double */
  enforced_percent: number;
  /** @format double */
  one_month_percent: number;
  /** @format double */
  one_week_percent: number;
}

export interface PerfPiracyDetailPerfWebsiteContentCompRatePiracyProtocolsGetComplianceRateOverTimeRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  frequency_filter?: PiracyCommonEnumsPerfPerfTimeFrequencyEnum;
  report_type: PiracyCommonEnumsPerfPerfWebsiteContentReportTypeEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyDetailPerfWebsiteContentCompRatePiracyProtocolsGetComplianceRateOverTimeResponse {
  chart_value_list: PerfPiracyDetailPerfWebsiteContentCompRatePiracyProtocolsGetComplianceRateOverTimeResponseCompRateChartValue[];
  frequency_filter_list: PiracyCommonModelCodeLabelComboBoxResponse[];
  /** @format int64 */
  removed_count: number;
  /** @format int64 */
  reported_count: number;
}

export interface PerfPiracyDetailPerfWebsiteContentCompRatePiracyProtocolsGetComplianceRateOverTimeResponseCompRateChartValue {
  /**
   * @format date
   * @example "2023-03-01"
   */
  date: string;
  /** @format int64 */
  removed_count: number;
  /** @format int64 */
  reported_count: number;
}

export interface PerfPiracyDetailPerfWebsiteContentCompRatePiracyProtocolsGetComplianceRateOverTimeCsvRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  frequency_filter?: PiracyCommonEnumsPerfPerfTimeFrequencyEnum;
  report_type: PiracyCommonEnumsPerfPerfWebsiteContentReportTypeEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyDetailPerfWebsiteContentEnfAnalysisPiracyProtocolsGetListingCountByAnalysisTypeRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyDetailPerfWebsiteContentEnfAnalysisPiracyProtocolsGetListingCountByAnalysisTypeResponse {
  /** @format int64 */
  confirmed_count?: number | null;
  /** @format int64 */
  denied_count: number;
  /** @format int64 */
  detected_count: number;
  /** @format int64 */
  dismissed_count?: number | null;
  /** @format int64 */
  removed_count: number;
  /** @format int64 */
  reported_count: number;
}

export interface PerfPiracyDetailPerfWebsiteContentEnfAnalysisPiracyProtocolsGetListingsOverTimeRequest {
  analysis_type: PiracyCommonEnumsPerfPerfListingStatusEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  frequency_filter?: PiracyCommonEnumsPerfPerfTimeFrequencyEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyDetailPerfWebsiteContentEnfAnalysisPiracyProtocolsGetListingsOverTimeResponse {
  chart_value_list: MarqBrandModelRequestSeListingsChartValue[];
  /** @format int64 */
  content_removed_count: number;
  frequency_filter_list: PiracyCommonModelCodeLabelComboBoxResponse[];
  /** @format int64 */
  search_engine_delisted_count: number;
  /** @format int64 */
  top_search_delisted_count: number;
}

export interface PerfPiracyDetailPerfWebsiteContentEnfAnalysisPiracyProtocolsGetListingsOverTimeCsvRequest {
  analysis_type: PiracyCommonEnumsPerfPerfListingStatusEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  frequency_filter?: PiracyCommonEnumsPerfPerfTimeFrequencyEnum;
  group_by_filter: PiracyCommonEnumsPerfPerfGroupByEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyDetailPerfWebsiteContentEnfAnalysisPiracyProtocolsGetTopDataRequest {
  analysis_type: PiracyCommonEnumsPerfPerfListingStatusEnum;
  category: PiracyCommonEnumsPerfPerfGroupByEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  group_by_filter: PiracyCommonEnumsPerfPerfGroupByEnum;
  report_type?: PiracyCommonEnumsPerfPerfWebsiteContentReportTypeEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export interface PerfPiracyDetailPerfWebsiteContentEnfAnalysisPiracyProtocolsGetTopDataResponse {
  top_data_list: PiracyCommonModelTopData[];
}

export interface PerfPiracyDetailPerfWebsiteContentEnfAnalysisPiracyProtocolsGetTopDataCsvRequest {
  analysis_type: PiracyCommonEnumsPerfPerfListingStatusEnum;
  category: PiracyCommonEnumsPerfPerfGroupByEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  group_by_filter: PiracyCommonEnumsPerfPerfGroupByEnum;
  report_type?: PiracyCommonEnumsPerfPerfWebsiteContentReportTypeEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
}

export enum PiracyCommonEnumsAuthorizedListSortedColumnEnum {
  Name = 'name',
  AddedDate = 'added_date',
}

export enum PiracyCommonEnumsChannelEnum {
  Google = 'Google',
  Facebook = 'Facebook',
  Instagram = 'Instagram',
  Tiktok = 'Tiktok',
  Twitter = 'Twitter',
  Douyin = 'Douyin',
  Youtube = 'Youtube',
  VK = 'VK',
  Dailymotion = 'Dailymotion',
  Vimeo = 'Vimeo',
  Twitch = 'Twitch',
  Bilibili = 'Bilibili',
  BilibiliTV = 'Bilibili TV',
  GooglePlay = 'Google Play',
  AppleAppstore = 'Apple Appstore',
  Telegram = 'Telegram',
  Discord = 'Discord',
  Reddit = 'Reddit',
  Youku = 'Youku',
  WeiboTV = 'Weibo TV',
  XiguaVideo = 'Xigua Video',
  Sohu = 'Sohu',
  Sora = 'Sora',
}

export enum PiracyCommonEnumsClientDelistingStatusEnum {
  Reported = 'reported',
  Delisted = 'delisted',
  Denied = 'denied',
}

export enum PiracyCommonEnumsClientInfringingContentStatusEnum {
  Registrant = 'registrant',
  Registrar = 'registrar',
  Cdn = 'cdn',
  HostingProvider = 'hosting_provider',
  Removed = 'removed',
  Denied = 'denied',
}

export enum PiracyCommonEnumsClientStatus {
  Detected = 'detected',
  Confirmed = 'confirmed',
  Reported = 'reported',
  Enforced = 'enforced',
  Denied = 'denied',
  Dismissed = 'dismissed',
}

export enum PiracyCommonEnumsContentRemovalStatusEnum {
  InProgress = 'in_progress',
  Removed = 'removed',
  Denied = 'denied',
  NotAvailable = 'not_available',
}

export enum PiracyCommonEnumsEnforcementMethodEnum {
  GoogleDlisting = 'google_dlisting',
  SnRegistrant = 'sn_registrant',
  RaHostingProviders = 'ra_hosting_providers',
  RaRegistrar = 'ra_registrar',
}

export enum PiracyCommonEnumsProductTypeEnum {
  Webcomic = 'webcomic',
  Video = 'video',
  Webnovel = 'webnovel',
  Game = 'game',
  Adult = 'adult',
  Sports = 'sports',
  Publishing = 'publishing',
  Music = 'music',
  Films = 'films',
  Animation = 'animation',
  ELearning = 'e-learning',
  Software = 'software',
}

export enum PiracyCommonEnumsSearchMethodEnum {
  Web = 'web',
  Image = 'image',
  Facebook = 'Facebook',
  Instagram = 'Instagram',
  Tiktok = 'Tiktok',
  TiktokLive = 'Tiktok Live',
  Twitter = 'Twitter',
  Douyin = 'Douyin',
  Youtube = 'Youtube',
  YoutubeShorts = 'Youtube Shorts',
  YoutubeLive = 'Youtube Live',
  VK = 'VK',
  Dailymotion = 'Dailymotion',
  Vimeo = 'Vimeo',
  Twitch = 'Twitch',
  Bilibili = 'Bilibili',
  BilibiliTV = 'Bilibili TV',
  GooglePlay = 'Google Play',
  AppleAppstore = 'Apple Appstore',
  Telegram = 'Telegram',
  Discord = 'Discord',
  RedditPost = 'Reddit Post',
  RedditComment = 'Reddit Comment',
  Youku = 'Youku',
  WeiboTV = 'Weibo TV',
  XiguaVideo = 'Xigua Video',
  Sohu = 'Sohu',
  Sora = 'Sora',
}

export enum PiracyCommonEnumsSortColumnEnum {
  AssetName = 'asset_name',
  AssetType = 'asset_type',
  UpdatedDate = 'updated_date',
  SearchMethod = 'search_method',
  CreatedDate = 'created_date',
  DetectedDate = 'detected_date',
  UploadedDate = 'uploaded_date',
  Domain = 'domain',
  Views = 'views',
  Subscriptions = 'subscriptions',
  RelevancyScore = 'relevancy_score',
  InfringingScore = 'infringing_score',
}

export enum PiracyCommonEnumsSortOrderEnum {
  Asc = 'asc',
  Desc = 'desc',
}

export enum PiracyCommonEnumsWebsiteListingHistoryStatusEnum {
  ReportedToGoogle = 'reported_to_google',
  Delisted = 'delisted',
  Denied = 'denied',
}

export enum PiracyCommonEnumsCrCRStatusEnum {
  InProgress = 'in_progress',
  Completed = 'completed',
  NotAvailable = 'not_available',
}

export enum PiracyCommonEnumsCrCRTypeEnum {
  Enforce = 'enforce',
  Retract = 'retract',
  AddWhitelist = 'add_whitelist',
  ChangeAsset = 'change_asset',
}

export enum PiracyCommonEnumsPerfPerfChannelGroupEnum {
  SearchEngine = 'search_engine',
  SocialMedia = 'social_media',
}

export enum PiracyCommonEnumsPerfPerfGroupByEnum {
  None = 'none',
  Asset = 'asset',
  Domain = 'domain',
  Channel = 'channel',
  Keyword = 'keyword',
  Language = 'language',
  Registrar = 'registrar',
  HostingProvider = 'hosting_provider',
}

export enum PiracyCommonEnumsPerfPerfListingStatusEnum {
  Detected = 'detected',
  Confirmed = 'confirmed',
  Reported = 'reported',
  Removed = 'removed',
  Denied = 'denied',
  Dismissed = 'dismissed',
}

export enum PiracyCommonEnumsPerfPerfTimeFrequencyEnum {
  Daily = 'daily',
  Weekly = 'weekly',
  Monthly = 'monthly',
  Yearly = 'yearly',
}

export enum PiracyCommonEnumsPerfPerfWebsiteContentReportTypeEnum {
  SearchEngine = 'search_engine',
  InfringingContent = 'infringing_content',
}

export interface PiracyCommonModelAttachment {
  /** @format int32 */
  id?: number | null;
  name: string;
  s3_url: string;
}

export interface PiracyCommonModelCodeLabelComboBoxResponse {
  label: string;
  value: string;
}

export interface PiracyCommonModelEnforcementProgress {
  google_delisting_info?: PiracyCommonModelEnforcementProgressGoogleDelisting;
  infringing_content_info: PiracyCommonModelEnforcementProgressInfringingContent;
}

export interface PiracyCommonModelEnforcementProgressGoogleDelisting {
  history_list: PiracyCommonModelEnforcementProgressGoogleDelistingHistory[];
  status: PiracyCommonEnumsClientDelistingStatusEnum;
}

export interface PiracyCommonModelEnforcementProgressGoogleDelistingHistory {
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  date: string;
  status: PiracyCommonEnumsClientDelistingStatusEnum;
}

export interface PiracyCommonModelEnforcementProgressInfringingContent {
  history_list: PiracyCommonModelEnforcementProgressInfringingContentHistory[];
  status?: PiracyCommonEnumsContentRemovalStatusEnum;
}

export interface PiracyCommonModelEnforcementProgressInfringingContentHistory {
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  date: string;
  status: PiracyCommonEnumsClientInfringingContentStatusEnum;
}

export interface PiracyCommonModelListingsChartValue {
  /**
   * @format date
   * @example "2023-03-01"
   */
  date: string;
  grouped_count_list?: PiracyCommonModelListingsChartValueGroupedCount[] | null;
  /** @format int64 */
  listing_count: number;
  /** @format int64 */
  top_search_count?: number | null;
}

export interface PiracyCommonModelListingsChartValueGroupedCount {
  /** @format int64 */
  count: number;
  /** @format int32 */
  id?: number | null;
  name: string;
}

export interface PiracyCommonModelTopData {
  grouped_list?: PiracyCommonModelTopDataGroupedTopData[] | null;
  /** @format int64 */
  listing_count: number;
  /** @format double */
  listing_percent: number;
  name: string;
}

export interface PiracyCommonModelTopDataGroupedTopData {
  /** @format int64 */
  count: number;
  /** @format int32 */
  group_id?: number | null;
  group_label: string;
}

export interface PiracyCommonModelTopOffender {
  channel_name: string;
  /** @format int32 */
  id: number;
  name: string;
  /** @format int64 */
  removed_count: number;
}

export interface PiracyCommonProtocolFileResponse {
  /** @format byte */
  bytes: string;
  content_type: IoKtorHttpContentType;
  filename: string;
}

export interface PortfolioAssetProtocolsBulkUpdateAssetRequest {
  asset_ids: number[];
  currency?: MarqFoundationEnumsCurrencyEnum;
  excluding_ip_doc_ids?: number[] | null;
  /** @format double */
  min_price?: number | null;
  related_ip_doc_ids?: number[] | null;
}

export interface PortfolioAssetProtocolsCreateAssetByPresignedRequest {
  asset_name: string;
  /** @format int32 */
  brand_id: number;
  /** @format int32 */
  collection_id?: number | null;
  currency: MarqFoundationEnumsCurrencyEnum;
  image_file_url_list: string[];
  /** @format double */
  min_price: number;
  product_code?: string[] | null;
  product_url?: string | null;
  related_ip_doc_ids: number[];
}

export interface PortfolioAssetProtocolsCreateCollectionRequest {
  /** @format int32 */
  brand_id: number;
  collection_name: string;
}

export interface PortfolioAssetProtocolsCreateCollectionResponse {
  /** @format int32 */
  collection_id: number;
}

export interface PortfolioAssetProtocolsDeleteAssetRequest {
  /** @format int32 */
  asset_id: number;
}

export interface PortfolioAssetProtocolsDeleteCollectionRequest {
  /** @format int32 */
  collection_id: number;
}

export interface PortfolioAssetProtocolsGetAllAssetListRequest {
  /** @format int32 */
  ipr_filter?: number | null;
  search?: string | null;
}

export interface PortfolioAssetProtocolsGetAllAssetListResponse {
  brands: PortfolioAssetProtocolsGetAllAssetListResponseBrand[];
}

export interface PortfolioAssetProtocolsGetAllAssetListResponseBrand {
  /** @format int32 */
  brand_id: number;
  brand_name: string;
  collections: PortfolioAssetProtocolsGetAllAssetListResponseBrandCollection[];
}

export interface PortfolioAssetProtocolsGetAllAssetListResponseBrandCollection {
  assets: PortfolioAssetProtocolsGetAllAssetListResponseBrandCollectionAsset[];
  /** @format int32 */
  collection_id?: number | null;
  collection_name?: string | null;
  /** @format int32 */
  count: number;
}

export interface PortfolioAssetProtocolsGetAllAssetListResponseBrandCollectionAsset {
  /** @format int32 */
  asset_id: number;
  asset_name: string;
  image_url?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  updated_date: string;
}

export interface PortfolioAssetProtocolsGetAllCollectionsResponse {
  brand_collection: PortfolioAssetProtocolsGetAllCollectionsResponseIpPortfolioCollection[];
}

export interface PortfolioAssetProtocolsGetAllCollectionsResponseCollectionData {
  /** @format int32 */
  id: number;
  name: string;
}

export interface PortfolioAssetProtocolsGetAllCollectionsResponseIpPortfolioCollection {
  brand: PortfolioAssetProtocolsGetAllCollectionsResponseIpPortfolioData;
  collection_tree: PortfolioAssetProtocolsGetAllCollectionsResponseCollectionData[];
}

export interface PortfolioAssetProtocolsGetAllCollectionsResponseIpPortfolioData {
  /** @format int32 */
  id: number;
  name: string;
}

export interface PortfolioAssetProtocolsGetAssetRequest {
  /** @format int32 */
  id: number;
}

export interface PortfolioAssetProtocolsGetAssetResponse {
  /** @format int32 */
  asset_brand_id: number;
  /** @format int32 */
  asset_collection_id?: number | null;
  asset_currency: MarqFoundationEnumsCurrencyEnum;
  asset_full_ip_doc_list: MarqBrandDataModelAssetDataFullIpDoc[];
  /** @format int32 */
  asset_id: number;
  asset_images: string[];
  /** @format double */
  asset_min_price?: number | null;
  asset_name: string;
  asset_product_code?: string[] | null;
  asset_product_url?: string | null;
  asset_related_ip_doc_ids: number[];
}

export interface PortfolioAssetProtocolsGetAssetCountByBrandRequest {
  /** @format int32 */
  ipr_filter?: number | null;
  search?: string | null;
}

export interface PortfolioAssetProtocolsGetAssetCountByBrandResponse {
  brands: PortfolioAssetProtocolsGetAssetCountByBrandResponseBrand[];
}

export interface PortfolioAssetProtocolsGetAssetCountByBrandResponseBrand {
  /** @format int32 */
  brand_id: number;
  brand_name: string;
  /** @format int32 */
  count: number;
}

export interface PortfolioAssetProtocolsGetAssetListRequest {
  /** @format int32 */
  brand_id?: number | null;
  /** @format int32 */
  collection_id?: number | null;
}

export interface PortfolioAssetProtocolsGetAssetListResponse {
  asset_list: PortfolioAssetProtocolsGetAssetListResponseAsset[];
}

export interface PortfolioAssetProtocolsGetAssetListResponseAsset {
  /** @format int32 */
  brand_id: number;
  brand_name: string;
  /** @format int32 */
  collection_id?: number | null;
  currency: MarqFoundationEnumsCurrencyEnum;
  /** @format int32 */
  id: number;
  images: string[];
  /** @format double */
  min_price?: number | null;
  name: string;
  product_code?: string[] | null;
  product_url?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  updated_date?: string | null;
}

export interface PortfolioAssetProtocolsGetAssetPresignedUrlRequest {
  file_name: string;
}

export interface PortfolioAssetProtocolsGetAssetPresignedUrlResponse {
  url: string;
}

export interface PortfolioAssetProtocolsGetIpDocumentsRequest {
  /** @format int32 */
  brand_id: number;
  selected_asset_ids?: number[] | null;
}

export interface PortfolioAssetProtocolsGetIpDocumentsResponse {
  common_ip_document_ids: number[];
  ip_documents: MarqBrandDataModelIpDocByClass[];
}

export interface PortfolioAssetProtocolsGetIprFilterOptionRequest {
  /** @format int32 */
  brand_id?: number | null;
  search?: string | null;
}

export interface PortfolioAssetProtocolsGetRelatedIprForNonManufacturedAssetRequest {
  /** @format int32 */
  collection_id: number;
}

export interface PortfolioAssetProtocolsGetRelatedIprForNonManufacturedAssetResponse {
  ip_document_ids: number[];
}

export interface PortfolioAssetProtocolsUpdateAssetByPresignedRequest {
  added_image_string_list: string[];
  /** @format int32 */
  brand_id: number;
  /** @format int32 */
  collection_id?: number | null;
  currency: MarqFoundationEnumsCurrencyEnum;
  deleted_image_string_list: string[];
  /** @format int32 */
  id: number;
  image_file_url_list?: string[] | null;
  /** @format double */
  min_price: number;
  name: string;
  product_code?: string[] | null;
  product_url?: string | null;
  related_ip_doc_ids: number[];
  urls?: string[] | null;
}

export interface PortfolioAssetProtocolsUpdateCollectionRequest {
  /** @format int32 */
  collection_id: number;
  collection_name: string;
  related_ip_doc_ids?: number[] | null;
}

export interface PortfolioCopyrightsProtocolsAddCopyrightRequest {
  /** @format int32 */
  brand_id: number;
  /** @format int32 */
  doc_id: number;
  list: PortfolioCopyrightsProtocolsAddCopyrightRequestItem[];
}

export interface PortfolioCopyrightsProtocolsAddCopyrightRequestItem {
  name: string;
  thumbnail_url: string;
}

export interface PortfolioCopyrightsProtocolsAddDocumentRequest {
  /** @format int32 */
  brand_id: number;
  copyright_type?: MarqCommonEnumsIpCopyrightType;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  creation?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  expiration?: string | null;
  file_name: string;
  file_url: string;
  /** @format int32 */
  licensee_id?: number | null;
  name: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  publication?: string | null;
  registration_no?: string | null;
  /** @format int32 */
  rights_owner_id: number;
}

export interface PortfolioCopyrightsProtocolsAddDocumentResponse {
  /** @format int32 */
  id: number;
}

export interface PortfolioCopyrightsProtocolsDeleteCopyrightRequest {
  /** @format int32 */
  doc_id: number;
  /** @format int32 */
  id: number;
}

export interface PortfolioCopyrightsProtocolsDeleteDocumentRequest {
  /** @format int32 */
  id: number;
}

export interface PortfolioCopyrightsProtocolsGetCopyrightsRequest {
  /** @format int32 */
  doc_id: number;
  sorted_order_enum: MarqCommonEnumsSortedOrderEnum;
}

export interface PortfolioCopyrightsProtocolsGetCopyrightsResponse {
  doc_name: string;
  list: PortfolioCopyrightsProtocolsGetCopyrightsResponseCopyright[];
}

export interface PortfolioCopyrightsProtocolsGetCopyrightsResponseCopyright {
  /** @format int32 */
  id: number;
  name: string;
  thumbnail_url: string;
}

export interface PortfolioCopyrightsProtocolsGetDocumentDetailsRequest {
  /** @format int32 */
  id: number;
}

export interface PortfolioCopyrightsProtocolsGetDocumentDetailsResponse {
  copyright_type?: MarqCommonEnumsIpCopyrightType;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  creation?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  expiration?: string | null;
  file_name?: string | null;
  file_url?: string | null;
  /** @format int32 */
  id: number;
  /** @format int32 */
  licensee_id?: number | null;
  name: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  publication?: string | null;
  registration_no?: string | null;
  /** @format int32 */
  rights_owner_id: number;
}

export interface PortfolioCopyrightsProtocolsGetDocumentsRequest {
  /** @format int32 */
  brand_id: number;
}

export interface PortfolioCopyrightsProtocolsGetDocumentsResponse {
  list: PortfolioCopyrightsProtocolsGetDocumentsResponseDocument[];
}

export interface PortfolioCopyrightsProtocolsGetDocumentsResponseDocument {
  copyright_type?: MarqCommonEnumsIpCopyrightType;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  creation?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  expiration?: string | null;
  file_name?: string | null;
  file_url?: string | null;
  /** @format int32 */
  id: number;
  licensee?: string | null;
  name: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  publication?: string | null;
  registration_no?: string | null;
  rights_owner: string;
}

export interface PortfolioCopyrightsProtocolsUpdateCopyrightRequest {
  /** @format int32 */
  doc_id: number;
  /** @format int32 */
  id: number;
  name: string;
  thumbnail_url: string;
}

export interface PortfolioCopyrightsProtocolsUpdateDocumentRequest {
  copyright_type?: MarqCommonEnumsIpCopyrightType;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  creation?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  expiration?: string | null;
  file_name: string;
  file_url: string;
  /** @format int32 */
  id: number;
  /** @format int32 */
  licensee_id?: number | null;
  name: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  publication?: string | null;
  registration_no?: string | null;
  /** @format int32 */
  rights_owner_id: number;
}

export interface PortfolioDesignProtocolsAddDesignRequest {
  /** @format int32 */
  brand_id: number;
  countries: MarqFoundationEnumsCountryCodeEnum[];
  document_name: string;
  document_url: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  expiration_date: string;
  ip_class: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  licensee_expiration_date?: string | null;
  /** @format int32 */
  licensee_id?: number | null;
  name: string;
  /** @format int32 */
  owner_id: number;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  registered_date?: string | null;
  registration_no: string;
  thumbnail_url?: string | null;
}

export interface PortfolioDesignProtocolsAddDesignResponse {
  /** @format int32 */
  doc_id: number;
}

export interface PortfolioDesignProtocolsDeleteDesignRequest {
  /** @format int32 */
  brand_id: number;
  /** @format int32 */
  doc_id: number;
}

export interface PortfolioDesignProtocolsGetDesignDetailRequest {
  /** @format int32 */
  brand_id: number;
  /** @format int32 */
  doc_id: number;
}

export interface PortfolioDesignProtocolsGetDesignDetailResponse {
  countries: MarqFoundationEnumsCountryCodeEnum[];
  document_name: string;
  document_url: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  expiration_date?: string | null;
  ip_class?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  licensee_expiration_date?: string | null;
  /** @format int32 */
  licensee_id?: number | null;
  name: string;
  /** @format int32 */
  owner_id?: number | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  registered_date?: string | null;
  registration_no?: string | null;
  thumbnail_url?: string | null;
}

export interface PortfolioDesignProtocolsGetDesignListResponse {
  design_list: PortfolioDesignProtocolsGetDesignListResponseDesign[];
}

export interface PortfolioDesignProtocolsGetDesignListResponseDesign {
  countries: MarqFoundationEnumsCountryCodeEnum[];
  /** @format int32 */
  doc_id: number;
  document_name: string;
  document_url: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  expiration_date?: string | null;
  ip_class?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  licensee_expiration_date?: string | null;
  name: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  registered_date?: string | null;
  registration_no?: string | null;
  rights_licensee?: string | null;
  rights_owner?: string | null;
  thumbnail?: string | null;
}

export interface PortfolioDesignProtocolsRequest {
  /** @format int32 */
  brand_id: number;
  country?: MarqFoundationEnumsCountryCodeEnum[] | null;
  expiration_date?: MarqCommonModelOffsetDateTimeRange;
  ip_class?: string[] | null;
  is_expired_filter?: boolean | null;
  is_expiring_soon_filter?: boolean | null;
  keyword?: string | null;
  registered_date?: MarqCommonModelOffsetDateTimeRange;
}

export interface PortfolioDesignProtocolsUpdateDesignRequest {
  /** @format int32 */
  brand_id: number;
  countries: MarqFoundationEnumsCountryCodeEnum[];
  /** @format int32 */
  doc_id: number;
  document_name: string;
  document_url: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  expiration_date: string;
  ip_class: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  licensee_expiration_date?: string | null;
  /** @format int32 */
  licensee_id?: number | null;
  name: string;
  /** @format int32 */
  owner_id: number;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  registered_date?: string | null;
  registration_no: string;
  thumbnail_url?: string | null;
}

export interface PortfolioIpDocProtocolsAddBrandRequest {
  copyright_footer?: string | null;
  logo_url: string;
  name: string;
}

export interface PortfolioIpDocProtocolsAddBrandResponse {
  /** @format int32 */
  brand_id: number;
}

export interface PortfolioIpDocProtocolsDeleteBrandRequest {
  /** @format int32 */
  brand_id: number;
}

export interface PortfolioIpDocProtocolsGetBrandDetailRequest {
  /** @format int32 */
  brand_id: number;
}

export interface PortfolioIpDocProtocolsGetBrandDetailResponse {
  copyright_footer?: string | null;
  /** @format int32 */
  copyrights: number;
  /** @format int32 */
  designs: number;
  logo_url: string;
  name: string;
  /** @format int32 */
  trademarks: number;
}

export interface PortfolioIpDocProtocolsGetBrandListResponse {
  brand_list: PortfolioIpDocProtocolsGetBrandListResponseBrand[];
}

export interface PortfolioIpDocProtocolsGetBrandListResponseBrand {
  /** @format int32 */
  brand_id: number;
  /** @format int32 */
  copyrights: number;
  /** @format int32 */
  designs: number;
  logo_url: string;
  name: string;
  /** @format int32 */
  trademarks: number;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  updated_date: string;
}

export interface PortfolioIpDocProtocolsGetDownloadUrlRequest {
  url: string;
}

export interface PortfolioIpDocProtocolsGetDownloadUrlResponse {
  url: string;
}

export interface PortfolioIpDocProtocolsGetLicenseeListResponse {
  list: PortfolioIpDocProtocolsGetLicenseeListResponseRightsLicensee[];
}

export interface PortfolioIpDocProtocolsGetLicenseeListResponseRightsLicensee {
  /** @format int32 */
  licensee_id: number;
  licensee_name: string;
}

export interface PortfolioIpDocProtocolsGetOwnerListResponse {
  list: PortfolioIpDocProtocolsGetOwnerListResponseRightsOwner[];
}

export interface PortfolioIpDocProtocolsGetOwnerListResponseRightsOwner {
  /** @format int32 */
  owner_id: number;
  owner_name: string;
}

export interface PortfolioIpDocProtocolsGetUploadUrlRequest {
  /** @format int32 */
  brand_id?: number | null;
  file_name: string;
}

export interface PortfolioIpDocProtocolsGetUploadUrlResponse {
  url: string;
}

export interface PortfolioIpDocProtocolsUpdateBrandRequest {
  /** @format int32 */
  brand_id: number;
  copyright_footer?: string | null;
  logo_url: string;
  name: string;
}

export interface PortfolioTrademarkProtocolsAddTrademarkRequest {
  /** @format int32 */
  brand_id: number;
  class_list: string[];
  countries: MarqFoundationEnumsCountryCodeEnum[];
  document_name: string;
  document_url: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  expiration_date: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  licensee_expiration_date?: string | null;
  /** @format int32 */
  licensee_id?: number | null;
  name: string;
  /** @format int32 */
  owner_id: number;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  registered_date?: string | null;
  registration_no: string;
  thumbnail_url?: string | null;
  trademark_text?: string[] | null;
  trademark_type?: MarqCommonEnumsIpTrademarkTypeEnum;
}

export interface PortfolioTrademarkProtocolsAddTrademarkResponse {
  /** @format int32 */
  doc_id: number;
}

export interface PortfolioTrademarkProtocolsDeleteTrademarkRequest {
  /** @format int32 */
  brand_id: number;
  /** @format int32 */
  doc_id: number;
}

export interface PortfolioTrademarkProtocolsGetTrademarkDetailRequest {
  /** @format int32 */
  brand_id: number;
  /** @format int32 */
  doc_id: number;
}

export interface PortfolioTrademarkProtocolsGetTrademarkDetailResponse {
  class_list: string[];
  countries: MarqFoundationEnumsCountryCodeEnum[];
  document_name: string;
  document_url: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  expiration_date?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  licensee_expiration_date?: string | null;
  /** @format int32 */
  licensee_id?: number | null;
  name: string;
  /** @format int32 */
  owner_id?: number | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  registered_date?: string | null;
  registration_no?: string | null;
  thumbnail_url?: string | null;
  trademark_text: string[];
  trademark_type?: MarqCommonEnumsIpTrademarkTypeEnum;
}

export interface PortfolioTrademarkProtocolsGetTrademarkListResponse {
  trademark_list: PortfolioTrademarkProtocolsGetTrademarkListResponseTrademark[];
}

export interface PortfolioTrademarkProtocolsGetTrademarkListResponseTrademark {
  class_list?: string[] | null;
  countries: MarqFoundationEnumsCountryCodeEnum[];
  /** @format int32 */
  doc_id: number;
  document_name: string;
  document_url: string;
  exclusive_licensee?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  expiration_date?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  licensee_expiration_date?: string | null;
  name: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  registered_date?: string | null;
  registration_no?: string | null;
  rights_owner?: string | null;
  thumbnail?: string | null;
  trademark_text?: string[] | null;
  trademark_type?: MarqCommonEnumsIpTrademarkTypeEnum;
}

export interface PortfolioTrademarkProtocolsRequest {
  /** @format int32 */
  brand_id: number;
  country?: MarqFoundationEnumsCountryCodeEnum[] | null;
  expiration_date?: MarqCommonModelOffsetDateTimeRange;
  ip_class?: string[] | null;
  is_expired_filter?: boolean | null;
  is_expiring_soon_filter?: boolean | null;
  keyword?: string | null;
  registered_date?: MarqCommonModelOffsetDateTimeRange;
}

export interface PortfolioTrademarkProtocolsUpdateTrademarkRequest {
  /** @format int32 */
  brand_id: number;
  class_list: string[];
  countries: MarqFoundationEnumsCountryCodeEnum[];
  /** @format int32 */
  doc_id: number;
  document_name: string;
  document_url: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  expiration_date: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  licensee_expiration_date?: string | null;
  /** @format int32 */
  licensee_id?: number | null;
  name: string;
  /** @format int32 */
  owner_id: number;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  registered_date?: string | null;
  registration_no: string;
  thumbnail_url?: string | null;
  trademark_text?: string[] | null;
  trademark_type?: MarqCommonEnumsIpTrademarkTypeEnum;
}

export interface ReleaseReleaseNoteProtocolsGetDetailRequest {
  /** @format int32 */
  id: number;
}

export interface ReleaseReleaseNoteProtocolsGetDetailResponse {
  content?: string | null;
  /** @format int32 */
  id: number;
  main_image_url?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  publish_date: string;
  title?: string | null;
}

export interface ReleaseReleaseNoteProtocolsGetListResponse {
  list: ReleaseReleaseNoteProtocolsGetListResponseNoteThumbnailGroup[];
}

export interface ReleaseReleaseNoteProtocolsGetListResponseNoteThumbnailGroup {
  /**
   * @format date
   * @example "2023-03-01"
   */
  date: string;
  is_new: boolean;
  popup_list: ReleaseReleaseNoteProtocolsNoteThumbnail[];
}

export interface ReleaseReleaseNoteProtocolsGetPopupResponse {
  popup?: ReleaseReleaseNoteProtocolsPopup;
}

export interface ReleaseReleaseNoteProtocolsNoteThumbnail {
  content?: string | null;
  /** @format int32 */
  id: number;
  thumbnail_url?: string | null;
  title?: string | null;
}

export interface ReleaseReleaseNoteProtocolsPopup {
  content?: string | null;
  /** @format int32 */
  id: number;
  thumbnail_url?: string | null;
  title?: string | null;
}

export interface RuleSmartRuleFilterProtocolsRequest {
  actions?: MarqCommonEnumsRuleSmartRuleActionEnum[] | null;
  asset_ids?: number[] | null;
  /** @format int32 */
  brand_id?: number | null;
  channel: MarqCommonEnumsChannelTypeEnum;
  custom_tag_ids?: number[] | null;
  is_active?: boolean | null;
  model_ids?: number[] | null;
  search?: string | null;
}

export interface RuleSmartRuleFilterProtocolsResponse {
  /** @format int32 */
  count: number;
  filter_display: boolean;
  list: RuleSmartRuleFilterProtocolsResponseFilterItem[];
}

export interface RuleSmartRuleFilterProtocolsResponseFilterItem {
  /** @format int32 */
  count: number;
  /** @format int32 */
  id: number;
  text: string;
}

export interface RuleSmartRuleProtocolsCreateSmartRuleRequest {
  action: MarqCommonEnumsRuleSmartRuleActionEnum;
  /** @format int32 */
  brand_id: number;
  channel: MarqCommonEnumsChannelTypeEnum;
  condition: MarqCommonModelRuleSmartRuleConditionForClient;
  custom_tag_ids?: number[] | null;
  title: string;
}

export interface RuleSmartRuleProtocolsCreateSmartRuleResponse {
  /** @format int32 */
  id: number;
}

export interface RuleSmartRuleProtocolsDeleteSmartRuleRequest {
  /** @format int32 */
  id: number;
}

export interface RuleSmartRuleProtocolsGetAssetsRequest {
  /** @format int32 */
  brand_id?: number | null;
}

export interface RuleSmartRuleProtocolsGetAssetsResponse {
  assets: RuleSmartRuleProtocolsGetAssetsResponseAsset[];
}

export interface RuleSmartRuleProtocolsGetAssetsResponseAsset {
  /** @format int32 */
  id: number;
  models: RuleSmartRuleProtocolsGetAssetsResponseAssetAtom[];
  name: string;
}

export interface RuleSmartRuleProtocolsGetAssetsResponseAssetAtom {
  /** @format int32 */
  id: number;
  image_url?: string | null;
  model_name: string;
  model_number?: string | null;
}

export interface RuleSmartRuleProtocolsGetCurrenciesResponse {
  currencies: MarqFoundationEnumsCurrencyEnum[];
}

export interface RuleSmartRuleProtocolsGetDomainGroupsRequest {
  channel: MarqCommonEnumsChannelTypeEnum;
}

export interface RuleSmartRuleProtocolsGetDomainGroupsResponse {
  domain_groups: RuleSmartRuleProtocolsGetDomainGroupsResponseDomainGroup[];
}

export interface RuleSmartRuleProtocolsGetDomainGroupsResponseDomainGroup {
  code: string;
  name: string;
}

export interface RuleSmartRuleProtocolsGetDomainsRequest {
  channel: MarqCommonEnumsChannelTypeEnum;
}

export interface RuleSmartRuleProtocolsGetDomainsResponse {
  domain_countries: RuleSmartRuleProtocolsGetDomainsResponseDomainCountry[];
}

export interface RuleSmartRuleProtocolsGetDomainsResponseDomainCountry {
  country_code: MarqFoundationEnumsCountryCodeEnum;
  country_name: string;
  domains: RuleSmartRuleProtocolsGetDomainsResponseDomainCountryDomain[];
}

export interface RuleSmartRuleProtocolsGetDomainsResponseDomainCountryDomain {
  /** @format int32 */
  count?: number | null;
  /** @format int32 */
  id: number;
  name: string;
}

export interface RuleSmartRuleProtocolsGetInfringingImagesRequest {
  /** @format int32 */
  brand_id?: number | null;
}

export interface RuleSmartRuleProtocolsGetInfringingImagesResponse {
  collections: RuleSmartRuleProtocolsGetInfringingImagesResponseCollection[];
}

export interface RuleSmartRuleProtocolsGetInfringingImagesResponseCollection {
  /** @format int32 */
  id?: number | null;
  images: RuleSmartRuleProtocolsGetInfringingImagesResponseCollectionInfringingImage[];
  name: string;
}

export interface RuleSmartRuleProtocolsGetInfringingImagesResponseCollectionInfringingImage {
  /** @format int32 */
  id: number;
  image_url?: string | null;
}

export interface RuleSmartRuleProtocolsGetNumOfExpectedAffectedListingsRequest {
  /** @format int32 */
  brand_id: number;
  channel?: MarqCommonEnumsChannelTypeEnum;
  condition?: MarqCommonModelRuleSmartRuleConditionForClient;
  /** @format int32 */
  smart_rule_id?: number | null;
}

export interface RuleSmartRuleProtocolsGetNumOfExpectedAffectedListingsResponse {
  /** @format int32 */
  count: number;
}

export interface RuleSmartRuleProtocolsGetOfficialImageCollectionsRequest {
  /** @format int32 */
  brand_id?: number | null;
  search?: string | null;
}

export interface RuleSmartRuleProtocolsGetOfficialImageCollectionsResponse {
  collections: RuleSmartRuleProtocolsGetOfficialImageCollectionsResponseCollection[];
}

export interface RuleSmartRuleProtocolsGetOfficialImageCollectionsResponseCollection {
  /** @format int32 */
  count: number;
  /** @format int32 */
  id?: number | null;
  name: string;
}

export interface RuleSmartRuleProtocolsGetOfficialImagesRequest {
  /** @format int32 */
  brand_id: number;
  /** @format int32 */
  official_image_collection_id?: number | null;
  search?: string | null;
  search_after?: KotlinAny[] | null;
  /** @format int32 */
  size: number;
}

export interface RuleSmartRuleProtocolsGetOfficialImagesResponse {
  images: RuleSmartRuleProtocolsGetOfficialImagesResponseOfficialImage[];
  search_after?: KotlinAny[] | null;
}

export interface RuleSmartRuleProtocolsGetOfficialImagesResponseOfficialImage {
  /** @format int32 */
  id: number;
  image_url: string;
  name: string;
}

export interface RuleSmartRuleProtocolsGetSellersRequest {
  /** @format int32 */
  brand_id: number;
  /** @format int32 */
  limit: number;
  /** @format int32 */
  offset: number;
  search?: string | null;
}

export interface RuleSmartRuleProtocolsGetSellersResponse {
  seller_names: string[];
  /** @format int32 */
  total_count: number;
}

export interface RuleSmartRuleProtocolsGetShipFromCountriesResponse {
  countries: string[];
}

export interface RuleSmartRuleProtocolsGetSmartRuleStatusRequest {
  ids: number[];
}

export interface RuleSmartRuleProtocolsGetSmartRuleStatusResponse {
  smart_rules: RuleSmartRuleProtocolsGetSmartRuleStatusResponseSmartRuleIdWithStatus[];
}

export interface RuleSmartRuleProtocolsGetSmartRuleStatusResponseSmartRuleIdWithStatus {
  /** @format int32 */
  id: number;
  status: MarqCommonEnumsRuleSmartRuleStatusEnum;
}

export interface RuleSmartRuleProtocolsGetSmartRulesRequest {
  actions?: MarqCommonEnumsRuleSmartRuleActionEnum[] | null;
  asset_ids?: number[] | null;
  /** @format int32 */
  brand_id?: number | null;
  channel: MarqCommonEnumsChannelTypeEnum;
  custom_tag_ids?: number[] | null;
  is_active?: boolean | null;
  model_ids?: number[] | null;
  search?: string | null;
  sorted_by: MarqCommonEnumsSmartRuleSortedByEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
}

export interface RuleSmartRuleProtocolsGetSmartRulesResponse {
  smart_rules: MarqBrandCoreModelRuleSmartRuleForClient[];
}

export interface RuleSmartRuleProtocolsGetTrademarkedLogosRequest {
  /** @format int32 */
  brand_id?: number | null;
}

export interface RuleSmartRuleProtocolsGetTrademarkedLogosResponse {
  logos: RuleSmartRuleProtocolsGetTrademarkedLogosResponseTrademarkedLogo[];
}

export interface RuleSmartRuleProtocolsGetTrademarkedLogosResponseTrademarkedLogo {
  bbox_list: MarqCommonModelCoordinate[];
  /** @format int32 */
  id: number;
  image_url: string;
  name: string;
}

export interface RuleSmartRuleProtocolsUpdateSmartRuleRequest {
  action: MarqCommonEnumsRuleSmartRuleActionEnum;
  condition: MarqCommonModelRuleSmartRuleConditionForClient;
  custom_tag_ids?: number[] | null;
  /** @format int32 */
  id: number;
  title: string;
}

export interface RuleSmartRuleProtocolsUpdateSmartRuleResponse {
  /** @format int32 */
  id: number;
}

export interface RuleSmartRuleProtocolsUpdateSmartRulePinnedRequest {
  /** @format int32 */
  id: number;
  should_pin: boolean;
}

export interface RuleSmartRuleProtocolsUpdateSmartRulePinnedResponse {
  /** @format int32 */
  id: number;
}

export interface RuleSmartRuleProtocolsUpdateSmartRuleStatusRequest {
  /** @format int32 */
  id: number;
  to_active: boolean;
}

export interface RuleSmartRuleProtocolsUpdateSmartRuleStatusResponse {
  /** @format int32 */
  id: number;
}

export interface SellerMarketplaceEnforcementActivityProtocolsExportExcelForEnforcementActivityRequest {
  seller_id: string;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
  status_filter?: MarqCommonEnumsEnforcementStatusEnum[] | null;
}

export interface SellerMarketplaceEnforcementActivityProtocolsExportExcelForEnforcementActivityResponse {
  /** @format int32 */
  progress_id: number;
}

export interface SellerMarketplaceEnforcementActivityProtocolsGetEnforcementActivityCountRequest {
  seller_id: string;
  status_filter?: MarqCommonEnumsEnforcementStatusEnum[] | null;
}

export interface SellerMarketplaceEnforcementActivityProtocolsGetEnforcementActivityCountResponse {
  /** @format int32 */
  total_count: number;
}

export interface SellerMarketplaceEnforcementActivityProtocolsGetEnforcementActivityListRequest {
  /** @format int32 */
  limit: number;
  /** @format int32 */
  offset: number;
  seller_id: string;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
  status_filter?: MarqCommonEnumsEnforcementStatusEnum[] | null;
}

export interface SellerMarketplaceEnforcementActivityProtocolsGetEnforcementActivityListResponse {
  listing_list: SellerMarketplaceEnforcementActivityProtocolsGetEnforcementActivityListResponseListingResponse[];
  seller_name: string;
}

export interface SellerMarketplaceEnforcementActivityProtocolsGetEnforcementActivityListResponseListingResponse {
  listing_attachments: MarqBrandDataModelListingAttachmentResponseBase[];
  /** @format int32 */
  listing_id: number;
  listing_title?: string | null;
  listing_title_translate?: string | null;
  listing_url?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  removed_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  reported_date?: string | null;
  status?: string | null;
  tag: MarqBrandCoreModelProtocolInvestigationTags;
}

export interface SellerMarketplaceEnforcementActivityProtocolsGetFilterOptionsRequest {
  seller_id: string;
}

export interface SellerSellerAnalyticClusterProtocolsExportExcelRequest {
  active_seller_filter?: boolean | null;
  cluster_id_list?: number[] | null;
  domain_id_filter?: number[] | null;
  last_detected_date_filter?: MarqCommonModelLocalDateRange;
  risk_score_filter?: MarqBrandCoreModelRequestRiskScoreFilterRequestRiskScoreItem;
  search?: string | null;
  sorted_column: MarqCommonEnumsSellerSearchSortEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
}

export interface SellerSellerAnalyticClusterProtocolsExportExcelResponse {
  /** @format int32 */
  progress_id: number;
}

export interface SellerSellerAnalyticClusterProtocolsGetChannelDomainFilterRequest {
  active_seller_filter?: boolean | null;
  domain_id_filter?: number[] | null;
  last_detected_date_filter?: MarqCommonModelLocalDateRange;
  risk_score_filter?: MarqBrandCoreModelRequestRiskScoreFilterRequestRiskScoreItem;
  search?: string | null;
}

export interface SellerSellerAnalyticClusterProtocolsGetSellerClusterCountRequest {
  active_seller_filter?: boolean | null;
  domain_id_filter?: number[] | null;
  last_detected_date_filter?: MarqCommonModelLocalDateRange;
  risk_score_filter?: MarqBrandCoreModelRequestRiskScoreFilterRequestRiskScoreItem;
  search?: string | null;
}

export interface SellerSellerAnalyticClusterProtocolsGetSellerClusterCountResponse {
  /** @format int32 */
  total_count: number;
  /**
   * @format date
   * @example "2023-03-01"
   */
  updated_date?: string | null;
}

export interface SellerSellerAnalyticClusterProtocolsGetSellerClusterListRequest {
  active_seller_filter?: boolean | null;
  domain_id_filter?: number[] | null;
  last_detected_date_filter?: MarqCommonModelLocalDateRange;
  /** @format int32 */
  limit: number;
  /** @format int32 */
  offset: number;
  risk_score_filter?: MarqBrandCoreModelRequestRiskScoreFilterRequestRiskScoreItem;
  search?: string | null;
  sorted_column: MarqCommonEnumsSellerSearchSortEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
}

export interface SellerSellerAnalyticClusterProtocolsGetSellerClusterListResponse {
  seller_cluster_list: MarqBrandModelResponseSellerBrandSellerClusterResponse[];
}

export interface SellerSellerAnalyticDetailArchivedListingProtocolsExportListingStatusListRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  listing_id_list?: number[] | null;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
  sorted_column: MarqCommonEnumsSortedColumnArchivedPageEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
}

export interface SellerSellerAnalyticDetailArchivedListingProtocolsExportListingStatusListResponse {
  /** @format int32 */
  progress_id: number;
}

export interface SellerSellerAnalyticDetailArchivedListingProtocolsGetArchivedListingListRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  /** @format int32 */
  limit: number;
  /** @format int32 */
  offset: number;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
  sorted_column: MarqCommonEnumsSortedColumnArchivedPageEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
}

export interface SellerSellerAnalyticDetailArchivedListingProtocolsGetArchivedListingListResponse {
  listing_list: SellerSellerAnalyticDetailArchivedListingProtocolsGetArchivedListingListResponseListingResponse[];
}

export interface SellerSellerAnalyticDetailArchivedListingProtocolsGetArchivedListingListResponseListingResponse {
  /**
   * @format date
   * @example "2023-03-01"
   */
  archived_date?: string | null;
  asset_name: string;
  currency?: MarqFoundationEnumsCurrencyEnum;
  domain_name: string;
  /** @format int32 */
  listing_id: number;
  listing_title: string;
  listing_title_translate?: string | null;
  listing_url: string;
  /** @format double */
  price?: number | null;
  /** @format int32 */
  seller_id: number;
  seller_name: string;
  thumbnail_url: string;
}

export interface SellerSellerAnalyticDetailArchivedListingProtocolsGetFilterInfoCustomTagRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
}

export interface SellerSellerAnalyticDetailArchivedListingProtocolsGetFilterInfoDomainRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
}

export interface SellerSellerAnalyticDetailArchivedListingProtocolsGetFilterInfoSellerRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
}

export interface SellerSellerAnalyticDetailArchivedListingProtocolsGetListingStatusCountRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
}

export interface SellerSellerAnalyticDetailArchivedListingProtocolsGetListingStatusCountResponse {
  /** @format int32 */
  total_count: number;
}

export interface SellerSellerAnalyticDetailDataDrivenProtocolsRequestDemandLetterRequest {
  /** @format int32 */
  cluster_id?: number | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  requested_date: string;
  seller_id?: string | null;
}

export interface SellerSellerAnalyticDetailDataDrivenProtocolsRequestUDRPRequest {
  /** @format int32 */
  cluster_id?: number | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  requested_date: string;
  seller_id?: string | null;
}

export interface SellerSellerAnalyticDetailDetectedListingProtocolsExportListingStatusListRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  listing_id_list?: number[] | null;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
  sorted_column: MarqBrandCoreModelClientListingSortedColumnEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
}

export interface SellerSellerAnalyticDetailDetectedListingProtocolsExportListingStatusListResponse {
  /** @format int32 */
  progress_id: number;
}

export interface SellerSellerAnalyticDetailDetectedListingProtocolsGetDetectedListingListRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  /** @format int32 */
  limit: number;
  /** @format int32 */
  offset: number;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
  sorted_column: MarqBrandCoreModelClientListingSortedColumnEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
}

export interface SellerSellerAnalyticDetailDetectedListingProtocolsGetDetectedListingListResponse {
  listing_list: SellerSellerAnalyticDetailDetectedListingProtocolsGetDetectedListingListResponseListingResponse[];
}

export interface SellerSellerAnalyticDetailDetectedListingProtocolsGetDetectedListingListResponseListingResponse {
  asset_name: string;
  currency?: MarqFoundationEnumsCurrencyEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  detected_date: string;
  domain_name: string;
  /** @format int32 */
  listing_id: number;
  listing_title: string;
  listing_title_translate?: string | null;
  listing_url: string;
  /** @format double */
  price?: number | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  scanned_date: string;
  /** @format int32 */
  seller_id: number;
  seller_name: string;
  thumbnail_url: string;
}

export interface SellerSellerAnalyticDetailDetectedListingProtocolsGetFilterInfoCustomTagRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
}

export interface SellerSellerAnalyticDetailDetectedListingProtocolsGetFilterInfoDomainRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
}

export interface SellerSellerAnalyticDetailDetectedListingProtocolsGetFilterInfoSellerRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
}

export interface SellerSellerAnalyticDetailDetectedListingProtocolsGetListingStatusCountRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
}

export interface SellerSellerAnalyticDetailDetectedListingProtocolsGetListingStatusCountResponse {
  /** @format int32 */
  total_count: number;
}

export interface SellerSellerAnalyticDetailDismissedListingProtocolsExportListingStatusListRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  listing_id_list?: number[] | null;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
  sorted_column: MarqCommonEnumsSortedColumnArchivedPageEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
}

export interface SellerSellerAnalyticDetailDismissedListingProtocolsExportListingStatusListResponse {
  /** @format int32 */
  progress_id: number;
}

export interface SellerSellerAnalyticDetailDismissedListingProtocolsGetDismissedListingListRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  /** @format int32 */
  limit: number;
  /** @format int32 */
  offset: number;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
  sorted_column: MarqCommonEnumsSortedColumnArchivedPageEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
}

export interface SellerSellerAnalyticDetailDismissedListingProtocolsGetDismissedListingListResponse {
  listing_list: SellerSellerAnalyticDetailDismissedListingProtocolsGetDismissedListingListResponseListingResponse[];
}

export interface SellerSellerAnalyticDetailDismissedListingProtocolsGetDismissedListingListResponseListingResponse {
  /**
   * @format date
   * @example "2023-03-01"
   */
  archived_date?: string | null;
  asset_name: string;
  currency?: MarqFoundationEnumsCurrencyEnum;
  domain_name: string;
  /** @format int32 */
  listing_id: number;
  listing_title: string;
  listing_title_translate?: string | null;
  listing_url: string;
  /** @format double */
  price?: number | null;
  /** @format int32 */
  seller_id: number;
  seller_name: string;
  thumbnail_url: string;
}

export interface SellerSellerAnalyticDetailDismissedListingProtocolsGetFilterInfoCustomTagRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
}

export interface SellerSellerAnalyticDetailDismissedListingProtocolsGetFilterInfoDomainRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
}

export interface SellerSellerAnalyticDetailDismissedListingProtocolsGetFilterInfoSellerRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
}

export interface SellerSellerAnalyticDetailDismissedListingProtocolsGetListingStatusCountRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
}

export interface SellerSellerAnalyticDetailDismissedListingProtocolsGetListingStatusCountResponse {
  /** @format int32 */
  total_count: number;
}

export interface SellerSellerAnalyticDetailEnforcedListingProtocolsExportListingStatusListRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  listing_id_list?: number[] | null;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
  sorted_column: MarqCommonEnumsSortedColumnEnforcementPageEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
  status_filter?: MarqCommonEnumsEnforcementStatusEnum[] | null;
}

export interface SellerSellerAnalyticDetailEnforcedListingProtocolsExportListingStatusListResponse {
  /** @format int32 */
  progress_id: number;
}

export interface SellerSellerAnalyticDetailEnforcedListingProtocolsGetEnforcedListingListRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  /** @format int32 */
  limit: number;
  /** @format int32 */
  offset: number;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
  sorted_column: MarqCommonEnumsSortedColumnEnforcementPageEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
  status_filter?: MarqCommonEnumsEnforcementStatusEnum[] | null;
}

export interface SellerSellerAnalyticDetailEnforcedListingProtocolsGetEnforcedListingListResponse {
  listing_list: SellerSellerAnalyticDetailEnforcedListingProtocolsGetEnforcedListingListResponseListingResponse[];
}

export interface SellerSellerAnalyticDetailEnforcedListingProtocolsGetEnforcedListingListResponseListingResponse {
  asset_name: string;
  currency?: MarqFoundationEnumsCurrencyEnum;
  domain_name: string;
  listing_attachments: MarqBrandDataModelListingAttachmentResponseBase[];
  /** @format int32 */
  listing_id: number;
  listing_title: string;
  listing_title_translate?: string | null;
  listing_url: string;
  /** @format double */
  price?: number | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  requested_date?: string | null;
  /** @format int32 */
  seller_id: number;
  seller_name: string;
  status: string;
  thumbnail_url: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  updated_date: string;
}

export interface SellerSellerAnalyticDetailEnforcedListingProtocolsGetFilterInfoCustomTagRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
  status_filter?: MarqCommonEnumsEnforcementStatusEnum[] | null;
}

export interface SellerSellerAnalyticDetailEnforcedListingProtocolsGetFilterInfoDomainRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
  status_filter?: MarqCommonEnumsEnforcementStatusEnum[] | null;
}

export interface SellerSellerAnalyticDetailEnforcedListingProtocolsGetFilterInfoSellerRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
  status_filter?: MarqCommonEnumsEnforcementStatusEnum[] | null;
}

export interface SellerSellerAnalyticDetailEnforcedListingProtocolsGetFilterInfoStatusRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
  status_filter?: MarqCommonEnumsEnforcementStatusEnum[] | null;
}

export interface SellerSellerAnalyticDetailEnforcedListingProtocolsGetListingStatusCountRequest {
  /** @format int32 */
  cluster_id?: number | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  search?: string | null;
  seller_id?: string | null;
  seller_name_filter?: string[] | null;
  status_filter?: MarqCommonEnumsEnforcementStatusEnum[] | null;
}

export interface SellerSellerAnalyticDetailEnforcedListingProtocolsGetListingStatusCountResponse {
  /** @format int32 */
  total_count: number;
}

export interface SellerSellerAnalyticDetailProtocolsEditProfileRequest {
  address?: string | null;
  business_reg_num?: string | null;
  company_name?: string | null;
  country_code?: MarqFoundationEnumsCountryCodeEnum;
  email?: string | null;
  legal_representative?: string | null;
  online_marketing_number?: string | null;
  phone?: string | null;
  seller_id: string;
  seller_name?: string | null;
  shop_name?: string | null;
}

export interface SellerSellerAnalyticDetailProtocolsGetClusterProfileRequest {
  /** @format int32 */
  cluster_id?: number | null;
  seller_id?: string | null;
}

export interface SellerSellerAnalyticDetailProtocolsGetClusterProfileResponse {
  profile: MarqBrandCoreModelResponseClusterProfileResponse;
}

export interface SellerSellerAnalyticDetailProtocolsGetClusterSellerListRequest {
  /** @format int32 */
  cluster_id: number;
  /** @format int32 */
  limit: number;
  /** @format int32 */
  offset: number;
  sort_by?: MarqCommonEnumsSellerintelSellerClusterDataSortByEnum;
}

export interface SellerSellerAnalyticDetailProtocolsGetClusterSellerListResponse {
  seller_list: MarqBrandDataModelSellerClusterAnalysisSellerDataSellerData[];
}

export interface SellerSellerAnalyticDetailProtocolsGetDataDrivenInsightRequest {
  /** @format int32 */
  cluster_id?: number | null;
  seller_id?: string | null;
}

export interface SellerSellerAnalyticDetailProtocolsGetDataDrivenInsightResponse {
  response: MarqBrandCoreModelResponseDataDrivenInsightResponse;
}

export interface SellerSellerAnalyticDetailProtocolsGetDetailRequest {
  /** @format int32 */
  cluster_id?: number | null;
  seller_id?: string | null;
}

export interface SellerSellerAnalyticDetailProtocolsGetFirstEnforcementHistoryRequest {
  seller_id: string;
}

export interface SellerSellerAnalyticDetailProtocolsGetFirstEnforcementHistoryResponse {
  first_enforcement_history: MarqBrandModelResponseSellerDetailResponseFirstEnforcementHistory[];
  /** @format int64 */
  reported_listings_count: number;
}

export interface SellerSellerAnalyticDetailProtocolsGetListingStatusGraphRequest {
  /** @format int32 */
  cluster_id?: number | null;
  period_type: MarqCommonEnumsSellerListingStatusGraphTabType;
  seller_id?: string | null;
}

export interface SellerSellerAnalyticDetailProtocolsGetListingStatusGraphResponse {
  detected: SellerSellerAnalyticDetailProtocolsGetListingStatusGraphStatusData[];
  enforcement_req: SellerSellerAnalyticDetailProtocolsGetListingStatusGraphStatusData[];
  removed: SellerSellerAnalyticDetailProtocolsGetListingStatusGraphStatusData[];
}

export interface SellerSellerAnalyticDetailProtocolsGetListingStatusGraphStatusData {
  label: string;
  /** @format int64 */
  total_count: number;
}

export interface SellerSellerAnalyticDetailProtocolsGetSummaryRequest {
  /** @format int32 */
  cluster_id?: number | null;
  seller_id?: string | null;
}

export interface SellerSellerAnalyticDetailProtocolsGetSummaryResponse {
  summary: MarqBrandCoreModelResponseSellerDetailSummaryResponse;
}

export interface SellerSellerAnalyticSellerInClusterProtocolsExportExcelRequest {
  active_seller_filter?: boolean | null;
  /** @format int32 */
  cluster_id: number;
  domain_id_filter?: number[] | null;
  last_detected_date_filter?: MarqCommonModelLocalDateRange;
  risk_score_filter?: MarqBrandCoreModelRequestRiskScoreFilterRequestRiskScoreItem;
  search?: string | null;
  seller_id_list?: string[] | null;
  sorted_column: MarqCommonEnumsSellerSearchSortEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
}

export interface SellerSellerAnalyticSellerInClusterProtocolsExportExcelResponse {
  /** @format int32 */
  progress_id: number;
}

export interface SellerSellerAnalyticSellerInClusterProtocolsGetChannelDomainFilterRequest {
  active_seller_filter?: boolean | null;
  /** @format int32 */
  cluster_id: number;
  domain_id_filter?: number[] | null;
  last_detected_date_filter?: MarqCommonModelLocalDateRange;
  risk_score_filter?: MarqBrandCoreModelRequestRiskScoreFilterRequestRiskScoreItem;
  search?: string | null;
}

export interface SellerSellerAnalyticSellerInClusterProtocolsGetSellerCountRequest {
  active_seller_filter?: boolean | null;
  /** @format int32 */
  cluster_id: number;
  domain_id_filter?: number[] | null;
  last_detected_date_filter?: MarqCommonModelLocalDateRange;
  risk_score_filter?: MarqBrandCoreModelRequestRiskScoreFilterRequestRiskScoreItem;
  search?: string | null;
}

export interface SellerSellerAnalyticSellerInClusterProtocolsGetSellerCountResponse {
  /** @format int32 */
  total_count: number;
  /**
   * @format date
   * @example "2023-03-01"
   */
  updated_date: string;
}

export interface SellerSellerAnalyticSellerInClusterProtocolsGetSellerListRequest {
  active_seller_filter?: boolean | null;
  /** @format int32 */
  cluster_id: number;
  domain_id_filter?: number[] | null;
  last_detected_date_filter?: MarqCommonModelLocalDateRange;
  /** @format int32 */
  limit: number;
  /** @format int32 */
  offset: number;
  risk_score_filter?: MarqBrandCoreModelRequestRiskScoreFilterRequestRiskScoreItem;
  search?: string | null;
  sorted_column: MarqCommonEnumsSellerSearchSortEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
}

export interface SellerSellerAnalyticSellerInClusterProtocolsGetSellerListResponse {
  seller_list: MarqBrandModelResponseSellerSellerAnalyticsSellerInClusterResponse[];
}

export interface SellerSellerAnalyticSellerProtocolsExportExcelRequest {
  active_seller_filter?: boolean | null;
  authorized?: boolean | null;
  domain_id_filter?: number[] | null;
  last_detected_date_filter?: MarqCommonModelLocalDateRange;
  risk_score_filter?: MarqBrandCoreModelRequestRiskScoreFilterRequestRiskScoreItem;
  search?: string | null;
  seller_contact_status?: MarqCommonEnumsSellerContactThreadStatusEnum[] | null;
  seller_id_list?: string[] | null;
  sorted_column: MarqCommonEnumsSellerSearchSortEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
}

export interface SellerSellerAnalyticSellerProtocolsExportExcelResponse {
  /** @format int32 */
  progress_id: number;
}

export interface SellerSellerAnalyticSellerProtocolsGetChannelDomainFilterRequest {
  active_seller_filter?: boolean | null;
  authorized?: boolean | null;
  domain_id_filter?: number[] | null;
  last_detected_date_filter?: MarqCommonModelLocalDateRange;
  risk_score_filter?: MarqBrandCoreModelRequestRiskScoreFilterRequestRiskScoreItem;
  search?: string | null;
  seller_contact_status?: MarqCommonEnumsSellerContactThreadStatusEnum[] | null;
}

export interface SellerSellerAnalyticSellerProtocolsGetSellerCountRequest {
  active_seller_filter?: boolean | null;
  authorized?: boolean | null;
  domain_id_filter?: number[] | null;
  last_detected_date_filter?: MarqCommonModelLocalDateRange;
  risk_score_filter?: MarqBrandCoreModelRequestRiskScoreFilterRequestRiskScoreItem;
  search?: string | null;
  seller_contact_status?: MarqCommonEnumsSellerContactThreadStatusEnum[] | null;
}

export interface SellerSellerAnalyticSellerProtocolsGetSellerCountResponse {
  /** @format int32 */
  total_count: number;
}

export interface SellerSellerAnalyticSellerProtocolsGetSellerListRequest {
  active_seller_filter?: boolean | null;
  authorized?: boolean | null;
  domain_id_filter?: number[] | null;
  last_detected_date_filter?: MarqCommonModelLocalDateRange;
  /** @format int32 */
  limit: number;
  /** @format int32 */
  offset: number;
  risk_score_filter?: MarqBrandCoreModelRequestRiskScoreFilterRequestRiskScoreItem;
  search?: string | null;
  seller_contact_status?: MarqCommonEnumsSellerContactThreadStatusEnum[] | null;
  sorted_column: MarqCommonEnumsSellerSearchSortEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
}

export interface SellerSellerAnalyticSellerProtocolsGetSellerListResponse {
  seller_list: MarqBrandModelResponseSellerSellerAnalyticsResponse[];
}

export interface SellerSellerContactProtocolsAddTemplateRequest {
  body: string;
  name: string;
  subject: string;
}

export interface SellerSellerContactProtocolsAttachment {
  file_name: string;
  url: string;
}

export interface SellerSellerContactProtocolsComposeRequest {
  attachments?: SellerSellerContactProtocolsAttachment[] | null;
  body: string;
  /** @format int32 */
  seller_id?: number | null;
  seller_id_code?: string | null;
  subject: string;
  type: MarqCommonEnumsSellerContactTemplateTypeEnum;
}

export interface SellerSellerContactProtocolsComposeResponse {
  thread_id: string;
}

export interface SellerSellerContactProtocolsDeleteTemplateRequest {
  /** @format int32 */
  id: number;
}

export interface SellerSellerContactProtocolsGetComposeFormInfoRequest {
  /** @format int32 */
  seller_id?: number | null;
  seller_id_code?: string | null;
}

export interface SellerSellerContactProtocolsGetComposeFormInfoResponse {
  templates: SellerSellerContactProtocolsGetComposeFormInfoResponseTemplate[];
  to_name: string;
}

export interface SellerSellerContactProtocolsGetComposeFormInfoResponseTemplate {
  body: string;
  /** @format int32 */
  custom_template_id?: number | null;
  footer_message?: string | null;
  name: string;
  subject: string;
  type: MarqCommonEnumsSellerContactTemplateTypeEnum;
}

export interface SellerSellerContactProtocolsGetThreadDetailsRequest {
  thread_id: string;
}

export interface SellerSellerContactProtocolsGetThreadDetailsResponse {
  messages: SellerSellerContactProtocolsGetThreadDetailsResponseMessage[];
  status: MarqCommonEnumsSellerContactThreadStatusEnum;
  subject: string;
}

export interface SellerSellerContactProtocolsGetThreadDetailsResponseMessage {
  attachments?: SellerSellerContactProtocolsAttachment[] | null;
  body: string;
  from_name: string;
  mime_type: MarqCommonEnumsMimeTypeEnum;
  sender_type: MarqCommonEnumsSellerContactSenderTypeEnum;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  sent_at: string;
  to_name: string;
}

export interface SellerSellerContactProtocolsGetThreadListRequest {
  /** @format int32 */
  seller_id?: number | null;
  seller_id_code?: string | null;
}

export interface SellerSellerContactProtocolsGetThreadListResponse {
  threads: SellerSellerContactProtocolsGetThreadListResponseThread[];
}

export interface SellerSellerContactProtocolsGetThreadListResponseThread {
  status: MarqCommonEnumsSellerContactThreadStatusEnum;
  subject: string;
  thread_id: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  updated_at: string;
}

export interface SellerSellerContactProtocolsReplyRequest {
  attachments?: SellerSellerContactProtocolsAttachment[] | null;
  body: string;
  /** @format int32 */
  seller_id?: number | null;
  seller_id_code?: string | null;
  thread_id: string;
}

export interface SellerSellerContactProtocolsUpdateTemplateRequest {
  body: string;
  /** @format int32 */
  id: number;
  name: string;
  subject: string;
}

export interface SellerSellerContactProtocolsUpdateThreadRequest {
  status: MarqCommonEnumsSellerContactThreadStatusEnum;
  thread_id: string;
}

export interface SellerSellerLinkProtocolsAddSingleRequest {
  address?: string | null;
  business_registration_number?: string | null;
  company_name?: string | null;
  email?: string | null;
  name: string;
  phone?: string | null;
}

export interface SellerSellerLinkProtocolsAddSingleResponse {
  /** @format int32 */
  progress_id: number;
}

export interface SellerSellerLinkProtocolsGetClusterDetailRequest {
  /** @format int32 */
  cluster_id: number;
}

export interface SellerSellerLinkProtocolsGetClusterDetailResponse {
  clustered_sellers: SellerSellerLinkProtocolsGetClusterDetailResponseClusteredSeller[];
  input_data_list: SellerSellerLinkProtocolsGetClusterDetailResponseInputData[];
  matched_keywords: SellerSellerLinkProtocolsMatchedKeywords;
}

export interface SellerSellerLinkProtocolsGetClusterDetailResponseClusteredSeller {
  address: string;
  business_registration_number: string;
  company_name: string;
  email: string;
  phone: string;
  seller_info: SellerSellerLinkProtocolsSellerInfo;
}

export interface SellerSellerLinkProtocolsGetClusterDetailResponseInputData {
  address?: string | null;
  business_registration_number?: string | null;
  company_name?: string | null;
  email?: string | null;
  name: string;
  phone?: string | null;
}

export interface SellerSellerLinkProtocolsGetClustersRequest {
  /** @format int32 */
  id: number;
}

export interface SellerSellerLinkProtocolsGetClustersResponse {
  /** @format int32 */
  cluster_count: number;
  clusters: SellerSellerLinkProtocolsGetClustersResponseClusterSummary[];
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  created_at: string;
  /** @format int32 */
  input_count: number;
  /** @format int32 */
  seller_count: number;
  /** @format int32 */
  total_input_count: number;
}

export interface SellerSellerLinkProtocolsGetClustersResponseClusterSummary {
  domain_groups: SellerSellerLinkProtocolsGetClustersResponseClusterSummaryDomainGroup[];
  evidence: SellerSellerLinkProtocolsKeywordCategories;
  /** @format int32 */
  id: number;
  input_names: string[];
}

export interface SellerSellerLinkProtocolsGetClustersResponseClusterSummaryDomainGroup {
  /** @format int32 */
  domain_id?: number | null;
  domain_name: string;
  seller_info_list: SellerSellerLinkProtocolsSellerInfo[];
}

export interface SellerSellerLinkProtocolsGetRequestsResponse {
  requests: SellerSellerLinkProtocolsGetRequestsResponseRequestItem[];
}

export interface SellerSellerLinkProtocolsGetRequestsResponseRequestItem {
  /** @format int32 */
  cluster_count: number;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  created_at: string;
  /** @format int32 */
  id: number;
  /** @format int32 */
  input_count: number;
  is_new: boolean;
  status: MarqCommonEnumsSellerLinkRequestStatusEnum;
}

export interface SellerSellerLinkProtocolsHasNewRequestResponse {
  has_new: boolean;
}

export interface SellerSellerLinkProtocolsHasPendingRequestResponse {
  has_pending: boolean;
}

export interface SellerSellerLinkProtocolsKeywordCategories {
  addresses: string[];
  business_registration_numbers: string[];
  company_names: string[];
  emails: string[];
  phones: string[];
}

export interface SellerSellerLinkProtocolsMatchedKeywords {
  level1: SellerSellerLinkProtocolsKeywordCategories;
  level2: SellerSellerLinkProtocolsKeywordCategories;
}

export interface SellerSellerLinkProtocolsSellerInfo {
  authorized: boolean;
  domain_name?: string | null;
  /** @format int32 */
  id: number;
  name: string;
  seller_id_code?: string | null;
}

export interface SettingsBillingProtocolsAddPaymentMethodResponse {
  added: boolean;
}

export interface SettingsBillingProtocolsAddress {
  city?: string | null;
  country?: MarqFoundationEnumsCountryCodeEnum;
  line1?: string | null;
  line2?: string | null;
  postal_code?: string | null;
  region?: string | null;
}

export interface SettingsBillingProtocolsDeletePaymentMethodRequest {
  payment_method_id: string;
}

export interface SettingsBillingProtocolsGetBillingHistoryResponse {
  history_list: SettingsBillingProtocolsGetBillingHistoryResponseBillingHistoryRow[];
}

export interface SettingsBillingProtocolsGetBillingHistoryResponseBillingHistoryRow {
  /** @format double */
  amount: number;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  created_date: string;
  currency: MarqFoundationEnumsCurrencyEnum;
  description: string;
  invoice_link: string;
  /** @format double */
  paid_amount: number;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  paid_date?: string | null;
  pay_link?: string | null;
  payment_error?: string | null;
  receipt_link?: string | null;
  status: SettingsBillingProtocolsInvoiceStatus;
}

export interface SettingsBillingProtocolsGetCustomerInfoResponse {
  address?: SettingsBillingProtocolsAddress;
  customer_name?: string | null;
  email?: string | null;
  phone?: string | null;
}

export interface SettingsBillingProtocolsGetPaymentMethodResponse {
  banking_list: SettingsBillingProtocolsGetPaymentMethodResponseBankingDetails[];
  card_list: SettingsBillingProtocolsGetPaymentMethodResponseCardDetails[];
}

export interface SettingsBillingProtocolsGetPaymentMethodResponseBankingDetails {
  bank_name: string;
  default_method: boolean;
  id: string;
  last4: string;
}

export interface SettingsBillingProtocolsGetPaymentMethodResponseCardDetails {
  brand: string;
  default_method: boolean;
  /** @format int32 */
  exp_month?: number | null;
  /** @format int32 */
  exp_year?: number | null;
  id: string;
  last4: string;
}

export interface SettingsBillingProtocolsGetSetupIntentResponse {
  client_secret?: string | null;
}

export interface SettingsBillingProtocolsGetSubscriptionPlansResponse {
  plans: SettingsBillingProtocolsGetSubscriptionPlansResponsePlan[];
}

export enum SettingsBillingProtocolsGetSubscriptionPlansResponseClientSubscriptionStatus {
  Active = 'Active',
  Unpaid = 'Unpaid',
}

export interface SettingsBillingProtocolsGetSubscriptionPlansResponsePlan {
  /** @format double */
  amount: number;
  currency: MarqFoundationEnumsCurrencyEnum;
  frequency: string;
  name: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  next_invoice?: string | null;
  status: SettingsBillingProtocolsGetSubscriptionPlansResponseClientSubscriptionStatus;
}

export enum SettingsBillingProtocolsInvoiceStatus {
  Open = 'Open',
  Retrying = 'Retrying',
  Paid = 'Paid',
  PastDue = 'Past Due',
  Uncollectible = 'Uncollectible',
}

export interface SettingsBillingProtocolsSetDefaultPaymentMethodRequest {
  payment_method_id: string;
}

export interface SettingsBillingProtocolsUpdateCustomerInfoRequest {
  address?: SettingsBillingProtocolsAddress;
  customer_name?: string | null;
  email?: string | null;
  phone?: string | null;
}

export enum SettingsCreditsProtocolsGetCreditHistoryCreditHistoryType {
  RETURNED_CREDITS = 'RETURNED_CREDITS',
}

export interface SettingsCreditsProtocolsGetCreditHistoryRequest {
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
  token?: string | null;
  type: SettingsCreditsProtocolsGetCreditHistoryCreditHistoryType;
}

export interface SettingsCreditsProtocolsGetCreditHistoryResponse {
  history: SettingsCreditsProtocolsGetCreditHistoryResponseHistory[];
  token: string;
}

export interface SettingsCreditsProtocolsGetCreditHistoryResponseHistory {
  /** @format int32 */
  accrued: number;
  /**
   * @format date
   * @example "2023-03-01"
   */
  date: string;
  type: string;
  /** @format int32 */
  used: number;
}

export interface SettingsCreditsProtocolsGetCreditsResponse {
  /** @format int32 */
  available_returned_credits: number;
}

export interface SettingsCustomTagProtocolsCreateCustomTagRequest {
  domain_type: MarqCommonEnumsChannelTypeEnum;
  name: string;
}

export interface SettingsCustomTagProtocolsCreateCustomTagResponse {
  /** @format int32 */
  id: number;
}

export interface SettingsCustomTagProtocolsDeleteCustomTagRequest {
  domain_type: MarqCommonEnumsChannelTypeEnum;
  /** @format int32 */
  id: number;
}

export interface SettingsCustomTagProtocolsGetCustomTagsRequest {
  domain_type: MarqCommonEnumsChannelTypeEnum;
}

export interface SettingsCustomTagProtocolsGetCustomTagsResponse {
  custom_tags: SettingsCustomTagProtocolsGetCustomTagsResponseCustomTag[];
}

export interface SettingsCustomTagProtocolsGetCustomTagsResponseCustomTag {
  email: string;
  /** @format int32 */
  id: number;
  name: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  updated_date: string;
}

export interface SettingsCustomTagProtocolsUpdateCustomTagRequest {
  domain_type: MarqCommonEnumsChannelTypeEnum;
  /** @format int32 */
  id: number;
  name: string;
}

export interface StorageStorageProtocolsGetPresignedDownloadUrlRequest {
  url: string;
}

export interface StorageStorageProtocolsGetPresignedDownloadUrlResponse {
  url: string;
}

export interface StorageStorageProtocolsGetPresignedUploadUrlRequest {
  file_name: string;
  storage_file_type: MarqCommonEnumsStorageFileTypeEnum;
}

export interface StorageStorageProtocolsGetPresignedUploadUrlResponse {
  url: string;
}

export interface CopyrightedImageProtocolsBulkUpdateCopyrightedImagesRequest {
  /** @format int32 */
  brand_id: number;
  /** @format int32 */
  collection_id?: number | null;
  id_list: number[];
  note?: string | null;
}

export enum MarqCommonEnumsFilterModelSearchTypeEnum {
  ModelId = 'model_id',
  ModelName = 'model_name',
  ProductNumber = 'product_number',
}

export interface PortfolioModelProtocolsGetModelCountResponse {
  /** @format int32 */
  count: number;
}

export interface PortfolioModelProtocolsGetModelCountRequest {
  /** @format int32 */
  brand_id?: number | null;
  search?: string | null;
  search_type?: MarqCommonEnumsFilterModelSearchTypeEnum;
  target_model_filter?: boolean | null;
}

export interface PortfolioModelProtocolsGetModelListResponse {
  list: PortfolioModelProtocolsGetModelListResponseModelResponse[];
}

export interface PortfolioModelProtocolsGetModelListResponseModelResponse {
  asset_name: string;
  brand_name: string;
  /** @format int32 */
  id: number;
  is_target_model: boolean;
  name: string;
  price_list?: PortfolioModelProtocolsRetailPriceResponse[] | null;
  primary_image_url?: string | null;
  product_number?: string | null;
  product_url?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  updated_date: string;
}

export interface MarqBrandCoreModelSwWebsiteContentsDetailResponse {
  enforcement_progress?: MarqBrandCoreModelSwWebsiteContentsEnforcementResponse;
  tp_info?: MarqBrandCoreModelResponseTpDetailResponseForBrand;
  website_info: MarqBrandCoreModelSwWebsiteContentsDetailInfoResponse;
}

export interface MarqBrandCoreModelSwWebsiteContentsEnforcementResponse {
  google_progress?: MarqBrandCoreModelSwWebsiteContentsEnforcementResponseGoogleProgressResponse;
  infringing_progress?: MarqBrandCoreModelSwWebsiteContentsEnforcementResponseInfringingProgressResponse;
}

export interface MarqBrandCoreModelSwWebsiteContentsEnforcementResponseGoogleProgressResponse {
  progress_list: MarqBrandCoreModelSwWebsiteContentsEnforcementResponseGoogleProgressResponseItem[];
  status: MarqCommonEnumsSwWebsiteDelistingProgressEnum;
}

export interface MarqBrandCoreModelSwWebsiteContentsEnforcementResponseGoogleProgressResponseItem {
  action: MarqCommonEnumsSwSWActionTypeEnum;
  isp?: MarqCommonEnumsReportAbuseIspEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  progress_date: string;
  status: MarqCommonEnumsSwWebsiteDelistingProgressEnum;
}

export interface MarqBrandCoreModelSwWebsiteContentsEnforcementResponseInfringingProgressResponse {
  progress_list: MarqBrandCoreModelSwWebsiteContentsEnforcementResponseInfringingProgressResponseItem[];
  status: MarqCommonEnumsSwWebsiteReportProgressEnum;
}

export interface MarqBrandCoreModelSwWebsiteContentsEnforcementResponseInfringingProgressResponseItem {
  action: MarqCommonEnumsSwSWActionTypeEnum;
  from_cdn?: PiracyCommonEnumsCdnEnum;
  isp?: MarqCommonEnumsReportAbuseIspEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  progress_date: string;
  status: MarqCommonEnumsSwWebsiteReportProgressEnum;
}

export interface MarqBrandCoreModelSwWebsiteContentsDetailInfoResponse {
  asset_name?: string | null;
  cdn?: MarqBrandCoreModelSwWebsiteCommonCdnResponse;
  /** @format int32 */
  comment_count: number;
  custom_tag_list?: MarqBrandCoreModelResponseCustomTagResponse[] | null;
  hosting_provider?: MarqBrandCoreModelSwWebsiteCommonHostingProviderResponse;
  image_url?: string | null;
  ip?: MarqBrandCoreModelSwIpResponse;
  latest_comment?: MarqBrandCoreModelCommentCommentDto;
  logo_detection?: MarqBrandCoreModelSwLogoDetectionResponse;
  proof_url?: string | null;
  registrant?: MarqBrandCoreModelSwWebsiteCommonRegistrantResponse;
  registrar?: MarqBrandCoreModelSwWebsiteCommonRegistrarResponse;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  scanned_date?: string | null;
  scanned_status?: MarqCommonEnumsScannedStatusEnum;
  search_keyword?: string | null;
  thumbnail_url?: string | null;
  title: string;
  title_translate?: string | null;
  /** @format int32 */
  website_id: number;
  website_url: string;
}

export interface PortfolioModelProtocolsRetailPriceResponse {
  currency: MarqFoundationEnumsCurrencyEnum;
  /** @format double */
  retail_price: number;
  /** @format double */
  rrp_price?: number | null;
}

export interface PortfolioModelProtocolsGetModelListRequest {
  /** @format int32 */
  brand_id?: number | null;
  /** @format int32 */
  limit?: number | null;
  /** @format int32 */
  offset?: number | null;
  search?: string | null;
  search_type?: MarqCommonEnumsFilterModelSearchTypeEnum;
  sorted_column: MarqCommonEnumsIpModelListSortEnum;
  sorted_order: MarqCommonEnumsSortedOrderEnum;
  target_model_filter?: boolean | null;
}

export enum MarqCommonEnumsIpModelListSortEnum {
  UpdatedDate = 'updated_date',
  ModelName = 'model_name',
  AssetName = 'asset_name',
}

export interface PortfolioModelProtocolsGetModelIdListResponse {
  list: number[];
}

export interface PortfolioModelProtocolsGetModelIdListRequest {
  /** @format int32 */
  brand_id?: number | null;
  search?: string | null;
  search_type?: MarqCommonEnumsFilterModelSearchTypeEnum;
  target_model_filter?: boolean | null;
}

export interface PortfolioModelProtocolsExportModelListResponse {
  /** @format int32 */
  progress_id: number;
}

export interface PortfolioModelProtocolsExportModelListRequest {
  /** @format int32 */
  brand_id?: number | null;
  model_id_list?: number[] | null;
  search?: string | null;
  search_type?: MarqCommonEnumsFilterModelSearchTypeEnum;
  sorted_column?: MarqCommonEnumsIpModelListSortEnum;
  sorted_order?: MarqCommonEnumsSortedOrderEnum;
  target_model_filter?: boolean | null;
}

export interface MarqBrandCoreModelSwWebsiteCommonHostingProviderResponse {
  address?: string | null;
  city?: string | null;
  country_code?: MarqFoundationEnumsCountryCodeEnum;
  email?: string | null;
  name?: string | null;
  organization_id?: string | null;
  phone_number?: string | null;
  postal_code?: string | null;
  state?: string | null;
}

export interface MarqBrandCoreModelSwIpResponse {
  asn?: string | null;
  country?: MarqFoundationEnumsCountryCodeEnum;
  /** @format int32 */
  id: number;
  ip_address: string;
  isp?: string | null;
}

export interface MarqBrandCoreModelSwLogoDetectionResponse {
  /** @format double */
  bb_x1?: number | null;
  /** @format double */
  bb_x2?: number | null;
  /** @format double */
  bb_y1?: number | null;
  /** @format double */
  bb_y2?: number | null;
  /** @format int32 */
  image_height?: number | null;
  /** @format int32 */
  image_width?: number | null;
}

export interface MarqBrandCoreModelSwWebsiteCommonRegistrantResponse {
  address?: string | null;
  city?: string | null;
  country_code?: MarqFoundationEnumsCountryCodeEnum;
  email_list?: MarqBrandCoreModelResponseIdAndStringValueResponse[] | null;
  name?: string | null;
  organization?: string | null;
  phone_number?: string | null;
  postal_code?: string | null;
  state?: string | null;
}

export interface MarqBrandCoreModelSwWebsiteCommonRegistrarResponse {
  email?: string | null;
  homepage?: string | null;
  icann_id?: string | null;
  name?: string | null;
  phone_number?: string | null;
  whois_server?: string | null;
}

export interface MarqBrandCoreModelSwWebsiteDomainNamesDetailResponse {
  enforcement_progress?: MarqBrandCoreModelSwWebsiteDomainNamesEnforcementResponse;
  website_info: MarqBrandCoreModelSwWebsiteDomainNamesDetailInfoResponse;
}

export interface MarqBrandCoreModelSwWebsiteDomainNamesEnforcementResponse {
  google_progress?: MarqBrandCoreModelSwWebsiteDomainNamesEnforcementResponseGoogleProgressResponse;
  infringing_progress?: MarqBrandCoreModelSwWebsiteDomainNamesEnforcementResponseInfringingProgressResponse;
}

export interface MarqBrandCoreModelSwWebsiteDomainNamesEnforcementResponseGoogleProgressResponse {
  progress_list: MarqBrandCoreModelSwWebsiteDomainNamesEnforcementResponseGoogleProgressResponseItem[];
  status: MarqCommonEnumsSwWebsiteDelistingProgressEnum;
}

export interface MarqBrandCoreModelSwWebsiteDomainNamesEnforcementResponseGoogleProgressResponseItem {
  action: MarqCommonEnumsSwSWActionTypeEnum;
  isp?: MarqCommonEnumsReportAbuseIspEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  progress_date: string;
  status: MarqCommonEnumsSwWebsiteDelistingProgressEnum;
}

export interface MarqBrandCoreModelSwWebsiteDomainNamesEnforcementResponseInfringingProgressResponse {
  progress_list: MarqBrandCoreModelSwWebsiteDomainNamesEnforcementResponseInfringingProgressResponseItem[];
  status: MarqCommonEnumsSwWebsiteReportProgressEnum;
}

export interface MarqBrandCoreModelSwWebsiteDomainNamesEnforcementResponseInfringingProgressResponseItem {
  action: MarqCommonEnumsSwSWActionTypeEnum;
  from_cdn?: PiracyCommonEnumsCdnEnum;
  isp?: MarqCommonEnumsReportAbuseIspEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  progress_date: string;
  status: MarqCommonEnumsSwWebsiteReportProgressEnum;
}

export interface MarqBrandCoreModelSwWebsiteDomainNamesDetailInfoResponse {
  cdn?: MarqBrandCoreModelSwWebsiteCommonCdnResponse;
  /** @format int32 */
  comment_count: number;
  country: MarqFoundationEnumsCountryCodeEnum;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  created_date?: string | null;
  custom_tag_list?: MarqBrandCoreModelResponseCustomTagResponse[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  expiration_date?: string | null;
  hosting_provider?: MarqBrandCoreModelSwWebsiteCommonHostingProviderResponse;
  image_url?: string | null;
  ip?: MarqBrandCoreModelSwIpResponse;
  latest_comment?: MarqBrandCoreModelCommentCommentDto;
  logo_detection: boolean;
  logo_detection_data?: MarqBrandCoreModelSwLogoDetectionResponse;
  mx_record: boolean;
  proof_url?: string | null;
  registrant?: MarqBrandCoreModelSwWebsiteCommonRegistrantResponse;
  registrar?: MarqBrandCoreModelSwWebsiteCommonRegistrarResponse;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  scanned_date?: string | null;
  scanned_status?: MarqCommonEnumsScannedStatusEnum;
  ssl_certificate?: string | null;
  thumbnail_url?: string | null;
  title: string;
  title_translate?: string | null;
  /** @format int32 */
  website_id: number;
  website_url: string;
}

export interface MarqBrandCoreModelSwWebsiteDomainNamesReportedDetailResponse {
  ai_verdict_info?: MarqBrandCoreModelSwWebsiteDomainNamesDetailAiVerdictInfoResponse;
  /** @format int32 */
  comment_count: number;
  domain_history_list?: MarqBrandCoreModelSwWebsiteDomainNamesDomainHistoryResponse[] | null;
  header_info: MarqBrandCoreModelSwWebsiteDomainNamesDetailHeaderInfoResponse;
  overview: MarqBrandCoreModelSwWebsiteDomainNamesDetailOverviewResponse;
  screenshot_url?: string | null;
  takedown_history_list: MarqBrandCoreModelSwWebsiteDomainNamesTakedownHistoryResponse[];
}

export interface MarqBrandCoreModelSwWebsiteDomainNamesDetailAiVerdictInfoResponse {
  ai_verdict: MarqCommonEnumsSwAiLabelEnum;
  reason_list: MarqBrandCoreModelSwWebsiteDomainNamesDetailAiVerdictInfoResponseAiReason[];
}

export interface MarqBrandCoreModelSwWebsiteDomainNamesDetailAiVerdictInfoResponseAiReason {
  reason: string;
  subheading: string;
}

export interface MarqBrandCoreModelSwWebsiteDomainNamesDomainHistoryResponse {
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  date: string;
  favicon_url?: string | null;
  pdf_url?: string | null;
  status: MarqCommonEnumsSwAiLabelEnum;
}

export interface MarqBrandCoreModelSwWebsiteDomainNamesDetailHeaderInfoResponse {
  brand_name: string;
  current_status?: MarqCommonEnumsSwDomainTakedownStatusEnum;
  domain_status?: MarqCommonEnumsSwAiLabelEnum;
  favicon_url?: string | null;
  /** @format int32 */
  takedown_history_count: number;
  website_url: string;
}

export interface MarqBrandCoreModelSwWebsiteDomainNamesDetailOverviewResponse {
  address?: string | null;
  address_location?: MarqBrandCoreModelSwWebsiteDomainNamesDetailOverviewResponseLocation;
  asn?: string | null;
  brand_name: string;
  cdn_name?: string | null;
  country: MarqFoundationEnumsCountryCodeEnum;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  created_date?: string | null;
  custom_tag_list?: MarqBrandCoreModelResponseCustomTagResponse[] | null;
  description: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  expiration_date?: string | null;
  hosting_provider_name?: string | null;
  ip_address: string;
  logo_detection: boolean;
  mx_record: boolean;
  mx_record_list?: string[] | null;
  registrant_name?: string | null;
  registrar_name?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  registration_date?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  scanned_date?: string | null;
  ssl_certificate?: string | null;
  title: string;
  title_translate?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  updated_date?: string | null;
  /** @format int32 */
  website_id: number;
}

export interface MarqBrandCoreModelSwWebsiteDomainNamesDetailOverviewResponseLocation {
  /** @format double */
  lat: number;
  /** @format double */
  lng: number;
}

export interface MarqBrandCoreModelSwWebsiteDomainNamesTakedownHistoryResponse {
  google_progress?: MarqBrandCoreModelSwWebsiteDomainNamesTakedownHistoryResponseGoogleProgressResponse;
  infringing_progress?: MarqBrandCoreModelSwWebsiteDomainNamesTakedownHistoryResponseInfringingProgressResponse;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  start_date: string;
  status: MarqCommonEnumsSwDomainTakedownStatusEnum;
}

export interface MarqBrandCoreModelSwWebsiteDomainNamesTakedownHistoryResponseGoogleProgressResponse {
  progress_list: MarqBrandCoreModelSwWebsiteDomainNamesTakedownHistoryResponseGoogleProgressResponseItem[];
  status: MarqCommonEnumsSwWebsiteDelistingProgressEnum;
}

export interface MarqBrandCoreModelSwWebsiteDomainNamesTakedownHistoryResponseGoogleProgressResponseItem {
  /**
   * @format date
   * @example "2023-03-01"
   */
  progress_date: string;
  status: MarqCommonEnumsSwWebsiteDelistingProgressEnum;
}

export interface MarqBrandCoreModelSwWebsiteDomainNamesTakedownHistoryResponseInfringingProgressResponse {
  progress_list: MarqBrandCoreModelSwWebsiteDomainNamesTakedownHistoryResponseInfringingProgressResponseItem[];
  status: MarqCommonEnumsSwWebsiteReportProgressEnum;
}

export interface MarqBrandCoreModelSwWebsiteDomainNamesTakedownHistoryResponseInfringingProgressResponseItem {
  action: MarqCommonEnumsSwSWActionTypeEnum;
  from_cdn?: PiracyCommonEnumsCdnEnum;
  isp?: MarqCommonEnumsReportAbuseIspEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  progress_date: string;
  status: MarqCommonEnumsSwWebsiteReportProgressEnum;
}

export interface PerfCommercePerformanceLandscapingProtocolsGetReportResponse {
  report?: PerfCommercePerformanceLandscapingProtocolsGetReportResponseReport;
  status?: MarqCommonEnumsLandscapingReportStatusEnum;
}

export interface PerfCommercePerformanceLandscapingProtocolsGetReportResponseDomainBreakdown {
  segments: PerfCommercePerformanceLandscapingProtocolsHeatMapSegment[];
  target_location: string;
}

export interface PerfCommercePerformanceLandscapingProtocolsHeatMapSegment {
  domain_name: string;
  /** @format int32 */
  id: number;
  /** @format int32 */
  relevant_count: number;
  /** @format double */
  saturation_rate?: number | null;
}

export interface PerfCommercePerformanceLandscapingProtocolsGetReportResponseGlobalOverview {
  /** @format double */
  average_saturation_rate: number;
  /** @format int32 */
  relevant_count: number;
  /** @format int32 */
  scanned_count: number;
  segments: PerfCommercePerformanceLandscapingProtocolsSegment[];
  /** @format int32 */
  suspected_infringement_count: number;
}

export interface PerfCommercePerformanceLandscapingProtocolsSegment {
  label: MarqCommonEnumsCleanlinessCleanlinessLabelEnum;
  /** @format double */
  proportion: number;
}

export interface PerfCommercePerformanceLandscapingProtocolsGetReportResponseRegionalDeepDive {
  country_risk_overview: PerfCommercePerformanceLandscapingProtocolsCountryRiskOverviewItem[];
  segments: PerfCommercePerformanceLandscapingProtocolsRegionalSegment[];
  type: PerfCommercePerformanceLandscapingProtocolsLocationType;
}

export interface PerfCommercePerformanceLandscapingProtocolsRegionalSegment {
  code: string;
  label: string;
  trademark_exists?: boolean | null;
  /** @format double */
  value: number;
}

export enum PerfCommercePerformanceLandscapingProtocolsLocationType {
  Region = 'region',
  Country = 'country',
}

export interface PerfCommercePerformanceLandscapingProtocolsGetReportResponseListing {
  /** @format int32 */
  available_stock?: number | null;
  converted_currency: MarqFoundationEnumsCurrencyEnum;
  /** @format double */
  converted_price: number;
  listing_currency: MarqFoundationEnumsCurrencyEnum;
  listing_name: string;
  /** @format double */
  listing_price: number;
  listing_url: string;
  platform: string;
  risk_category: MarqCommonEnumsCleanlinessCleanlinessLabelEnum;
  risk_description: string;
  /** @format int32 */
  sales_volume?: number | null;
  seller_name: string;
  ship_from?: string | null;
  tags: MarqBrandCoreModelProtocolTags;
  thumbnail_url?: string | null;
}

export interface PerfCommercePerformanceLandscapingProtocolsGetReportRequest {
  /** @format int32 */
  report_id: number;
}

export interface PerfCommercePerformanceLandscapingProtocolsGetWorldMapResponse {
  segments: PerfCommercePerformanceLandscapingProtocolsRegionalSegment[];
  type: MarqCommonEnumsLandscapingLocationTypeEnum;
}

export interface PerfCommercePerformanceLandscapingProtocolsGetWorldMapRequest {
  data_type: MarqCommonEnumsLandscapingDataTypeEnum;
  location_type: MarqCommonEnumsLandscapingLocationTypeEnum;
  /** @format int32 */
  report_id: number;
}

export interface PerfCommercePerformanceLandscapingProtocolsGetPlatformDetailResponse {
  category_segments: PerfCommercePerformanceLandscapingProtocolsCategorySegment[];
  /** @format int64 */
  monthly_traffic?: number | null;
  /** @format int32 */
  relevant_count: number;
  /** @format double */
  saturation_rate: number;
  /** @format int32 */
  suspected_infringement_count: number;
}

export interface PerfCommercePerformanceLandscapingProtocolsGetPlatformDetailRequest {
  /** @format int32 */
  domain_id: number;
  /** @format int32 */
  report_id: number;
}

export interface PerfCommercePerformanceLandscapingProtocolsGetCountryAndRegionResponse {
  countries_by_region: Record<string, MarqFoundationEnumsCountryCodeEnum[]>;
}

export interface PerfCommercePerformanceLandscapingProtocolsGetReportResponseReportDetail {
  ai_summary: PerfCommercePerformanceLandscapingProtocolsGetReportResponseReportDetailAiSummary[];
  global_overview: PerfCommercePerformanceLandscapingProtocolsGetReportResponseReportDetailGlobalOverview;
  /** @uniqueItems true */
  keywords: string[];
  regional_deep_dive: PerfCommercePerformanceLandscapingProtocolsGetReportResponseReportDetailRegionalDeepDive;
  risk_highlights: PerfCommercePerformanceLandscapingProtocolsGetReportResponseReportDetailListing[];
  /**
   * @format date
   * @example "2023-03-01"
   */
  scanned_end: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  scanned_start: string;
}

export interface PerfCommercePerformanceLandscapingProtocolsCountryRiskOverviewItem {
  country_code: MarqFoundationEnumsCountryCodeEnum;
  country_name: string;
  /** @format double */
  saturation_rate: number;
  trademark_exists: boolean;
}

export enum PerfCommercePerformanceLandscapingProtocolsLandscapingReportStatusEnum {
  Generating = 'generating',
  Generated = 'generated',
  DraftSaved = 'draft_saved',
  Confirmed = 'confirmed',
}

export enum PerfCommercePerformanceLandscapingProtocolsDataTypeEnum {
  SuspectedInfringement = 'suspected_infringement',
  Relevant = 'relevant',
}

export interface PerfCommercePerformanceLandscapingProtocolsGetWorldMapDetailResponse {
  detail_segments: PerfCommercePerformanceLandscapingProtocolsTreemapSegment[];
  trademark_list?: PerfCommercePerformanceLandscapingProtocolsTrademark[] | null;
}

export interface PerfCommercePerformanceLandscapingProtocolsGetWorldMapDetailRequest {
  data_type: MarqCommonEnumsLandscapingDataTypeEnum;
  location?: string | null;
  location_type: MarqCommonEnumsLandscapingLocationTypeEnum;
  /** @format int32 */
  report_id: number;
}

export interface PerfCommercePerformanceLandscapingProtocolsTrademark {
  class_list: number[];
  /** @format int32 */
  id: number;
  name: string;
  type?: MarqCommonEnumsIpTrademarkTypeEnum;
}

export enum MarqCommonEnumsIpTrademarkTypeEnum {
  Word = 'word',
  Logo = 'logo',
  Composite = 'composite',
  Others = 'others',
}

export interface PerfCommercePerformanceLandscapingProtocolsGetReportResponseReportDetailAiSummary {
  content: string;
  title: string;
}

export interface PerfCommercePerformanceLandscapingProtocolsGetReportResponseReportDetailDomainBreakdown {
  segments: PerfCommercePerformanceLandscapingProtocolsHeatMapSegment[];
  target_location: string;
}

export interface PerfCommercePerformanceLandscapingProtocolsGetReportResponseReportDetailGlobalOverview {
  /** @format double */
  average_saturation_rate: number;
  category_segments: PerfCommercePerformanceLandscapingProtocolsCategorySegment[];
  /** @format int32 */
  relevant_count: number;
  /** @format int32 */
  scanned_count: number;
  /** @format int32 */
  suspected_infringement_count: number;
}

export interface PerfCommercePerformanceLandscapingProtocolsGetReportResponseReportDetailRegionalDeepDive {
  country_risk_segments: PerfCommercePerformanceLandscapingProtocolsCountryRiskOverviewItem[];
  tree_map_segments: PerfCommercePerformanceLandscapingProtocolsTreemapSegment[];
  type: MarqCommonEnumsLandscapingLocationTypeEnum;
  world_map_segments: PerfCommercePerformanceLandscapingProtocolsRegionalSegment[];
}

export interface PerfCommercePerformanceLandscapingProtocolsGetReportResponseReportDetailListing {
  /** @format int32 */
  available_stock?: number | null;
  converted_currency?: MarqFoundationEnumsCurrencyEnum;
  /** @format double */
  converted_price?: number | null;
  infringement_type: MarqCommonEnumsCleanlinessCleanlinessLabelEnum;
  infringing_reason: string;
  listing_currency?: MarqFoundationEnumsCurrencyEnum;
  /** @format int32 */
  listing_id: number;
  listing_name?: string | null;
  /** @format double */
  listing_price?: number | null;
  listing_url?: string | null;
  platform: string;
  /** @format int32 */
  sales_volume?: number | null;
  seller_name?: string | null;
  ship_from?: string | null;
  tags: MarqBrandCoreModelProtocolTags;
  thumbnail_url?: string | null;
}

export enum MarqCommonEnumsLandscapingReportStatusEnum {
  Generating = 'generating',
  Generated = 'generated',
  DraftSaved = 'draft_saved',
  Confirmed = 'confirmed',
}

export interface MonitoringWebsiteContentWebsiteContentCommonProtocolsGetCommentUserTypeFilterRequest {
  /** @format int32 */
  brand_id?: number | null;
  comment_user_type_filter?: MarqCommonEnumsCommentCommentUserTypeEnum[] | null;
  country_filter?: MarqFoundationEnumsCountryCodeEnum[] | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  favicon_detected_filter?: boolean | null;
  logo_detection_filter?: boolean | null;
  mx_records_filter?: boolean | null;
  requested_date_filter?: MarqCommonModelLocalDateRange;
  scanned_date_filter?: MarqCommonModelLocalDateRange;
  scanned_status_filter?: MarqCommonEnumsScannedStatusEnum;
  search?: string | null;
  ssl_cert_filter?: boolean | null;
  tab: MarqCommonEnumsSwWebsiteContentsTabEnum;
  tp_progress_status_filter?: MarqCommonEnumsTpTpProgressStatusEnum[] | null;
  tp_reported_filter?: boolean | null;
}

export interface MarqBrandCoreModelCommentCommentDto {
  attachments: MarqBrandCoreModelCommentCommentAttachmentDto[];
  content?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  created_at: string;
  deleted: boolean;
  email: string;
  /** @format int32 */
  id: number;
  is_admin: boolean;
  /** @format int32 */
  reply_count?: number | null;
  user_type: MarqCommonEnumsCommentCommentUserTypeEnum;
}

export interface MarqBrandCoreModelCommentCommentAttachmentDto {
  file_name: string;
  /** @format int32 */
  id?: number | null;
  url: string;
}

export interface MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetCommentUserTypeFilterRequest {
  /** @format int32 */
  brand_id?: number | null;
  comment_user_type_filter?: MarqCommonEnumsCommentCommentUserTypeEnum[] | null;
  country_filter?: MarqFoundationEnumsCountryCodeEnum[] | null;
  custom_tag_id_filter?: number[] | null;
  domain_status_filter?: MarqCommonEnumsSwAiLabelEnum[] | null;
  favicon_detected_filter?: boolean | null;
  logo_detection_filter?: boolean | null;
  mx_records_filter?: boolean | null;
  requested_date_filter?: MarqCommonModelLocalDateRange;
  scanned_date_filter?: MarqCommonModelLocalDateRange;
  scanned_status_filter?: MarqCommonEnumsScannedStatusEnum;
  search?: string | null;
  ssl_cert_filter?: boolean | null;
  tab: MarqCommonEnumsSwWebsiteBrandDomainNamesTabEnum;
  watch_list_added_date_filter?: MarqCommonModelLocalDateRange;
}

export interface SwCommentProtocolsGetParentListResponse {
  list: SwCommentProtocolsComment[];
}

export interface SwCommentProtocolsComment {
  attachments: SwCommentProtocolsCommentAttachment[];
  content?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  created_at: string;
  deleted: boolean;
  email: string;
  /** @format int32 */
  id: number;
  is_admin: boolean;
  /** @format int32 */
  reply_count?: number | null;
}

export interface SwCommentProtocolsCommentAttachment {
  file_name: string;
  /** @format int32 */
  id?: number | null;
  url: string;
}

export interface SwCommentProtocolsGetParentListRequest {
  /** @format int32 */
  sw_id: number;
}

export interface SwCommentProtocolsGetChildListResponse {
  list: SwCommentProtocolsComment[];
}

export interface SwCommentProtocolsGetChildListRequest {
  /** @format int32 */
  parent_id: number;
  /** @format int32 */
  sw_id: number;
}

export interface SwCommentProtocolsCreateRequest {
  comment: SwCommentProtocolsCreateRequestCreateComment;
  /** @format int32 */
  parent_comment_id?: number | null;
  sw_id_list: number[];
}

export interface SwCommentProtocolsCreateRequestCreateComment {
  attachments: SwCommentProtocolsCommentAttachment[];
  content: string;
}

export interface SwCommentProtocolsUploadAttachmentResponse {
  attachments: SwCommentProtocolsCommentAttachment[];
}

export interface SwCommentProtocolsUploadAttachmentRequest {
  file_names: string[];
}

export interface SwCommentProtocolsDeleteRequest {
  /** @format int32 */
  comment_id: number;
  /** @format int32 */
  sw_id: number;
}

export interface PerfCommercePerformanceLandscapingProtocolsCategorySegment {
  label: MarqCommonEnumsCleanlinessCleanlinessLabelEnum;
  /** @format double */
  proportion: number;
}

export interface PerfCommercePerformanceLandscapingProtocolsTreemapSegment {
  domain_name: string;
  /** @format int32 */
  id: number;
  /** @format int32 */
  relevant_count: number;
  /** @format double */
  saturation_rate?: number | null;
}

export enum MarqCommonEnumsLandscapingLocationTypeEnum {
  Country = 'country',
  Region = 'region',
}

export enum MarqCommonEnumsLandscapingDataTypeEnum {
  SuspectedInfringement = 'suspected_infringement',
  Relevant = 'relevant',
}

export interface PerfCommercePerformanceLandscapingProtocolsGetReportResponseReport {
  /** @format int32 */
  brand_id: number;
  report_detail?: PerfCommercePerformanceLandscapingProtocolsGetReportResponseReportReportDetail;
  /** @format int32 */
  report_id: number;
  report_status: MarqCommonEnumsLandscapingReportStatusEnum;
}

export interface PerfCommercePerformanceLandscapingProtocolsGetReportResponseReportReportDetail {
  ai_summary: PerfCommercePerformanceLandscapingProtocolsGetReportResponseReportReportDetailAiSummary[];
  global_overview: PerfCommercePerformanceLandscapingProtocolsGetReportResponseReportReportDetailGlobalOverview;
  keywords: string[];
  regional_deep_dive: PerfCommercePerformanceLandscapingProtocolsGetReportResponseReportReportDetailRegionalDeepDive;
  risk_highlights: PerfCommercePerformanceLandscapingProtocolsGetReportResponseReportReportDetailListing[];
  /**
   * @format date
   * @example "2023-03-01"
   */
  scanned_end: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  scanned_start: string;
}

export interface PerfCommercePerformanceLandscapingProtocolsGetReportResponseReportReportDetailAiSummary {
  content: string;
  title: string;
}

export interface PerfCommercePerformanceLandscapingProtocolsGetReportResponseReportReportDetailGlobalOverview {
  /** @format double */
  average_saturation_rate: number;
  category_segments: PerfCommercePerformanceLandscapingProtocolsCategorySegment[];
  /** @format int32 */
  relevant_count: number;
  /** @format int32 */
  scanned_count: number;
  /** @format int32 */
  suspected_infringement_count: number;
}

export interface PerfCommercePerformanceLandscapingProtocolsGetReportResponseReportReportDetailRegionalDeepDive {
  tree_map_segments: PerfCommercePerformanceLandscapingProtocolsTreemapSegment[];
  type: MarqCommonEnumsLandscapingLocationTypeEnum;
  world_map_segments: PerfCommercePerformanceLandscapingProtocolsRegionalSegment[];
}

export interface PerfCommercePerformanceLandscapingProtocolsGetReportResponseReportReportDetailListing {
  /** @format int32 */
  available_stock?: number | null;
  converted_currency?: MarqFoundationEnumsCurrencyEnum;
  /** @format double */
  converted_price?: number | null;
  infringement_type: MarqCommonEnumsCleanlinessCleanlinessLabelEnum;
  infringing_reason: string;
  listing_currency?: MarqFoundationEnumsCurrencyEnum;
  /** @format int32 */
  listing_id: number;
  listing_name?: string | null;
  /** @format double */
  listing_price?: number | null;
  listing_url?: string | null;
  platform: string;
  /** @format int32 */
  sales_volume?: number | null;
  seller_name?: string | null;
  ship_from?: string | null;
  tags: MarqBrandCoreModelProtocolTags;
  thumbnail_url?: string | null;
}

export interface PerfCommercePerformanceLandscapingProtocolsGetSlideLinkResponse {
  url?: string | null;
}

export interface PerfCommercePerformanceLandscapingProtocolsGetSlideLinkRequest {
  /** @format int32 */
  report_id: number;
}

export interface MonitoringGenerativeaiPiracyGenerativeAiPiracyProtocolsGetListingCountResponse {
  /** @format int32 */
  count: number;
}

export interface MonitoringGenerativeaiPiracyGenerativeAiPiracyProtocolsGetListingCountRequest {
  asset_list?: number[] | null;
  client_status: PiracyCommonEnumsClientStatus;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  live_filter?: boolean | null;
  search_method_list?: PiracyCommonEnumsSearchMethodEnum[] | null;
  search_string?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
  top_search_filter?: boolean | null;
  website_id_list?: number[] | null;
}

export interface MonitoringGenerativeaiPiracyGenerativeAiPiracyProtocolsExportCsvRequest {
  asset_list?: number[] | null;
  client_status: PiracyCommonEnumsClientStatus;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  listing_id_list?: number[] | null;
  live_filter?: boolean | null;
  search_method_list?: PiracyCommonEnumsSearchMethodEnum[] | null;
  search_string?: string | null;
  sort_column: PiracyCommonEnumsSortColumnEnum;
  sort_order: PiracyCommonEnumsSortOrderEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
  top_search_filter?: boolean | null;
  website_id_list?: number[] | null;
}

export interface MonitoringGenerativeaiPiracyGenerativeAiPiracyProtocolsGetListResponse {
  list: MonitoringGenerativeaiPiracyGenerativeAiPiracyProtocolsGetListResponseListing[];
}

export interface MonitoringGenerativeaiPiracyGenerativeAiPiracyProtocolsGetListResponseListing {
  asset_name: string;
  channel: PiracyCommonEnumsChannelEnum;
  features: MarqBrandModelProtocolFeatures;
  /** @format int32 */
  id: number;
  platform_name: string;
  profile_name: string;
  search_method: PiracyCommonEnumsSearchMethodEnum;
  thumbnail_url: string;
  title: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  update_date: string;
  url: string;
}

export interface MarqBrandModelProtocolFeatures {
  live: boolean;
}

export interface MonitoringGenerativeaiPiracyGenerativeAiPiracyProtocolsGetListRequest {
  asset_list?: number[] | null;
  client_status: PiracyCommonEnumsClientStatus;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /** @format int32 */
  limit: number;
  live_filter?: boolean | null;
  /** @format int32 */
  offset: number;
  search_method_list?: PiracyCommonEnumsSearchMethodEnum[] | null;
  search_string?: string | null;
  sort_column: PiracyCommonEnumsSortColumnEnum;
  sort_order: PiracyCommonEnumsSortOrderEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
  top_search_filter?: boolean | null;
  website_id_list?: number[] | null;
}

export interface MonitoringGenerativeaiPiracyGenerativeAiPiracyProtocolsGetListingIdListResponse {
  listing_id_list: number[];
  /** @format int32 */
  size: number;
}

export interface MonitoringGenerativeaiPiracyGenerativeAiPiracyProtocolsGetListingIdListRequest {
  asset_list?: number[] | null;
  client_status: PiracyCommonEnumsClientStatus;
  /**
   * @format date
   * @example "2023-03-01"
   */
  end_date?: string | null;
  /** @format int32 */
  limit: number;
  live_filter?: boolean | null;
  /** @format int32 */
  offset: number;
  search_method_list?: PiracyCommonEnumsSearchMethodEnum[] | null;
  search_string?: string | null;
  sort_column: PiracyCommonEnumsSortColumnEnum;
  sort_order: PiracyCommonEnumsSortOrderEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  start_date?: string | null;
  top_search_filter?: boolean | null;
  website_id_list?: number[] | null;
}

export interface MonitoringGenerativeaiPiracyGenerativeAiPiracyProtocolsGetDetailRequest {
  channel: PiracyCommonEnumsChannelEnum;
  /** @format int32 */
  id: number;
}

export interface MonitoringGenerativeaiPiracyGenerativeAiPiracyProtocolsPostConfirmRequest {
  doc_list?: MonitoringGenerativeaiPiracyGenerativeAiPiracyProtocolsPostConfirmRequestFileRequest[] | null;
  listing_id_list: number[];
  note?: string | null;
}

export interface MonitoringGenerativeaiPiracyGenerativeAiPiracyProtocolsPostConfirmRequestFileRequest {
  file_name: string;
  url: string;
}

export interface MonitoringGenerativeaiPiracyGenerativeAiPiracyProtocolsPostDismissRequest {
  listing_id_list: number[];
}

export interface MonitoringGenerativeaiPiracyGenerativeAiPiracyProtocolsCancelConfirmRequest {
  listing_id_list: number[];
}

export interface PerfCommercePerformanceLandscapingProtocolsGetReportListResponse {
  brands: PerfCommercePerformanceLandscapingProtocolsGetReportListResponseBrand[];
}

export interface PerfCommercePerformanceLandscapingProtocolsGetReportListResponseBrand {
  /** @format int32 */
  id: number;
  name: string;
  reports: PerfCommercePerformanceLandscapingProtocolsGetReportListResponseBrandReport[];
}

export interface PerfCommercePerformanceLandscapingProtocolsGetReportListResponseBrandReport {
  /**
   * @format date
   * @example "2023-03-01"
   */
  created_at: string;
  /** @format int32 */
  id: number;
  keywords: string[];
  status: MarqCommonEnumsLandscapingReportStatusEnum;
}

export interface PerfCommercePerformanceLandscapingProtocolsGetReportListRequest {
  /** @format int32 */
  brand_id?: number | null;
}

export interface PerfCommercePerformanceProtocolsGetCountriesResponse {
  countries: PerfCommercePerformanceProtocolsGetCountriesResponseCountry[];
}

export interface PerfCommercePerformanceProtocolsGetCountriesResponseCountry {
  code: string;
  name: string;
}

export interface PerfCommercePerformanceProtocolsGetCountriesRequest {
  domain_ids?: number[] | null;
}

export interface PerfCommercePerformanceProtocolsGetDomainsResponse {
  channels: PerfCommercePerformanceProtocolsGetDomainsResponseChannel[];
}

export interface PerfCommercePerformanceProtocolsGetDomainsResponseChannel {
  domains: PerfCommercePerformanceProtocolsGetDomainsResponseChannelDomain[];
  name: string;
}

export interface PerfCommercePerformanceProtocolsGetDomainsResponseChannelDomain {
  /** @format int32 */
  id: number;
  name: string;
}

export interface PerfCommercePerformanceProtocolsGetDomainsRequest {
  countries?: string[] | null;
}

export enum MarqCommonEnumsClientEmployeeAccessPageEnum {
  Home = 'home',
  Analytics = 'analytics',
  Portfolio = 'portfolio',
  Marketplace = 'marketplace',
  SocialMedia = 'social_media',
  WebsiteContent = 'website_content',
  DomainNames = 'domain_names',
  SellerManagement = 'seller_management',
  SellerMatch = 'seller_match',
  SellerIntel = 'seller_intel',
  AiContentTakedown = 'ai_content_takedown',
}

export interface SettingsProtocolsLimitedAccessPolicyPiracyAsset {
  /** @format int32 */
  id: number;
  name?: string | null;
}

export interface MarqBrandCoreModelSwWebsiteCommonCdnResponse {
  address?: string | null;
  city?: string | null;
  country_code?: MarqFoundationEnumsCountryCodeEnum;
  email?: string | null;
  name?: string | null;
  organization_id?: string | null;
  phone_number?: string | null;
  postal_code?: string | null;
  state?: string | null;
}

export enum PiracyCommonEnumsCdnEnum {
  Cloudflareinc = 'cloudflareinc',
}

export interface PerfCommercePerformanceCleanlinessProtocolsGetSaturationRateTrendDetailResponseSaturationRate {
  is_active: boolean;
  /** @format double */
  value?: number | null;
}

export interface MapMapModelCountryProtocolsGetViolationPlatformListResponse {
  violation_platform_list: MapMapModelCountryProtocolsGetViolationPlatformListResponseViolationPlatformItem[];
}

export interface MapMapModelCountryProtocolsGetViolationPlatformListResponseViolationPlatformItem {
  currency: MarqFoundationEnumsCurrencyEnum;
  /** @format int32 */
  domain_id: number;
  domain_name: string;
  /** @format double */
  lowest_dynamic_price: number;
  /** @format double */
  lowest_final_price: number;
  /** @format double */
  lowest_price: number;
  /** @format int32 */
  violation_listings: number;
  /** @format int32 */
  violation_sellers: number;
}

export interface MapMapModelCountryProtocolsGetViolationPlatformListRequest {
  country: MarqFoundationEnumsCountryCodeEnum;
  /** @format int32 */
  model_id: number;
  sort: MarqCommonEnumsMapSortEnum;
}

export enum MapMapModelCountryProtocolsEnforceabilityActionEnum {
  Enforce = 'enforce',
  EnforceRequested = 'enforce_requested',
  Authorized = 'authorized',
  ReviewNeeded = 'review_needed',
  CaseClosed = 'case_closed',
  OutOfScope = 'out_of_scope',
}

export interface MapMapModelCountryProtocolsGetFilterInfoExpandDomainRequest {
  country: MarqFoundationEnumsCountryCodeEnum;
  /** @format int32 */
  model_id: number;
}

export interface MapMapModelCountryProtocolsGetViolationListingsExpandResponse {
  has_model_group: boolean;
  listing_list: MapMapModelCountryProtocolsGetViolationListingsExpandResponseMapListingExpand[];
  /** @format int32 */
  total_count: number;
  unit_price_per?: string | null;
}

export interface MapMapModelCountryProtocolsGetViolationListingsExpandResponseMapListingExpand {
  /** @format double */
  advertised_price: number;
  authorized_seller: boolean;
  /** @format double */
  converted_advertised_price: number;
  /** @format double */
  converted_dynamic_price: number;
  currency: MarqFoundationEnumsCurrencyEnum;
  domain_name: string;
  /** @format double */
  dynamic_price: number;
  enforceability_action: MapMapModelCountryProtocolsEnforceabilityActionEnum;
  /** @format double */
  final_price: number;
  is_expanded: boolean;
  is_hourly_supported: boolean;
  is_unprotected_model: boolean;
  /** @format int32 */
  listing_id: number;
  /** @format int32 */
  listing_option_id: number;
  listing_url: string;
  seller_name?: string | null;
  shipping_additional_info?: string | null;
  /** @format double */
  shipping_fee: number;
  shipping_type: MarqCommonEnumsShippingTypeEnum;
  should_highlight: boolean;
  title: string;
  /** @format double */
  unit_price: number;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  updated_date: string;
}

export interface MapMapModelCountryProtocolsGetViolationListingsExpandRequest {
  authorized_seller?: boolean | null;
  country: MarqFoundationEnumsCountryCodeEnum;
  domain_id_list?: number[] | null;
  /** @format int32 */
  model_id: number;
  sort?: MarqCommonEnumsMapSortEnum;
}

export interface MonitoringEnforcementTPProtocolsGetTpProgressFilterRequest {
  asset_id_filter?: number[] | null;
  /** @format int32 */
  brand_id?: number | null;
  channel_type: MarqCommonEnumsChannelTypeEnum[];
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  model_id_filter?: number[] | null;
  search?: string | null;
  seller_name_filter?: string[] | null;
  ship_from_filter?: string[] | null;
  tp_progress_status_filter?: MarqCommonEnumsTpTpProgressStatusEnum[] | null;
  tp_reported_filter?: boolean | null;
}

export enum MarqCommonEnumsTpTpProgressStatusEnum {
  Reviewing = 'reviewing',
  Purchase = 'purchase',
  Completed = 'completed',
  Closed = 'closed',
  Others = 'others',
}

export enum MarqCommonEnumsTpTpTypeEnum {
  Standard = 'standard',
  Basic = 'basic',
}

export interface MarqBrandDataModelDtoTpTpProductDetailAttr {
  type: MarqCommonEnumsTpTpProductDetailTypeEnum;
  value?: T;
}

export enum MarqCommonEnumsTpTpProductDetailTypeEnum {
  PackagingIssues = 'packaging_issues',
  CorrectProductShipment = 'correct_product_shipment',
  ProductSku = 'product_sku',
  QrCodeSerialNumber = 'qr_code_serial_number',
  QrCodeNotes = 'qr_code_notes',
  BatchCodeDateOfManufacture = 'batch_code_date_of_manufacture',
  PidNumber = 'pid_number',
  ExpiryWarrantyInstallDate = 'expiry_warranty_install_date',
  ValidWarranty = 'valid_warranty',
}

export type T = object;

export enum MarqCommonEnumsTpTpResultType {
  Counterfeit = 'counterfeit',
  Genuine = 'genuine',
  ComplianceViolation = 'compliance_violation',
  Compliant = 'compliant',
  Others = 'others',
}

export enum MarqCommonEnumsTpTpImageTypeEnum {
  Waybill = 'waybill',
  Package = 'package',
  Product = 'product',
  Labels = 'labels',
  Others = 'others',
  Report = 'report',
  Image = 'image',
}

export interface MonitoringEnforcementTPProtocolsGetTpReportRequest {
  /** @format int32 */
  listing_id?: number | null;
  /** @format int32 */
  sw_id?: number | null;
}

export interface MarqBrandCoreModelResponseTpHistoryTpDeliverResponse {
  /**
   * @format date
   * @example "2023-03-01"
   */
  delivery_eta?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  shipping_date?: string | null;
}

export interface MarqBrandCoreModelResponseTpHistoryTpOrder {
  order_confirmation_name?: string | null;
  order_confirmation_url?: string | null;
  order_note?: string | null;
  order_number?: string | null;
  product_price?: MarqBrandCoreModelResponsePriceResponse;
  shipping_company?: string | null;
  shipping_fee?: MarqBrandCoreModelResponsePriceResponse;
  tax?: MarqBrandCoreModelResponsePriceResponse;
  total_price?: MarqBrandCoreModelResponsePriceResponse;
  tracking_number?: string | null;
}

export interface MarqBrandCoreModelResponsePriceResponse {
  currency: MarqFoundationEnumsCurrencyEnum;
  /** @format double */
  price: number;
}

export interface MonitoringEnforcementTPProtocolsGetTpReportResponse {
  tp_result?: MarqBrandCoreModelResponseTpReportResponse;
}

export interface MonitoringWebsiteContentWebsiteContentCommonProtocolsGetTpProgressFilterRequest {
  /** @format int32 */
  brand_id?: number | null;
  comment_user_type_filter?: MarqCommonEnumsCommentCommentUserTypeEnum[] | null;
  country_filter?: MarqFoundationEnumsCountryCodeEnum[] | null;
  custom_tag_id_filter?: number[] | null;
  domain_id_filter?: number[] | null;
  favicon_detected_filter?: boolean | null;
  logo_detection_filter?: boolean | null;
  mx_records_filter?: boolean | null;
  requested_date_filter?: MarqCommonModelLocalDateRange;
  scanned_date_filter?: MarqCommonModelLocalDateRange;
  scanned_status_filter?: MarqCommonEnumsScannedStatusEnum;
  search?: string | null;
  ssl_cert_filter?: boolean | null;
  tab: MarqCommonEnumsSwWebsiteContentsTabEnum;
  tp_progress_status_filter?: MarqCommonEnumsTpTpProgressStatusEnum[] | null;
  tp_reported_filter?: boolean | null;
}

export enum MarqCommonEnumsTpTpPaymentStatusEnum {
  TpPaymentOnHold = 'tp_payment_on_hold',
  TpPaymentConfirmed = 'tp_payment_confirmed',
  TpPaymentDenied = 'tp_payment_denied',
  TpInvoiceDelivery = 'tp_invoice_delivery',
  TpFinalPaymentOnHold = 'tp_final_payment_on_hold',
  TpFinalPaymentConfirmed = 'tp_final_payment_confirmed',
  TpPartnerPayment = 'tp_partner_payment',
  TpFinalPaymentDenied = 'tp_final_payment_denied',
}

export enum MarqCommonEnumsTpTpStatusEnum {
  TpPending = 'tp_pending',
  TpReview = 'tp_review',
  TpAvailable = 'tp_available',
  TpUnavailable = 'tp_unavailable',
  TpCancelled = 'tp_cancelled',
  TpOnHold = 'tp_on_hold',
  TpPrepare = 'tp_prepare',
  TpOrder = 'tp_order',
  TpReceiptSuccess = 'tp_receipt_success',
  TpReceiptFailed = 'tp_receipt_failed',
  TpReportPrepare = 'tp_report_prepare',
  TpReportPub = 'tp_report_pub',
  TpReported = 'tp_reported',
  TpEnforced = 'tp_enforced',
  TpReportRejected = 'tp_report_rejected',
  TpUnreportable = 'tp_unreportable',
  TpReturnRequest = 'tp_return_request',
  TpReturning = 'tp_returning',
  TpReturnSuccess = 'tp_return_success',
  TpReturnFailed = 'tp_return_failed',
  TpDelivering = 'tp_delivering',
  TpDelivered = 'tp_delivered',
  TpCompleted = 'tp_completed',
}
